(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree41b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree41b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1IdZj", function(module, exports) {
'use strict';

module.exports = (parcelRequire("89wqa"));

});
parcelRegister("89wqa", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5ef850295e0236ca$export$ffb0004e005737fa, (v) => $5ef850295e0236ca$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $5ef850295e0236ca$export$34b9dba7ce09269b, (v) => $5ef850295e0236ca$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $5ef850295e0236ca$export$25062201e9e25d76, (v) => $5ef850295e0236ca$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ef850295e0236ca$export$ffb0004e005737fa;
var $5ef850295e0236ca$export$34b9dba7ce09269b;
var $5ef850295e0236ca$export$25062201e9e25d76;
'use strict';

var $8NFma = parcelRequire("8NFma");
var $5ef850295e0236ca$var$k = Symbol.for("react.element"), $5ef850295e0236ca$var$l = Symbol.for("react.fragment"), $5ef850295e0236ca$var$m = Object.prototype.hasOwnProperty, $5ef850295e0236ca$var$n = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $5ef850295e0236ca$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5ef850295e0236ca$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$5ef850295e0236ca$var$m.call(a, b) && !$5ef850295e0236ca$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $5ef850295e0236ca$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $5ef850295e0236ca$var$n.current
    };
}
$5ef850295e0236ca$export$ffb0004e005737fa = $5ef850295e0236ca$var$l;
$5ef850295e0236ca$export$34b9dba7ce09269b = $5ef850295e0236ca$var$q;
$5ef850295e0236ca$export$25062201e9e25d76 = $5ef850295e0236ca$var$q;

});
parcelRegister("8NFma", function(module, exports) {
'use strict';

module.exports = (parcelRequire("j1rj6"));

});
parcelRegister("j1rj6", function(module, exports) {

$parcel$export(module.exports, "Children", () => $dd934af551f44020$export$dca3b0875bd9a954, (v) => $dd934af551f44020$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $dd934af551f44020$export$16fa2f45be04daa8, (v) => $dd934af551f44020$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $dd934af551f44020$export$ffb0004e005737fa, (v) => $dd934af551f44020$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $dd934af551f44020$export$e2c29f18771995cb, (v) => $dd934af551f44020$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $dd934af551f44020$export$221d75b3f55bb0bd, (v) => $dd934af551f44020$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $dd934af551f44020$export$5f8d39834fd61797, (v) => $dd934af551f44020$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $dd934af551f44020$export$74bf444e3cd11ea5, (v) => $dd934af551f44020$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $dd934af551f44020$export$ae55be85d98224ed, (v) => $dd934af551f44020$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $dd934af551f44020$export$3ba232387fd5d6dd, (v) => $dd934af551f44020$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $dd934af551f44020$export$e530037191fcd5d7, (v) => $dd934af551f44020$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $dd934af551f44020$export$fd42f52fd3ae1109, (v) => $dd934af551f44020$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $dd934af551f44020$export$c8a8987d4410bf2d, (v) => $dd934af551f44020$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $dd934af551f44020$export$d38cd72104c1f0e9, (v) => $dd934af551f44020$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $dd934af551f44020$export$7d1e3a5e95ceca43, (v) => $dd934af551f44020$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $dd934af551f44020$export$257a8862b851cb5b, (v) => $dd934af551f44020$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $dd934af551f44020$export$a8257692ac88316c, (v) => $dd934af551f44020$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $dd934af551f44020$export$488013bae63b21da, (v) => $dd934af551f44020$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $dd934af551f44020$export$7c73462e0d25e514, (v) => $dd934af551f44020$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $dd934af551f44020$export$7568632d0d33d16d, (v) => $dd934af551f44020$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $dd934af551f44020$export$88948ce120ea2619, (v) => $dd934af551f44020$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $dd934af551f44020$export$35808ee640e87ca7, (v) => $dd934af551f44020$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $dd934af551f44020$export$fae74005e78b1a27, (v) => $dd934af551f44020$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $dd934af551f44020$export$dc8fbce3eb94dc1e, (v) => $dd934af551f44020$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $dd934af551f44020$export$6a7bc4e911dc01cf, (v) => $dd934af551f44020$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $dd934af551f44020$export$6d9c69b0de29b591, (v) => $dd934af551f44020$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $dd934af551f44020$export$f680877a34711e37, (v) => $dd934af551f44020$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $dd934af551f44020$export$d5a552a76deda3c2, (v) => $dd934af551f44020$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $dd934af551f44020$export$aaabe4eda9ed9969, (v) => $dd934af551f44020$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $dd934af551f44020$export$e5c5a5f917a5871c, (v) => $dd934af551f44020$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $dd934af551f44020$export$1538c33de8887b59, (v) => $dd934af551f44020$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $dd934af551f44020$export$13e3392192263954, (v) => $dd934af551f44020$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $dd934af551f44020$export$b8f5890fc79d6aca, (v) => $dd934af551f44020$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $dd934af551f44020$export$60241385465d0a34, (v) => $dd934af551f44020$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $dd934af551f44020$export$306c0aa65ff9ec16, (v) => $dd934af551f44020$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $dd934af551f44020$export$7b286972b8d8ccbf, (v) => $dd934af551f44020$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $dd934af551f44020$export$83d89fbfd8236492, (v) => $dd934af551f44020$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd934af551f44020$export$dca3b0875bd9a954;
var $dd934af551f44020$export$16fa2f45be04daa8;
var $dd934af551f44020$export$ffb0004e005737fa;
var $dd934af551f44020$export$e2c29f18771995cb;
var $dd934af551f44020$export$221d75b3f55bb0bd;
var $dd934af551f44020$export$5f8d39834fd61797;
var $dd934af551f44020$export$74bf444e3cd11ea5;
var $dd934af551f44020$export$ae55be85d98224ed;
var $dd934af551f44020$export$3ba232387fd5d6dd;
var $dd934af551f44020$export$e530037191fcd5d7;
var $dd934af551f44020$export$fd42f52fd3ae1109;
var $dd934af551f44020$export$c8a8987d4410bf2d;
var $dd934af551f44020$export$d38cd72104c1f0e9;
var $dd934af551f44020$export$7d1e3a5e95ceca43;
var $dd934af551f44020$export$257a8862b851cb5b;
var $dd934af551f44020$export$a8257692ac88316c;
var $dd934af551f44020$export$488013bae63b21da;
var $dd934af551f44020$export$7c73462e0d25e514;
var $dd934af551f44020$export$7568632d0d33d16d;
var $dd934af551f44020$export$88948ce120ea2619;
var $dd934af551f44020$export$35808ee640e87ca7;
var $dd934af551f44020$export$fae74005e78b1a27;
var $dd934af551f44020$export$dc8fbce3eb94dc1e;
var $dd934af551f44020$export$6a7bc4e911dc01cf;
var $dd934af551f44020$export$6d9c69b0de29b591;
var $dd934af551f44020$export$f680877a34711e37;
var $dd934af551f44020$export$d5a552a76deda3c2;
var $dd934af551f44020$export$aaabe4eda9ed9969;
var $dd934af551f44020$export$e5c5a5f917a5871c;
var $dd934af551f44020$export$1538c33de8887b59;
var $dd934af551f44020$export$13e3392192263954;
var $dd934af551f44020$export$b8f5890fc79d6aca;
var $dd934af551f44020$export$60241385465d0a34;
var $dd934af551f44020$export$306c0aa65ff9ec16;
var $dd934af551f44020$export$7b286972b8d8ccbf;
var $dd934af551f44020$export$83d89fbfd8236492;
'use strict';
var $dd934af551f44020$var$l = Symbol.for("react.element"), $dd934af551f44020$var$n = Symbol.for("react.portal"), $dd934af551f44020$var$p = Symbol.for("react.fragment"), $dd934af551f44020$var$q = Symbol.for("react.strict_mode"), $dd934af551f44020$var$r = Symbol.for("react.profiler"), $dd934af551f44020$var$t = Symbol.for("react.provider"), $dd934af551f44020$var$u = Symbol.for("react.context"), $dd934af551f44020$var$v = Symbol.for("react.forward_ref"), $dd934af551f44020$var$w = Symbol.for("react.suspense"), $dd934af551f44020$var$x = Symbol.for("react.memo"), $dd934af551f44020$var$y = Symbol.for("react.lazy"), $dd934af551f44020$var$z = Symbol.iterator;
function $dd934af551f44020$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $dd934af551f44020$var$z && a[$dd934af551f44020$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $dd934af551f44020$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $dd934af551f44020$var$C = Object.assign, $dd934af551f44020$var$D = {};
function $dd934af551f44020$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
$dd934af551f44020$var$E.prototype.isReactComponent = {};
$dd934af551f44020$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$dd934af551f44020$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $dd934af551f44020$var$F() {}
$dd934af551f44020$var$F.prototype = $dd934af551f44020$var$E.prototype;
function $dd934af551f44020$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
var $dd934af551f44020$var$H = $dd934af551f44020$var$G.prototype = new $dd934af551f44020$var$F;
$dd934af551f44020$var$H.constructor = $dd934af551f44020$var$G;
$dd934af551f44020$var$C($dd934af551f44020$var$H, $dd934af551f44020$var$E.prototype);
$dd934af551f44020$var$H.isPureReactComponent = !0;
var $dd934af551f44020$var$I = Array.isArray, $dd934af551f44020$var$J = Object.prototype.hasOwnProperty, $dd934af551f44020$var$K = {
    current: null
}, $dd934af551f44020$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dd934af551f44020$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$dd934af551f44020$var$J.call(b, d) && !$dd934af551f44020$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $dd934af551f44020$var$K.current
    };
}
function $dd934af551f44020$var$N(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $dd934af551f44020$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dd934af551f44020$var$l;
}
function $dd934af551f44020$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $dd934af551f44020$var$P = /\/+/g;
function $dd934af551f44020$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $dd934af551f44020$var$escape("" + a.key) : b.toString(36);
}
function $dd934af551f44020$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $dd934af551f44020$var$l:
                case $dd934af551f44020$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $dd934af551f44020$var$Q(h, 0) : d, $dd934af551f44020$var$I(c) ? (e = "", null != a && (e = a.replace($dd934af551f44020$var$P, "$&/") + "/"), $dd934af551f44020$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($dd934af551f44020$var$O(c) && (c = $dd934af551f44020$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($dd934af551f44020$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($dd934af551f44020$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $dd934af551f44020$var$Q(k, g);
        h += $dd934af551f44020$var$R(k, b, e, f, c);
    }
    else if (f = $dd934af551f44020$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $dd934af551f44020$var$Q(k, g++), h += $dd934af551f44020$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $dd934af551f44020$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $dd934af551f44020$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $dd934af551f44020$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $dd934af551f44020$var$U = {
    current: null
}, $dd934af551f44020$var$V = {
    transition: null
}, $dd934af551f44020$var$W = {
    ReactCurrentDispatcher: $dd934af551f44020$var$U,
    ReactCurrentBatchConfig: $dd934af551f44020$var$V,
    ReactCurrentOwner: $dd934af551f44020$var$K
};
function $dd934af551f44020$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$dd934af551f44020$export$dca3b0875bd9a954 = {
    map: $dd934af551f44020$var$S,
    forEach: function(a, b, e) {
        $dd934af551f44020$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $dd934af551f44020$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $dd934af551f44020$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$dd934af551f44020$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$dd934af551f44020$export$16fa2f45be04daa8 = $dd934af551f44020$var$E;
$dd934af551f44020$export$ffb0004e005737fa = $dd934af551f44020$var$p;
$dd934af551f44020$export$e2c29f18771995cb = $dd934af551f44020$var$r;
$dd934af551f44020$export$221d75b3f55bb0bd = $dd934af551f44020$var$G;
$dd934af551f44020$export$5f8d39834fd61797 = $dd934af551f44020$var$q;
$dd934af551f44020$export$74bf444e3cd11ea5 = $dd934af551f44020$var$w;
$dd934af551f44020$export$ae55be85d98224ed = $dd934af551f44020$var$W;
$dd934af551f44020$export$3ba232387fd5d6dd = $dd934af551f44020$var$X;
$dd934af551f44020$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $dd934af551f44020$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $dd934af551f44020$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$dd934af551f44020$var$J.call(b, f) && !$dd934af551f44020$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$dd934af551f44020$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $dd934af551f44020$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $dd934af551f44020$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$dd934af551f44020$export$c8a8987d4410bf2d = $dd934af551f44020$var$M;
$dd934af551f44020$export$d38cd72104c1f0e9 = function(a) {
    var b = $dd934af551f44020$var$M.bind(null, a);
    b.type = a;
    return b;
};
$dd934af551f44020$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$dd934af551f44020$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$v,
        render: a
    };
};
$dd934af551f44020$export$a8257692ac88316c = $dd934af551f44020$var$O;
$dd934af551f44020$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $dd934af551f44020$var$T
    };
};
$dd934af551f44020$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$dd934af551f44020$export$7568632d0d33d16d = function(a) {
    var b = $dd934af551f44020$var$V.transition;
    $dd934af551f44020$var$V.transition = {};
    try {
        a();
    } finally{
        $dd934af551f44020$var$V.transition = b;
    }
};
$dd934af551f44020$export$88948ce120ea2619 = $dd934af551f44020$var$X;
$dd934af551f44020$export$35808ee640e87ca7 = function(a, b) {
    return $dd934af551f44020$var$U.current.useCallback(a, b);
};
$dd934af551f44020$export$fae74005e78b1a27 = function(a) {
    return $dd934af551f44020$var$U.current.useContext(a);
};
$dd934af551f44020$export$dc8fbce3eb94dc1e = function() {};
$dd934af551f44020$export$6a7bc4e911dc01cf = function(a) {
    return $dd934af551f44020$var$U.current.useDeferredValue(a);
};
$dd934af551f44020$export$6d9c69b0de29b591 = function(a, b) {
    return $dd934af551f44020$var$U.current.useEffect(a, b);
};
$dd934af551f44020$export$f680877a34711e37 = function() {
    return $dd934af551f44020$var$U.current.useId();
};
$dd934af551f44020$export$d5a552a76deda3c2 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useImperativeHandle(a, b, e);
};
$dd934af551f44020$export$aaabe4eda9ed9969 = function(a, b) {
    return $dd934af551f44020$var$U.current.useInsertionEffect(a, b);
};
$dd934af551f44020$export$e5c5a5f917a5871c = function(a, b) {
    return $dd934af551f44020$var$U.current.useLayoutEffect(a, b);
};
$dd934af551f44020$export$1538c33de8887b59 = function(a, b) {
    return $dd934af551f44020$var$U.current.useMemo(a, b);
};
$dd934af551f44020$export$13e3392192263954 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useReducer(a, b, e);
};
$dd934af551f44020$export$b8f5890fc79d6aca = function(a) {
    return $dd934af551f44020$var$U.current.useRef(a);
};
$dd934af551f44020$export$60241385465d0a34 = function(a) {
    return $dd934af551f44020$var$U.current.useState(a);
};
$dd934af551f44020$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useSyncExternalStore(a, b, e);
};
$dd934af551f44020$export$7b286972b8d8ccbf = function() {
    return $dd934af551f44020$var$U.current.useTransition();
};
$dd934af551f44020$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("6T1J1", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $503937b663c395c4$export$882461b6382ed46c, (v) => $503937b663c395c4$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $503937b663c395c4$export$757ceba2d55c277e, (v) => $503937b663c395c4$export$757ceba2d55c277e = v);
var $503937b663c395c4$export$882461b6382ed46c;
var $503937b663c395c4$export$757ceba2d55c277e;
'use strict';

var $2pmb0 = parcelRequire("2pmb0");
var $503937b663c395c4$var$i;
$503937b663c395c4$export$882461b6382ed46c = $2pmb0.createRoot;
$503937b663c395c4$export$757ceba2d55c277e = $2pmb0.hydrateRoot;

});
parcelRegister("2pmb0", function(module, exports) {
'use strict';
function $1c0f1e610963dfb8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1c0f1e610963dfb8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1c0f1e610963dfb8$var$checkDCE();

module.exports = (parcelRequire("23wBm"));

});
parcelRegister("23wBm", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $17f526922e4a857c$export$ae55be85d98224ed, (v) => $17f526922e4a857c$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $17f526922e4a857c$export$d39a5bbd09211389, (v) => $17f526922e4a857c$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $17f526922e4a857c$export$882461b6382ed46c, (v) => $17f526922e4a857c$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $17f526922e4a857c$export$466bfc07425424d5, (v) => $17f526922e4a857c$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $17f526922e4a857c$export$cd75ccfd720a3cd4, (v) => $17f526922e4a857c$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $17f526922e4a857c$export$fa8d919ba61d84db, (v) => $17f526922e4a857c$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $17f526922e4a857c$export$757ceba2d55c277e, (v) => $17f526922e4a857c$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $17f526922e4a857c$export$b3890eb0ae9dca99, (v) => $17f526922e4a857c$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $17f526922e4a857c$export$502457920280e6be, (v) => $17f526922e4a857c$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $17f526922e4a857c$export$c78a37762a8d58e1, (v) => $17f526922e4a857c$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $17f526922e4a857c$export$dc54d992c10e8a18, (v) => $17f526922e4a857c$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $17f526922e4a857c$export$83d89fbfd8236492, (v) => $17f526922e4a857c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $17f526922e4a857c$export$ae55be85d98224ed;
var $17f526922e4a857c$export$d39a5bbd09211389;
var $17f526922e4a857c$export$882461b6382ed46c;
var $17f526922e4a857c$export$466bfc07425424d5;
var $17f526922e4a857c$export$cd75ccfd720a3cd4;
var $17f526922e4a857c$export$fa8d919ba61d84db;
var $17f526922e4a857c$export$757ceba2d55c277e;
var $17f526922e4a857c$export$b3890eb0ae9dca99;
var $17f526922e4a857c$export$502457920280e6be;
var $17f526922e4a857c$export$c78a37762a8d58e1;
var $17f526922e4a857c$export$dc54d992c10e8a18;
var $17f526922e4a857c$export$83d89fbfd8236492;
'use strict';

var $8NFma = parcelRequire("8NFma");

var $clk2u = parcelRequire("clk2u");
function $17f526922e4a857c$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $17f526922e4a857c$var$da = new Set, $17f526922e4a857c$var$ea = {};
function $17f526922e4a857c$var$fa(a, b) {
    $17f526922e4a857c$var$ha(a, b);
    $17f526922e4a857c$var$ha(a + "Capture", b);
}
function $17f526922e4a857c$var$ha(a, b) {
    $17f526922e4a857c$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$17f526922e4a857c$var$da.add(b[a]);
}
var $17f526922e4a857c$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $17f526922e4a857c$var$ja = Object.prototype.hasOwnProperty, $17f526922e4a857c$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $17f526922e4a857c$var$la = {}, $17f526922e4a857c$var$ma = {};
function $17f526922e4a857c$var$oa(a) {
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$ma, a)) return !0;
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$la, a)) return !1;
    if ($17f526922e4a857c$var$ka.test(a)) return $17f526922e4a857c$var$ma[a] = !0;
    $17f526922e4a857c$var$la[a] = !0;
    return !1;
}
function $17f526922e4a857c$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $17f526922e4a857c$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $17f526922e4a857c$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $17f526922e4a857c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $17f526922e4a857c$var$ra = /[\-:]([a-z])/g;
function $17f526922e4a857c$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$17f526922e4a857c$var$z.xlinkHref = new $17f526922e4a857c$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $17f526922e4a857c$var$ta(a, b, c, d) {
    var e = $17f526922e4a857c$var$z.hasOwnProperty(b) ? $17f526922e4a857c$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $17f526922e4a857c$var$qa(b, c, e, d) && (c = null), d || null === e ? $17f526922e4a857c$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $17f526922e4a857c$var$ua = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $17f526922e4a857c$var$va = Symbol.for("react.element"), $17f526922e4a857c$var$wa = Symbol.for("react.portal"), $17f526922e4a857c$var$ya = Symbol.for("react.fragment"), $17f526922e4a857c$var$za = Symbol.for("react.strict_mode"), $17f526922e4a857c$var$Aa = Symbol.for("react.profiler"), $17f526922e4a857c$var$Ba = Symbol.for("react.provider"), $17f526922e4a857c$var$Ca = Symbol.for("react.context"), $17f526922e4a857c$var$Da = Symbol.for("react.forward_ref"), $17f526922e4a857c$var$Ea = Symbol.for("react.suspense"), $17f526922e4a857c$var$Fa = Symbol.for("react.suspense_list"), $17f526922e4a857c$var$Ga = Symbol.for("react.memo"), $17f526922e4a857c$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $17f526922e4a857c$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $17f526922e4a857c$var$Ja = Symbol.iterator;
function $17f526922e4a857c$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $17f526922e4a857c$var$Ja && a[$17f526922e4a857c$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $17f526922e4a857c$var$A = Object.assign, $17f526922e4a857c$var$La;
function $17f526922e4a857c$var$Ma(a) {
    if (void 0 === $17f526922e4a857c$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $17f526922e4a857c$var$La = b && b[1] || "";
    }
    return "\n" + $17f526922e4a857c$var$La + a;
}
var $17f526922e4a857c$var$Na = !1;
function $17f526922e4a857c$var$Oa(a, b) {
    if (!a || $17f526922e4a857c$var$Na) return "";
    $17f526922e4a857c$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $17f526922e4a857c$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $17f526922e4a857c$var$Ma(a) : "";
}
function $17f526922e4a857c$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $17f526922e4a857c$var$Ma(a.type);
        case 16:
            return $17f526922e4a857c$var$Ma("Lazy");
        case 13:
            return $17f526922e4a857c$var$Ma("Suspense");
        case 19:
            return $17f526922e4a857c$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $17f526922e4a857c$var$Oa(a.type, !1), a;
        case 11:
            return a = $17f526922e4a857c$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $17f526922e4a857c$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $17f526922e4a857c$var$ya:
            return "Fragment";
        case $17f526922e4a857c$var$wa:
            return "Portal";
        case $17f526922e4a857c$var$Aa:
            return "Profiler";
        case $17f526922e4a857c$var$za:
            return "StrictMode";
        case $17f526922e4a857c$var$Ea:
            return "Suspense";
        case $17f526922e4a857c$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $17f526922e4a857c$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $17f526922e4a857c$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $17f526922e4a857c$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $17f526922e4a857c$var$Ga:
            return b = a.displayName || null, null !== b ? b : $17f526922e4a857c$var$Qa(a.type) || "Memo";
        case $17f526922e4a857c$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $17f526922e4a857c$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $17f526922e4a857c$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $17f526922e4a857c$var$Qa(b);
        case 8:
            return b === $17f526922e4a857c$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $17f526922e4a857c$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $17f526922e4a857c$var$Ua(a) {
    var b = $17f526922e4a857c$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $17f526922e4a857c$var$Va(a) {
    a._valueTracker || (a._valueTracker = $17f526922e4a857c$var$Ua(a));
}
function $17f526922e4a857c$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $17f526922e4a857c$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $17f526922e4a857c$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $17f526922e4a857c$var$Ya(a, b) {
    var c = b.checked;
    return $17f526922e4a857c$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $17f526922e4a857c$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $17f526922e4a857c$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $17f526922e4a857c$var$ab(a, b) {
    b = b.checked;
    null != b && $17f526922e4a857c$var$ta(a, "checked", b, !1);
}
function $17f526922e4a857c$var$bb(a, b) {
    $17f526922e4a857c$var$ab(a, b);
    var c = $17f526922e4a857c$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $17f526922e4a857c$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $17f526922e4a857c$var$cb(a, b.type, $17f526922e4a857c$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $17f526922e4a857c$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $17f526922e4a857c$var$cb(a, b, c) {
    if ("number" !== b || $17f526922e4a857c$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $17f526922e4a857c$var$eb = Array.isArray;
function $17f526922e4a857c$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $17f526922e4a857c$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $17f526922e4a857c$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($17f526922e4a857c$var$p(91));
    return $17f526922e4a857c$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $17f526922e4a857c$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($17f526922e4a857c$var$p(92));
            if ($17f526922e4a857c$var$eb(c)) {
                if (1 < c.length) throw Error($17f526922e4a857c$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $17f526922e4a857c$var$Sa(c)
    };
}
function $17f526922e4a857c$var$ib(a, b) {
    var c = $17f526922e4a857c$var$Sa(b.value), d = $17f526922e4a857c$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $17f526922e4a857c$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $17f526922e4a857c$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $17f526922e4a857c$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $17f526922e4a857c$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $17f526922e4a857c$var$mb, $17f526922e4a857c$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $17f526922e4a857c$var$mb = $17f526922e4a857c$var$mb || document.createElement("div");
        $17f526922e4a857c$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $17f526922e4a857c$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $17f526922e4a857c$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $17f526922e4a857c$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $17f526922e4a857c$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($17f526922e4a857c$var$pb).forEach(function(a) {
    $17f526922e4a857c$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $17f526922e4a857c$var$pb[b] = $17f526922e4a857c$var$pb[a];
    });
});
function $17f526922e4a857c$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $17f526922e4a857c$var$pb.hasOwnProperty(a) && $17f526922e4a857c$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $17f526922e4a857c$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $17f526922e4a857c$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $17f526922e4a857c$var$tb = $17f526922e4a857c$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $17f526922e4a857c$var$ub(a, b) {
    if (b) {
        if ($17f526922e4a857c$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($17f526922e4a857c$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($17f526922e4a857c$var$p(62));
    }
}
function $17f526922e4a857c$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $17f526922e4a857c$var$wb = null;
function $17f526922e4a857c$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $17f526922e4a857c$var$yb = null, $17f526922e4a857c$var$zb = null, $17f526922e4a857c$var$Ab = null;
function $17f526922e4a857c$var$Bb(a) {
    if (a = $17f526922e4a857c$var$Cb(a)) {
        if ("function" !== typeof $17f526922e4a857c$var$yb) throw Error($17f526922e4a857c$var$p(280));
        var b = a.stateNode;
        b && (b = $17f526922e4a857c$var$Db(b), $17f526922e4a857c$var$yb(a.stateNode, a.type, b));
    }
}
function $17f526922e4a857c$var$Eb(a) {
    $17f526922e4a857c$var$zb ? $17f526922e4a857c$var$Ab ? $17f526922e4a857c$var$Ab.push(a) : $17f526922e4a857c$var$Ab = [
        a
    ] : $17f526922e4a857c$var$zb = a;
}
function $17f526922e4a857c$var$Fb() {
    if ($17f526922e4a857c$var$zb) {
        var a = $17f526922e4a857c$var$zb, b = $17f526922e4a857c$var$Ab;
        $17f526922e4a857c$var$Ab = $17f526922e4a857c$var$zb = null;
        $17f526922e4a857c$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$17f526922e4a857c$var$Bb(b[a]);
    }
}
function $17f526922e4a857c$var$Gb(a, b) {
    return a(b);
}
function $17f526922e4a857c$var$Hb() {}
var $17f526922e4a857c$var$Ib = !1;
function $17f526922e4a857c$var$Jb(a, b, c) {
    if ($17f526922e4a857c$var$Ib) return a(b, c);
    $17f526922e4a857c$var$Ib = !0;
    try {
        return $17f526922e4a857c$var$Gb(a, b, c);
    } finally{
        if ($17f526922e4a857c$var$Ib = !1, null !== $17f526922e4a857c$var$zb || null !== $17f526922e4a857c$var$Ab) $17f526922e4a857c$var$Hb(), $17f526922e4a857c$var$Fb();
    }
}
function $17f526922e4a857c$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $17f526922e4a857c$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($17f526922e4a857c$var$p(231, b, typeof c));
    return c;
}
var $17f526922e4a857c$var$Lb = !1;
if ($17f526922e4a857c$var$ia) try {
    var $17f526922e4a857c$var$Mb = {};
    Object.defineProperty($17f526922e4a857c$var$Mb, "passive", {
        get: function() {
            $17f526922e4a857c$var$Lb = !0;
        }
    });
    window.addEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
    window.removeEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
} catch (a) {
    $17f526922e4a857c$var$Lb = !1;
}
function $17f526922e4a857c$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $17f526922e4a857c$var$Ob = !1, $17f526922e4a857c$var$Pb = null, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, $17f526922e4a857c$var$Sb = {
    onError: function(a) {
        $17f526922e4a857c$var$Ob = !0;
        $17f526922e4a857c$var$Pb = a;
    }
};
function $17f526922e4a857c$var$Tb(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Ob = !1;
    $17f526922e4a857c$var$Pb = null;
    $17f526922e4a857c$var$Nb.apply($17f526922e4a857c$var$Sb, arguments);
}
function $17f526922e4a857c$var$Ub(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Tb.apply(this, arguments);
    if ($17f526922e4a857c$var$Ob) {
        if ($17f526922e4a857c$var$Ob) {
            var l = $17f526922e4a857c$var$Pb;
            $17f526922e4a857c$var$Ob = !1;
            $17f526922e4a857c$var$Pb = null;
        } else throw Error($17f526922e4a857c$var$p(198));
        $17f526922e4a857c$var$Qb || ($17f526922e4a857c$var$Qb = !0, $17f526922e4a857c$var$Rb = l);
    }
}
function $17f526922e4a857c$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $17f526922e4a857c$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $17f526922e4a857c$var$Xb(a) {
    if ($17f526922e4a857c$var$Vb(a) !== a) throw Error($17f526922e4a857c$var$p(188));
}
function $17f526922e4a857c$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $17f526922e4a857c$var$Vb(a);
        if (null === b) throw Error($17f526922e4a857c$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $17f526922e4a857c$var$Xb(e), a;
                if (f === d) return $17f526922e4a857c$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($17f526922e4a857c$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($17f526922e4a857c$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($17f526922e4a857c$var$p(190));
    }
    if (3 !== c.tag) throw Error($17f526922e4a857c$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $17f526922e4a857c$var$Zb(a) {
    a = $17f526922e4a857c$var$Yb(a);
    return null !== a ? $17f526922e4a857c$var$$b(a) : null;
}
function $17f526922e4a857c$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $17f526922e4a857c$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$ac = $clk2u.unstable_scheduleCallback, $17f526922e4a857c$var$bc = $clk2u.unstable_cancelCallback, $17f526922e4a857c$var$cc = $clk2u.unstable_shouldYield, $17f526922e4a857c$var$dc = $clk2u.unstable_requestPaint, $17f526922e4a857c$var$B = $clk2u.unstable_now, $17f526922e4a857c$var$ec = $clk2u.unstable_getCurrentPriorityLevel, $17f526922e4a857c$var$fc = $clk2u.unstable_ImmediatePriority, $17f526922e4a857c$var$gc = $clk2u.unstable_UserBlockingPriority, $17f526922e4a857c$var$hc = $clk2u.unstable_NormalPriority, $17f526922e4a857c$var$ic = $clk2u.unstable_LowPriority, $17f526922e4a857c$var$jc = $clk2u.unstable_IdlePriority, $17f526922e4a857c$var$kc = null, $17f526922e4a857c$var$lc = null;
function $17f526922e4a857c$var$mc(a) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberRoot) try {
        $17f526922e4a857c$var$lc.onCommitFiberRoot($17f526922e4a857c$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $17f526922e4a857c$var$oc = Math.clz32 ? Math.clz32 : $17f526922e4a857c$var$nc, $17f526922e4a857c$var$pc = Math.log, $17f526922e4a857c$var$qc = Math.LN2;
function $17f526922e4a857c$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($17f526922e4a857c$var$pc(a) / $17f526922e4a857c$var$qc | 0) | 0;
}
var $17f526922e4a857c$var$rc = 64, $17f526922e4a857c$var$sc = 4194304;
function $17f526922e4a857c$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $17f526922e4a857c$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $17f526922e4a857c$var$tc(h) : (f &= g, 0 !== f && (d = $17f526922e4a857c$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $17f526922e4a857c$var$tc(g) : 0 !== f && (d = $17f526922e4a857c$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $17f526922e4a857c$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $17f526922e4a857c$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $17f526922e4a857c$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $17f526922e4a857c$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $17f526922e4a857c$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $17f526922e4a857c$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $17f526922e4a857c$var$yc() {
    var a = $17f526922e4a857c$var$rc;
    $17f526922e4a857c$var$rc <<= 1;
    0 === ($17f526922e4a857c$var$rc & 4194240) && ($17f526922e4a857c$var$rc = 64);
    return a;
}
function $17f526922e4a857c$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $17f526922e4a857c$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $17f526922e4a857c$var$oc(b);
    a[b] = c;
}
function $17f526922e4a857c$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $17f526922e4a857c$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $17f526922e4a857c$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $17f526922e4a857c$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $17f526922e4a857c$var$C = 0;
function $17f526922e4a857c$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $17f526922e4a857c$var$Ec, $17f526922e4a857c$var$Fc, $17f526922e4a857c$var$Gc, $17f526922e4a857c$var$Hc, $17f526922e4a857c$var$Ic, $17f526922e4a857c$var$Jc = !1, $17f526922e4a857c$var$Kc = [], $17f526922e4a857c$var$Lc = null, $17f526922e4a857c$var$Mc = null, $17f526922e4a857c$var$Nc = null, $17f526922e4a857c$var$Oc = new Map, $17f526922e4a857c$var$Pc = new Map, $17f526922e4a857c$var$Qc = [], $17f526922e4a857c$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $17f526922e4a857c$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $17f526922e4a857c$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $17f526922e4a857c$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $17f526922e4a857c$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $17f526922e4a857c$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $17f526922e4a857c$var$Pc.delete(b.pointerId);
    }
}
function $17f526922e4a857c$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $17f526922e4a857c$var$Cb(b), null !== b && $17f526922e4a857c$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $17f526922e4a857c$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $17f526922e4a857c$var$Lc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $17f526922e4a857c$var$Mc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $17f526922e4a857c$var$Nc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $17f526922e4a857c$var$Oc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $17f526922e4a857c$var$Pc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $17f526922e4a857c$var$Vc(a) {
    var b = $17f526922e4a857c$var$Wc(a.target);
    if (null !== b) {
        var c = $17f526922e4a857c$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $17f526922e4a857c$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $17f526922e4a857c$var$Ic(a.priority, function() {
                        $17f526922e4a857c$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $17f526922e4a857c$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $17f526922e4a857c$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $17f526922e4a857c$var$wb = d;
            c.target.dispatchEvent(d);
            $17f526922e4a857c$var$wb = null;
        } else return b = $17f526922e4a857c$var$Cb(c), null !== b && $17f526922e4a857c$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $17f526922e4a857c$var$Zc(a, b, c) {
    $17f526922e4a857c$var$Xc(a) && c.delete(b);
}
function $17f526922e4a857c$var$$c() {
    $17f526922e4a857c$var$Jc = !1;
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Lc) && ($17f526922e4a857c$var$Lc = null);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Mc) && ($17f526922e4a857c$var$Mc = null);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Nc) && ($17f526922e4a857c$var$Nc = null);
    $17f526922e4a857c$var$Oc.forEach($17f526922e4a857c$var$Zc);
    $17f526922e4a857c$var$Pc.forEach($17f526922e4a857c$var$Zc);
}
function $17f526922e4a857c$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $17f526922e4a857c$var$Jc || ($17f526922e4a857c$var$Jc = !0, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, $17f526922e4a857c$var$$c)));
}
function $17f526922e4a857c$var$bd(a) {
    function b(b) {
        return $17f526922e4a857c$var$ad(b, a);
    }
    if (0 < $17f526922e4a857c$var$Kc.length) {
        $17f526922e4a857c$var$ad($17f526922e4a857c$var$Kc[0], a);
        for(var c = 1; c < $17f526922e4a857c$var$Kc.length; c++){
            var d = $17f526922e4a857c$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Lc, a);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Mc, a);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Nc, a);
    $17f526922e4a857c$var$Oc.forEach(b);
    $17f526922e4a857c$var$Pc.forEach(b);
    for(c = 0; c < $17f526922e4a857c$var$Qc.length; c++)d = $17f526922e4a857c$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $17f526922e4a857c$var$Qc.length && (c = $17f526922e4a857c$var$Qc[0], null === c.blockedOn);)$17f526922e4a857c$var$Vc(c), null === c.blockedOn && $17f526922e4a857c$var$Qc.shift();
}
var $17f526922e4a857c$var$cd = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$dd = !0;
function $17f526922e4a857c$var$ed(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$gd(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 4, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$fd(a, b, c, d) {
    if ($17f526922e4a857c$var$dd) {
        var e = $17f526922e4a857c$var$Yc(a, b, c, d);
        if (null === e) $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c), $17f526922e4a857c$var$Sc(a, d);
        else if ($17f526922e4a857c$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($17f526922e4a857c$var$Sc(a, d), b & 4 && -1 < $17f526922e4a857c$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $17f526922e4a857c$var$Cb(e);
                null !== f && $17f526922e4a857c$var$Ec(f);
                f = $17f526922e4a857c$var$Yc(a, b, c, d);
                null === f && $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $17f526922e4a857c$var$hd(a, b, d, null, c);
    }
}
var $17f526922e4a857c$var$id = null;
function $17f526922e4a857c$var$Yc(a, b, c, d) {
    $17f526922e4a857c$var$id = null;
    a = $17f526922e4a857c$var$xb(d);
    a = $17f526922e4a857c$var$Wc(a);
    if (null !== a) {
        if (b = $17f526922e4a857c$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $17f526922e4a857c$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $17f526922e4a857c$var$id = a;
    return null;
}
function $17f526922e4a857c$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($17f526922e4a857c$var$ec()){
                case $17f526922e4a857c$var$fc:
                    return 1;
                case $17f526922e4a857c$var$gc:
                    return 4;
                case $17f526922e4a857c$var$hc:
                case $17f526922e4a857c$var$ic:
                    return 16;
                case $17f526922e4a857c$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ld = null, $17f526922e4a857c$var$md = null;
function $17f526922e4a857c$var$nd() {
    if ($17f526922e4a857c$var$md) return $17f526922e4a857c$var$md;
    var a, b = $17f526922e4a857c$var$ld, c = b.length, d, e = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $17f526922e4a857c$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $17f526922e4a857c$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $17f526922e4a857c$var$pd() {
    return !0;
}
function $17f526922e4a857c$var$qd() {
    return !1;
}
function $17f526922e4a857c$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $17f526922e4a857c$var$pd : $17f526922e4a857c$var$qd;
        this.isPropagationStopped = $17f526922e4a857c$var$qd;
        return this;
    }
    $17f526922e4a857c$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $17f526922e4a857c$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $17f526922e4a857c$var$pd);
        },
        persist: function() {},
        isPersistent: $17f526922e4a857c$var$pd
    });
    return b;
}
var $17f526922e4a857c$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $17f526922e4a857c$var$td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$sd), $17f526922e4a857c$var$ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    view: 0,
    detail: 0
}), $17f526922e4a857c$var$vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$ud), $17f526922e4a857c$var$wd, $17f526922e4a857c$var$xd, $17f526922e4a857c$var$yd, $17f526922e4a857c$var$Ad = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $17f526922e4a857c$var$yd && ($17f526922e4a857c$var$yd && "mousemove" === a.type ? ($17f526922e4a857c$var$wd = a.screenX - $17f526922e4a857c$var$yd.screenX, $17f526922e4a857c$var$xd = a.screenY - $17f526922e4a857c$var$yd.screenY) : $17f526922e4a857c$var$xd = $17f526922e4a857c$var$wd = 0, $17f526922e4a857c$var$yd = a);
        return $17f526922e4a857c$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $17f526922e4a857c$var$xd;
    }
}), $17f526922e4a857c$var$Bd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ad), $17f526922e4a857c$var$Cd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    dataTransfer: 0
}), $17f526922e4a857c$var$Dd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Cd), $17f526922e4a857c$var$Ed = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    relatedTarget: 0
}), $17f526922e4a857c$var$Fd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ed), $17f526922e4a857c$var$Gd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Hd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Gd), $17f526922e4a857c$var$Id = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $17f526922e4a857c$var$Jd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Id), $17f526922e4a857c$var$Kd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    data: 0
}), $17f526922e4a857c$var$Ld = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Kd), $17f526922e4a857c$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $17f526922e4a857c$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $17f526922e4a857c$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $17f526922e4a857c$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $17f526922e4a857c$var$Od[a]) ? !!b[a] : !1;
}
function $17f526922e4a857c$var$zd() {
    return $17f526922e4a857c$var$Pd;
}
var $17f526922e4a857c$var$Qd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $17f526922e4a857c$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $17f526922e4a857c$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $17f526922e4a857c$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $17f526922e4a857c$var$Rd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Qd), $17f526922e4a857c$var$Sd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $17f526922e4a857c$var$Td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Sd), $17f526922e4a857c$var$Ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $17f526922e4a857c$var$zd
}), $17f526922e4a857c$var$Vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ud), $17f526922e4a857c$var$Wd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Xd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Wd), $17f526922e4a857c$var$Yd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $17f526922e4a857c$var$Zd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Yd), $17f526922e4a857c$var$$d = [
    9,
    13,
    27,
    32
], $17f526922e4a857c$var$ae = $17f526922e4a857c$var$ia && "CompositionEvent" in window, $17f526922e4a857c$var$be = null;
$17f526922e4a857c$var$ia && "documentMode" in document && ($17f526922e4a857c$var$be = document.documentMode);
var $17f526922e4a857c$var$ce = $17f526922e4a857c$var$ia && "TextEvent" in window && !$17f526922e4a857c$var$be, $17f526922e4a857c$var$de = $17f526922e4a857c$var$ia && (!$17f526922e4a857c$var$ae || $17f526922e4a857c$var$be && 8 < $17f526922e4a857c$var$be && 11 >= $17f526922e4a857c$var$be), $17f526922e4a857c$var$ee = String.fromCharCode(32), $17f526922e4a857c$var$fe = !1;
function $17f526922e4a857c$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $17f526922e4a857c$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $17f526922e4a857c$var$ie = !1;
function $17f526922e4a857c$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $17f526922e4a857c$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $17f526922e4a857c$var$fe = !0;
            return $17f526922e4a857c$var$ee;
        case "textInput":
            return a = b.data, a === $17f526922e4a857c$var$ee && $17f526922e4a857c$var$fe ? null : a;
        default:
            return null;
    }
}
function $17f526922e4a857c$var$ke(a, b) {
    if ($17f526922e4a857c$var$ie) return "compositionend" === a || !$17f526922e4a857c$var$ae && $17f526922e4a857c$var$ge(a, b) ? (a = $17f526922e4a857c$var$nd(), $17f526922e4a857c$var$md = $17f526922e4a857c$var$ld = $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $17f526922e4a857c$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $17f526922e4a857c$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$17f526922e4a857c$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $17f526922e4a857c$var$ne(a, b, c, d) {
    $17f526922e4a857c$var$Eb(d);
    b = $17f526922e4a857c$var$oe(b, "onChange");
    0 < b.length && (c = new $17f526922e4a857c$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $17f526922e4a857c$var$pe = null, $17f526922e4a857c$var$qe = null;
function $17f526922e4a857c$var$re(a) {
    $17f526922e4a857c$var$se(a, 0);
}
function $17f526922e4a857c$var$te(a) {
    var b = $17f526922e4a857c$var$ue(a);
    if ($17f526922e4a857c$var$Wa(b)) return a;
}
function $17f526922e4a857c$var$ve(a, b) {
    if ("change" === a) return b;
}
var $17f526922e4a857c$var$we = !1;
if ($17f526922e4a857c$var$ia) {
    var $17f526922e4a857c$var$xe;
    if ($17f526922e4a857c$var$ia) {
        var $17f526922e4a857c$var$ye = "oninput" in document;
        if (!$17f526922e4a857c$var$ye) {
            var $17f526922e4a857c$var$ze = document.createElement("div");
            $17f526922e4a857c$var$ze.setAttribute("oninput", "return;");
            $17f526922e4a857c$var$ye = "function" === typeof $17f526922e4a857c$var$ze.oninput;
        }
        $17f526922e4a857c$var$xe = $17f526922e4a857c$var$ye;
    } else $17f526922e4a857c$var$xe = !1;
    $17f526922e4a857c$var$we = $17f526922e4a857c$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $17f526922e4a857c$var$Ae() {
    $17f526922e4a857c$var$pe && ($17f526922e4a857c$var$pe.detachEvent("onpropertychange", $17f526922e4a857c$var$Be), $17f526922e4a857c$var$qe = $17f526922e4a857c$var$pe = null);
}
function $17f526922e4a857c$var$Be(a) {
    if ("value" === a.propertyName && $17f526922e4a857c$var$te($17f526922e4a857c$var$qe)) {
        var b = [];
        $17f526922e4a857c$var$ne(b, $17f526922e4a857c$var$qe, a, $17f526922e4a857c$var$xb(a));
        $17f526922e4a857c$var$Jb($17f526922e4a857c$var$re, b);
    }
}
function $17f526922e4a857c$var$Ce(a, b, c) {
    "focusin" === a ? ($17f526922e4a857c$var$Ae(), $17f526922e4a857c$var$pe = b, $17f526922e4a857c$var$qe = c, $17f526922e4a857c$var$pe.attachEvent("onpropertychange", $17f526922e4a857c$var$Be)) : "focusout" === a && $17f526922e4a857c$var$Ae();
}
function $17f526922e4a857c$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $17f526922e4a857c$var$te($17f526922e4a857c$var$qe);
}
function $17f526922e4a857c$var$Ee(a, b) {
    if ("click" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $17f526922e4a857c$var$He = "function" === typeof Object.is ? Object.is : $17f526922e4a857c$var$Ge;
function $17f526922e4a857c$var$Ie(a, b) {
    if ($17f526922e4a857c$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$17f526922e4a857c$var$ja.call(b, e) || !$17f526922e4a857c$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $17f526922e4a857c$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $17f526922e4a857c$var$Ke(a, b) {
    var c = $17f526922e4a857c$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $17f526922e4a857c$var$Je(c);
    }
}
function $17f526922e4a857c$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $17f526922e4a857c$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $17f526922e4a857c$var$Me() {
    for(var a = window, b = $17f526922e4a857c$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $17f526922e4a857c$var$Xa(a.document);
    }
    return b;
}
function $17f526922e4a857c$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $17f526922e4a857c$var$Oe(a) {
    var b = $17f526922e4a857c$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $17f526922e4a857c$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $17f526922e4a857c$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $17f526922e4a857c$var$Ke(c, f);
                var g = $17f526922e4a857c$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $17f526922e4a857c$var$Pe = $17f526922e4a857c$var$ia && "documentMode" in document && 11 >= document.documentMode, $17f526922e4a857c$var$Qe = null, $17f526922e4a857c$var$Re = null, $17f526922e4a857c$var$Se = null, $17f526922e4a857c$var$Te = !1;
function $17f526922e4a857c$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $17f526922e4a857c$var$Te || null == $17f526922e4a857c$var$Qe || $17f526922e4a857c$var$Qe !== $17f526922e4a857c$var$Xa(d) || (d = $17f526922e4a857c$var$Qe, "selectionStart" in d && $17f526922e4a857c$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $17f526922e4a857c$var$Se && $17f526922e4a857c$var$Ie($17f526922e4a857c$var$Se, d) || ($17f526922e4a857c$var$Se = d, d = $17f526922e4a857c$var$oe($17f526922e4a857c$var$Re, "onSelect"), 0 < d.length && (b = new $17f526922e4a857c$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $17f526922e4a857c$var$Qe)));
}
function $17f526922e4a857c$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $17f526922e4a857c$var$We = {
    animationend: $17f526922e4a857c$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $17f526922e4a857c$var$Ve("Animation", "AnimationIteration"),
    animationstart: $17f526922e4a857c$var$Ve("Animation", "AnimationStart"),
    transitionend: $17f526922e4a857c$var$Ve("Transition", "TransitionEnd")
}, $17f526922e4a857c$var$Xe = {}, $17f526922e4a857c$var$Ye = {};
$17f526922e4a857c$var$ia && ($17f526922e4a857c$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $17f526922e4a857c$var$We.animationend.animation, delete $17f526922e4a857c$var$We.animationiteration.animation, delete $17f526922e4a857c$var$We.animationstart.animation), "TransitionEvent" in window || delete $17f526922e4a857c$var$We.transitionend.transition);
function $17f526922e4a857c$var$Ze(a) {
    if ($17f526922e4a857c$var$Xe[a]) return $17f526922e4a857c$var$Xe[a];
    if (!$17f526922e4a857c$var$We[a]) return a;
    var b = $17f526922e4a857c$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $17f526922e4a857c$var$Ye) return $17f526922e4a857c$var$Xe[a] = b[c];
    return a;
}
var $17f526922e4a857c$var$$e = $17f526922e4a857c$var$Ze("animationend"), $17f526922e4a857c$var$af = $17f526922e4a857c$var$Ze("animationiteration"), $17f526922e4a857c$var$bf = $17f526922e4a857c$var$Ze("animationstart"), $17f526922e4a857c$var$cf = $17f526922e4a857c$var$Ze("transitionend"), $17f526922e4a857c$var$df = new Map, $17f526922e4a857c$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $17f526922e4a857c$var$ff(a, b) {
    $17f526922e4a857c$var$df.set(a, b);
    $17f526922e4a857c$var$fa(b, [
        a
    ]);
}
for(var $17f526922e4a857c$var$gf = 0; $17f526922e4a857c$var$gf < $17f526922e4a857c$var$ef.length; $17f526922e4a857c$var$gf++){
    var $17f526922e4a857c$var$hf = $17f526922e4a857c$var$ef[$17f526922e4a857c$var$gf], $17f526922e4a857c$var$jf = $17f526922e4a857c$var$hf.toLowerCase(), $17f526922e4a857c$var$kf = $17f526922e4a857c$var$hf[0].toUpperCase() + $17f526922e4a857c$var$hf.slice(1);
    $17f526922e4a857c$var$ff($17f526922e4a857c$var$jf, "on" + $17f526922e4a857c$var$kf);
}
$17f526922e4a857c$var$ff($17f526922e4a857c$var$$e, "onAnimationEnd");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$af, "onAnimationIteration");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$bf, "onAnimationStart");
$17f526922e4a857c$var$ff("dblclick", "onDoubleClick");
$17f526922e4a857c$var$ff("focusin", "onFocus");
$17f526922e4a857c$var$ff("focusout", "onBlur");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$cf, "onTransitionEnd");
$17f526922e4a857c$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$17f526922e4a857c$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $17f526922e4a857c$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $17f526922e4a857c$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($17f526922e4a857c$var$lf));
function $17f526922e4a857c$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $17f526922e4a857c$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $17f526922e4a857c$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($17f526922e4a857c$var$Qb) throw a = $17f526922e4a857c$var$Rb, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, a;
}
function $17f526922e4a857c$var$D(a, b) {
    var c = b[$17f526922e4a857c$var$of];
    void 0 === c && (c = b[$17f526922e4a857c$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($17f526922e4a857c$var$pf(b, a, 2, !1), c.add(d));
}
function $17f526922e4a857c$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $17f526922e4a857c$var$pf(c, a, d, b);
}
var $17f526922e4a857c$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $17f526922e4a857c$var$sf(a) {
    if (!a[$17f526922e4a857c$var$rf]) {
        a[$17f526922e4a857c$var$rf] = !0;
        $17f526922e4a857c$var$da.forEach(function(b) {
            "selectionchange" !== b && ($17f526922e4a857c$var$mf.has(b) || $17f526922e4a857c$var$qf(b, !1, a), $17f526922e4a857c$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$17f526922e4a857c$var$rf] || (b[$17f526922e4a857c$var$rf] = !0, $17f526922e4a857c$var$qf("selectionchange", !1, b));
    }
}
function $17f526922e4a857c$var$pf(a, b, c, d) {
    switch($17f526922e4a857c$var$jd(b)){
        case 1:
            var e = $17f526922e4a857c$var$ed;
            break;
        case 4:
            e = $17f526922e4a857c$var$gd;
            break;
        default:
            e = $17f526922e4a857c$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$17f526922e4a857c$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $17f526922e4a857c$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $17f526922e4a857c$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $17f526922e4a857c$var$Jb(function() {
        var d = f, e = $17f526922e4a857c$var$xb(c), g = [];
        a: {
            var h = $17f526922e4a857c$var$df.get(a);
            if (void 0 !== h) {
                var k = $17f526922e4a857c$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $17f526922e4a857c$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $17f526922e4a857c$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $17f526922e4a857c$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $17f526922e4a857c$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $17f526922e4a857c$var$Vd;
                        break;
                    case $17f526922e4a857c$var$$e:
                    case $17f526922e4a857c$var$af:
                    case $17f526922e4a857c$var$bf:
                        k = $17f526922e4a857c$var$Hd;
                        break;
                    case $17f526922e4a857c$var$cf:
                        k = $17f526922e4a857c$var$Xd;
                        break;
                    case "scroll":
                        k = $17f526922e4a857c$var$vd;
                        break;
                    case "wheel":
                        k = $17f526922e4a857c$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $17f526922e4a857c$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $17f526922e4a857c$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $17f526922e4a857c$var$Kb(w, x), null != F && t.push($17f526922e4a857c$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $17f526922e4a857c$var$wb && (n = c.relatedTarget || c.fromElement) && ($17f526922e4a857c$var$Wc(n) || n[$17f526922e4a857c$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $17f526922e4a857c$var$Wc(n) : null, null !== n && (J = $17f526922e4a857c$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $17f526922e4a857c$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $17f526922e4a857c$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $17f526922e4a857c$var$ue(k);
                        u = null == n ? h : $17f526922e4a857c$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $17f526922e4a857c$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $17f526922e4a857c$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $17f526922e4a857c$var$vf(F))u++;
                            for(; 0 < w - u;)t = $17f526922e4a857c$var$vf(t), w--;
                            for(; 0 < u - w;)x = $17f526922e4a857c$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $17f526922e4a857c$var$vf(t);
                                x = $17f526922e4a857c$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $17f526922e4a857c$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $17f526922e4a857c$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $17f526922e4a857c$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $17f526922e4a857c$var$ve;
                else if ($17f526922e4a857c$var$me(h)) {
                    if ($17f526922e4a857c$var$we) na = $17f526922e4a857c$var$Fe;
                    else {
                        na = $17f526922e4a857c$var$De;
                        var xa = $17f526922e4a857c$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $17f526922e4a857c$var$Ee);
                if (na && (na = na(a, d))) {
                    $17f526922e4a857c$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $17f526922e4a857c$var$cb(h, "number", h.value);
            }
            xa = d ? $17f526922e4a857c$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($17f526922e4a857c$var$me(xa) || "true" === xa.contentEditable) $17f526922e4a857c$var$Qe = xa, $17f526922e4a857c$var$Re = d, $17f526922e4a857c$var$Se = null;
                    break;
                case "focusout":
                    $17f526922e4a857c$var$Se = $17f526922e4a857c$var$Re = $17f526922e4a857c$var$Qe = null;
                    break;
                case "mousedown":
                    $17f526922e4a857c$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $17f526922e4a857c$var$Te = !1;
                    $17f526922e4a857c$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($17f526922e4a857c$var$Pe) break;
                case "keydown":
                case "keyup":
                    $17f526922e4a857c$var$Ue(g, c, e);
            }
            var $a;
            if ($17f526922e4a857c$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $17f526922e4a857c$var$ie ? $17f526922e4a857c$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($17f526922e4a857c$var$de && "ko" !== c.locale && ($17f526922e4a857c$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $17f526922e4a857c$var$ie && ($a = $17f526922e4a857c$var$nd()) : ($17f526922e4a857c$var$kd = e, $17f526922e4a857c$var$ld = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, $17f526922e4a857c$var$ie = !0)), xa = $17f526922e4a857c$var$oe(d, ba), 0 < xa.length && (ba = new $17f526922e4a857c$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $17f526922e4a857c$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $17f526922e4a857c$var$ce ? $17f526922e4a857c$var$je(a, c) : $17f526922e4a857c$var$ke(a, c)) d = $17f526922e4a857c$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $17f526922e4a857c$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $17f526922e4a857c$var$se(g, b);
    });
}
function $17f526922e4a857c$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $17f526922e4a857c$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $17f526922e4a857c$var$Kb(a, c), null != f && d.unshift($17f526922e4a857c$var$tf(a, f, e)), f = $17f526922e4a857c$var$Kb(a, b), null != f && d.push($17f526922e4a857c$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $17f526922e4a857c$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $17f526922e4a857c$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.unshift($17f526922e4a857c$var$tf(c, k, h))) : e || (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.push($17f526922e4a857c$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $17f526922e4a857c$var$xf = /\r\n?/g, $17f526922e4a857c$var$yf = /\u0000|\uFFFD/g;
function $17f526922e4a857c$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($17f526922e4a857c$var$xf, "\n").replace($17f526922e4a857c$var$yf, "");
}
function $17f526922e4a857c$var$Af(a, b, c) {
    b = $17f526922e4a857c$var$zf(b);
    if ($17f526922e4a857c$var$zf(a) !== b && c) throw Error($17f526922e4a857c$var$p(425));
}
function $17f526922e4a857c$var$Bf() {}
var $17f526922e4a857c$var$Cf = null, $17f526922e4a857c$var$Df = null;
function $17f526922e4a857c$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $17f526922e4a857c$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $17f526922e4a857c$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $17f526922e4a857c$var$Hf = "function" === typeof Promise ? Promise : void 0, $17f526922e4a857c$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $17f526922e4a857c$var$Hf ? function(a) {
    return $17f526922e4a857c$var$Hf.resolve(null).then(a).catch($17f526922e4a857c$var$If);
} : $17f526922e4a857c$var$Ff;
function $17f526922e4a857c$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $17f526922e4a857c$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $17f526922e4a857c$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $17f526922e4a857c$var$bd(b);
}
function $17f526922e4a857c$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $17f526922e4a857c$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $17f526922e4a857c$var$Nf = Math.random().toString(36).slice(2), $17f526922e4a857c$var$Of = "__reactFiber$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Pf = "__reactProps$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$uf = "__reactContainer$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$of = "__reactEvents$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Qf = "__reactListeners$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Rf = "__reactHandles$" + $17f526922e4a857c$var$Nf;
function $17f526922e4a857c$var$Wc(a) {
    var b = a[$17f526922e4a857c$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$17f526922e4a857c$var$uf] || c[$17f526922e4a857c$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $17f526922e4a857c$var$Mf(a); null !== a;){
                if (c = a[$17f526922e4a857c$var$Of]) return c;
                a = $17f526922e4a857c$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $17f526922e4a857c$var$Cb(a) {
    a = a[$17f526922e4a857c$var$Of] || a[$17f526922e4a857c$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $17f526922e4a857c$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($17f526922e4a857c$var$p(33));
}
function $17f526922e4a857c$var$Db(a) {
    return a[$17f526922e4a857c$var$Pf] || null;
}
var $17f526922e4a857c$var$Sf = [], $17f526922e4a857c$var$Tf = -1;
function $17f526922e4a857c$var$Uf(a) {
    return {
        current: a
    };
}
function $17f526922e4a857c$var$E(a) {
    0 > $17f526922e4a857c$var$Tf || (a.current = $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf], $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = null, $17f526922e4a857c$var$Tf--);
}
function $17f526922e4a857c$var$G(a, b) {
    $17f526922e4a857c$var$Tf++;
    $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = a.current;
    a.current = b;
}
var $17f526922e4a857c$var$Vf = {}, $17f526922e4a857c$var$H = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$Vf), $17f526922e4a857c$var$Wf = $17f526922e4a857c$var$Uf(!1), $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$Vf;
function $17f526922e4a857c$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $17f526922e4a857c$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $17f526922e4a857c$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $17f526922e4a857c$var$$f() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
}
function $17f526922e4a857c$var$ag(a, b, c) {
    if ($17f526922e4a857c$var$H.current !== $17f526922e4a857c$var$Vf) throw Error($17f526922e4a857c$var$p(168));
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
function $17f526922e4a857c$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($17f526922e4a857c$var$p(108, $17f526922e4a857c$var$Ra(a) || "Unknown", e));
    return $17f526922e4a857c$var$A({}, c, d);
}
function $17f526922e4a857c$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $17f526922e4a857c$var$Vf;
    $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$H.current;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, $17f526922e4a857c$var$Wf.current);
    return !0;
}
function $17f526922e4a857c$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($17f526922e4a857c$var$p(169));
    c ? (a = $17f526922e4a857c$var$bg(a, b, $17f526922e4a857c$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a)) : $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
var $17f526922e4a857c$var$eg = null, $17f526922e4a857c$var$fg = !1, $17f526922e4a857c$var$gg = !1;
function $17f526922e4a857c$var$hg(a) {
    null === $17f526922e4a857c$var$eg ? $17f526922e4a857c$var$eg = [
        a
    ] : $17f526922e4a857c$var$eg.push(a);
}
function $17f526922e4a857c$var$ig(a) {
    $17f526922e4a857c$var$fg = !0;
    $17f526922e4a857c$var$hg(a);
}
function $17f526922e4a857c$var$jg() {
    if (!$17f526922e4a857c$var$gg && null !== $17f526922e4a857c$var$eg) {
        $17f526922e4a857c$var$gg = !0;
        var a = 0, b = $17f526922e4a857c$var$C;
        try {
            var c = $17f526922e4a857c$var$eg;
            for($17f526922e4a857c$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $17f526922e4a857c$var$eg = null;
            $17f526922e4a857c$var$fg = !1;
        } catch (e) {
            throw null !== $17f526922e4a857c$var$eg && ($17f526922e4a857c$var$eg = $17f526922e4a857c$var$eg.slice(a + 1)), $17f526922e4a857c$var$ac($17f526922e4a857c$var$fc, $17f526922e4a857c$var$jg), e;
        } finally{
            $17f526922e4a857c$var$C = b, $17f526922e4a857c$var$gg = !1;
        }
    }
    return null;
}
var $17f526922e4a857c$var$kg = [], $17f526922e4a857c$var$lg = 0, $17f526922e4a857c$var$mg = null, $17f526922e4a857c$var$ng = 0, $17f526922e4a857c$var$og = [], $17f526922e4a857c$var$pg = 0, $17f526922e4a857c$var$qg = null, $17f526922e4a857c$var$rg = 1, $17f526922e4a857c$var$sg = "";
function $17f526922e4a857c$var$tg(a, b) {
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$ng;
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$mg;
    $17f526922e4a857c$var$mg = a;
    $17f526922e4a857c$var$ng = b;
}
function $17f526922e4a857c$var$ug(a, b, c) {
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg;
    $17f526922e4a857c$var$qg = a;
    var d = $17f526922e4a857c$var$rg;
    a = $17f526922e4a857c$var$sg;
    var e = 32 - $17f526922e4a857c$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $17f526922e4a857c$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $17f526922e4a857c$var$rg = 1 << 32 - $17f526922e4a857c$var$oc(b) + e | c << e | d;
        $17f526922e4a857c$var$sg = f + a;
    } else $17f526922e4a857c$var$rg = 1 << f | c << e | d, $17f526922e4a857c$var$sg = a;
}
function $17f526922e4a857c$var$vg(a) {
    null !== a.return && ($17f526922e4a857c$var$tg(a, 1), $17f526922e4a857c$var$ug(a, 1, 0));
}
function $17f526922e4a857c$var$wg(a) {
    for(; a === $17f526922e4a857c$var$mg;)$17f526922e4a857c$var$mg = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null, $17f526922e4a857c$var$ng = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null;
    for(; a === $17f526922e4a857c$var$qg;)$17f526922e4a857c$var$qg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$sg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$rg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null;
}
var $17f526922e4a857c$var$xg = null, $17f526922e4a857c$var$yg = null, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$zg = null;
function $17f526922e4a857c$var$Ag(a, b) {
    var c = $17f526922e4a857c$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $17f526922e4a857c$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $17f526922e4a857c$var$qg ? {
                id: $17f526922e4a857c$var$rg,
                overflow: $17f526922e4a857c$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $17f526922e4a857c$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $17f526922e4a857c$var$Eg(a) {
    if ($17f526922e4a857c$var$I) {
        var b = $17f526922e4a857c$var$yg;
        if (b) {
            var c = b;
            if (!$17f526922e4a857c$var$Cg(a, b)) {
                if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
                b = $17f526922e4a857c$var$Lf(c.nextSibling);
                var d = $17f526922e4a857c$var$xg;
                b && $17f526922e4a857c$var$Cg(a, b) ? $17f526922e4a857c$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$xg = a);
            }
        } else {
            if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $17f526922e4a857c$var$I = !1;
            $17f526922e4a857c$var$xg = a;
        }
    }
}
function $17f526922e4a857c$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $17f526922e4a857c$var$xg = a;
}
function $17f526922e4a857c$var$Gg(a) {
    if (a !== $17f526922e4a857c$var$xg) return !1;
    if (!$17f526922e4a857c$var$I) return $17f526922e4a857c$var$Fg(a), $17f526922e4a857c$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$17f526922e4a857c$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $17f526922e4a857c$var$yg)) {
        if ($17f526922e4a857c$var$Dg(a)) throw $17f526922e4a857c$var$Hg(), Error($17f526922e4a857c$var$p(418));
        for(; b;)$17f526922e4a857c$var$Ag(a, b), b = $17f526922e4a857c$var$Lf(b.nextSibling);
    }
    $17f526922e4a857c$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($17f526922e4a857c$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $17f526922e4a857c$var$yg = null;
        }
    } else $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg ? $17f526922e4a857c$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $17f526922e4a857c$var$Hg() {
    for(var a = $17f526922e4a857c$var$yg; a;)a = $17f526922e4a857c$var$Lf(a.nextSibling);
}
function $17f526922e4a857c$var$Ig() {
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg = null;
    $17f526922e4a857c$var$I = !1;
}
function $17f526922e4a857c$var$Jg(a) {
    null === $17f526922e4a857c$var$zg ? $17f526922e4a857c$var$zg = [
        a
    ] : $17f526922e4a857c$var$zg.push(a);
}
var $17f526922e4a857c$var$Kg = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig;
function $17f526922e4a857c$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($17f526922e4a857c$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($17f526922e4a857c$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($17f526922e4a857c$var$p(284));
        if (!c._owner) throw Error($17f526922e4a857c$var$p(290, a));
    }
    return a;
}
function $17f526922e4a857c$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($17f526922e4a857c$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $17f526922e4a857c$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $17f526922e4a857c$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $17f526922e4a857c$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $17f526922e4a857c$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $17f526922e4a857c$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $17f526922e4a857c$var$Lg(a, b, c), d.return = a, d;
        d = $17f526922e4a857c$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $17f526922e4a857c$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $17f526922e4a857c$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $17f526922e4a857c$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $17f526922e4a857c$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c = $17f526922e4a857c$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $17f526922e4a857c$var$Lg(a, null, b), c.return = a, c;
                case $17f526922e4a857c$var$wa:
                    return b = $17f526922e4a857c$var$Sg(b, a.mode, c), b.return = a, b;
                case $17f526922e4a857c$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($17f526922e4a857c$var$eb(b) || $17f526922e4a857c$var$Ka(b)) return b = $17f526922e4a857c$var$Tg(b, a.mode, c, null), b.return = a, b;
            $17f526922e4a857c$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $17f526922e4a857c$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $17f526922e4a857c$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($17f526922e4a857c$var$eb(c) || $17f526922e4a857c$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $17f526922e4a857c$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $17f526922e4a857c$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $17f526922e4a857c$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $17f526922e4a857c$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($17f526922e4a857c$var$eb(d) || $17f526922e4a857c$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $17f526922e4a857c$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $17f526922e4a857c$var$Ka(h);
        if ("function" !== typeof l) throw Error($17f526922e4a857c$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($17f526922e4a857c$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $17f526922e4a857c$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $17f526922e4a857c$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $17f526922e4a857c$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $17f526922e4a857c$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $17f526922e4a857c$var$ya ? (d = $17f526922e4a857c$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $17f526922e4a857c$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $17f526922e4a857c$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $17f526922e4a857c$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $17f526922e4a857c$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $17f526922e4a857c$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($17f526922e4a857c$var$eb(f)) return n(a, d, f, h);
            if ($17f526922e4a857c$var$Ka(f)) return t(a, d, f, h);
            $17f526922e4a857c$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $17f526922e4a857c$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $17f526922e4a857c$var$Ug = $17f526922e4a857c$var$Og(!0), $17f526922e4a857c$var$Vg = $17f526922e4a857c$var$Og(!1), $17f526922e4a857c$var$Wg = $17f526922e4a857c$var$Uf(null), $17f526922e4a857c$var$Xg = null, $17f526922e4a857c$var$Yg = null, $17f526922e4a857c$var$Zg = null;
function $17f526922e4a857c$var$$g() {
    $17f526922e4a857c$var$Zg = $17f526922e4a857c$var$Yg = $17f526922e4a857c$var$Xg = null;
}
function $17f526922e4a857c$var$ah(a) {
    var b = $17f526922e4a857c$var$Wg.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wg);
    a._currentValue = b;
}
function $17f526922e4a857c$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $17f526922e4a857c$var$ch(a, b) {
    $17f526922e4a857c$var$Xg = a;
    $17f526922e4a857c$var$Zg = $17f526922e4a857c$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($17f526922e4a857c$var$dh = !0), a.firstContext = null);
}
function $17f526922e4a857c$var$eh(a) {
    var b = a._currentValue;
    if ($17f526922e4a857c$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $17f526922e4a857c$var$Yg) {
            if (null === $17f526922e4a857c$var$Xg) throw Error($17f526922e4a857c$var$p(308));
            $17f526922e4a857c$var$Yg = a;
            $17f526922e4a857c$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $17f526922e4a857c$var$Yg = $17f526922e4a857c$var$Yg.next = a;
    }
    return b;
}
var $17f526922e4a857c$var$fh = null;
function $17f526922e4a857c$var$gh(a) {
    null === $17f526922e4a857c$var$fh ? $17f526922e4a857c$var$fh = [
        a
    ] : $17f526922e4a857c$var$fh.push(a);
}
function $17f526922e4a857c$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $17f526922e4a857c$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $17f526922e4a857c$var$ih(a, d);
}
function $17f526922e4a857c$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $17f526922e4a857c$var$jh = !1;
function $17f526922e4a857c$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $17f526922e4a857c$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $17f526922e4a857c$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $17f526922e4a857c$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($17f526922e4a857c$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $17f526922e4a857c$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $17f526922e4a857c$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $17f526922e4a857c$var$ih(a, c);
}
function $17f526922e4a857c$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
function $17f526922e4a857c$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $17f526922e4a857c$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $17f526922e4a857c$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $17f526922e4a857c$var$A({}, q, r);
                            break a;
                        case 2:
                            $17f526922e4a857c$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $17f526922e4a857c$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $17f526922e4a857c$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($17f526922e4a857c$var$p(191, e));
            e.call(d);
        }
    }
}
var $17f526922e4a857c$var$th = {}, $17f526922e4a857c$var$uh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th), $17f526922e4a857c$var$vh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th), $17f526922e4a857c$var$wh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th);
function $17f526922e4a857c$var$xh(a) {
    if (a === $17f526922e4a857c$var$th) throw Error($17f526922e4a857c$var$p(174));
    return a;
}
function $17f526922e4a857c$var$yh(a, b) {
    $17f526922e4a857c$var$G($17f526922e4a857c$var$wh, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$vh, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, $17f526922e4a857c$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $17f526922e4a857c$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $17f526922e4a857c$var$lb(b, a);
    }
    $17f526922e4a857c$var$E($17f526922e4a857c$var$uh);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, b);
}
function $17f526922e4a857c$var$zh() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$uh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$vh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$wh);
}
function $17f526922e4a857c$var$Ah(a) {
    $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
    var b = $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
    var c = $17f526922e4a857c$var$lb(b, a.type);
    b !== c && ($17f526922e4a857c$var$G($17f526922e4a857c$var$vh, a), $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, c));
}
function $17f526922e4a857c$var$Bh(a) {
    $17f526922e4a857c$var$vh.current === a && ($17f526922e4a857c$var$E($17f526922e4a857c$var$uh), $17f526922e4a857c$var$E($17f526922e4a857c$var$vh));
}
var $17f526922e4a857c$var$L = $17f526922e4a857c$var$Uf(0);
function $17f526922e4a857c$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$Dh = [];
function $17f526922e4a857c$var$Eh() {
    for(var a = 0; a < $17f526922e4a857c$var$Dh.length; a++)$17f526922e4a857c$var$Dh[a]._workInProgressVersionPrimary = null;
    $17f526922e4a857c$var$Dh.length = 0;
}
var $17f526922e4a857c$var$Fh = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$Gh = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$Hh = 0, $17f526922e4a857c$var$M = null, $17f526922e4a857c$var$N = null, $17f526922e4a857c$var$O = null, $17f526922e4a857c$var$Ih = !1, $17f526922e4a857c$var$Jh = !1, $17f526922e4a857c$var$Kh = 0, $17f526922e4a857c$var$Lh = 0;
function $17f526922e4a857c$var$P() {
    throw Error($17f526922e4a857c$var$p(321));
}
function $17f526922e4a857c$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$17f526922e4a857c$var$He(a[c], b[c])) return !1;
    return !0;
}
function $17f526922e4a857c$var$Nh(a, b, c, d, e, f) {
    $17f526922e4a857c$var$Hh = f;
    $17f526922e4a857c$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $17f526922e4a857c$var$Fh.current = null === a || null === a.memoizedState ? $17f526922e4a857c$var$Oh : $17f526922e4a857c$var$Ph;
    a = c(d, e);
    if ($17f526922e4a857c$var$Jh) {
        f = 0;
        do {
            $17f526922e4a857c$var$Jh = !1;
            $17f526922e4a857c$var$Kh = 0;
            if (25 <= f) throw Error($17f526922e4a857c$var$p(301));
            f += 1;
            $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = null;
            b.updateQueue = null;
            $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Qh;
            a = c(d, e);
        }while ($17f526922e4a857c$var$Jh);
    }
    $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Rh;
    b = null !== $17f526922e4a857c$var$N && null !== $17f526922e4a857c$var$N.next;
    $17f526922e4a857c$var$Hh = 0;
    $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = $17f526922e4a857c$var$M = null;
    $17f526922e4a857c$var$Ih = !1;
    if (b) throw Error($17f526922e4a857c$var$p(300));
    return a;
}
function $17f526922e4a857c$var$Sh() {
    var a = 0 !== $17f526922e4a857c$var$Kh;
    $17f526922e4a857c$var$Kh = 0;
    return a;
}
function $17f526922e4a857c$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState = $17f526922e4a857c$var$O = a : $17f526922e4a857c$var$O = $17f526922e4a857c$var$O.next = a;
    return $17f526922e4a857c$var$O;
}
function $17f526922e4a857c$var$Uh() {
    if (null === $17f526922e4a857c$var$N) {
        var a = $17f526922e4a857c$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $17f526922e4a857c$var$N.next;
    var b = null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState : $17f526922e4a857c$var$O.next;
    if (null !== b) $17f526922e4a857c$var$O = b, $17f526922e4a857c$var$N = a;
    else {
        if (null === a) throw Error($17f526922e4a857c$var$p(310));
        $17f526922e4a857c$var$N = a;
        a = {
            memoizedState: $17f526922e4a857c$var$N.memoizedState,
            baseState: $17f526922e4a857c$var$N.baseState,
            baseQueue: $17f526922e4a857c$var$N.baseQueue,
            queue: $17f526922e4a857c$var$N.queue,
            next: null
        };
        null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState = $17f526922e4a857c$var$O = a : $17f526922e4a857c$var$O = $17f526922e4a857c$var$O.next = a;
    }
    return $17f526922e4a857c$var$O;
}
function $17f526922e4a857c$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $17f526922e4a857c$var$Wh(a) {
    var b = $17f526922e4a857c$var$Uh(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = $17f526922e4a857c$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($17f526922e4a857c$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $17f526922e4a857c$var$M.lanes |= m;
                $17f526922e4a857c$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $17f526922e4a857c$var$He(d, b.memoizedState) || ($17f526922e4a857c$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $17f526922e4a857c$var$M.lanes |= f, $17f526922e4a857c$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $17f526922e4a857c$var$Xh(a) {
    var b = $17f526922e4a857c$var$Uh(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $17f526922e4a857c$var$He(f, b.memoizedState) || ($17f526922e4a857c$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $17f526922e4a857c$var$Yh() {}
function $17f526922e4a857c$var$Zh(a, b) {
    var c = $17f526922e4a857c$var$M, d = $17f526922e4a857c$var$Uh(), e = b(), f = !$17f526922e4a857c$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $17f526922e4a857c$var$dh = !0);
    d = d.queue;
    $17f526922e4a857c$var$$h($17f526922e4a857c$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $17f526922e4a857c$var$O && $17f526922e4a857c$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $17f526922e4a857c$var$bi(9, $17f526922e4a857c$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $17f526922e4a857c$var$Q) throw Error($17f526922e4a857c$var$p(349));
        0 !== ($17f526922e4a857c$var$Hh & 30) || $17f526922e4a857c$var$di(c, b, e);
    }
    return e;
}
function $17f526922e4a857c$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $17f526922e4a857c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $17f526922e4a857c$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $17f526922e4a857c$var$ei(b) && $17f526922e4a857c$var$fi(a);
}
function $17f526922e4a857c$var$ai(a, b, c) {
    return c(function() {
        $17f526922e4a857c$var$ei(b) && $17f526922e4a857c$var$fi(a);
    });
}
function $17f526922e4a857c$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$17f526922e4a857c$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $17f526922e4a857c$var$fi(a) {
    var b = $17f526922e4a857c$var$ih(a, 1);
    null !== b && $17f526922e4a857c$var$gi(b, a, 1, -1);
}
function $17f526922e4a857c$var$hi(a) {
    var b = $17f526922e4a857c$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $17f526922e4a857c$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $17f526922e4a857c$var$ii.bind(null, $17f526922e4a857c$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $17f526922e4a857c$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $17f526922e4a857c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $17f526922e4a857c$var$ji() {
    return $17f526922e4a857c$var$Uh().memoizedState;
}
function $17f526922e4a857c$var$ki(a, b, c, d) {
    var e = $17f526922e4a857c$var$Th();
    $17f526922e4a857c$var$M.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $17f526922e4a857c$var$li(a, b, c, d) {
    var e = $17f526922e4a857c$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $17f526922e4a857c$var$N) {
        var g = $17f526922e4a857c$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $17f526922e4a857c$var$Mh(d, g.deps)) {
            e.memoizedState = $17f526922e4a857c$var$bi(b, c, f, d);
            return;
        }
    }
    $17f526922e4a857c$var$M.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$bi(1 | b, c, f, d);
}
function $17f526922e4a857c$var$mi(a, b) {
    return $17f526922e4a857c$var$ki(8390656, 8, a, b);
}
function $17f526922e4a857c$var$$h(a, b) {
    return $17f526922e4a857c$var$li(2048, 8, a, b);
}
function $17f526922e4a857c$var$ni(a, b) {
    return $17f526922e4a857c$var$li(4, 2, a, b);
}
function $17f526922e4a857c$var$oi(a, b) {
    return $17f526922e4a857c$var$li(4, 4, a, b);
}
function $17f526922e4a857c$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $17f526922e4a857c$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $17f526922e4a857c$var$li(4, 4, $17f526922e4a857c$var$pi.bind(null, b, a), c);
}
function $17f526922e4a857c$var$ri() {}
function $17f526922e4a857c$var$si(a, b) {
    var c = $17f526922e4a857c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$ti(a, b) {
    var c = $17f526922e4a857c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$ui(a, b, c) {
    if (0 === ($17f526922e4a857c$var$Hh & 21)) return a.baseState && (a.baseState = !1, $17f526922e4a857c$var$dh = !0), a.memoizedState = c;
    $17f526922e4a857c$var$He(c, b) || (c = $17f526922e4a857c$var$yc(), $17f526922e4a857c$var$M.lanes |= c, $17f526922e4a857c$var$rh |= c, a.baseState = !0);
    return b;
}
function $17f526922e4a857c$var$vi(a, b) {
    var c = $17f526922e4a857c$var$C;
    $17f526922e4a857c$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $17f526922e4a857c$var$Gh.transition;
    $17f526922e4a857c$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$Gh.transition = d;
    }
}
function $17f526922e4a857c$var$wi() {
    return $17f526922e4a857c$var$Uh().memoizedState;
}
function $17f526922e4a857c$var$xi(a, b, c) {
    var d = $17f526922e4a857c$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$zi(a)) $17f526922e4a857c$var$Ai(b, c);
    else if (c = $17f526922e4a857c$var$hh(a, b, c, d), null !== c) {
        var e = $17f526922e4a857c$var$R();
        $17f526922e4a857c$var$gi(c, a, d, e);
        $17f526922e4a857c$var$Bi(c, b, d);
    }
}
function $17f526922e4a857c$var$ii(a, b, c) {
    var d = $17f526922e4a857c$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$zi(a)) $17f526922e4a857c$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($17f526922e4a857c$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $17f526922e4a857c$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $17f526922e4a857c$var$hh(a, b, e, d);
        null !== c && (e = $17f526922e4a857c$var$R(), $17f526922e4a857c$var$gi(c, a, d, e), $17f526922e4a857c$var$Bi(c, b, d));
    }
}
function $17f526922e4a857c$var$zi(a) {
    var b = a.alternate;
    return a === $17f526922e4a857c$var$M || null !== b && b === $17f526922e4a857c$var$M;
}
function $17f526922e4a857c$var$Ai(a, b) {
    $17f526922e4a857c$var$Jh = $17f526922e4a857c$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $17f526922e4a857c$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
var $17f526922e4a857c$var$Rh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$P,
    useContext: $17f526922e4a857c$var$P,
    useEffect: $17f526922e4a857c$var$P,
    useImperativeHandle: $17f526922e4a857c$var$P,
    useInsertionEffect: $17f526922e4a857c$var$P,
    useLayoutEffect: $17f526922e4a857c$var$P,
    useMemo: $17f526922e4a857c$var$P,
    useReducer: $17f526922e4a857c$var$P,
    useRef: $17f526922e4a857c$var$P,
    useState: $17f526922e4a857c$var$P,
    useDebugValue: $17f526922e4a857c$var$P,
    useDeferredValue: $17f526922e4a857c$var$P,
    useTransition: $17f526922e4a857c$var$P,
    useMutableSource: $17f526922e4a857c$var$P,
    useSyncExternalStore: $17f526922e4a857c$var$P,
    useId: $17f526922e4a857c$var$P,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Oh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: function(a, b) {
        $17f526922e4a857c$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $17f526922e4a857c$var$ki(4194308, 4, $17f526922e4a857c$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $17f526922e4a857c$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $17f526922e4a857c$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $17f526922e4a857c$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $17f526922e4a857c$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $17f526922e4a857c$var$xi.bind(null, $17f526922e4a857c$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $17f526922e4a857c$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $17f526922e4a857c$var$hi,
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        return $17f526922e4a857c$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$hi(!1), b = a[0];
        a = $17f526922e4a857c$var$vi.bind(null, a[1]);
        $17f526922e4a857c$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $17f526922e4a857c$var$M, e = $17f526922e4a857c$var$Th();
        if ($17f526922e4a857c$var$I) {
            if (void 0 === c) throw Error($17f526922e4a857c$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $17f526922e4a857c$var$Q) throw Error($17f526922e4a857c$var$p(349));
            0 !== ($17f526922e4a857c$var$Hh & 30) || $17f526922e4a857c$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $17f526922e4a857c$var$mi($17f526922e4a857c$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $17f526922e4a857c$var$bi(9, $17f526922e4a857c$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $17f526922e4a857c$var$Th(), b = $17f526922e4a857c$var$Q.identifierPrefix;
        if ($17f526922e4a857c$var$I) {
            var c = $17f526922e4a857c$var$sg;
            var d = $17f526922e4a857c$var$rg;
            c = (d & ~(1 << 32 - $17f526922e4a857c$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $17f526922e4a857c$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $17f526922e4a857c$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Ph = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$si,
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$$h,
    useImperativeHandle: $17f526922e4a857c$var$qi,
    useInsertionEffect: $17f526922e4a857c$var$ni,
    useLayoutEffect: $17f526922e4a857c$var$oi,
    useMemo: $17f526922e4a857c$var$ti,
    useReducer: $17f526922e4a857c$var$Wh,
    useRef: $17f526922e4a857c$var$ji,
    useState: function() {
        return $17f526922e4a857c$var$Wh($17f526922e4a857c$var$Vh);
    },
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$Uh();
        return $17f526922e4a857c$var$ui(b, $17f526922e4a857c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$Wh($17f526922e4a857c$var$Vh)[0], b = $17f526922e4a857c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$Yh,
    useSyncExternalStore: $17f526922e4a857c$var$Zh,
    useId: $17f526922e4a857c$var$wi,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Qh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$si,
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$$h,
    useImperativeHandle: $17f526922e4a857c$var$qi,
    useInsertionEffect: $17f526922e4a857c$var$ni,
    useLayoutEffect: $17f526922e4a857c$var$oi,
    useMemo: $17f526922e4a857c$var$ti,
    useReducer: $17f526922e4a857c$var$Xh,
    useRef: $17f526922e4a857c$var$ji,
    useState: function() {
        return $17f526922e4a857c$var$Xh($17f526922e4a857c$var$Vh);
    },
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$Uh();
        return null === $17f526922e4a857c$var$N ? b.memoizedState = a : $17f526922e4a857c$var$ui(b, $17f526922e4a857c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$Xh($17f526922e4a857c$var$Vh)[0], b = $17f526922e4a857c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$Yh,
    useSyncExternalStore: $17f526922e4a857c$var$Zh,
    useId: $17f526922e4a857c$var$wi,
    unstable_isNewReconciler: !1
};
function $17f526922e4a857c$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $17f526922e4a857c$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $17f526922e4a857c$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $17f526922e4a857c$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $17f526922e4a857c$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $17f526922e4a857c$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$R(), e = $17f526922e4a857c$var$yi(a), f = $17f526922e4a857c$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$nh(a, f, e);
        null !== b && ($17f526922e4a857c$var$gi(b, a, e, d), $17f526922e4a857c$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$R(), e = $17f526922e4a857c$var$yi(a), f = $17f526922e4a857c$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$nh(a, f, e);
        null !== b && ($17f526922e4a857c$var$gi(b, a, e, d), $17f526922e4a857c$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $17f526922e4a857c$var$R(), d = $17f526922e4a857c$var$yi(a), e = $17f526922e4a857c$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $17f526922e4a857c$var$nh(a, e, d);
        null !== b && ($17f526922e4a857c$var$gi(b, a, d, c), $17f526922e4a857c$var$oh(b, a, d));
    }
};
function $17f526922e4a857c$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$17f526922e4a857c$var$Ie(c, d) || !$17f526922e4a857c$var$Ie(e, f) : !0;
}
function $17f526922e4a857c$var$Gi(a, b, c) {
    var d = !1, e = $17f526922e4a857c$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $17f526922e4a857c$var$eh(f) : (e = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $17f526922e4a857c$var$Yf(a, e) : $17f526922e4a857c$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $17f526922e4a857c$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $17f526922e4a857c$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $17f526922e4a857c$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $17f526922e4a857c$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $17f526922e4a857c$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $17f526922e4a857c$var$eh(f) : (f = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, e.context = $17f526922e4a857c$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($17f526922e4a857c$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $17f526922e4a857c$var$Ei.enqueueReplaceState(e, e.state, null), $17f526922e4a857c$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $17f526922e4a857c$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $17f526922e4a857c$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $17f526922e4a857c$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $17f526922e4a857c$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $17f526922e4a857c$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $17f526922e4a857c$var$Ni(a, b, c) {
    c = $17f526922e4a857c$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $17f526922e4a857c$var$Oi || ($17f526922e4a857c$var$Oi = !0, $17f526922e4a857c$var$Pi = d);
        $17f526922e4a857c$var$Li(a, b);
    };
    return c;
}
function $17f526922e4a857c$var$Qi(a, b, c) {
    c = $17f526922e4a857c$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $17f526922e4a857c$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $17f526922e4a857c$var$Li(a, b);
        "function" !== typeof d && (null === $17f526922e4a857c$var$Ri ? $17f526922e4a857c$var$Ri = new Set([
            this
        ]) : $17f526922e4a857c$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $17f526922e4a857c$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $17f526922e4a857c$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $17f526922e4a857c$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $17f526922e4a857c$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $17f526922e4a857c$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $17f526922e4a857c$var$mh(-1, 1), b.tag = 2, $17f526922e4a857c$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $17f526922e4a857c$var$Wi = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$dh = !1;
function $17f526922e4a857c$var$Xi(a, b, c, d) {
    b.child = null === a ? $17f526922e4a857c$var$Vg(b, null, c, d) : $17f526922e4a857c$var$Ug(b, a.child, c, d);
}
function $17f526922e4a857c$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $17f526922e4a857c$var$ch(b, e);
    d = $17f526922e4a857c$var$Nh(a, b, c, d, f, e);
    c = $17f526922e4a857c$var$Sh();
    if (null !== a && !$17f526922e4a857c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$Zi(a, b, e);
    $17f526922e4a857c$var$I && c && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Xi(a, b, d, e);
    return b.child;
}
function $17f526922e4a857c$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$17f526922e4a857c$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $17f526922e4a857c$var$bj(a, b, f, d, e);
        a = $17f526922e4a857c$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $17f526922e4a857c$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $17f526922e4a857c$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $17f526922e4a857c$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $17f526922e4a857c$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($17f526922e4a857c$var$Ie(f, d) && a.ref === b.ref) {
            if ($17f526922e4a857c$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($17f526922e4a857c$var$dh = !0);
            else return b.lanes = a.lanes, $17f526922e4a857c$var$Zi(a, b, e);
        }
    }
    return $17f526922e4a857c$var$cj(a, b, c, d, e);
}
function $17f526922e4a857c$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj);
            $17f526922e4a857c$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= d;
    $17f526922e4a857c$var$Xi(a, b, e, c);
    return b.child;
}
function $17f526922e4a857c$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $17f526922e4a857c$var$cj(a, b, c, d, e) {
    var f = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current;
    f = $17f526922e4a857c$var$Yf(b, f);
    $17f526922e4a857c$var$ch(b, e);
    c = $17f526922e4a857c$var$Nh(a, b, c, d, f, e);
    d = $17f526922e4a857c$var$Sh();
    if (null !== a && !$17f526922e4a857c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$Zi(a, b, e);
    $17f526922e4a857c$var$I && d && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Xi(a, b, c, e);
    return b.child;
}
function $17f526922e4a857c$var$hj(a, b, c, d, e) {
    if ($17f526922e4a857c$var$Zf(c)) {
        var f = !0;
        $17f526922e4a857c$var$cg(b);
    } else f = !1;
    $17f526922e4a857c$var$ch(b, e);
    if (null === b.stateNode) $17f526922e4a857c$var$ij(a, b), $17f526922e4a857c$var$Gi(b, c, d), $17f526922e4a857c$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $17f526922e4a857c$var$eh(l) : (l = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, l = $17f526922e4a857c$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $17f526922e4a857c$var$Hi(b, g, d, l);
        $17f526922e4a857c$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$jh ? ("function" === typeof m && ($17f526922e4a857c$var$Di(b, c, m, d), k = b.memoizedState), (h = $17f526922e4a857c$var$jh || $17f526922e4a857c$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $17f526922e4a857c$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $17f526922e4a857c$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $17f526922e4a857c$var$eh(k) : (k = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, k = $17f526922e4a857c$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $17f526922e4a857c$var$Hi(b, g, d, k);
        $17f526922e4a857c$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$jh ? ("function" === typeof y && ($17f526922e4a857c$var$Di(b, c, y, d), n = b.memoizedState), (l = $17f526922e4a857c$var$jh || $17f526922e4a857c$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $17f526922e4a857c$var$jj(a, b, c, d, f, e);
}
function $17f526922e4a857c$var$jj(a, b, c, d, e, f) {
    $17f526922e4a857c$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $17f526922e4a857c$var$dg(b, c, !1), $17f526922e4a857c$var$Zi(a, b, f);
    d = b.stateNode;
    $17f526922e4a857c$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $17f526922e4a857c$var$Ug(b, a.child, null, f), b.child = $17f526922e4a857c$var$Ug(b, null, h, f)) : $17f526922e4a857c$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $17f526922e4a857c$var$dg(b, c, !0);
    return b.child;
}
function $17f526922e4a857c$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $17f526922e4a857c$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $17f526922e4a857c$var$ag(a, b.context, !1);
    $17f526922e4a857c$var$yh(a, b.containerInfo);
}
function $17f526922e4a857c$var$lj(a, b, c, d, e) {
    $17f526922e4a857c$var$Ig();
    $17f526922e4a857c$var$Jg(e);
    b.flags |= 256;
    $17f526922e4a857c$var$Xi(a, b, c, d);
    return b.child;
}
var $17f526922e4a857c$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $17f526922e4a857c$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $17f526922e4a857c$var$oj(a, b, c) {
    var d = b.pendingProps, e = $17f526922e4a857c$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$L, e & 1);
    if (null === a) {
        $17f526922e4a857c$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $17f526922e4a857c$var$pj(g, d, 0, null), a = $17f526922e4a857c$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $17f526922e4a857c$var$nj(c), b.memoizedState = $17f526922e4a857c$var$mj, a) : $17f526922e4a857c$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $17f526922e4a857c$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $17f526922e4a857c$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $17f526922e4a857c$var$Pg(h, f) : (f = $17f526922e4a857c$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $17f526922e4a857c$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $17f526922e4a857c$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $17f526922e4a857c$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $17f526922e4a857c$var$qj(a, b) {
    b = $17f526922e4a857c$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $17f526922e4a857c$var$sj(a, b, c, d) {
    null !== d && $17f526922e4a857c$var$Jg(d);
    $17f526922e4a857c$var$Ug(b, a.child, null, c);
    a = $17f526922e4a857c$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $17f526922e4a857c$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(422))), $17f526922e4a857c$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $17f526922e4a857c$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $17f526922e4a857c$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $17f526922e4a857c$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $17f526922e4a857c$var$nj(g);
        b.memoizedState = $17f526922e4a857c$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $17f526922e4a857c$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($17f526922e4a857c$var$p(419));
        d = $17f526922e4a857c$var$Ki(f, d, void 0);
        return $17f526922e4a857c$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($17f526922e4a857c$var$dh || h) {
        d = $17f526922e4a857c$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $17f526922e4a857c$var$ih(a, e), $17f526922e4a857c$var$gi(d, a, e, -1));
        }
        $17f526922e4a857c$var$tj();
        d = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(421)));
        return $17f526922e4a857c$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $17f526922e4a857c$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(e.nextSibling);
    $17f526922e4a857c$var$xg = b;
    $17f526922e4a857c$var$I = !0;
    $17f526922e4a857c$var$zg = null;
    null !== a && ($17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg, $17f526922e4a857c$var$rg = a.id, $17f526922e4a857c$var$sg = a.overflow, $17f526922e4a857c$var$qg = b);
    b = $17f526922e4a857c$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $17f526922e4a857c$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $17f526922e4a857c$var$bh(a.return, b, c);
}
function $17f526922e4a857c$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $17f526922e4a857c$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $17f526922e4a857c$var$Xi(a, b, d.children, c);
    d = $17f526922e4a857c$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $17f526922e4a857c$var$vj(a, c, b);
            else if (19 === a.tag) $17f526922e4a857c$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $17f526922e4a857c$var$G($17f526922e4a857c$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $17f526922e4a857c$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $17f526922e4a857c$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $17f526922e4a857c$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $17f526922e4a857c$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $17f526922e4a857c$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $17f526922e4a857c$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $17f526922e4a857c$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($17f526922e4a857c$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $17f526922e4a857c$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $17f526922e4a857c$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $17f526922e4a857c$var$kj(b);
            $17f526922e4a857c$var$Ig();
            break;
        case 5:
            $17f526922e4a857c$var$Ah(b);
            break;
        case 1:
            $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$cg(b);
            break;
        case 4:
            $17f526922e4a857c$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $17f526922e4a857c$var$oj(a, b, c);
                $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1);
                a = $17f526922e4a857c$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $17f526922e4a857c$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $17f526922e4a857c$var$dj(a, b, c);
    }
    return $17f526922e4a857c$var$Zi(a, b, c);
}
var $17f526922e4a857c$var$zj, $17f526922e4a857c$var$Aj, $17f526922e4a857c$var$Bj, $17f526922e4a857c$var$Cj;
$17f526922e4a857c$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$17f526922e4a857c$var$Aj = function() {};
$17f526922e4a857c$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $17f526922e4a857c$var$Ya(a, e);
                d = $17f526922e4a857c$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $17f526922e4a857c$var$A({}, e, {
                    value: void 0
                });
                d = $17f526922e4a857c$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $17f526922e4a857c$var$gb(a, e);
                d = $17f526922e4a857c$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
        }
        $17f526922e4a857c$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $17f526922e4a857c$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$17f526922e4a857c$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $17f526922e4a857c$var$Dj(a, b) {
    if (!$17f526922e4a857c$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $17f526922e4a857c$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $17f526922e4a857c$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $17f526922e4a857c$var$S(b), null;
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 3:
            d = b.stateNode;
            $17f526922e4a857c$var$zh();
            $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
            $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
            $17f526922e4a857c$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $17f526922e4a857c$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Fj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null));
            $17f526922e4a857c$var$Aj(a, b);
            $17f526922e4a857c$var$S(b);
            return null;
        case 5:
            $17f526922e4a857c$var$Bh(b);
            var e = $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $17f526922e4a857c$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                    $17f526922e4a857c$var$S(b);
                    return null;
                }
                a = $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    d[$17f526922e4a857c$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $17f526922e4a857c$var$D("cancel", d);
                            $17f526922e4a857c$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], d);
                            break;
                        case "source":
                            $17f526922e4a857c$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $17f526922e4a857c$var$D("error", d);
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "details":
                            $17f526922e4a857c$var$D("toggle", d);
                            break;
                        case "input":
                            $17f526922e4a857c$var$Za(d, f);
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$hb(d, f), $17f526922e4a857c$var$D("invalid", d);
                    }
                    $17f526922e4a857c$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $17f526922e4a857c$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $17f526922e4a857c$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $17f526922e4a857c$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $17f526922e4a857c$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$17f526922e4a857c$var$Of] = b;
                    a[$17f526922e4a857c$var$Pf] = d;
                    $17f526922e4a857c$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $17f526922e4a857c$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $17f526922e4a857c$var$D("cancel", a);
                                $17f526922e4a857c$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $17f526922e4a857c$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $17f526922e4a857c$var$D("error", a);
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $17f526922e4a857c$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $17f526922e4a857c$var$Za(a, d);
                                e = $17f526922e4a857c$var$Ya(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $17f526922e4a857c$var$A({}, d, {
                                    value: void 0
                                });
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$hb(a, d);
                                e = $17f526922e4a857c$var$gb(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $17f526922e4a857c$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $17f526922e4a857c$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $17f526922e4a857c$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $17f526922e4a857c$var$ob(a, k) : "number" === typeof k && $17f526922e4a857c$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($17f526922e4a857c$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $17f526922e4a857c$var$D("scroll", a) : null != k && $17f526922e4a857c$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $17f526922e4a857c$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $17f526922e4a857c$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $17f526922e4a857c$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $17f526922e4a857c$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                c = $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
                $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $17f526922e4a857c$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$17f526922e4a857c$var$Of] = b, b.stateNode = d;
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($17f526922e4a857c$var$I && null !== $17f526922e4a857c$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $17f526922e4a857c$var$Hg(), $17f526922e4a857c$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $17f526922e4a857c$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($17f526922e4a857c$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($17f526922e4a857c$var$p(317));
                        f[$17f526922e4a857c$var$Of] = b;
                    } else $17f526922e4a857c$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $17f526922e4a857c$var$S(b);
                    f = !1;
                } else null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Fj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($17f526922e4a857c$var$L.current & 1) ? 0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 3) : $17f526922e4a857c$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $17f526922e4a857c$var$S(b);
            return null;
        case 4:
            return $17f526922e4a857c$var$zh(), $17f526922e4a857c$var$Aj(a, b), null === a && $17f526922e4a857c$var$sf(b.stateNode.containerInfo), $17f526922e4a857c$var$S(b), null;
        case 10:
            return $17f526922e4a857c$var$ah(b.type._context), $17f526922e4a857c$var$S(b), null;
        case 17:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 19:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            f = b.memoizedState;
            if (null === f) return $17f526922e4a857c$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $17f526922e4a857c$var$Dj(f, !1);
                else {
                    if (0 !== $17f526922e4a857c$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $17f526922e4a857c$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $17f526922e4a857c$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $17f526922e4a857c$var$B() > $17f526922e4a857c$var$Gj && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $17f526922e4a857c$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $17f526922e4a857c$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$17f526922e4a857c$var$I) return $17f526922e4a857c$var$S(b), null;
                    } else 2 * $17f526922e4a857c$var$B() - f.renderingStartTime > $17f526922e4a857c$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $17f526922e4a857c$var$B(), b.sibling = null, c = $17f526922e4a857c$var$L.current, $17f526922e4a857c$var$G($17f526922e4a857c$var$L, d ? c & 1 | 2 : c & 1), b;
            $17f526922e4a857c$var$S(b);
            return null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($17f526922e4a857c$var$fj & 1073741824) && ($17f526922e4a857c$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $17f526922e4a857c$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
}
function $17f526922e4a857c$var$Ij(a, b) {
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $17f526922e4a857c$var$zh(), $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $17f526922e4a857c$var$Bh(b), null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($17f526922e4a857c$var$p(340));
                $17f526922e4a857c$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $17f526922e4a857c$var$E($17f526922e4a857c$var$L), null;
        case 4:
            return $17f526922e4a857c$var$zh(), null;
        case 10:
            return $17f526922e4a857c$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$Jj = !1, $17f526922e4a857c$var$U = !1, $17f526922e4a857c$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $17f526922e4a857c$var$V = null;
function $17f526922e4a857c$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $17f526922e4a857c$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $17f526922e4a857c$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $17f526922e4a857c$var$W(a, b, d);
    }
}
var $17f526922e4a857c$var$Nj = !1;
function $17f526922e4a857c$var$Oj(a, b) {
    $17f526922e4a857c$var$Cf = $17f526922e4a857c$var$dd;
    a = $17f526922e4a857c$var$Me();
    if ($17f526922e4a857c$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $17f526922e4a857c$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $17f526922e4a857c$var$dd = !1;
    for($17f526922e4a857c$var$V = b; null !== $17f526922e4a857c$var$V;)if (b = $17f526922e4a857c$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $17f526922e4a857c$var$V = a;
    else for(; null !== $17f526922e4a857c$var$V;){
        b = $17f526922e4a857c$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $17f526922e4a857c$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(163));
            }
        } catch (F) {
            $17f526922e4a857c$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $17f526922e4a857c$var$V = a;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
    n = $17f526922e4a857c$var$Nj;
    $17f526922e4a857c$var$Nj = !1;
    return n;
}
function $17f526922e4a857c$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $17f526922e4a857c$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $17f526922e4a857c$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $17f526922e4a857c$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $17f526922e4a857c$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $17f526922e4a857c$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$17f526922e4a857c$var$Of], delete b[$17f526922e4a857c$var$Pf], delete b[$17f526922e4a857c$var$of], delete b[$17f526922e4a857c$var$Qf], delete b[$17f526922e4a857c$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $17f526922e4a857c$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $17f526922e4a857c$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $17f526922e4a857c$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $17f526922e4a857c$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $17f526922e4a857c$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Vj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Vj(a, b, c), a = a.sibling;
}
function $17f526922e4a857c$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Wj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Wj(a, b, c), a = a.sibling;
}
var $17f526922e4a857c$var$X = null, $17f526922e4a857c$var$Xj = !1;
function $17f526922e4a857c$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$17f526922e4a857c$var$Zj(a, b, c), c = c.sibling;
}
function $17f526922e4a857c$var$Zj(a, b, c) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberUnmount) try {
        $17f526922e4a857c$var$lc.onCommitFiberUnmount($17f526922e4a857c$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $17f526922e4a857c$var$U || $17f526922e4a857c$var$Lj(c, b);
        case 6:
            var d = $17f526922e4a857c$var$X, e = $17f526922e4a857c$var$Xj;
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Yj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Xj = e;
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Xj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $17f526922e4a857c$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Xj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? $17f526922e4a857c$var$Kf(a.parentNode, c) : 1 === a.nodeType && $17f526922e4a857c$var$Kf(a, c), $17f526922e4a857c$var$bd(a)) : $17f526922e4a857c$var$Kf($17f526922e4a857c$var$X, c.stateNode));
            break;
        case 4:
            d = $17f526922e4a857c$var$X;
            e = $17f526922e4a857c$var$Xj;
            $17f526922e4a857c$var$X = c.stateNode.containerInfo;
            $17f526922e4a857c$var$Xj = !0;
            $17f526922e4a857c$var$Yj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$17f526922e4a857c$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $17f526922e4a857c$var$Mj(c, b, g) : 0 !== (f & 4) && $17f526922e4a857c$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 1:
            if (!$17f526922e4a857c$var$U && ($17f526922e4a857c$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $17f526922e4a857c$var$W(c, b, h);
            }
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 21:
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($17f526922e4a857c$var$U = (d = $17f526922e4a857c$var$U) || null !== c.memoizedState, $17f526922e4a857c$var$Yj(a, b, c), $17f526922e4a857c$var$U = d) : $17f526922e4a857c$var$Yj(a, b, c);
            break;
        default:
            $17f526922e4a857c$var$Yj(a, b, c);
    }
}
function $17f526922e4a857c$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $17f526922e4a857c$var$Kj);
        b.forEach(function(b) {
            var d = $17f526922e4a857c$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $17f526922e4a857c$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $17f526922e4a857c$var$X = h.stateNode;
                        $17f526922e4a857c$var$Xj = !1;
                        break a;
                    case 3:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Xj = !0;
                        break a;
                    case 4:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $17f526922e4a857c$var$X) throw Error($17f526922e4a857c$var$p(160));
            $17f526922e4a857c$var$Zj(f, g, e);
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $17f526922e4a857c$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$17f526922e4a857c$var$dk(b, a), b = b.sibling;
}
function $17f526922e4a857c$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4) {
                try {
                    $17f526922e4a857c$var$Pj(3, a, a.return), $17f526922e4a857c$var$Qj(3, a);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
                try {
                    $17f526922e4a857c$var$Pj(5, a, a.return);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Lj(c, c.return);
            break;
        case 5:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $17f526922e4a857c$var$ob(e, "");
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $17f526922e4a857c$var$ab(e, f);
                    $17f526922e4a857c$var$vb(h, g);
                    var l = $17f526922e4a857c$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $17f526922e4a857c$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $17f526922e4a857c$var$nb(e, q) : "children" === m ? $17f526922e4a857c$var$ob(e, q) : $17f526922e4a857c$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $17f526922e4a857c$var$bb(e, f);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $17f526922e4a857c$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $17f526922e4a857c$var$fb(e, !!f.multiple, f.defaultValue, !0) : $17f526922e4a857c$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$17f526922e4a857c$var$Pf] = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($17f526922e4a857c$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $17f526922e4a857c$var$bd(b.containerInfo);
            } catch (t) {
                $17f526922e4a857c$var$W(a, a.return, t);
            }
            break;
        case 4:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            break;
        case 13:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($17f526922e4a857c$var$fk = $17f526922e4a857c$var$B()));
            d & 4 && $17f526922e4a857c$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($17f526922e4a857c$var$U = (l = $17f526922e4a857c$var$U) || m, $17f526922e4a857c$var$ck(b, a), $17f526922e4a857c$var$U = l) : $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($17f526922e4a857c$var$V = a, m = a.child; null !== m;){
                    for(q = $17f526922e4a857c$var$V = m; null !== $17f526922e4a857c$var$V;){
                        r = $17f526922e4a857c$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $17f526922e4a857c$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $17f526922e4a857c$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $17f526922e4a857c$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $17f526922e4a857c$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $17f526922e4a857c$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $17f526922e4a857c$var$V = y) : $17f526922e4a857c$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $17f526922e4a857c$var$rb("display", g));
                            } catch (t) {
                                $17f526922e4a857c$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $17f526922e4a857c$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 4 && $17f526922e4a857c$var$ak(a);
            break;
        case 21:
            break;
        default:
            $17f526922e4a857c$var$ck(b, a), $17f526922e4a857c$var$ek(a);
    }
}
function $17f526922e4a857c$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($17f526922e4a857c$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($17f526922e4a857c$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($17f526922e4a857c$var$ob(e, ""), d.flags &= -33);
                    var f = $17f526922e4a857c$var$Uj(a);
                    $17f526922e4a857c$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $17f526922e4a857c$var$Uj(a);
                    $17f526922e4a857c$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(161));
            }
        } catch (k) {
            $17f526922e4a857c$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $17f526922e4a857c$var$hk(a, b, c) {
    $17f526922e4a857c$var$V = a;
    $17f526922e4a857c$var$ik(a, b, c);
}
function $17f526922e4a857c$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $17f526922e4a857c$var$V;){
        var e = $17f526922e4a857c$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $17f526922e4a857c$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $17f526922e4a857c$var$U;
                h = $17f526922e4a857c$var$Jj;
                var l = $17f526922e4a857c$var$U;
                $17f526922e4a857c$var$Jj = g;
                if (($17f526922e4a857c$var$U = k) && !l) for($17f526922e4a857c$var$V = e; null !== $17f526922e4a857c$var$V;)g = $17f526922e4a857c$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $17f526922e4a857c$var$jk(e) : null !== k ? (k.return = g, $17f526922e4a857c$var$V = k) : $17f526922e4a857c$var$jk(e);
                for(; null !== f;)$17f526922e4a857c$var$V = f, $17f526922e4a857c$var$ik(f, b, c), f = f.sibling;
                $17f526922e4a857c$var$V = e;
                $17f526922e4a857c$var$Jj = h;
                $17f526922e4a857c$var$U = l;
            }
            $17f526922e4a857c$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $17f526922e4a857c$var$V = f) : $17f526922e4a857c$var$kk(a, b, c);
    }
}
function $17f526922e4a857c$var$kk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $17f526922e4a857c$var$U || $17f526922e4a857c$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$17f526922e4a857c$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $17f526922e4a857c$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $17f526922e4a857c$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $17f526922e4a857c$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $17f526922e4a857c$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($17f526922e4a857c$var$p(163));
                }
                $17f526922e4a857c$var$U || b.flags & 512 && $17f526922e4a857c$var$Rj(b);
            } catch (r) {
                $17f526922e4a857c$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$gk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$jk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $17f526922e4a857c$var$Qj(4, b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $17f526922e4a857c$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $17f526922e4a857c$var$W(b, b.return, k);
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $17f526922e4a857c$var$V = h;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
var $17f526922e4a857c$var$lk = Math.ceil, $17f526922e4a857c$var$mk = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$nk = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$ok = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$K = 0, $17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Y = null, $17f526922e4a857c$var$Z = 0, $17f526922e4a857c$var$fj = 0, $17f526922e4a857c$var$ej = $17f526922e4a857c$var$Uf(0), $17f526922e4a857c$var$T = 0, $17f526922e4a857c$var$pk = null, $17f526922e4a857c$var$rh = 0, $17f526922e4a857c$var$qk = 0, $17f526922e4a857c$var$rk = 0, $17f526922e4a857c$var$sk = null, $17f526922e4a857c$var$tk = null, $17f526922e4a857c$var$fk = 0, $17f526922e4a857c$var$Gj = Infinity, $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Oi = !1, $17f526922e4a857c$var$Pi = null, $17f526922e4a857c$var$Ri = null, $17f526922e4a857c$var$vk = !1, $17f526922e4a857c$var$wk = null, $17f526922e4a857c$var$xk = 0, $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = null, $17f526922e4a857c$var$Ak = -1, $17f526922e4a857c$var$Bk = 0;
function $17f526922e4a857c$var$R() {
    return 0 !== ($17f526922e4a857c$var$K & 6) ? $17f526922e4a857c$var$B() : -1 !== $17f526922e4a857c$var$Ak ? $17f526922e4a857c$var$Ak : $17f526922e4a857c$var$Ak = $17f526922e4a857c$var$B();
}
function $17f526922e4a857c$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($17f526922e4a857c$var$K & 2) && 0 !== $17f526922e4a857c$var$Z) return $17f526922e4a857c$var$Z & -$17f526922e4a857c$var$Z;
    if (null !== $17f526922e4a857c$var$Kg.transition) return 0 === $17f526922e4a857c$var$Bk && ($17f526922e4a857c$var$Bk = $17f526922e4a857c$var$yc()), $17f526922e4a857c$var$Bk;
    a = $17f526922e4a857c$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $17f526922e4a857c$var$jd(a.type);
    return a;
}
function $17f526922e4a857c$var$gi(a, b, c, d) {
    if (50 < $17f526922e4a857c$var$yk) throw $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = null, Error($17f526922e4a857c$var$p(185));
    $17f526922e4a857c$var$Ac(a, c, d);
    if (0 === ($17f526922e4a857c$var$K & 2) || a !== $17f526922e4a857c$var$Q) a === $17f526922e4a857c$var$Q && (0 === ($17f526922e4a857c$var$K & 2) && ($17f526922e4a857c$var$qk |= c), 4 === $17f526922e4a857c$var$T && $17f526922e4a857c$var$Ck(a, $17f526922e4a857c$var$Z)), $17f526922e4a857c$var$Dk(a, d), 1 === c && 0 === $17f526922e4a857c$var$K && 0 === (b.mode & 1) && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
}
function $17f526922e4a857c$var$Dk(a, b) {
    var c = a.callbackNode;
    $17f526922e4a857c$var$wc(a, b);
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$Q ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) null !== c && $17f526922e4a857c$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $17f526922e4a857c$var$bc(c);
        if (1 === b) 0 === a.tag ? $17f526922e4a857c$var$ig($17f526922e4a857c$var$Ek.bind(null, a)) : $17f526922e4a857c$var$hg($17f526922e4a857c$var$Ek.bind(null, a)), $17f526922e4a857c$var$Jf(function() {
            0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
        }), c = null;
        else {
            switch($17f526922e4a857c$var$Dc(d)){
                case 1:
                    c = $17f526922e4a857c$var$fc;
                    break;
                case 4:
                    c = $17f526922e4a857c$var$gc;
                    break;
                case 16:
                    c = $17f526922e4a857c$var$hc;
                    break;
                case 536870912:
                    c = $17f526922e4a857c$var$jc;
                    break;
                default:
                    c = $17f526922e4a857c$var$hc;
            }
            c = $17f526922e4a857c$var$Fk(c, $17f526922e4a857c$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $17f526922e4a857c$var$Gk(a, b) {
    $17f526922e4a857c$var$Ak = -1;
    $17f526922e4a857c$var$Bk = 0;
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    var c = a.callbackNode;
    if ($17f526922e4a857c$var$Hk() && a.callbackNode !== c) return null;
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$Q ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $17f526922e4a857c$var$Ik(a, d);
    else {
        b = d;
        var e = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 2;
        var f = $17f526922e4a857c$var$Jk();
        if ($17f526922e4a857c$var$Q !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$Kk(a, b);
        for(;;)try {
            $17f526922e4a857c$var$Lk();
            break;
        } catch (h) {
            $17f526922e4a857c$var$Mk(a, h);
        }
        $17f526922e4a857c$var$$g();
        $17f526922e4a857c$var$mk.current = f;
        $17f526922e4a857c$var$K = e;
        null !== $17f526922e4a857c$var$Y ? b = 0 : ($17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Z = 0, b = $17f526922e4a857c$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $17f526922e4a857c$var$xc(a), 0 !== e && (d = e, b = $17f526922e4a857c$var$Nk(a, e)));
        if (1 === b) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, d), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
        if (6 === b) $17f526922e4a857c$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$17f526922e4a857c$var$Ok(e) && (b = $17f526922e4a857c$var$Ik(a, d), 2 === b && (f = $17f526922e4a857c$var$xc(a), 0 !== f && (d = f, b = $17f526922e4a857c$var$Nk(a, f))), 1 === b)) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, d), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($17f526922e4a857c$var$p(345));
                case 2:
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 3:
                    $17f526922e4a857c$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $17f526922e4a857c$var$fk + 500 - $17f526922e4a857c$var$B(), 10 < b)) {
                        if (0 !== $17f526922e4a857c$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $17f526922e4a857c$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Pk.bind(null, a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk), b);
                        break;
                    }
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 4:
                    $17f526922e4a857c$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $17f526922e4a857c$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $17f526922e4a857c$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $17f526922e4a857c$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Pk.bind(null, a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk), d);
                        break;
                    }
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 5:
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(329));
            }
        }
    }
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    return a.callbackNode === c ? $17f526922e4a857c$var$Gk.bind(null, a) : null;
}
function $17f526922e4a857c$var$Nk(a, b) {
    var c = $17f526922e4a857c$var$sk;
    a.current.memoizedState.isDehydrated && ($17f526922e4a857c$var$Kk(a, b).flags |= 256);
    a = $17f526922e4a857c$var$Ik(a, b);
    2 !== a && (b = $17f526922e4a857c$var$tk, $17f526922e4a857c$var$tk = c, null !== b && $17f526922e4a857c$var$Fj(b));
    return a;
}
function $17f526922e4a857c$var$Fj(a) {
    null === $17f526922e4a857c$var$tk ? $17f526922e4a857c$var$tk = a : $17f526922e4a857c$var$tk.push.apply($17f526922e4a857c$var$tk, a);
}
function $17f526922e4a857c$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$17f526922e4a857c$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $17f526922e4a857c$var$Ck(a, b) {
    b &= ~$17f526922e4a857c$var$rk;
    b &= ~$17f526922e4a857c$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $17f526922e4a857c$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $17f526922e4a857c$var$Ek(a) {
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    $17f526922e4a857c$var$Hk();
    var b = $17f526922e4a857c$var$uc(a, 0);
    if (0 === (b & 1)) return $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), null;
    var c = $17f526922e4a857c$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $17f526922e4a857c$var$xc(a);
        0 !== d && (b = d, c = $17f526922e4a857c$var$Nk(a, d));
    }
    if (1 === c) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, b), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
    if (6 === c) throw Error($17f526922e4a857c$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    return null;
}
function $17f526922e4a857c$var$Qk(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    try {
        return a(b);
    } finally{
        $17f526922e4a857c$var$K = c, 0 === $17f526922e4a857c$var$K && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
    }
}
function $17f526922e4a857c$var$Rk(a) {
    null !== $17f526922e4a857c$var$wk && 0 === $17f526922e4a857c$var$wk.tag && 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$Hk();
    var b = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    var c = $17f526922e4a857c$var$ok.transition, d = $17f526922e4a857c$var$C;
    try {
        if ($17f526922e4a857c$var$ok.transition = null, $17f526922e4a857c$var$C = 1, a) return a();
    } finally{
        $17f526922e4a857c$var$C = d, $17f526922e4a857c$var$ok.transition = c, $17f526922e4a857c$var$K = b, 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
    }
}
function $17f526922e4a857c$var$Hj() {
    $17f526922e4a857c$var$fj = $17f526922e4a857c$var$ej.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$ej);
}
function $17f526922e4a857c$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $17f526922e4a857c$var$Gf(c));
    if (null !== $17f526922e4a857c$var$Y) for(c = $17f526922e4a857c$var$Y.return; null !== c;){
        var d = c;
        $17f526922e4a857c$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $17f526922e4a857c$var$$f();
                break;
            case 3:
                $17f526922e4a857c$var$zh();
                $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
                $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
                $17f526922e4a857c$var$Eh();
                break;
            case 5:
                $17f526922e4a857c$var$Bh(d);
                break;
            case 4:
                $17f526922e4a857c$var$zh();
                break;
            case 13:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
                break;
            case 19:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
                break;
            case 10:
                $17f526922e4a857c$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $17f526922e4a857c$var$Hj();
        }
        c = c.return;
    }
    $17f526922e4a857c$var$Q = a;
    $17f526922e4a857c$var$Y = a = $17f526922e4a857c$var$Pg(a.current, null);
    $17f526922e4a857c$var$Z = $17f526922e4a857c$var$fj = b;
    $17f526922e4a857c$var$T = 0;
    $17f526922e4a857c$var$pk = null;
    $17f526922e4a857c$var$rk = $17f526922e4a857c$var$qk = $17f526922e4a857c$var$rh = 0;
    $17f526922e4a857c$var$tk = $17f526922e4a857c$var$sk = null;
    if (null !== $17f526922e4a857c$var$fh) {
        for(b = 0; b < $17f526922e4a857c$var$fh.length; b++)if (c = $17f526922e4a857c$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $17f526922e4a857c$var$fh = null;
    }
    return a;
}
function $17f526922e4a857c$var$Mk(a, b) {
    do {
        var c = $17f526922e4a857c$var$Y;
        try {
            $17f526922e4a857c$var$$g();
            $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Rh;
            if ($17f526922e4a857c$var$Ih) {
                for(var d = $17f526922e4a857c$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $17f526922e4a857c$var$Ih = !1;
            }
            $17f526922e4a857c$var$Hh = 0;
            $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = $17f526922e4a857c$var$M = null;
            $17f526922e4a857c$var$Jh = !1;
            $17f526922e4a857c$var$Kh = 0;
            $17f526922e4a857c$var$nk.current = null;
            if (null === c || null === c.return) {
                $17f526922e4a857c$var$T = 1;
                $17f526922e4a857c$var$pk = b;
                $17f526922e4a857c$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $17f526922e4a857c$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $17f526922e4a857c$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $17f526922e4a857c$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $17f526922e4a857c$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $17f526922e4a857c$var$Si(f, l, b);
                            $17f526922e4a857c$var$tj();
                            break a;
                        }
                        k = Error($17f526922e4a857c$var$p(426));
                    }
                } else if ($17f526922e4a857c$var$I && h.mode & 1) {
                    var J = $17f526922e4a857c$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $17f526922e4a857c$var$Vi(J, g, h, f, b);
                        $17f526922e4a857c$var$Jg($17f526922e4a857c$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $17f526922e4a857c$var$Ji(k, h);
                4 !== $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 2);
                null === $17f526922e4a857c$var$sk ? $17f526922e4a857c$var$sk = [
                    f
                ] : $17f526922e4a857c$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $17f526922e4a857c$var$Ni(f, k, b);
                            $17f526922e4a857c$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $17f526922e4a857c$var$Ri || !$17f526922e4a857c$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $17f526922e4a857c$var$Qi(f, h, b);
                                $17f526922e4a857c$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $17f526922e4a857c$var$Sk(c);
        } catch (na) {
            b = na;
            $17f526922e4a857c$var$Y === c && null !== c && ($17f526922e4a857c$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $17f526922e4a857c$var$Jk() {
    var a = $17f526922e4a857c$var$mk.current;
    $17f526922e4a857c$var$mk.current = $17f526922e4a857c$var$Rh;
    return null === a ? $17f526922e4a857c$var$Rh : a;
}
function $17f526922e4a857c$var$tj() {
    if (0 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T || 2 === $17f526922e4a857c$var$T) $17f526922e4a857c$var$T = 4;
    null === $17f526922e4a857c$var$Q || 0 === ($17f526922e4a857c$var$rh & 268435455) && 0 === ($17f526922e4a857c$var$qk & 268435455) || $17f526922e4a857c$var$Ck($17f526922e4a857c$var$Q, $17f526922e4a857c$var$Z);
}
function $17f526922e4a857c$var$Ik(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 2;
    var d = $17f526922e4a857c$var$Jk();
    if ($17f526922e4a857c$var$Q !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Kk(a, b);
    for(;;)try {
        $17f526922e4a857c$var$Tk();
        break;
    } catch (e) {
        $17f526922e4a857c$var$Mk(a, e);
    }
    $17f526922e4a857c$var$$g();
    $17f526922e4a857c$var$K = c;
    $17f526922e4a857c$var$mk.current = d;
    if (null !== $17f526922e4a857c$var$Y) throw Error($17f526922e4a857c$var$p(261));
    $17f526922e4a857c$var$Q = null;
    $17f526922e4a857c$var$Z = 0;
    return $17f526922e4a857c$var$T;
}
function $17f526922e4a857c$var$Tk() {
    for(; null !== $17f526922e4a857c$var$Y;)$17f526922e4a857c$var$Uk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Lk() {
    for(; null !== $17f526922e4a857c$var$Y && !$17f526922e4a857c$var$cc();)$17f526922e4a857c$var$Uk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Uk(a) {
    var b = $17f526922e4a857c$var$Vk(a.alternate, a, $17f526922e4a857c$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $17f526922e4a857c$var$Sk(a) : $17f526922e4a857c$var$Y = b;
    $17f526922e4a857c$var$nk.current = null;
}
function $17f526922e4a857c$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $17f526922e4a857c$var$Ej(c, b, $17f526922e4a857c$var$fj), null !== c) {
                $17f526922e4a857c$var$Y = c;
                return;
            }
        } else {
            c = $17f526922e4a857c$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $17f526922e4a857c$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $17f526922e4a857c$var$T = 6;
                $17f526922e4a857c$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $17f526922e4a857c$var$Y = b;
            return;
        }
        $17f526922e4a857c$var$Y = b = a;
    }while (null !== b);
    0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 5);
}
function $17f526922e4a857c$var$Pk(a, b, c) {
    var d = $17f526922e4a857c$var$C, e = $17f526922e4a857c$var$ok.transition;
    try {
        $17f526922e4a857c$var$ok.transition = null, $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$Wk(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$ok.transition = e, $17f526922e4a857c$var$C = d;
    }
    return null;
}
function $17f526922e4a857c$var$Wk(a, b, c, d) {
    do $17f526922e4a857c$var$Hk();
    while (null !== $17f526922e4a857c$var$wk);
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($17f526922e4a857c$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $17f526922e4a857c$var$Bc(a, f);
    a === $17f526922e4a857c$var$Q && ($17f526922e4a857c$var$Y = $17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $17f526922e4a857c$var$vk || ($17f526922e4a857c$var$vk = !0, $17f526922e4a857c$var$Fk($17f526922e4a857c$var$hc, function() {
        $17f526922e4a857c$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $17f526922e4a857c$var$ok.transition;
        $17f526922e4a857c$var$ok.transition = null;
        var g = $17f526922e4a857c$var$C;
        $17f526922e4a857c$var$C = 1;
        var h = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 4;
        $17f526922e4a857c$var$nk.current = null;
        $17f526922e4a857c$var$Oj(a, c);
        $17f526922e4a857c$var$dk(c, a);
        $17f526922e4a857c$var$Oe($17f526922e4a857c$var$Df);
        $17f526922e4a857c$var$dd = !!$17f526922e4a857c$var$Cf;
        $17f526922e4a857c$var$Df = $17f526922e4a857c$var$Cf = null;
        a.current = c;
        $17f526922e4a857c$var$hk(c, a, e);
        $17f526922e4a857c$var$dc();
        $17f526922e4a857c$var$K = h;
        $17f526922e4a857c$var$C = g;
        $17f526922e4a857c$var$ok.transition = f;
    } else a.current = c;
    $17f526922e4a857c$var$vk && ($17f526922e4a857c$var$vk = !1, $17f526922e4a857c$var$wk = a, $17f526922e4a857c$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($17f526922e4a857c$var$Ri = null);
    $17f526922e4a857c$var$mc(c.stateNode, d);
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($17f526922e4a857c$var$Oi) throw $17f526922e4a857c$var$Oi = !1, a = $17f526922e4a857c$var$Pi, $17f526922e4a857c$var$Pi = null, a;
    0 !== ($17f526922e4a857c$var$xk & 1) && 0 !== a.tag && $17f526922e4a857c$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $17f526922e4a857c$var$zk ? $17f526922e4a857c$var$yk++ : ($17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = a) : $17f526922e4a857c$var$yk = 0;
    $17f526922e4a857c$var$jg();
    return null;
}
function $17f526922e4a857c$var$Hk() {
    if (null !== $17f526922e4a857c$var$wk) {
        var a = $17f526922e4a857c$var$Dc($17f526922e4a857c$var$xk), b = $17f526922e4a857c$var$ok.transition, c = $17f526922e4a857c$var$C;
        try {
            $17f526922e4a857c$var$ok.transition = null;
            $17f526922e4a857c$var$C = 16 > a ? 16 : a;
            if (null === $17f526922e4a857c$var$wk) var d = !1;
            else {
                a = $17f526922e4a857c$var$wk;
                $17f526922e4a857c$var$wk = null;
                $17f526922e4a857c$var$xk = 0;
                if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(331));
                var e = $17f526922e4a857c$var$K;
                $17f526922e4a857c$var$K |= 4;
                for($17f526922e4a857c$var$V = a.current; null !== $17f526922e4a857c$var$V;){
                    var f = $17f526922e4a857c$var$V, g = f.child;
                    if (0 !== ($17f526922e4a857c$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($17f526922e4a857c$var$V = l; null !== $17f526922e4a857c$var$V;){
                                    var m = $17f526922e4a857c$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $17f526922e4a857c$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $17f526922e4a857c$var$V = q;
                                    else for(; null !== $17f526922e4a857c$var$V;){
                                        m = $17f526922e4a857c$var$V;
                                        var r = m.sibling, y = m.return;
                                        $17f526922e4a857c$var$Sj(m);
                                        if (m === l) {
                                            $17f526922e4a857c$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $17f526922e4a857c$var$V = r;
                                            break;
                                        }
                                        $17f526922e4a857c$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $17f526922e4a857c$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $17f526922e4a857c$var$V = g;
                    else b: for(; null !== $17f526922e4a857c$var$V;){
                        f = $17f526922e4a857c$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $17f526922e4a857c$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $17f526922e4a857c$var$V = x;
                            break b;
                        }
                        $17f526922e4a857c$var$V = f.return;
                    }
                }
                var w = a.current;
                for($17f526922e4a857c$var$V = w; null !== $17f526922e4a857c$var$V;){
                    g = $17f526922e4a857c$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $17f526922e4a857c$var$V = u;
                    else b: for(g = w; null !== $17f526922e4a857c$var$V;){
                        h = $17f526922e4a857c$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $17f526922e4a857c$var$Qj(9, h);
                            }
                        } catch (na) {
                            $17f526922e4a857c$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $17f526922e4a857c$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $17f526922e4a857c$var$V = F;
                            break b;
                        }
                        $17f526922e4a857c$var$V = h.return;
                    }
                }
                $17f526922e4a857c$var$K = e;
                $17f526922e4a857c$var$jg();
                if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onPostCommitFiberRoot) try {
                    $17f526922e4a857c$var$lc.onPostCommitFiberRoot($17f526922e4a857c$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$ok.transition = b;
        }
    }
    return !1;
}
function $17f526922e4a857c$var$Xk(a, b, c) {
    b = $17f526922e4a857c$var$Ji(c, b);
    b = $17f526922e4a857c$var$Ni(a, b, 1);
    a = $17f526922e4a857c$var$nh(a, b, 1);
    b = $17f526922e4a857c$var$R();
    null !== a && ($17f526922e4a857c$var$Ac(a, 1, b), $17f526922e4a857c$var$Dk(a, b));
}
function $17f526922e4a857c$var$W(a, b, c) {
    if (3 === a.tag) $17f526922e4a857c$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $17f526922e4a857c$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $17f526922e4a857c$var$Ri || !$17f526922e4a857c$var$Ri.has(d))) {
                a = $17f526922e4a857c$var$Ji(c, a);
                a = $17f526922e4a857c$var$Qi(b, a, 1);
                b = $17f526922e4a857c$var$nh(b, a, 1);
                a = $17f526922e4a857c$var$R();
                null !== b && ($17f526922e4a857c$var$Ac(b, 1, a), $17f526922e4a857c$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $17f526922e4a857c$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $17f526922e4a857c$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $17f526922e4a857c$var$Q === a && ($17f526922e4a857c$var$Z & c) === c && (4 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$Z & 130023424) === $17f526922e4a857c$var$Z && 500 > $17f526922e4a857c$var$B() - $17f526922e4a857c$var$fk ? $17f526922e4a857c$var$Kk(a, 0) : $17f526922e4a857c$var$rk |= c);
    $17f526922e4a857c$var$Dk(a, b);
}
function $17f526922e4a857c$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $17f526922e4a857c$var$sc, $17f526922e4a857c$var$sc <<= 1, 0 === ($17f526922e4a857c$var$sc & 130023424) && ($17f526922e4a857c$var$sc = 4194304)));
    var c = $17f526922e4a857c$var$R();
    a = $17f526922e4a857c$var$ih(a, b);
    null !== a && ($17f526922e4a857c$var$Ac(a, b, c), $17f526922e4a857c$var$Dk(a, c));
}
function $17f526922e4a857c$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $17f526922e4a857c$var$Yk(a, c);
}
function $17f526922e4a857c$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($17f526922e4a857c$var$p(314));
    }
    null !== d && d.delete(b);
    $17f526922e4a857c$var$Yk(a, c);
}
var $17f526922e4a857c$var$Vk;
$17f526922e4a857c$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $17f526922e4a857c$var$Wf.current) $17f526922e4a857c$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $17f526922e4a857c$var$dh = !1, $17f526922e4a857c$var$yj(a, b, c);
            $17f526922e4a857c$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $17f526922e4a857c$var$dh = !1, $17f526922e4a857c$var$I && 0 !== (b.flags & 1048576) && $17f526922e4a857c$var$ug(b, $17f526922e4a857c$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $17f526922e4a857c$var$ij(a, b);
            a = b.pendingProps;
            var e = $17f526922e4a857c$var$Yf(b, $17f526922e4a857c$var$H.current);
            $17f526922e4a857c$var$ch(b, c);
            e = $17f526922e4a857c$var$Nh(null, b, d, a, e, c);
            var f = $17f526922e4a857c$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $17f526922e4a857c$var$Zf(d) ? (f = !0, $17f526922e4a857c$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $17f526922e4a857c$var$kh(b), e.updater = $17f526922e4a857c$var$Ei, b.stateNode = e, e._reactInternals = b, $17f526922e4a857c$var$Ii(b, d, a, c), b = $17f526922e4a857c$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $17f526922e4a857c$var$I && f && $17f526922e4a857c$var$vg(b), $17f526922e4a857c$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $17f526922e4a857c$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $17f526922e4a857c$var$Zk(d);
                a = $17f526922e4a857c$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $17f526922e4a857c$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $17f526922e4a857c$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $17f526922e4a857c$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $17f526922e4a857c$var$$i(null, b, d, $17f526922e4a857c$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($17f526922e4a857c$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $17f526922e4a857c$var$kj(b);
                if (null === a) throw Error($17f526922e4a857c$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $17f526922e4a857c$var$lh(a, b);
                $17f526922e4a857c$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $17f526922e4a857c$var$Ji(Error($17f526922e4a857c$var$p(423)), b);
                        b = $17f526922e4a857c$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $17f526922e4a857c$var$Ji(Error($17f526922e4a857c$var$p(424)), b);
                        b = $17f526922e4a857c$var$lj(a, b, d, c, e);
                        break a;
                    } else for($17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.stateNode.containerInfo.firstChild), $17f526922e4a857c$var$xg = b, $17f526922e4a857c$var$I = !0, $17f526922e4a857c$var$zg = null, c = $17f526922e4a857c$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $17f526922e4a857c$var$Ig();
                    if (d === e) {
                        b = $17f526922e4a857c$var$Zi(a, b, c);
                        break a;
                    }
                    $17f526922e4a857c$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $17f526922e4a857c$var$Ah(b), null === a && $17f526922e4a857c$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $17f526922e4a857c$var$Ef(d, e) ? g = null : null !== f && $17f526922e4a857c$var$Ef(d, f) && (b.flags |= 32), $17f526922e4a857c$var$gj(a, b), $17f526922e4a857c$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $17f526922e4a857c$var$Eg(b), null;
        case 13:
            return $17f526922e4a857c$var$oj(a, b, c);
        case 4:
            return $17f526922e4a857c$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $17f526922e4a857c$var$Ug(b, null, d, c) : $17f526922e4a857c$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$Yi(a, b, d, e, c);
        case 7:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $17f526922e4a857c$var$G($17f526922e4a857c$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($17f526922e4a857c$var$He(f.value, g)) {
                        if (f.children === e.children && !$17f526922e4a857c$var$Wf.current) {
                            b = $17f526922e4a857c$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $17f526922e4a857c$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $17f526922e4a857c$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($17f526922e4a857c$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $17f526922e4a857c$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $17f526922e4a857c$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $17f526922e4a857c$var$ch(b, c), e = $17f526922e4a857c$var$eh(e), d = d(e), b.flags |= 1, $17f526922e4a857c$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $17f526922e4a857c$var$Ci(d, b.pendingProps), e = $17f526922e4a857c$var$Ci(d.type, e), $17f526922e4a857c$var$$i(a, b, d, e, c);
        case 15:
            return $17f526922e4a857c$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$ij(a, b), b.tag = 1, $17f526922e4a857c$var$Zf(d) ? (a = !0, $17f526922e4a857c$var$cg(b)) : a = !1, $17f526922e4a857c$var$ch(b, c), $17f526922e4a857c$var$Gi(b, d, e), $17f526922e4a857c$var$Ii(b, d, e, c), $17f526922e4a857c$var$jj(null, b, d, !0, a, c);
        case 19:
            return $17f526922e4a857c$var$xj(a, b, c);
        case 22:
            return $17f526922e4a857c$var$dj(a, b, c);
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
};
function $17f526922e4a857c$var$Fk(a, b) {
    return $17f526922e4a857c$var$ac(a, b);
}
function $17f526922e4a857c$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $17f526922e4a857c$var$Bg(a, b, c, d) {
    return new $17f526922e4a857c$var$$k(a, b, c, d);
}
function $17f526922e4a857c$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $17f526922e4a857c$var$Zk(a) {
    if ("function" === typeof a) return $17f526922e4a857c$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $17f526922e4a857c$var$Da) return 11;
        if (a === $17f526922e4a857c$var$Ga) return 14;
    }
    return 2;
}
function $17f526922e4a857c$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $17f526922e4a857c$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $17f526922e4a857c$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $17f526922e4a857c$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $17f526922e4a857c$var$ya:
            return $17f526922e4a857c$var$Tg(c.children, e, f, b);
        case $17f526922e4a857c$var$za:
            g = 8;
            e |= 8;
            break;
        case $17f526922e4a857c$var$Aa:
            return a = $17f526922e4a857c$var$Bg(12, c, b, e | 2), a.elementType = $17f526922e4a857c$var$Aa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ea:
            return a = $17f526922e4a857c$var$Bg(13, c, b, e), a.elementType = $17f526922e4a857c$var$Ea, a.lanes = f, a;
        case $17f526922e4a857c$var$Fa:
            return a = $17f526922e4a857c$var$Bg(19, c, b, e), a.elementType = $17f526922e4a857c$var$Fa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ia:
            return $17f526922e4a857c$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $17f526922e4a857c$var$Ba:
                    g = 10;
                    break a;
                case $17f526922e4a857c$var$Ca:
                    g = 9;
                    break a;
                case $17f526922e4a857c$var$Da:
                    g = 11;
                    break a;
                case $17f526922e4a857c$var$Ga:
                    g = 14;
                    break a;
                case $17f526922e4a857c$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($17f526922e4a857c$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $17f526922e4a857c$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $17f526922e4a857c$var$Tg(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$pj(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(22, a, d, b);
    a.elementType = $17f526922e4a857c$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $17f526922e4a857c$var$Qg(a, b, c) {
    a = $17f526922e4a857c$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$Sg(a, b, c) {
    b = $17f526922e4a857c$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $17f526922e4a857c$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $17f526922e4a857c$var$zc(0);
    this.expirationTimes = $17f526922e4a857c$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $17f526922e4a857c$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $17f526922e4a857c$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $17f526922e4a857c$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $17f526922e4a857c$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $17f526922e4a857c$var$kh(f);
    return a;
}
function $17f526922e4a857c$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $17f526922e4a857c$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $17f526922e4a857c$var$dl(a) {
    if (!a) return $17f526922e4a857c$var$Vf;
    a = a._reactInternals;
    a: {
        if ($17f526922e4a857c$var$Vb(a) !== a || 1 !== a.tag) throw Error($17f526922e4a857c$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($17f526922e4a857c$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($17f526922e4a857c$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($17f526922e4a857c$var$Zf(c)) return $17f526922e4a857c$var$bg(a, c, b);
    }
    return b;
}
function $17f526922e4a857c$var$el(a, b, c, d, e, f, g, h, k) {
    a = $17f526922e4a857c$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $17f526922e4a857c$var$dl(null);
    c = a.current;
    d = $17f526922e4a857c$var$R();
    e = $17f526922e4a857c$var$yi(c);
    f = $17f526922e4a857c$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $17f526922e4a857c$var$nh(c, f, e);
    a.current.lanes = e;
    $17f526922e4a857c$var$Ac(a, e, d);
    $17f526922e4a857c$var$Dk(a, d);
    return a;
}
function $17f526922e4a857c$var$fl(a, b, c, d) {
    var e = b.current, f = $17f526922e4a857c$var$R(), g = $17f526922e4a857c$var$yi(e);
    c = $17f526922e4a857c$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $17f526922e4a857c$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $17f526922e4a857c$var$nh(e, b, g);
    null !== a && ($17f526922e4a857c$var$gi(a, e, g, f), $17f526922e4a857c$var$oh(a, e, g));
    return g;
}
function $17f526922e4a857c$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $17f526922e4a857c$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $17f526922e4a857c$var$il(a, b) {
    $17f526922e4a857c$var$hl(a, b);
    (a = a.alternate) && $17f526922e4a857c$var$hl(a, b);
}
function $17f526922e4a857c$var$jl() {
    return null;
}
var $17f526922e4a857c$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $17f526922e4a857c$var$ll(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$ml.prototype.render = $17f526922e4a857c$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($17f526922e4a857c$var$p(409));
    $17f526922e4a857c$var$fl(a, b, null, null);
};
$17f526922e4a857c$var$ml.prototype.unmount = $17f526922e4a857c$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $17f526922e4a857c$var$Rk(function() {
            $17f526922e4a857c$var$fl(null, a, null, null);
        });
        b[$17f526922e4a857c$var$uf] = null;
    }
};
function $17f526922e4a857c$var$ml(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $17f526922e4a857c$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $17f526922e4a857c$var$Qc.length && 0 !== b && b < $17f526922e4a857c$var$Qc[c].priority; c++);
        $17f526922e4a857c$var$Qc.splice(c, 0, a);
        0 === c && $17f526922e4a857c$var$Vc(a);
    }
};
function $17f526922e4a857c$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $17f526922e4a857c$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $17f526922e4a857c$var$pl() {}
function $17f526922e4a857c$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $17f526922e4a857c$var$gl(g);
                f.call(a);
            };
        }
        var g = $17f526922e4a857c$var$el(b, d, a, 0, null, !1, !1, "", $17f526922e4a857c$var$pl);
        a._reactRootContainer = g;
        a[$17f526922e4a857c$var$uf] = g.current;
        $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
        $17f526922e4a857c$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $17f526922e4a857c$var$gl(k);
            h.call(a);
        };
    }
    var k = $17f526922e4a857c$var$bl(a, 0, !1, null, null, !1, !1, "", $17f526922e4a857c$var$pl);
    a._reactRootContainer = k;
    a[$17f526922e4a857c$var$uf] = k.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    $17f526922e4a857c$var$Rk(function() {
        $17f526922e4a857c$var$fl(b, k, c, d);
    });
    return k;
}
function $17f526922e4a857c$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $17f526922e4a857c$var$gl(g);
                h.call(a);
            };
        }
        $17f526922e4a857c$var$fl(b, g, a, e);
    } else g = $17f526922e4a857c$var$ql(c, b, a, e, d);
    return $17f526922e4a857c$var$gl(g);
}
$17f526922e4a857c$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $17f526922e4a857c$var$tc(b.pendingLanes);
                0 !== c && ($17f526922e4a857c$var$Cc(b, c | 1), $17f526922e4a857c$var$Dk(b, $17f526922e4a857c$var$B()), 0 === ($17f526922e4a857c$var$K & 6) && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$jg()));
            }
            break;
        case 13:
            $17f526922e4a857c$var$Rk(function() {
                var b = $17f526922e4a857c$var$ih(a, 1);
                if (null !== b) {
                    var c = $17f526922e4a857c$var$R();
                    $17f526922e4a857c$var$gi(b, a, 1, c);
                }
            }), $17f526922e4a857c$var$il(a, 1);
    }
};
$17f526922e4a857c$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$ih(a, 134217728);
        if (null !== b) {
            var c = $17f526922e4a857c$var$R();
            $17f526922e4a857c$var$gi(b, a, 134217728, c);
        }
        $17f526922e4a857c$var$il(a, 134217728);
    }
};
$17f526922e4a857c$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$yi(a), c = $17f526922e4a857c$var$ih(a, b);
        if (null !== c) {
            var d = $17f526922e4a857c$var$R();
            $17f526922e4a857c$var$gi(c, a, b, d);
        }
        $17f526922e4a857c$var$il(a, b);
    }
};
$17f526922e4a857c$var$Hc = function() {
    return $17f526922e4a857c$var$C;
};
$17f526922e4a857c$var$Ic = function(a, b) {
    var c = $17f526922e4a857c$var$C;
    try {
        return $17f526922e4a857c$var$C = a, b();
    } finally{
        $17f526922e4a857c$var$C = c;
    }
};
$17f526922e4a857c$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $17f526922e4a857c$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $17f526922e4a857c$var$Db(d);
                        if (!e) throw Error($17f526922e4a857c$var$p(90));
                        $17f526922e4a857c$var$Wa(d);
                        $17f526922e4a857c$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $17f526922e4a857c$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $17f526922e4a857c$var$fb(a, !!c.multiple, b, !1);
    }
};
$17f526922e4a857c$var$Gb = $17f526922e4a857c$var$Qk;
$17f526922e4a857c$var$Hb = $17f526922e4a857c$var$Rk;
var $17f526922e4a857c$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $17f526922e4a857c$var$Cb,
        $17f526922e4a857c$var$ue,
        $17f526922e4a857c$var$Db,
        $17f526922e4a857c$var$Eb,
        $17f526922e4a857c$var$Fb,
        $17f526922e4a857c$var$Qk
    ]
}, $17f526922e4a857c$var$tl = {
    findFiberByHostInstance: $17f526922e4a857c$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $17f526922e4a857c$var$ul = {
    bundleType: $17f526922e4a857c$var$tl.bundleType,
    version: $17f526922e4a857c$var$tl.version,
    rendererPackageName: $17f526922e4a857c$var$tl.rendererPackageName,
    rendererConfig: $17f526922e4a857c$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $17f526922e4a857c$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $17f526922e4a857c$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $17f526922e4a857c$var$tl.findFiberByHostInstance || $17f526922e4a857c$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $17f526922e4a857c$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$17f526922e4a857c$var$vl.isDisabled && $17f526922e4a857c$var$vl.supportsFiber) try {
        $17f526922e4a857c$var$kc = $17f526922e4a857c$var$vl.inject($17f526922e4a857c$var$ul), $17f526922e4a857c$var$lc = $17f526922e4a857c$var$vl;
    } catch (a) {}
}
$17f526922e4a857c$export$ae55be85d98224ed = $17f526922e4a857c$var$sl;
$17f526922e4a857c$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$17f526922e4a857c$var$nl(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$cl(a, b, null, c);
};
$17f526922e4a857c$export$882461b6382ed46c = function(a, b) {
    if (!$17f526922e4a857c$var$nl(a)) throw Error($17f526922e4a857c$var$p(299));
    var c = !1, d = "", e = $17f526922e4a857c$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $17f526922e4a857c$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $17f526922e4a857c$var$ll(b);
};
$17f526922e4a857c$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($17f526922e4a857c$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($17f526922e4a857c$var$p(268, a));
    }
    a = $17f526922e4a857c$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$17f526922e4a857c$export$cd75ccfd720a3cd4 = function(a) {
    return $17f526922e4a857c$var$Rk(a);
};
$17f526922e4a857c$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$rl(null, a, b, !0, c);
};
$17f526922e4a857c$export$757ceba2d55c277e = function(a, b, c) {
    if (!$17f526922e4a857c$var$nl(a)) throw Error($17f526922e4a857c$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $17f526922e4a857c$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $17f526922e4a857c$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $17f526922e4a857c$var$ml(b);
};
$17f526922e4a857c$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$rl(null, a, b, !1, c);
};
$17f526922e4a857c$export$502457920280e6be = function(a) {
    if (!$17f526922e4a857c$var$ol(a)) throw Error($17f526922e4a857c$var$p(40));
    return a._reactRootContainer ? ($17f526922e4a857c$var$Rk(function() {
        $17f526922e4a857c$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$17f526922e4a857c$var$uf] = null;
        });
    }), !0) : !1;
};
$17f526922e4a857c$export$c78a37762a8d58e1 = $17f526922e4a857c$var$Qk;
$17f526922e4a857c$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$17f526922e4a857c$var$ol(c)) throw Error($17f526922e4a857c$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($17f526922e4a857c$var$p(38));
    return $17f526922e4a857c$var$rl(a, b, c, !1, d);
};
$17f526922e4a857c$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("clk2u", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5fXYF"));

});
parcelRegister("5fXYF", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3d3ce0c592af0505$export$c4744153514ff05d, (v) => $3d3ce0c592af0505$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7, (v) => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3d3ce0c592af0505$export$e26fe2ed2fa76875, (v) => $3d3ce0c592af0505$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3d3ce0c592af0505$export$502329bbf4b505b1, (v) => $3d3ce0c592af0505$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3d3ce0c592af0505$export$6e3807111c4874c4, (v) => $3d3ce0c592af0505$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3d3ce0c592af0505$export$c27134553091fb3a, (v) => $3d3ce0c592af0505$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3d3ce0c592af0505$export$33ee1acdc04fd2a2, (v) => $3d3ce0c592af0505$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3d3ce0c592af0505$export$b00a404bbd5edef2, (v) => $3d3ce0c592af0505$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3d3ce0c592af0505$export$8352ce38b91d0c62, (v) => $3d3ce0c592af0505$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3d3ce0c592af0505$export$d66a1c1c77bd778b, (v) => $3d3ce0c592af0505$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3d3ce0c592af0505$export$d3dfb8e4810cb555, (v) => $3d3ce0c592af0505$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3d3ce0c592af0505$export$839f9183b0465a69, (v) => $3d3ce0c592af0505$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3d3ce0c592af0505$export$72fdf0e06517287b, (v) => $3d3ce0c592af0505$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3d3ce0c592af0505$export$4b844e58a3e414b4, (v) => $3d3ce0c592af0505$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3d3ce0c592af0505$export$816d2913ae6b83b1, (v) => $3d3ce0c592af0505$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3d3ce0c592af0505$export$61bcfe829111a1d0, (v) => $3d3ce0c592af0505$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3d3ce0c592af0505$export$7ee8c9beb337bc3f, (v) => $3d3ce0c592af0505$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3d3ce0c592af0505$export$b5836b71941fa3ed, (v) => $3d3ce0c592af0505$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3d3ce0c592af0505$export$cf845f2c119da08a, (v) => $3d3ce0c592af0505$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d3ce0c592af0505$export$c4744153514ff05d;
var $3d3ce0c592af0505$export$3e506c1ccc9cc1a7;
var $3d3ce0c592af0505$export$e26fe2ed2fa76875;
var $3d3ce0c592af0505$export$502329bbf4b505b1;
var $3d3ce0c592af0505$export$6e3807111c4874c4;
var $3d3ce0c592af0505$export$c27134553091fb3a;
var $3d3ce0c592af0505$export$33ee1acdc04fd2a2;
var $3d3ce0c592af0505$export$b00a404bbd5edef2;
var $3d3ce0c592af0505$export$8352ce38b91d0c62;
var $3d3ce0c592af0505$export$d66a1c1c77bd778b;
var $3d3ce0c592af0505$export$d3dfb8e4810cb555;
var $3d3ce0c592af0505$export$839f9183b0465a69;
var $3d3ce0c592af0505$export$72fdf0e06517287b;
var $3d3ce0c592af0505$export$4b844e58a3e414b4;
var $3d3ce0c592af0505$export$816d2913ae6b83b1;
var $3d3ce0c592af0505$export$61bcfe829111a1d0;
var $3d3ce0c592af0505$export$7ee8c9beb337bc3f;
var $3d3ce0c592af0505$export$b5836b71941fa3ed;
var $3d3ce0c592af0505$export$cf845f2c119da08a;
'use strict';
function $3d3ce0c592af0505$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $3d3ce0c592af0505$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3d3ce0c592af0505$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $3d3ce0c592af0505$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $3d3ce0c592af0505$var$g(C, c)) n < e && 0 > $3d3ce0c592af0505$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $3d3ce0c592af0505$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $3d3ce0c592af0505$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3d3ce0c592af0505$var$l = performance;
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$l.now();
    };
} else {
    var $3d3ce0c592af0505$var$p = Date, $3d3ce0c592af0505$var$q = $3d3ce0c592af0505$var$p.now();
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$p.now() - $3d3ce0c592af0505$var$q;
    };
}
var $3d3ce0c592af0505$var$r = [], $3d3ce0c592af0505$var$t = [], $3d3ce0c592af0505$var$u = 1, $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = 3, $3d3ce0c592af0505$var$z = !1, $3d3ce0c592af0505$var$A = !1, $3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$D = "function" === typeof setTimeout ? setTimeout : null, $3d3ce0c592af0505$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $3d3ce0c592af0505$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $3d3ce0c592af0505$var$G(a) {
    for(var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t); null !== b;){
        if (null === b.callback) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t);
        else if (b.startTime <= a) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t), b.sortIndex = b.expirationTime, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, b);
        else break;
        b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
    }
}
function $3d3ce0c592af0505$var$H(a) {
    $3d3ce0c592af0505$var$B = !1;
    $3d3ce0c592af0505$var$G(a);
    if (!$3d3ce0c592af0505$var$A) {
        if (null !== $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r)) $3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J);
        else {
            var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== b && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, b.startTime - a);
        }
    }
}
function $3d3ce0c592af0505$var$J(a, b) {
    $3d3ce0c592af0505$var$A = !1;
    $3d3ce0c592af0505$var$B && ($3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1);
    $3d3ce0c592af0505$var$z = !0;
    var c = $3d3ce0c592af0505$var$y;
    try {
        $3d3ce0c592af0505$var$G(b);
        for($3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r); null !== $3d3ce0c592af0505$var$v && (!($3d3ce0c592af0505$var$v.expirationTime > b) || a && !$3d3ce0c592af0505$var$M());){
            var d = $3d3ce0c592af0505$var$v.callback;
            if ("function" === typeof d) {
                $3d3ce0c592af0505$var$v.callback = null;
                $3d3ce0c592af0505$var$y = $3d3ce0c592af0505$var$v.priorityLevel;
                var e = d($3d3ce0c592af0505$var$v.expirationTime <= b);
                b = $3d3ce0c592af0505$export$c4744153514ff05d();
                "function" === typeof e ? $3d3ce0c592af0505$var$v.callback = e : $3d3ce0c592af0505$var$v === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
                $3d3ce0c592af0505$var$G(b);
            } else $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
            $3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
        }
        if (null !== $3d3ce0c592af0505$var$v) var w = !0;
        else {
            var m = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== m && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = c, $3d3ce0c592af0505$var$z = !1;
    }
}
var $3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null, $3d3ce0c592af0505$var$L = -1, $3d3ce0c592af0505$var$P = 5, $3d3ce0c592af0505$var$Q = -1;
function $3d3ce0c592af0505$var$M() {
    return $3d3ce0c592af0505$export$c4744153514ff05d() - $3d3ce0c592af0505$var$Q < $3d3ce0c592af0505$var$P ? !1 : !0;
}
function $3d3ce0c592af0505$var$R() {
    if (null !== $3d3ce0c592af0505$var$O) {
        var a = $3d3ce0c592af0505$export$c4744153514ff05d();
        $3d3ce0c592af0505$var$Q = a;
        var b = !0;
        try {
            b = $3d3ce0c592af0505$var$O(!0, a);
        } finally{
            b ? $3d3ce0c592af0505$var$S() : ($3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null);
        }
    } else $3d3ce0c592af0505$var$N = !1;
}
var $3d3ce0c592af0505$var$S;
if ("function" === typeof $3d3ce0c592af0505$var$F) $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$F($3d3ce0c592af0505$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3d3ce0c592af0505$var$T = new MessageChannel, $3d3ce0c592af0505$var$U = $3d3ce0c592af0505$var$T.port2;
    $3d3ce0c592af0505$var$T.port1.onmessage = $3d3ce0c592af0505$var$R;
    $3d3ce0c592af0505$var$S = function() {
        $3d3ce0c592af0505$var$U.postMessage(null);
    };
} else $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$D($3d3ce0c592af0505$var$R, 0);
};
function $3d3ce0c592af0505$var$I(a) {
    $3d3ce0c592af0505$var$O = a;
    $3d3ce0c592af0505$var$N || ($3d3ce0c592af0505$var$N = !0, $3d3ce0c592af0505$var$S());
}
function $3d3ce0c592af0505$var$K(a, b) {
    $3d3ce0c592af0505$var$L = $3d3ce0c592af0505$var$D(function() {
        a($3d3ce0c592af0505$export$c4744153514ff05d());
    }, b);
}
$3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = 5;
$3d3ce0c592af0505$export$e26fe2ed2fa76875 = 1;
$3d3ce0c592af0505$export$502329bbf4b505b1 = 4;
$3d3ce0c592af0505$export$6e3807111c4874c4 = 3;
$3d3ce0c592af0505$export$c27134553091fb3a = null;
$3d3ce0c592af0505$export$33ee1acdc04fd2a2 = 2;
$3d3ce0c592af0505$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3d3ce0c592af0505$export$8352ce38b91d0c62 = function() {
    $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J));
};
$3d3ce0c592af0505$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3d3ce0c592af0505$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$3d3ce0c592af0505$export$d3dfb8e4810cb555 = function() {
    return $3d3ce0c592af0505$var$y;
};
$3d3ce0c592af0505$export$839f9183b0465a69 = function() {
    return $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
};
$3d3ce0c592af0505$export$72fdf0e06517287b = function(a) {
    switch($3d3ce0c592af0505$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3d3ce0c592af0505$var$y;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = b;
    try {
        return a();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$4b844e58a3e414b4 = function() {};
$3d3ce0c592af0505$export$816d2913ae6b83b1 = function() {};
$3d3ce0c592af0505$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = a;
    try {
        return b();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3d3ce0c592af0505$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3d3ce0c592af0505$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$t, a), null === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && a === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t) && ($3d3ce0c592af0505$var$B ? ($3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1) : $3d3ce0c592af0505$var$B = !0, $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, c - d))) : (a.sortIndex = e, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, a), $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J)));
    return a;
};
$3d3ce0c592af0505$export$b5836b71941fa3ed = $3d3ce0c592af0505$var$M;
$3d3ce0c592af0505$export$cf845f2c119da08a = function(a) {
    var b = $3d3ce0c592af0505$var$y;
    return function() {
        var c = $3d3ce0c592af0505$var$y;
        $3d3ce0c592af0505$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3d3ce0c592af0505$var$y = c;
        }
    };
};

});





parcelRegister("fb0st", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b0c83d16b421d7f5$var$ReactIs, $b0c83d16b421d7f5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("6DzO8"))();

});
parcelRegister("6DzO8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $iz60K = parcelRequire("iz60K");
function $4d52293a79bcab4c$var$emptyFunction() {}
function $4d52293a79bcab4c$var$emptyFunctionWithReset() {}
$4d52293a79bcab4c$var$emptyFunctionWithReset.resetWarningCache = $4d52293a79bcab4c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iz60K) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4d52293a79bcab4c$var$emptyFunctionWithReset,
        resetWarningCache: $4d52293a79bcab4c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iz60K", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $d840288929500773$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $d840288929500773$var$ReactPropTypesSecret;

});



parcelRegister("WkwyL", function(module, exports) {

$parcel$export(module.exports, "goToExactSlide", () => goToExactSlide);
$parcel$export(module.exports, "goToPrevSlide", () => goToPrevSlide);
$parcel$export(module.exports, "goToNextSlide", () => goToNextSlide);
$parcel$export(module.exports, "onSlideChange", () => onSlideChange);
$parcel$export(module.exports, "getDimensionDots", () => getDimensionDots);
$parcel$export(module.exports, "restartSurvey", () => restartSurvey);
$parcel$export(module.exports, "showLeftNavButton", () => showLeftNavButton);
$parcel$export(module.exports, "showRightNavButton", () => showRightNavButton);
$parcel$export(module.exports, "isNextBtnDisabled", () => isNextBtnDisabled);

var $1IdZj = parcelRequire("1IdZj");

var $eVJd7 = parcelRequire("eVJd7");
const goToExactSlide = function(slideIndex) {
    // check first if user is allowed to go to slide (slideIndex)
    // is only allowed to go to slide if all questions up to that slide (slideIndex) are answered
    // 1. Get all question IDs up to position 'slideIndex' that need to be answered
    const slides = this.state.slides;
    const questions = [];
    Object.keys(slides).map((key)=>{
        if (slides[key].type === 'question' && key <= slideIndex) questions.push(slides[key].ID);
    });
    // 2. Get IDs of already answered questions
    const answeredQuestions = [];
    Object.keys(this.state.userData.dimensions).map((key)=>{
        if ('results' in this.state.userData.dimensions[key]) Object.keys(this.state.userData.dimensions[key].results).map((ID)=>{
            answeredQuestions.push(parseInt(ID));
        });
    });
    // 3. Check if all questions up to target slide are answered (exist in the answeredQuestions array)
    let goToSlide = true;
    for(let i = 0; i < questions.length; i++)if (!questions.includes(answeredQuestions[i])) {
        goToSlide = false;
        break;
    }
    if (goToSlide) this.setState({
        position: slideIndex
    });
    else console.error(`You're not allowed to go to the slide with the index ${slideIndex} because you didn't answer all necessary questions yet.`);
};
const goToPrevSlide = function() {
    let position = this.state.position;
    position > 0 && position--;
    this.setState({
        position: position
    }, ()=>{
        this.onSlideChange();
    });
};
const goToNextSlide = function() {
    let position = this.state.position;
    position < Object.keys(this.state.slides).length - 1 && position++;
    const targetState = {
        position: position
    };
    if (position > this.state.userData.progress) targetState.userData = {
        ...this.state.userData,
        progress: position
    };
    this.setState(targetState, ()=>{
        this.onSlideChange(true);
    });
};
const onSlideChange = function(nextSlide = false) {
    // Push data to database (nextSlide determines if user has gone forwards / backwards)
    this.dbPushData(nextSlide);
    // Adjust scroll position
    const container = document.querySelector(`#ms-form-${this.state.id}`);
    if (container) {
        let offset = 100; // Default offset of 100px
        // Take care of WP admin bar
        if (document.querySelector('#wpadminbar')) offset += document.querySelector('#wpadminbar').getBoundingClientRect().height;
        const y = container.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({
            top: y,
            behavior: 'smooth'
        });
    }
};
const getDimensionDots = function() {
    const { dimensions, progress, callback } = this.props;
    return Object.keys(dimensions).map((key, index)=>{
        const range = 100 / Object.keys(dimensions).length;
        const dotClasses = [
            'dot'
        ];
        if (progress.handle >= index * range) dotClasses.push(progress.handle >= (index + 1) * range ? 'done' : 'current');
        return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            className: dotClasses.join(' '),
            onClick: ()=>callback(dimensions[key].slide_start)
        }, key);
    });
};
const restartSurvey = function() {
    // Re-Init state
    this.setState(this.getInitialState());
    // Renew user ID
    this.generateUID(true);
    // Adjust scroll position
    this.onSlideChange();
};
const showLeftNavButton = function() {
    const { position, resultsSlide, labels, restartBtnCallback, prevBtnCallback } = this.props;
    if (position === resultsSlide) return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eVJd7.default), {
        type: "secondary",
        callback: restartBtnCallback,
        title: labels.btn_restart,
        blank: false
    });
    else if (position > 0) return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eVJd7.default), {
        type: "secondary",
        callback: prevBtnCallback,
        title: labels.btn_prev,
        blank: false
    });
};
const showRightNavButton = function() {
    const { position, slideCount, resultsSlide, labels, nextBtnCallback } = this.props;
    if (position < slideCount - 1) {
        const btnTitle = position === resultsSlide ? labels.btn_next_steps : labels.btn_next;
        return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $eVJd7.default), {
            type: "primary",
            disabled: this.isNextBtnDisabled(),
            callback: nextBtnCallback,
            title: btnTitle,
            blank: false
        });
    }
};
const isNextBtnDisabled = function() {
    const { slide, userData } = this.props;
    let show = true;
    if (slide.type === 'question') show = slide.dimension in userData.dimensions && 'results' in userData.dimensions[slide.dimension] && slide.ID in userData.dimensions[slide.dimension].results;
    return !show;
};

});
parcelRegister("eVJd7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ade97570ed73c258$export$2e2bcd8739ae039);

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");
class $ade97570ed73c258$var$Button extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
    }
    render() {
        const classes = [
            'btn',
            `btn--${this.props.type}`
        ];
        if (this.props.disabled) classes.push('disabled');
        return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            className: "btn-ctr",
            children: /*#__PURE__*/ (0, $1IdZj.jsx)("button", {
                onClick: this.props.callback,
                className: classes.join(' '),
                title: this.props.title,
                rel: this.props.blank ? 'noopener noreferrer' : '',
                target: this.props.blank ? '_blank' : '_self',
                children: this.props.title
            })
        });
    }
}
var $ade97570ed73c258$export$2e2bcd8739ae039 = $ade97570ed73c258$var$Button;
$ade97570ed73c258$var$Button.propTypes = {
    blank: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    callback: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string
};

});


parcelRegister("bvxsi", function(module, exports) {

$parcel$export(module.exports, "generateUID", () => generateUID);
$parcel$export(module.exports, "trackUser", () => trackUser);
$parcel$export(module.exports, "getStorageFormKey", () => getStorageFormKey);
$parcel$export(module.exports, "getSessionData", () => getSessionData);
$parcel$export(module.exports, "getUID", () => getUID);
$parcel$export(module.exports, "updateSessionData", () => updateSessionData);
const generateUID = function(force = false) {
    // Handle Session Storage
    const storageKey = 'itdms_uid';
    /**
	 * this.props.track can be
	 * => 0                       => Do not track
	 * => 1                       => Track with any user ID
	 * => a string of any length  => Track with given user ID, f.e. 'sf-lka'
	 */ /**
	 * Generate new user ID if
	 * => the user should be tracked
	 * AND
	 * => there is no user ID yet |OR| there should be a custom user ID |OR| the generation is enforced
	 */ if (this.trackUser() && (!sessionStorage.getItem(storageKey) || this.props.track !== '1' || force)) {
        let UID;
        // Generate random user ID if there is no custom ID transferred
        if (this.props.track === '1') UID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        else UID = this.props.track;
        sessionStorage.setItem(storageKey, UID);
    } else if (!this.trackUser()) sessionStorage.removeItem(storageKey);
};
const trackUser = function() {
    return this.props.track !== '0';
};
const getStorageFormKey = function() {
    const htmlTag = document.querySelector('html');
    const language = 'lang' in htmlTag ? htmlTag.lang + '_' : '';
    return `itdms_v${this.props.version}_form_${language}${this.state.id}`;
};
const getSessionData = function() {
    const key = this.getStorageFormKey();
    return sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key)) : {};
};
const getUID = function() {
    return sessionStorage.getItem('itdms_uid');
};
const updateSessionData = function() {
    const data = {
        position: this.state.position,
        userData: this.state.userData
    };
    sessionStorage.setItem(this.getStorageFormKey(), JSON.stringify(data));
};

});

parcelRegister("5zL6F", function(module, exports) {

$parcel$export(module.exports, "default", () => $40f4c2feb843f2da$export$2e2bcd8739ae039);
function $40f4c2feb843f2da$export$2e2bcd8739ae039(t, e) {
    return $40f4c2feb843f2da$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $40f4c2feb843f2da$export$2e2bcd8739ae039(t, e);
}

});

parcelRegister("1oVxX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1054abeafa6bc7e1$export$2e2bcd8739ae039);
function $1054abeafa6bc7e1$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("jz4iA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3e49ed681292e30$export$2e2bcd8739ae039);
function $e3e49ed681292e30$export$2e2bcd8739ae039() {
    return $e3e49ed681292e30$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e3e49ed681292e30$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("hQtye", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfde373be945f92b$export$2e2bcd8739ae039);
function $cfde373be945f92b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("j1hfP", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $dd8b7eae05661df3$export$a7c73072b1a182ae, (v) => $dd8b7eae05661df3$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $dd8b7eae05661df3$export$9f27bc3417b4524d, (v) => $dd8b7eae05661df3$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $dd8b7eae05661df3$export$db77ccec0bb4ccac, (v) => $dd8b7eae05661df3$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $dd8b7eae05661df3$export$8392c0c9d3dcbd35, (v) => $dd8b7eae05661df3$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $dd8b7eae05661df3$export$ffb0004e005737fa, (v) => $dd8b7eae05661df3$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $dd8b7eae05661df3$export$b624eff549462981, (v) => $dd8b7eae05661df3$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $dd8b7eae05661df3$export$7897aa7841a5380c, (v) => $dd8b7eae05661df3$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $dd8b7eae05661df3$export$602eac185826482c, (v) => $dd8b7eae05661df3$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $dd8b7eae05661df3$export$e2c29f18771995cb, (v) => $dd8b7eae05661df3$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $dd8b7eae05661df3$export$5f8d39834fd61797, (v) => $dd8b7eae05661df3$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $dd8b7eae05661df3$export$74bf444e3cd11ea5, (v) => $dd8b7eae05661df3$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $dd8b7eae05661df3$export$998bcd577473dd93, (v) => $dd8b7eae05661df3$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $dd8b7eae05661df3$export$92387174baf9b227, (v) => $dd8b7eae05661df3$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $dd8b7eae05661df3$export$ec112efeb987d9c6, (v) => $dd8b7eae05661df3$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $dd8b7eae05661df3$export$b706b080d889d2c9, (v) => $dd8b7eae05661df3$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $dd8b7eae05661df3$export$5be5a87408f70ddc, (v) => $dd8b7eae05661df3$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $dd8b7eae05661df3$export$45a5e7f76e0caa8d, (v) => $dd8b7eae05661df3$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $dd8b7eae05661df3$export$455c2e768291efa6, (v) => $dd8b7eae05661df3$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $dd8b7eae05661df3$export$9522e17588c12572, (v) => $dd8b7eae05661df3$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $dd8b7eae05661df3$export$2110ac352bb060b9, (v) => $dd8b7eae05661df3$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $dd8b7eae05661df3$export$56885ab8b9c456ab, (v) => $dd8b7eae05661df3$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $dd8b7eae05661df3$export$d927fcb6adf8f9de, (v) => $dd8b7eae05661df3$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $dd8b7eae05661df3$export$b82d16f27459e05a, (v) => $dd8b7eae05661df3$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $dd8b7eae05661df3$export$522c17b4f5e123e8, (v) => $dd8b7eae05661df3$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $dd8b7eae05661df3$export$1aabd8a0274ecfd6, (v) => $dd8b7eae05661df3$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $dd8b7eae05661df3$export$3d6c20d97e46b957, (v) => $dd8b7eae05661df3$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $dd8b7eae05661df3$export$9b621391a187a31a, (v) => $dd8b7eae05661df3$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $dd8b7eae05661df3$export$f5bbd400c2f4426f, (v) => $dd8b7eae05661df3$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd8b7eae05661df3$export$a7c73072b1a182ae;
var $dd8b7eae05661df3$export$9f27bc3417b4524d;
var $dd8b7eae05661df3$export$db77ccec0bb4ccac;
var $dd8b7eae05661df3$export$8392c0c9d3dcbd35;
var $dd8b7eae05661df3$export$ffb0004e005737fa;
var $dd8b7eae05661df3$export$b624eff549462981;
var $dd8b7eae05661df3$export$7897aa7841a5380c;
var $dd8b7eae05661df3$export$602eac185826482c;
var $dd8b7eae05661df3$export$e2c29f18771995cb;
var $dd8b7eae05661df3$export$5f8d39834fd61797;
var $dd8b7eae05661df3$export$74bf444e3cd11ea5;
var $dd8b7eae05661df3$export$998bcd577473dd93;
var $dd8b7eae05661df3$export$92387174baf9b227;
var $dd8b7eae05661df3$export$ec112efeb987d9c6;
var $dd8b7eae05661df3$export$b706b080d889d2c9;
var $dd8b7eae05661df3$export$5be5a87408f70ddc;
var $dd8b7eae05661df3$export$45a5e7f76e0caa8d;
var $dd8b7eae05661df3$export$455c2e768291efa6;
var $dd8b7eae05661df3$export$9522e17588c12572;
var $dd8b7eae05661df3$export$2110ac352bb060b9;
var $dd8b7eae05661df3$export$56885ab8b9c456ab;
var $dd8b7eae05661df3$export$d927fcb6adf8f9de;
var $dd8b7eae05661df3$export$b82d16f27459e05a;
var $dd8b7eae05661df3$export$522c17b4f5e123e8;
var $dd8b7eae05661df3$export$1aabd8a0274ecfd6;
var $dd8b7eae05661df3$export$3d6c20d97e46b957;
var $dd8b7eae05661df3$export$9b621391a187a31a;
var $dd8b7eae05661df3$export$f5bbd400c2f4426f;
'use strict';
var $dd8b7eae05661df3$var$b = Symbol.for("react.element"), $dd8b7eae05661df3$var$c = Symbol.for("react.portal"), $dd8b7eae05661df3$var$d = Symbol.for("react.fragment"), $dd8b7eae05661df3$var$e = Symbol.for("react.strict_mode"), $dd8b7eae05661df3$var$f = Symbol.for("react.profiler"), $dd8b7eae05661df3$var$g = Symbol.for("react.provider"), $dd8b7eae05661df3$var$h = Symbol.for("react.context"), $dd8b7eae05661df3$var$k = Symbol.for("react.server_context"), $dd8b7eae05661df3$var$l = Symbol.for("react.forward_ref"), $dd8b7eae05661df3$var$m = Symbol.for("react.suspense"), $dd8b7eae05661df3$var$n = Symbol.for("react.suspense_list"), $dd8b7eae05661df3$var$p = Symbol.for("react.memo"), $dd8b7eae05661df3$var$q = Symbol.for("react.lazy"), $dd8b7eae05661df3$var$t = Symbol.for("react.offscreen"), $dd8b7eae05661df3$var$u;
$dd8b7eae05661df3$var$u = Symbol.for("react.module.reference");
function $dd8b7eae05661df3$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $dd8b7eae05661df3$var$b:
                switch(a = a.type, a){
                    case $dd8b7eae05661df3$var$d:
                    case $dd8b7eae05661df3$var$f:
                    case $dd8b7eae05661df3$var$e:
                    case $dd8b7eae05661df3$var$m:
                    case $dd8b7eae05661df3$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $dd8b7eae05661df3$var$k:
                            case $dd8b7eae05661df3$var$h:
                            case $dd8b7eae05661df3$var$l:
                            case $dd8b7eae05661df3$var$q:
                            case $dd8b7eae05661df3$var$p:
                            case $dd8b7eae05661df3$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $dd8b7eae05661df3$var$c:
                return r;
        }
    }
}
$dd8b7eae05661df3$export$a7c73072b1a182ae = $dd8b7eae05661df3$var$h;
$dd8b7eae05661df3$export$9f27bc3417b4524d = $dd8b7eae05661df3$var$g;
$dd8b7eae05661df3$export$db77ccec0bb4ccac = $dd8b7eae05661df3$var$b;
$dd8b7eae05661df3$export$8392c0c9d3dcbd35 = $dd8b7eae05661df3$var$l;
$dd8b7eae05661df3$export$ffb0004e005737fa = $dd8b7eae05661df3$var$d;
$dd8b7eae05661df3$export$b624eff549462981 = $dd8b7eae05661df3$var$q;
$dd8b7eae05661df3$export$7897aa7841a5380c = $dd8b7eae05661df3$var$p;
$dd8b7eae05661df3$export$602eac185826482c = $dd8b7eae05661df3$var$c;
$dd8b7eae05661df3$export$e2c29f18771995cb = $dd8b7eae05661df3$var$f;
$dd8b7eae05661df3$export$5f8d39834fd61797 = $dd8b7eae05661df3$var$e;
$dd8b7eae05661df3$export$74bf444e3cd11ea5 = $dd8b7eae05661df3$var$m;
$dd8b7eae05661df3$export$998bcd577473dd93 = $dd8b7eae05661df3$var$n;
$dd8b7eae05661df3$export$92387174baf9b227 = function() {
    return !1;
};
$dd8b7eae05661df3$export$ec112efeb987d9c6 = function() {
    return !1;
};
$dd8b7eae05661df3$export$b706b080d889d2c9 = function(a) {
    return $dd8b7eae05661df3$var$v(a) === $dd8b7eae05661df3$var$h;
};
$dd8b7eae05661df3$export$5be5a87408f70ddc = function(a) {
    return $dd8b7eae05661df3$var$v(a) === $dd8b7eae05661df3$var$g;
};
$dd8b7eae05661df3$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dd8b7eae05661df3$var$b;
};
$dd8b7eae05661df3$export$455c2e768291efa6 = function(a) {
    return $dd8b7eae05661df3$var$v(a) === $dd8b7eae05661df3$var$l;
};
$dd8b7eae05661df3$export$9522e17588c12572 = function(a) {
    return $dd8b7eae05661df3$var$v(a) === $dd8b7eae05661df3$var$d;
};
$dd8b7eae05661df3$export$2110ac352bb060b9 = function(a) {
    return $dd8b7eae05661df3$var$v(a) === $dd8b7eae05661df3$var$q;
};
$dd8b7eae05661df3$export$56885ab8b9c456ab = function(a) {
    return $dd8b7eae05661df3$var$v(a) === $dd8b7eae05661df3$var$p;
};
$dd8b7eae05661df3$export$d927fcb6adf8f9de = function(a) {
    return $dd8b7eae05661df3$var$v(a) === $dd8b7eae05661df3$var$c;
};
$dd8b7eae05661df3$export$b82d16f27459e05a = function(a) {
    return $dd8b7eae05661df3$var$v(a) === $dd8b7eae05661df3$var$f;
};
$dd8b7eae05661df3$export$522c17b4f5e123e8 = function(a) {
    return $dd8b7eae05661df3$var$v(a) === $dd8b7eae05661df3$var$e;
};
$dd8b7eae05661df3$export$1aabd8a0274ecfd6 = function(a) {
    return $dd8b7eae05661df3$var$v(a) === $dd8b7eae05661df3$var$m;
};
$dd8b7eae05661df3$export$3d6c20d97e46b957 = function(a) {
    return $dd8b7eae05661df3$var$v(a) === $dd8b7eae05661df3$var$n;
};
$dd8b7eae05661df3$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $dd8b7eae05661df3$var$d || a === $dd8b7eae05661df3$var$f || a === $dd8b7eae05661df3$var$e || a === $dd8b7eae05661df3$var$m || a === $dd8b7eae05661df3$var$n || a === $dd8b7eae05661df3$var$t || "object" === typeof a && null !== a && (a.$$typeof === $dd8b7eae05661df3$var$q || a.$$typeof === $dd8b7eae05661df3$var$p || a.$$typeof === $dd8b7eae05661df3$var$g || a.$$typeof === $dd8b7eae05661df3$var$h || a.$$typeof === $dd8b7eae05661df3$var$l || a.$$typeof === $dd8b7eae05661df3$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$dd8b7eae05661df3$export$f5bbd400c2f4426f = $dd8b7eae05661df3$var$v;

});

parcelRegister("NnYqF", function(module, exports) {

$parcel$export(module.exports, "handleChange", () => handleChange);
$parcel$export(module.exports, "handleSliderChange", () => handleSliderChange);
$parcel$export(module.exports, "afterChangeHandled", () => afterChangeHandled);
const handleChange = function(event) {
    const t = event.target;
    const q = this.state.slides[this.state.position];
    const userData = {
        ...this.state.userData
    };
    const includeInScore = this.state.dimensions[q.dimension].include_in_score;
    if (!(q.dimension in userData.dimensions)) userData.dimensions[q.dimension] = {
        results: {}
    };
    const results = {
        ...userData.dimensions[q.dimension].results
    };
    let answers;
    if (t.type === 'radio') answers = parseInt(t.id);
    else if (t.type === 'checkbox') {
        const answerIndex = parseInt(t.id);
        answers = q.ID in results ? results[q.ID].answers : [];
        // Get exclusive answers
        let exclusiveAnswers = [];
        q.answers.forEach((answer, i)=>{
            if (answer.exclusive) exclusiveAnswers.push(i);
        });
        if (t.checked) {
            // Checkbox is checked
            if (exclusiveAnswers.includes(answerIndex)) // is an exclusive answer
            answers = [
                answerIndex
            ];
            else {
                // is not an exclusive answer
                // uncheck all exclusive answers
                exclusiveAnswers.forEach((i)=>{
                    if (answers.includes(i)) answers.splice(answers.indexOf(i), 1);
                });
                // push answer to answers array
                answers.push(answerIndex);
            }
        } else if (answers.indexOf(answerIndex) !== -1) {
            // Checkbox is not checked and unchecked box still exists in the answers array
            answers.splice(answers.indexOf(answerIndex), 1);
            // If no answer is selected set answers to false to remove it from the results list
            if (!answers.length) answers = false;
        }
    } else if (t.type === 'text') answers = t.value.length ? parseInt(t.value) : false;
    if (answers !== false) {
        results[q.ID] = {
            answers: answers
        };
        if (includeInScore) results[q.ID].score = this.getQuestionScore(answers);
    } else delete results[q.ID];
    userData.dimensions[q.dimension].results = results;
    this.afterChangeHandled(userData);
};
const handleSliderChange = function(value) {
    const q = this.state.slides[this.state.position];
    const userData = {
        ...this.state.userData
    };
    const includeInScore = this.state.dimensions[q.dimension].include_in_score;
    if (!(q.dimension in userData.dimensions)) userData.dimensions[q.dimension] = {
        results: {}
    };
    const results = {
        ...userData.dimensions[q.dimension].results
    };
    if (q.scale_options.type === 'percentage') {
        let i = 0;
        for(let key in q.answers){
            const answer = q.answers[key];
            if (value >= answer.min && value <= answer.max) {
                results[q.ID] = {
                    answers: value,
                    answerIndex: i
                };
                if (includeInScore) results[q.ID].score = answer.value;
                break;
            }
            i++;
        }
    } else if (q.scale_options.type === 'fixed') {
        const steps = 100 / (Object.keys(q.answers).length - 1);
        for(let i = 0; i < steps; i++)if (value === steps * i) {
            results[q.ID] = {
                answers: i
            };
            if (includeInScore) results[q.ID].score = q.answers[i].value;
            break;
        }
    }
    userData.dimensions[q.dimension].results = results;
    this.afterChangeHandled(userData);
};
const afterChangeHandled = function(userData) {
    this.setState({
        userData: userData
    }, this.calcUserScore);
};

});

parcelRegister("aoYbE", function(module, exports) {

$parcel$export(module.exports, "getQuestionScore", () => getQuestionScore);
$parcel$export(module.exports, "calcUserScore", () => calcUserScore);
$parcel$export(module.exports, "calcDimensionScore", () => calcDimensionScore);
$parcel$export(module.exports, "calcTotalScore", () => calcTotalScore);
const getQuestionScore = function(chosenAnswers) {
    const slide = this.state.slides[this.state.position];
    let score = 0;
    if (Array.isArray(chosenAnswers)) chosenAnswers.forEach((answerKey)=>{
        score += slide.answers[answerKey].value;
    });
    else score = slide.answers[chosenAnswers].value;
    return score;
};
const calcUserScore = function() {
    const state = this.state;
    // Only recalculate score if question is inside a dimension that is included in the total score
    if (state.dimensions[state.slides[state.position].dimension].include_in_score) this.calcDimensionScore(this.calcTotalScore);
};
const calcDimensionScore = function(callback) {
    const d = this.state.slides[this.state.position].dimension;
    const dimensionResults = {
        ...this.state.userData.dimensions[d].results
    };
    // Only calculate score of dimension if all its questions are answered
    if (Object.keys(dimensionResults).length === this.state.dimensions[d].question_count) {
        let pointsInDimension = 0;
        for(let i in dimensionResults)pointsInDimension += dimensionResults[i].score;
        // Calculate final score as ratio
        const dimensionScore = Math.round(pointsInDimension / this.state.dimensions[d].max_score * 100);
        this.setState({
            userData: {
                ...this.state.userData,
                dimensions: {
                    ...this.state.userData.dimensions,
                    [d]: {
                        ...this.state.userData.dimensions[d],
                        score: dimensionScore
                    }
                }
            }
        }, callback);
    // Remove dimension score and total score if not all questions in the dimension are answered
    } else this.setState({
        userData: {
            ...this.state.userData,
            dimensions: {
                ...this.state.userData.dimensions,
                [d]: {
                    ...this.state.userData.dimensions[d],
                    score: false
                }
            },
            score: false
        }
    });
};
const calcTotalScore = function() {
    const dimensions = this.state.dimensions;
    let dimensionScores = [];
    let score = false;
    for(let d in dimensions)// Check if dimension should be included for total score calculation
    if (dimensions[d].include_in_score) {
        // Check if dimension exists in user data and has a valid score, otherwise reset score to false
        if (d in this.state.userData.dimensions && this.state.userData.dimensions[d].score !== false) dimensionScores.push(this.state.userData.dimensions[d].score);
        else {
            dimensionScores = [];
            break;
        }
    }
    if (dimensionScores.length) score = Math.round(dimensionScores.reduce((previousValue, currentValue)=>{
        return previousValue + currentValue;
    }) / dimensionScores.length);
    this.setState({
        userData: {
            ...this.state.userData,
            score: score
        }
    });
};

});


var $1IdZj = parcelRequire("1IdZj");

var $6T1J1 = parcelRequire("6T1J1");

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");

var $WkwyL = parcelRequire("WkwyL");

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");

var $WkwyL = parcelRequire("WkwyL");
class $e9050d49f4902b22$var$ProgressBar extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.getDimensionDots = (0, $WkwyL.getDimensionDots).bind(this);
    }
    render() {
        const { progress: progress, callback: callback, resultsSlide: resultsSlide } = this.props;
        return progress && /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: "ms-form__progress",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                    className: "progress__label",
                    children: 'label' in progress && progress.label
                }),
                !isNaN(progress.handle) && /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                    className: "progress__bar",
                    style: {
                        '--progress': `${progress.handle}%`
                    },
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                            className: "progress__bar-dots",
                            children: [
                                this.getDimensionDots().map((dot)=>dot),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                    className: `dot${progress.handle == 100 ? ' done' : ''}`,
                                    onClick: ()=>callback(resultsSlide)
                                }, "success")
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                            className: "progress__bar-handle"
                        })
                    ]
                })
            ]
        });
    }
}
var $e9050d49f4902b22$export$2e2bcd8739ae039 = $e9050d49f4902b22$var$ProgressBar;
$e9050d49f4902b22$var$ProgressBar.propTypes = {
    resultsSlide: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number,
    dimensions: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    progress: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object
    ]),
    callback: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func
};


class $a3d3ed27e1a6538a$var$Navigation extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.showLeftNavButton = (0, $WkwyL.showLeftNavButton).bind(this);
        this.showRightNavButton = (0, $WkwyL.showRightNavButton).bind(this);
        this.isNextBtnDisabled = (0, $WkwyL.isNextBtnDisabled).bind(this);
    }
    render() {
        const { resultsSlide: resultsSlide, dimensions: dimensions, progress: progress, goToSlideCallback: goToSlideCallback } = this.props;
        return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: "ms-form__nav",
            "data-color-scheme": "highlight",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    className: "left",
                    children: this.showLeftNavButton()
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    className: "center",
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $e9050d49f4902b22$export$2e2bcd8739ae039), {
                        resultsSlide: resultsSlide,
                        dimensions: dimensions,
                        progress: progress,
                        callback: goToSlideCallback
                    })
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    className: "right",
                    children: this.showRightNavButton()
                })
            ]
        });
    }
}
var $a3d3ed27e1a6538a$export$2e2bcd8739ae039 = $a3d3ed27e1a6538a$var$Navigation;
$a3d3ed27e1a6538a$var$Navigation.propTypes = {
    dimensions: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    goToSlideCallback: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    progress: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object
    ]),
    resultsSlide: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number
};



var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");
function $1c5e0f262090d698$export$2e2bcd8739ae039({ tile_content: tile_content }) {
    const { name: name, image: image, desc: desc, link: link, link_type: link_type, link_text: link_text } = {
        ...tile_content
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)("a", {
        href: link,
        target: "_blank",
        rel: "noreferrer",
        title: link_text,
        className: "tile tile--image-size-regular",
        "data-link-type": link_type,
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: "tile__container",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsxs)("header", {
                    className: "tile__header",
                    children: [
                        image && /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
                            src: image,
                            alt: name
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                            className: "h6",
                            children: name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    className: "tile__content",
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                        children: desc
                    })
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("footer", {
                    className: "tile__footer"
                })
            ]
        })
    });
}
$1c5e0f262090d698$export$2e2bcd8739ae039.propTypes = {
    tile_content: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object
};


const $df23d4326b8d2ae1$export$a0e4cd1069957a24 = function() {
    const { dimensions: dimensions, userData: userData, highscoreContent: highscoreContent } = this.props;
    /**
	 * 1. Classify the result of the dimension in stage
	 */ let userStages = {};
    Object.keys(userData.dimensions).map((d)=>{
        // Make sure a score for the dimension exists
        if ('score' in userData.dimensions[d] && userData.dimensions[d].score !== false) {
            let score = userData.dimensions[d].score;
            // If any stage exists in this dimension check in which stage the user has reached with his score
            const stages = dimensions[d].stages;
            if (stages.length) for(let i = 0; i < stages.length; i++){
                // Divides the number of existing stages into steps of equal size and determines the upper limit for the current stage
                const upperStageLimit = 100 / (stages.length + 1) * (i + 1);
                if (score <= upperStageLimit) {
                    // Check if score is smaller than the upper stage limit
                    userStages[d] = {
                        index: i,
                        ratio: (i + 1) / (stages.length + 1)
                    };
                    break;
                } else if (i === stages.length - 1) // If the score was always higher than the previous stage limits it must be in the highest stage
                userStages[d] = {
                    ratio: 1
                };
            }
        }
    });
    // Only continue if any dimension score could be classified in a stage
    if (!Object.keys(userStages).length) return {};
    /**
	 * 2. Check in which dimension the user is in the lowest stage
	 */ let [highestStageValue, lowStageDimensions] = [
        1,
        []
    ];
    for(let dimension in userStages){
        let value = userStages[dimension].ratio;
        const obj = {
            dimension: dimension,
            priority: dimensions[dimension].priority
        };
        // Check if value if lower than the currently set highest value
        if (value < highestStageValue) {
            highestStageValue = value;
            lowStageDimensions = [
                obj
            ];
        } else if (value === highestStageValue) lowStageDimensions.push(obj);
    }
    /**
	 * 3. Return the recommendations from this stage / If the user is already in the highest stage return the highscore text
	 */ if (highestStageValue === 1) // User is in the highest stage in all dimensions
    // Return the highscore recommendation object
    return highscoreContent;
    else {
        // There is a single lowest stage of all dimensions
        // OR there are multiple stages that are equally low (potentially all stages even have the same value)
        let d = lowStageDimensions[0].dimension;
        if (lowStageDimensions.length > 1) {
            // Check the dimension's priorities.
            // Hint: If there are multiple dimensions with equally high priorities the recommendation will be delievered from the first dimension in the loop
            let maxPriority = 0;
            lowStageDimensions.forEach((obj, i)=>{
                if (obj.priority > maxPriority) {
                    d = lowStageDimensions[i].dimension;
                    maxPriority = obj.priority;
                }
            });
        }
        return dimensions[d].stages[userStages[d].index];
    }
};
const $df23d4326b8d2ae1$export$b141de964f0a90c1 = function(max) {
    return Math.floor(Math.random() * max);
};
const $df23d4326b8d2ae1$export$52411745da118fc8 = function() {
    const { contacts: contacts, userData: userData } = this.props;
    if ('contact' in userData) return userData.contact in contacts ? contacts[userData.contact] : false;
    else {
        const length = Object.keys(contacts).length;
        if (!length) // There are no contacts to show so immediately return
        return false;
        else if (length > 1) {
            // Choose any contact by random and save it in the userData
            const randomKey = Object.keys(contacts)[$df23d4326b8d2ae1$export$b141de964f0a90c1(length)];
            this.props.updateUserContact(randomKey);
            return contacts[randomKey];
        } else // Return the only contact
        return contacts[Object.keys(contacts)[0]];
    }
};
const $df23d4326b8d2ae1$export$56eb8157210847c9 = function(contactKey) {
    this.setState({
        userData: {
            ...this.state.userData,
            contact: contactKey
        }
    });
};


const $247928ef2df5839f$export$35062f12cb0d3a15 = function() {
    const { recommended_content: score_recommendations, userData: userData, slides: slides } = this.props;
    const contents = [];
    /**
	 * 1. Score Based Recommended Content
	 */ if (score_recommendations) {
        if (score_recommendations.length > 1) // Get the recommendation based on the user's score
        for(let i = 0; i < score_recommendations.length; i++){
            const upperLimit = 100 / score_recommendations.length * (i + 1);
            if (userData.score < upperLimit) {
                contents.push(score_recommendations[i]);
                break;
            }
        }
        else // Add the one and only recommended content
        contents.push(score_recommendations[0]);
    }
    /**
	 * 2. Answer Based Recommended Content
	 */ const answer_recommendations = [];
    Object.keys(userData.dimensions).map((d)=>{
        Object.keys(userData.dimensions[d].results).map((id)=>{
            // Get the related slide for the question with the current ID
            const slide = slides[slides.indexOf(slides.filter((s)=>s.ID === parseInt(id))[0])];
            // Get the selected answer(s)
            let selection;
            if (slide.input_type === 'scale' && slide.scale_options.type === 'percentage') // Exception for percentage scales, since the 'answers' key doesn't represent the answer index but the absolute slider value
            selection = userData.dimensions[d].results[id].answerIndex;
            else selection = userData.dimensions[d].results[id].answers;
            // Convert number to array to make it 'loopable'
            if (Number.isInteger(selection)) selection = [
                selection
            ];
            // Check if there are any recommendations for each given answer
            selection.forEach((value)=>{
                if (slide.answers[value].recommended_content) answer_recommendations.push(slide.answers[value].recommended_content);
            });
        });
    });
    if (answer_recommendations.length) // If there are multiple answer based recommendations choose a single recommendation by random
    contents.push(answer_recommendations.length > 1 ? answer_recommendations[(0, $df23d4326b8d2ae1$export$b141de964f0a90c1)(answer_recommendations.length)] : answer_recommendations[0]);
    return contents;
};



var $bvxsi = parcelRequire("bvxsi");
class $01328e895cd0998c$var$NextSteps extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.getRecommendedContent = $247928ef2df5839f$export$35062f12cb0d3a15.bind(this);
    }
    componentDidMount = ()=>{
        const { dimensions: dimensions, userData: userData } = this.props;
        /**
		 * Handle HubSpot form data
		 */ const wrapper = document.querySelector('.maturity-score');
        const hiddenFormMeta = {
            uid: 'input[name="itdms_uid"]',
            score: 'input[name="itdms_score"]',
            dimension: 'input[name="itdms_dimension"]'
        };
        if ((0, $bvxsi.getUID)() && wrapper.querySelector(hiddenFormMeta.uid)) wrapper.querySelector(hiddenFormMeta.uid).value = (0, $bvxsi.getUID)();
        if ('score' in userData && wrapper.querySelector(hiddenFormMeta.score)) wrapper.querySelector(hiddenFormMeta.score).value = userData.score;
        if (wrapper.querySelector(hiddenFormMeta.dimension)) {
            const dimensionScores = [];
            Object.keys(userData.dimensions).map((key)=>{
                if (dimensions[key].include_in_score) dimensionScores.push(`${dimensions[key].name}: ${userData.dimensions[key].score}`);
            });
            wrapper.querySelector(hiddenFormMeta.dimension).value = dimensionScores.join('\n');
        }
    };
    render() {
        const { headline: headline, subline: subline, custom_content: custom_content } = this.props;
        const recommendations = this.getRecommendedContent();
        return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: "ms-form__next",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("h2", {
                    children: headline
                }),
                subline && /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                    children: subline
                }),
                recommendations && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    className: "tile-grid",
                    "data-row-elms": "4",
                    children: Object.keys(recommendations).map((key)=>{
                        const rec = recommendations[key];
                        const tile_content = {
                            name: rec.title,
                            desc: rec.link_text,
                            link_type: rec.link_type,
                            link: rec.link,
                            image: rec.image
                        };
                        return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1c5e0f262090d698$export$2e2bcd8739ae039), {
                            tile_content: tile_content
                        }, key);
                    })
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    className: "ms-form__custom-content",
                    dangerouslySetInnerHTML: {
                        __html: custom_content
                    }
                })
            ]
        });
    }
}
var $01328e895cd0998c$export$2e2bcd8739ae039 = $01328e895cd0998c$var$NextSteps;
$01328e895cd0998c$var$NextSteps.propTypes = {
    custom_content: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    dimensions: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    headline: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    slides: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).any,
    subline: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    userData: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object
};



var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");
class $9edc08ff19eb0b97$var$Image extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    render() {
        const image = this.props.image;
        return /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
            src: 'large' in image.sizes ? image.sizes.large.url : image.url,
            alt: ""
        });
    }
}
var $9edc08ff19eb0b97$export$2e2bcd8739ae039 = $9edc08ff19eb0b97$var$Image;
$9edc08ff19eb0b97$var$Image.propTypes = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object
};



var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");
class $ce4a206fc6628ca0$var$Dropdown extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.state = {
            active: false
        };
        this.selectRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createRef();
        this.input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createRef();
    }
    toggleSelect = ()=>{
        this.setState({
            active: !this.state.active
        });
    };
    changeOption = (key, label)=>{
        this.selectRef.current.innerHTML = label;
        this.input.current.value = parseInt(key);
        this.input.current.dispatchEvent(new Event('input', {
            bubbles: true
        }));
    };
    render() {
        const { name: name, options: options, defaultValue: defaultValue, placeholder: placeholder, handleChange: handleChange } = this.props;
        const selectValues = Array();
        Object.keys(options).map((key)=>selectValues.push(options[key].label));
        return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: 'dropdown' + (this.state.active ? ' active' : ''),
            onClick: (e)=>this.toggleSelect(e),
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                    className: "dropdown__select",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                            ref: this.selectRef,
                            children: defaultValue !== false ? selectValues[defaultValue] : placeholder
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("i", {
                            className: "select__icon"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("ul", {
                    className: "dropdown__menu",
                    children: Object.keys(options).map((key)=>/*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                            className: defaultValue === parseInt(key) ? 'active' : '',
                            onClick: ()=>this.changeOption(key, options[key].label),
                            children: options[key].label
                        }, `option_${key}`))
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                    type: "text",
                    ref: this.input,
                    name: name,
                    onInput: handleChange,
                    value: defaultValue
                })
            ]
        });
    }
}
var $ce4a206fc6628ca0$export$2e2bcd8739ae039 = $ce4a206fc6628ca0$var$Dropdown;
$ce4a206fc6628ca0$var$Dropdown.propTypes = {
    defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number
    ]),
    handleChange: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).array,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string
};



var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");
class $d5af52267f39a723$var$Radio extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    render() {
        const { id: id, name: name, title: title, checked: checked, handleChange: handleChange } = this.props;
        return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: "input",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                    htmlFor: id,
                    children: title
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                    type: "radio",
                    name: name,
                    id: id,
                    onChange: handleChange,
                    defaultChecked: checked
                })
            ]
        });
    }
}
var $d5af52267f39a723$export$2e2bcd8739ae039 = $d5af52267f39a723$var$Radio;
$d5af52267f39a723$var$Radio.propTypes = {
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    handleChange: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string
};



var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");
function $e6d8aa307cfbe8b4$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e6d8aa307cfbe8b4$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039(o);
}



function $b650924e9996270c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $e977edce0f75b0db$export$2e2bcd8739ae039(t) {
    var i = (0, $b650924e9996270c$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $1c3963e2ec4676f7$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $e977edce0f75b0db$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $41de237383779de8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41de237383779de8$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41de237383779de8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41de237383779de8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $a0703d0085fc4fb2$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $fe9a5bf59b39de5a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $e977edce0f75b0db$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $fe9a5bf59b39de5a$export$2e2bcd8739ae039(e, r, t) {
    return r && $fe9a5bf59b39de5a$var$_defineProperties(e.prototype, r), t && $fe9a5bf59b39de5a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



var $5zL6F = parcelRequire("5zL6F");
function $165305ab584beb18$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $5zL6F.default)(t, e);
}


function $7d424663944f7a08$export$2e2bcd8739ae039(t) {
    return $7d424663944f7a08$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $7d424663944f7a08$export$2e2bcd8739ae039(t);
}


function $130fc8bc944821df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($130fc8bc944821df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




var $1oVxX = parcelRequire("1oVxX");
function $7c1fc3fad5a369a2$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $1oVxX.default)(t);
}


function $5d0d7e04eb688530$export$2e2bcd8739ae039(t) {
    var r = (0, $130fc8bc944821df$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $7d424663944f7a08$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $7d424663944f7a08$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $7c1fc3fad5a369a2$export$2e2bcd8739ae039)(this, e);
    };
}



var $8NFma = parcelRequire("8NFma");
/* eslint-disable no-console */ var $64ecca1b33f9f5ed$var$warned = {};
var $64ecca1b33f9f5ed$var$preWarningFns = [];
var $64ecca1b33f9f5ed$export$61616f168f0e5a05 = function preMessage(fn) {
    $64ecca1b33f9f5ed$var$preWarningFns.push(fn);
};
function $64ecca1b33f9f5ed$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $64ecca1b33f9f5ed$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $64ecca1b33f9f5ed$export$60eef1277fe463e4() {
    $64ecca1b33f9f5ed$var$warned = {};
}
function $64ecca1b33f9f5ed$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$64ecca1b33f9f5ed$var$warned[message]) {
        method(false, message);
        $64ecca1b33f9f5ed$var$warned[message] = true;
    }
}
function $64ecca1b33f9f5ed$export$82934adf09101657(valid, message) {
    $64ecca1b33f9f5ed$export$848feb93d8f32b9b($64ecca1b33f9f5ed$export$491112666e282270, valid, message);
}
function $64ecca1b33f9f5ed$export$89ff31684837bbbf(valid, message) {
    $64ecca1b33f9f5ed$export$848feb93d8f32b9b($64ecca1b33f9f5ed$export$a92e4c44d367d0af, valid, message);
}
$64ecca1b33f9f5ed$export$82934adf09101657.preMessage = $64ecca1b33f9f5ed$export$61616f168f0e5a05;
$64ecca1b33f9f5ed$export$82934adf09101657.resetWarned = $64ecca1b33f9f5ed$export$60eef1277fe463e4;
$64ecca1b33f9f5ed$export$82934adf09101657.noteOnce = $64ecca1b33f9f5ed$export$89ff31684837bbbf;
var $64ecca1b33f9f5ed$export$2e2bcd8739ae039 = $64ecca1b33f9f5ed$export$82934adf09101657;





var $8NFma = parcelRequire("8NFma");
var $6153d32a04184434$var$Track = function Track(props) {
    var _ref, _ref2;
    var className = props.className, included = props.included, vertical = props.vertical, style = props.style;
    var length = props.length, offset = props.offset, reverse = props.reverse;
    if (length < 0) {
        reverse = !reverse;
        length = Math.abs(length);
        offset = 100 - offset;
    }
    var positonStyle = vertical ? (_ref = {}, (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_ref, reverse ? 'bottom' : 'top', 'auto'), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_ref, "height", "".concat(length, "%")), _ref) : (_ref2 = {}, (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_ref2, reverse ? 'left' : 'right', 'auto'), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_ref2, "width", "".concat(length, "%")), _ref2);
    var elStyle = (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, style), positonStyle);
    return included ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
        className: className,
        style: elStyle
    }) : null;
};
var $6153d32a04184434$export$2e2bcd8739ae039 = $6153d32a04184434$var$Track;



var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");
function $cfae3d675552f8ab$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $hQtye.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}




function $2c0fbfb5c55051c8$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $f8db557918a53714$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $2c0fbfb5c55051c8$export$2e2bcd8739ae039)(r);
}


function $975c10fa3ca03dc7$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $ae4970148ece50ad$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $2c0fbfb5c55051c8$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $2c0fbfb5c55051c8$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $852ae2ae0b46fbef$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $4ac5e71af87e3f54$export$2e2bcd8739ae039(r) {
    return (0, $f8db557918a53714$export$2e2bcd8739ae039)(r) || (0, $975c10fa3ca03dc7$export$2e2bcd8739ae039)(r) || (0, $ae4970148ece50ad$export$2e2bcd8739ae039)(r) || (0, $852ae2ae0b46fbef$export$2e2bcd8739ae039)();
}





function $b6bb34a45df95826$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $7d424663944f7a08$export$2e2bcd8739ae039)(t)););
    return t;
}


function $8bb798532ae78fac$export$2e2bcd8739ae039() {
    return $8bb798532ae78fac$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $b6bb34a45df95826$export$2e2bcd8739ae039)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $8bb798532ae78fac$export$2e2bcd8739ae039.apply(null, arguments);
}






var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");
function $22181e543287e129$export$2e2bcd8739ae039(target, eventType, cb, option) {
    /* eslint camelcase: 2 */ var callback = (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).unstable_batchedUpdates ? function run(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).unstable_batchedUpdates(cb, e);
    } : cb;
    if (target !== null && target !== void 0 && target.addEventListener) target.addEventListener(eventType, callback, option);
    return {
        remove: function remove() {
            if (target !== null && target !== void 0 && target.removeEventListener) target.removeEventListener(eventType, callback, option);
        }
    };
}


var $f8c99c41bd600645$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($f8c99c41bd600645$exports) {
        classNames.default = classNames;
        $f8c99c41bd600645$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();






var $8NFma = parcelRequire("8NFma");


var $6ccc7ce48334b185$var$calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
    (0, $64ecca1b33f9f5ed$export$2e2bcd8739ae039)(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
    var points = Object.keys(marks).map(parseFloat).sort(function(a, b) {
        return a - b;
    });
    if (dots && step) {
        for(var i = min; i <= max; i += step)if (points.indexOf(i) === -1) points.push(i);
    }
    return points;
};
var $6ccc7ce48334b185$var$Steps = function Steps(_ref) {
    var prefixCls = _ref.prefixCls, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, dots = _ref.dots, step = _ref.step, included = _ref.included, lowerBound = _ref.lowerBound, upperBound = _ref.upperBound, max = _ref.max, min = _ref.min, dotStyle = _ref.dotStyle, activeDotStyle = _ref.activeDotStyle;
    var range = max - min;
    var elements = $6ccc7ce48334b185$var$calcPoints(vertical, marks, dots, step, min, max).map(function(point) {
        var _classNames;
        var offset = "".concat(Math.abs(point - min) / range * 100, "%");
        var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
        var style = vertical ? (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, dotStyle), {}, (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)({}, reverse ? 'top' : 'bottom', offset)) : (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, dotStyle), {}, (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)({}, reverse ? 'right' : 'left', offset));
        if (isActived) style = (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, style), activeDotStyle);
        var pointClassName = (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))((_classNames = {}, (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot"), true), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot-active"), isActived), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot-reverse"), reverse), _classNames));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("span", {
            className: pointClassName,
            style: style,
            key: point
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
        className: "".concat(prefixCls, "-step")
    }, elements);
};
var $6ccc7ce48334b185$export$2e2bcd8739ae039 = $6ccc7ce48334b185$var$Steps;






var $8NFma = parcelRequire("8NFma");

var $858cd8dd7ffec76a$var$Marks = function Marks(_ref) {
    var className = _ref.className, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, included = _ref.included, upperBound = _ref.upperBound, lowerBound = _ref.lowerBound, max = _ref.max, min = _ref.min, onClickLabel = _ref.onClickLabel;
    var marksKeys = Object.keys(marks);
    var range = max - min;
    var elements = marksKeys.map(parseFloat).sort(function(a, b) {
        return a - b;
    }).map(function(point) {
        var _classNames;
        var markPoint = marks[point];
        var markPointIsObject = (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(markPoint) === 'object' && !/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).isValidElement(markPoint);
        var markLabel = markPointIsObject ? markPoint.label : markPoint;
        if (!markLabel && markLabel !== 0) return null;
        var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
        var markClassName = (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))((_classNames = {}, (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_classNames, "".concat(className, "-text"), true), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_classNames, "".concat(className, "-text-active"), isActive), _classNames));
        var bottomStyle = (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)({
            marginBottom: '-50%'
        }, reverse ? 'top' : 'bottom', "".concat((point - min) / range * 100, "%"));
        var leftStyle = (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)({
            transform: "translateX(".concat(reverse ? "50%" : "-50%", ")"),
            msTransform: "translateX(".concat(reverse ? "50%" : "-50%", ")")
        }, reverse ? 'right' : 'left', "".concat((point - min) / range * 100, "%"));
        var style = vertical ? bottomStyle : leftStyle;
        var markStyle = markPointIsObject ? (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, style), markPoint.style) : style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("span", {
            className: markClassName,
            style: markStyle,
            key: point,
            onMouseDown: function onMouseDown(e) {
                return onClickLabel(e, point);
            },
            onTouchStart: function onTouchStart(e) {
                return onClickLabel(e, point);
            }
        }, markLabel);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
        className: className
    }, elements);
};
var $858cd8dd7ffec76a$export$2e2bcd8739ae039 = $858cd8dd7ffec76a$var$Marks;



var $jz4iA = parcelRequire("jz4iA");








var $8NFma = parcelRequire("8NFma");


var $35ceda88dbcc177c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $165305ab584beb18$export$2e2bcd8739ae039)(Handle, _React$Component);
    var _super = (0, $5d0d7e04eb688530$export$2e2bcd8739ae039)(Handle);
    function Handle() {
        var _this;
        (0, $a0703d0085fc4fb2$export$2e2bcd8739ae039)(this, Handle);
        _this = _super.apply(this, arguments);
        _this.state = {
            clickFocused: false
        };
        _this.setHandleRef = function(node) {
            _this.handle = node;
        };
        _this.handleMouseUp = function() {
            if (document.activeElement === _this.handle) _this.setClickFocus(true);
        };
        _this.handleMouseDown = function(e) {
            // avoid selecting text during drag
            // https://github.com/ant-design/ant-design/issues/25010
            e.preventDefault(); // fix https://github.com/ant-design/ant-design/issues/15324
            _this.focus();
        };
        _this.handleBlur = function() {
            _this.setClickFocus(false);
        };
        _this.handleKeyDown = function() {
            _this.setClickFocus(false);
        };
        return _this;
    }
    (0, $fe9a5bf59b39de5a$export$2e2bcd8739ae039)(Handle, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // mouseup won't trigger if mouse moved out of handle,
                // so we listen on document here.
                this.onMouseUpListener = (0, $22181e543287e129$export$2e2bcd8739ae039)(document, 'mouseup', this.handleMouseUp);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.onMouseUpListener) this.onMouseUpListener.remove();
            }
        },
        {
            key: "setClickFocus",
            value: function setClickFocus(focused) {
                this.setState({
                    clickFocused: focused
                });
            }
        },
        {
            key: "clickFocus",
            value: function clickFocus() {
                this.setClickFocus(true);
                this.focus();
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.handle.focus();
            }
        },
        {
            key: "blur",
            value: function blur() {
                this.handle.blur();
            }
        },
        {
            key: "render",
            value: function render() {
                var _ref, _ref2;
                var _this$props = this.props, prefixCls = _this$props.prefixCls, vertical = _this$props.vertical, reverse = _this$props.reverse, offset = _this$props.offset, style = _this$props.style, disabled = _this$props.disabled, min = _this$props.min, max = _this$props.max, value = _this$props.value, tabIndex = _this$props.tabIndex, ariaLabel = _this$props.ariaLabel, ariaLabelledBy = _this$props.ariaLabelledBy, ariaValueTextFormatter = _this$props.ariaValueTextFormatter, restProps = (0, $cfae3d675552f8ab$export$2e2bcd8739ae039)(_this$props, [
                    "prefixCls",
                    "vertical",
                    "reverse",
                    "offset",
                    "style",
                    "disabled",
                    "min",
                    "max",
                    "value",
                    "tabIndex",
                    "ariaLabel",
                    "ariaLabelledBy",
                    "ariaValueTextFormatter"
                ]);
                var className = (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))(this.props.className, (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-handle-click-focused"), this.state.clickFocused));
                var positionStyle = vertical ? (_ref = {}, (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_ref, reverse ? 'bottom' : 'top', 'auto'), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_ref, "transform", reverse ? null : "translateY(+50%)"), _ref) : (_ref2 = {}, (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_ref2, reverse ? 'left' : 'right', 'auto'), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_ref2, "transform", "translateX(".concat(reverse ? '+' : '-', "50%)")), _ref2);
                var elStyle = (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, style), positionStyle);
                var mergedTabIndex = tabIndex || 0;
                if (disabled || tabIndex === null) mergedTabIndex = null;
                var ariaValueText;
                if (ariaValueTextFormatter) ariaValueText = ariaValueTextFormatter(value);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", (0, $jz4iA.default)({
                    ref: this.setHandleRef,
                    tabIndex: mergedTabIndex
                }, restProps, {
                    className: className,
                    style: elStyle,
                    onBlur: this.handleBlur,
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleMouseDown // aria attribute
                    ,
                    role: "slider",
                    "aria-valuemin": min,
                    "aria-valuemax": max,
                    "aria-valuenow": value,
                    "aria-disabled": !!disabled,
                    "aria-label": ariaLabel,
                    "aria-labelledby": ariaLabelledBy,
                    "aria-valuetext": ariaValueText
                }));
            }
        }
    ]);
    return Handle;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component);




var $2pmb0 = parcelRequire("2pmb0");
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $edac69c8e65773c9$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $edac69c8e65773c9$var$KeyCode.F1 && keyCode <= $edac69c8e65773c9$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $edac69c8e65773c9$var$KeyCode.ALT:
            case $edac69c8e65773c9$var$KeyCode.CAPS_LOCK:
            case $edac69c8e65773c9$var$KeyCode.CONTEXT_MENU:
            case $edac69c8e65773c9$var$KeyCode.CTRL:
            case $edac69c8e65773c9$var$KeyCode.DOWN:
            case $edac69c8e65773c9$var$KeyCode.END:
            case $edac69c8e65773c9$var$KeyCode.ESC:
            case $edac69c8e65773c9$var$KeyCode.HOME:
            case $edac69c8e65773c9$var$KeyCode.INSERT:
            case $edac69c8e65773c9$var$KeyCode.LEFT:
            case $edac69c8e65773c9$var$KeyCode.MAC_FF_META:
            case $edac69c8e65773c9$var$KeyCode.META:
            case $edac69c8e65773c9$var$KeyCode.NUMLOCK:
            case $edac69c8e65773c9$var$KeyCode.NUM_CENTER:
            case $edac69c8e65773c9$var$KeyCode.PAGE_DOWN:
            case $edac69c8e65773c9$var$KeyCode.PAGE_UP:
            case $edac69c8e65773c9$var$KeyCode.PAUSE:
            case $edac69c8e65773c9$var$KeyCode.PRINT_SCREEN:
            case $edac69c8e65773c9$var$KeyCode.RIGHT:
            case $edac69c8e65773c9$var$KeyCode.SHIFT:
            case $edac69c8e65773c9$var$KeyCode.UP:
            case $edac69c8e65773c9$var$KeyCode.WIN_KEY:
            case $edac69c8e65773c9$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $edac69c8e65773c9$var$KeyCode.ZERO && keyCode <= $edac69c8e65773c9$var$KeyCode.NINE) return true;
        if (keyCode >= $edac69c8e65773c9$var$KeyCode.NUM_ZERO && keyCode <= $edac69c8e65773c9$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $edac69c8e65773c9$var$KeyCode.A && keyCode <= $edac69c8e65773c9$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $edac69c8e65773c9$var$KeyCode.SPACE:
            case $edac69c8e65773c9$var$KeyCode.QUESTION_MARK:
            case $edac69c8e65773c9$var$KeyCode.NUM_PLUS:
            case $edac69c8e65773c9$var$KeyCode.NUM_MINUS:
            case $edac69c8e65773c9$var$KeyCode.NUM_PERIOD:
            case $edac69c8e65773c9$var$KeyCode.NUM_DIVISION:
            case $edac69c8e65773c9$var$KeyCode.SEMICOLON:
            case $edac69c8e65773c9$var$KeyCode.DASH:
            case $edac69c8e65773c9$var$KeyCode.EQUALS:
            case $edac69c8e65773c9$var$KeyCode.COMMA:
            case $edac69c8e65773c9$var$KeyCode.PERIOD:
            case $edac69c8e65773c9$var$KeyCode.SLASH:
            case $edac69c8e65773c9$var$KeyCode.APOSTROPHE:
            case $edac69c8e65773c9$var$KeyCode.SINGLE_QUOTE:
            case $edac69c8e65773c9$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $edac69c8e65773c9$var$KeyCode.BACKSLASH:
            case $edac69c8e65773c9$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $edac69c8e65773c9$export$2e2bcd8739ae039 = $edac69c8e65773c9$var$KeyCode;


function $7245e2184e59d4f1$export$597415897f3287c9(e, handles) {
    try {
        return Object.keys(handles).some(function(key) {
            return e.target === (0, $2pmb0.findDOMNode)(handles[key]);
        });
    } catch (error) {
        return false;
    }
}
function $7245e2184e59d4f1$export$f4657b4dc4cc2ea4(value, _ref) {
    var min = _ref.min, max = _ref.max;
    return value < min || value > max;
}
function $7245e2184e59d4f1$export$eaf0efc71c45a02(e) {
    return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}
function $7245e2184e59d4f1$export$e3e031d5dec39373(val, _ref2) {
    var marks = _ref2.marks, step = _ref2.step, min = _ref2.min, max = _ref2.max;
    var points = Object.keys(marks).map(parseFloat);
    if (step !== null) {
        var baseNum = Math.pow(10, $7245e2184e59d4f1$export$e0c74b50bbd10f68(step));
        var maxSteps = Math.floor((max * baseNum - min * baseNum) / (step * baseNum));
        var steps = Math.min((val - min) / step, maxSteps);
        var closestStep = Math.round(steps) * step + min;
        points.push(closestStep);
    }
    var diffs = points.map(function(point) {
        return Math.abs(val - point);
    });
    return points[diffs.indexOf(Math.min.apply(Math, (0, $4ac5e71af87e3f54$export$2e2bcd8739ae039)(diffs)))];
}
function $7245e2184e59d4f1$export$e0c74b50bbd10f68(step) {
    var stepString = step.toString();
    var precision = 0;
    if (stepString.indexOf('.') >= 0) precision = stepString.length - stepString.indexOf('.') - 1;
    return precision;
}
function $7245e2184e59d4f1$export$642213d516a9b928(vertical, e) {
    return vertical ? e.clientY : e.pageX;
}
function $7245e2184e59d4f1$export$7e1d3da113d10e8e(vertical, e) {
    return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}
function $7245e2184e59d4f1$export$ec6357f54996b379(vertical, handle) {
    var coords = handle.getBoundingClientRect();
    return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}
function $7245e2184e59d4f1$export$65e4339c6f9d8d24(val, _ref3) {
    var max = _ref3.max, min = _ref3.min;
    if (val <= min) return min;
    if (val >= max) return max;
    return val;
}
function $7245e2184e59d4f1$export$5bea24a9dfe5ab1a(val, props) {
    var step = props.step;
    var closestPoint = isFinite($7245e2184e59d4f1$export$e3e031d5dec39373(val, props)) ? $7245e2184e59d4f1$export$e3e031d5dec39373(val, props) : 0; // eslint-disable-line
    return step === null ? closestPoint : parseFloat(closestPoint.toFixed($7245e2184e59d4f1$export$e0c74b50bbd10f68(step)));
}
function $7245e2184e59d4f1$export$3f9ffdaf2961f43f(e) {
    e.stopPropagation();
    e.preventDefault();
}
function $7245e2184e59d4f1$export$e5722e0a8bbb32d9(func, value, props) {
    var operations = {
        increase: function increase(a, b) {
            return a + b;
        },
        decrease: function decrease(a, b) {
            return a - b;
        }
    };
    var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
    var keyToGet = Object.keys(props.marks)[indexToGet];
    if (props.step) return operations[func](value, props.step);
    if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) return props.marks[keyToGet];
    return value;
}
function $7245e2184e59d4f1$export$3bef836a1fb84ee6(e, vertical, reverse) {
    var increase = 'increase';
    var decrease = 'decrease';
    var method = increase;
    switch(e.keyCode){
        case (0, $edac69c8e65773c9$export$2e2bcd8739ae039).UP:
            method = vertical && reverse ? decrease : increase;
            break;
        case (0, $edac69c8e65773c9$export$2e2bcd8739ae039).RIGHT:
            method = !vertical && reverse ? decrease : increase;
            break;
        case (0, $edac69c8e65773c9$export$2e2bcd8739ae039).DOWN:
            method = vertical && reverse ? increase : decrease;
            break;
        case (0, $edac69c8e65773c9$export$2e2bcd8739ae039).LEFT:
            method = !vertical && reverse ? increase : decrease;
            break;
        case (0, $edac69c8e65773c9$export$2e2bcd8739ae039).END:
            return function(value, props) {
                return props.max;
            };
        case (0, $edac69c8e65773c9$export$2e2bcd8739ae039).HOME:
            return function(value, props) {
                return props.min;
            };
        case (0, $edac69c8e65773c9$export$2e2bcd8739ae039).PAGE_UP:
            return function(value, props) {
                return value + props.step * 2;
            };
        case (0, $edac69c8e65773c9$export$2e2bcd8739ae039).PAGE_DOWN:
            return function(value, props) {
                return value - props.step * 2;
            };
        default:
            return undefined;
    }
    return function(value, props) {
        return $7245e2184e59d4f1$export$e5722e0a8bbb32d9(method, value, props);
    };
}


/* eslint-disable @typescript-eslint/no-explicit-any */ function $2a78e0de08f64294$var$noop() {}
function $2a78e0de08f64294$export$2e2bcd8739ae039(Component) {
    var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return _a = /*#__PURE__*/ function(_Component) {
        (0, $165305ab584beb18$export$2e2bcd8739ae039)(ComponentEnhancer, _Component);
        var _super = (0, $5d0d7e04eb688530$export$2e2bcd8739ae039)(ComponentEnhancer);
        function ComponentEnhancer(props) {
            var _this;
            (0, $a0703d0085fc4fb2$export$2e2bcd8739ae039)(this, ComponentEnhancer);
            _this = _super.call(this, props);
            _this.onDown = function(e, position) {
                var p = position;
                var _this$props = _this.props, draggableTrack = _this$props.draggableTrack, isVertical = _this$props.vertical;
                var bounds = _this.state.bounds;
                var value = draggableTrack && _this.positionGetValue ? _this.positionGetValue(p) || [] : [];
                var inPoint = $7245e2184e59d4f1$export$597415897f3287c9(e, _this.handlesRefs);
                _this.dragTrack = draggableTrack && bounds.length >= 2 && !inPoint && !value.map(function(n, i) {
                    var v = !i ? n >= bounds[i] : true;
                    return i === value.length - 1 ? n <= bounds[i] : v;
                }).some(function(c) {
                    return !c;
                });
                if (_this.dragTrack) {
                    _this.dragOffset = p;
                    _this.startBounds = (0, $4ac5e71af87e3f54$export$2e2bcd8739ae039)(bounds);
                } else {
                    if (!inPoint) _this.dragOffset = 0;
                    else {
                        var handlePosition = $7245e2184e59d4f1$export$ec6357f54996b379(isVertical, e.target);
                        _this.dragOffset = p - handlePosition;
                        p = handlePosition;
                    }
                    _this.onStart(p);
                }
            };
            _this.onMouseDown = function(e) {
                if (e.button !== 0) return;
                _this.removeDocumentEvents();
                var isVertical = _this.props.vertical;
                var position = $7245e2184e59d4f1$export$642213d516a9b928(isVertical, e);
                _this.onDown(e, position);
                _this.addDocumentMouseEvents();
            };
            _this.onTouchStart = function(e) {
                if ($7245e2184e59d4f1$export$eaf0efc71c45a02(e)) return;
                var isVertical = _this.props.vertical;
                var position = $7245e2184e59d4f1$export$7e1d3da113d10e8e(isVertical, e);
                _this.onDown(e, position);
                _this.addDocumentTouchEvents();
                $7245e2184e59d4f1$export$3f9ffdaf2961f43f(e);
            };
            _this.onFocus = function(e) {
                var _this$props2 = _this.props, onFocus = _this$props2.onFocus, vertical = _this$props2.vertical;
                if ($7245e2184e59d4f1$export$597415897f3287c9(e, _this.handlesRefs) && !_this.dragTrack) {
                    var handlePosition = $7245e2184e59d4f1$export$ec6357f54996b379(vertical, e.target);
                    _this.dragOffset = 0;
                    _this.onStart(handlePosition);
                    $7245e2184e59d4f1$export$3f9ffdaf2961f43f(e);
                    if (onFocus) onFocus(e);
                }
            };
            _this.onBlur = function(e) {
                var onBlur = _this.props.onBlur;
                if (!_this.dragTrack) _this.onEnd();
                if (onBlur) onBlur(e);
            };
            _this.onMouseUp = function() {
                if (_this.handlesRefs[_this.prevMovedHandleIndex]) _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
            };
            _this.onMouseMove = function(e) {
                if (!_this.sliderRef) {
                    _this.onEnd();
                    return;
                }
                var position = $7245e2184e59d4f1$export$642213d516a9b928(_this.props.vertical, e);
                _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
            };
            _this.onTouchMove = function(e) {
                if ($7245e2184e59d4f1$export$eaf0efc71c45a02(e) || !_this.sliderRef) {
                    _this.onEnd();
                    return;
                }
                var position = $7245e2184e59d4f1$export$7e1d3da113d10e8e(_this.props.vertical, e);
                _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
            };
            _this.onKeyDown = function(e) {
                if (_this.sliderRef && $7245e2184e59d4f1$export$597415897f3287c9(e, _this.handlesRefs)) _this.onKeyboard(e);
            };
            _this.onClickMarkLabel = function(e, value) {
                e.stopPropagation();
                _this.onChange({
                    value: value
                }); // eslint-disable-next-line react/no-unused-state
                _this.setState({
                    value: value
                }, function() {
                    return _this.onEnd(true);
                });
            };
            _this.saveSlider = function(slider) {
                _this.sliderRef = slider;
            };
            var step = props.step, max = props.max, min = props.min;
            var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
            (0, $64ecca1b33f9f5ed$export$2e2bcd8739ae039)(step && Math.floor(step) === step ? isPointDiffEven : true, "Slider[max] - Slider[min] (".concat(max - min, ") should be a multiple of Slider[step] (").concat(step, ")"));
            _this.handlesRefs = {};
            return _this;
        }
        (0, $fe9a5bf59b39de5a$export$2e2bcd8739ae039)(ComponentEnhancer, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    // Snapshot testing cannot handle refs, so be sure to null-check this.
                    this.document = this.sliderRef && this.sliderRef.ownerDocument;
                    var _this$props3 = this.props, autoFocus = _this$props3.autoFocus, disabled = _this$props3.disabled;
                    if (autoFocus && !disabled) this.focus();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if ((0, $8bb798532ae78fac$export$2e2bcd8739ae039)((0, $7d424663944f7a08$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "componentWillUnmount", this)) (0, $8bb798532ae78fac$export$2e2bcd8739ae039)((0, $7d424663944f7a08$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "componentWillUnmount", this).call(this);
                    this.removeDocumentEvents();
                }
            },
            {
                key: "getSliderStart",
                value: function getSliderStart() {
                    var slider = this.sliderRef;
                    var _this$props4 = this.props, vertical = _this$props4.vertical, reverse = _this$props4.reverse;
                    var rect = slider.getBoundingClientRect();
                    if (vertical) return reverse ? rect.bottom : rect.top;
                    return window.pageXOffset + (reverse ? rect.right : rect.left);
                }
            },
            {
                key: "getSliderLength",
                value: function getSliderLength() {
                    var slider = this.sliderRef;
                    if (!slider) return 0;
                    var coords = slider.getBoundingClientRect();
                    return this.props.vertical ? coords.height : coords.width;
                }
            },
            {
                key: "addDocumentTouchEvents",
                value: function addDocumentTouchEvents() {
                    // just work for Chrome iOS Safari and Android Browser
                    this.onTouchMoveListener = (0, $22181e543287e129$export$2e2bcd8739ae039)(this.document, 'touchmove', this.onTouchMove);
                    this.onTouchUpListener = (0, $22181e543287e129$export$2e2bcd8739ae039)(this.document, 'touchend', this.onEnd);
                }
            },
            {
                key: "addDocumentMouseEvents",
                value: function addDocumentMouseEvents() {
                    this.onMouseMoveListener = (0, $22181e543287e129$export$2e2bcd8739ae039)(this.document, 'mousemove', this.onMouseMove);
                    this.onMouseUpListener = (0, $22181e543287e129$export$2e2bcd8739ae039)(this.document, 'mouseup', this.onEnd);
                }
            },
            {
                key: "removeDocumentEvents",
                value: function removeDocumentEvents() {
                    /* eslint-disable @typescript-eslint/no-unused-expressions */ this.onTouchMoveListener && this.onTouchMoveListener.remove();
                    this.onTouchUpListener && this.onTouchUpListener.remove();
                    this.onMouseMoveListener && this.onMouseMoveListener.remove();
                    this.onMouseUpListener && this.onMouseUpListener.remove();
                /* eslint-enable no-unused-expressions */ }
            },
            {
                key: "focus",
                value: function focus() {
                    var _this$handlesRefs$;
                    if (this.props.disabled) return;
                    (_this$handlesRefs$ = this.handlesRefs[0]) === null || _this$handlesRefs$ === void 0 || _this$handlesRefs$.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    var _this2 = this;
                    if (this.props.disabled) return;
                    Object.keys(this.handlesRefs).forEach(function(key) {
                        var _this2$handlesRefs$ke, _this2$handlesRefs$ke2;
                        (_this2$handlesRefs$ke = _this2.handlesRefs[key]) === null || _this2$handlesRefs$ke === void 0 || (_this2$handlesRefs$ke2 = _this2$handlesRefs$ke.blur) === null || _this2$handlesRefs$ke2 === void 0 || _this2$handlesRefs$ke2.call(_this2$handlesRefs$ke);
                    });
                }
            },
            {
                key: "calcValue",
                value: function calcValue(offset) {
                    var _this$props5 = this.props, vertical = _this$props5.vertical, min = _this$props5.min, max = _this$props5.max;
                    var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
                    var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
                    return value;
                }
            },
            {
                key: "calcValueByPos",
                value: function calcValueByPos(position) {
                    var sign = this.props.reverse ? -1 : 1;
                    var pixelOffset = sign * (position - this.getSliderStart());
                    var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
                    return nextValue;
                }
            },
            {
                key: "calcOffset",
                value: function calcOffset(value) {
                    var _this$props6 = this.props, min = _this$props6.min, max = _this$props6.max;
                    var ratio = (value - min) / (max - min);
                    return Math.max(0, ratio * 100);
                }
            },
            {
                key: "saveHandle",
                value: function saveHandle(index, handle) {
                    this.handlesRefs[index] = handle;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _classNames;
                    var _this$props7 = this.props, prefixCls = _this$props7.prefixCls, className = _this$props7.className, marks = _this$props7.marks, dots = _this$props7.dots, step = _this$props7.step, included = _this$props7.included, disabled = _this$props7.disabled, vertical = _this$props7.vertical, reverse = _this$props7.reverse, min = _this$props7.min, max = _this$props7.max, children = _this$props7.children, maximumTrackStyle = _this$props7.maximumTrackStyle, style = _this$props7.style, railStyle = _this$props7.railStyle, dotStyle = _this$props7.dotStyle, activeDotStyle = _this$props7.activeDotStyle;
                    var _get$call = (0, $8bb798532ae78fac$export$2e2bcd8739ae039)((0, $7d424663944f7a08$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "render", this).call(this), tracks = _get$call.tracks, handles = _get$call.handles;
                    var sliderClassName = (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))(prefixCls, (_classNames = {}, (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-with-marks"), Object.keys(marks).length), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-disabled"), disabled), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-vertical"), vertical), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_classNames, className, className), _classNames));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
                        ref: this.saveSlider,
                        className: sliderClassName,
                        onTouchStart: disabled ? $2a78e0de08f64294$var$noop : this.onTouchStart,
                        onMouseDown: disabled ? $2a78e0de08f64294$var$noop : this.onMouseDown,
                        onMouseUp: disabled ? $2a78e0de08f64294$var$noop : this.onMouseUp,
                        onKeyDown: disabled ? $2a78e0de08f64294$var$noop : this.onKeyDown,
                        onFocus: disabled ? $2a78e0de08f64294$var$noop : this.onFocus,
                        onBlur: disabled ? $2a78e0de08f64294$var$noop : this.onBlur,
                        style: style
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
                        className: "".concat(prefixCls, "-rail"),
                        style: (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, maximumTrackStyle), railStyle)
                    }), tracks, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $6ccc7ce48334b185$export$2e2bcd8739ae039), {
                        prefixCls: prefixCls,
                        vertical: vertical,
                        reverse: reverse,
                        marks: marks,
                        dots: dots,
                        step: step,
                        included: included,
                        lowerBound: this.getLowerBound(),
                        upperBound: this.getUpperBound(),
                        max: max,
                        min: min,
                        dotStyle: dotStyle,
                        activeDotStyle: activeDotStyle
                    }), handles, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $858cd8dd7ffec76a$export$2e2bcd8739ae039), {
                        className: "".concat(prefixCls, "-mark"),
                        onClickLabel: disabled ? $2a78e0de08f64294$var$noop : this.onClickMarkLabel,
                        vertical: vertical,
                        marks: marks,
                        included: included,
                        lowerBound: this.getLowerBound(),
                        upperBound: this.getUpperBound(),
                        max: max,
                        min: min,
                        reverse: reverse
                    }), children);
                }
            }
        ]);
        return ComponentEnhancer;
    }(Component), _a.displayName = "ComponentEnhancer(".concat(Component.displayName, ")"), _a.defaultProps = (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, Component.defaultProps), {}, {
        prefixCls: 'rc-slider',
        className: '',
        min: 0,
        max: 100,
        step: 1,
        marks: {},
        handle: function handle(props) {
            var index = props.index, restProps = (0, $cfae3d675552f8ab$export$2e2bcd8739ae039)(props, [
                "index"
            ]);
            delete restProps.dragging;
            if (restProps.value === null) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $35ceda88dbcc177c$export$2e2bcd8739ae039), (0, $jz4iA.default)({}, restProps, {
                key: index
            }));
        },
        onBeforeChange: $2a78e0de08f64294$var$noop,
        onChange: $2a78e0de08f64294$var$noop,
        onAfterChange: $2a78e0de08f64294$var$noop,
        included: true,
        disabled: false,
        dots: false,
        vertical: false,
        reverse: false,
        trackStyle: [
            {}
        ],
        handleStyle: [
            {}
        ],
        railStyle: {},
        dotStyle: {},
        activeDotStyle: {}
    }), _a;
}



var $0e654d3c2532379a$var$Slider = /*#__PURE__*/ function(_React$Component) {
    (0, $165305ab584beb18$export$2e2bcd8739ae039)(Slider, _React$Component);
    var _super = (0, $5d0d7e04eb688530$export$2e2bcd8739ae039)(Slider);
    /* eslint-enable */ function Slider(props) {
        var _this;
        (0, $a0703d0085fc4fb2$export$2e2bcd8739ae039)(this, Slider);
        _this = _super.call(this, props);
        _this.positionGetValue = function(position) {
            return [];
        };
        _this.onEnd = function(force) {
            var dragging = _this.state.dragging;
            _this.removeDocumentEvents();
            if (dragging || force) _this.props.onAfterChange(_this.getValue());
            _this.setState({
                dragging: false
            });
        };
        var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
        var value = props.value !== undefined ? props.value : defaultValue;
        _this.state = {
            value: _this.trimAlignValue(value),
            dragging: false
        };
        (0, $64ecca1b33f9f5ed$export$2e2bcd8739ae039)(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
        (0, $64ecca1b33f9f5ed$export$2e2bcd8739ae039)(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
        return _this;
    }
    /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */ /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */ (0, $fe9a5bf59b39de5a$export$2e2bcd8739ae039)(Slider, [
        {
            key: "calcValueByPos",
            value: function calcValueByPos(value) {
                return 0;
            }
        },
        {
            key: "calcOffset",
            value: function calcOffset(value) {
                return 0;
            }
        },
        {
            key: "saveHandle",
            value: function saveHandle(index, h) {}
        },
        {
            key: "removeDocumentEvents",
            value: function removeDocumentEvents() {}
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this$props = this.props, min = _this$props.min, max = _this$props.max, value = _this$props.value, onChange = _this$props.onChange;
                if (!('min' in this.props || 'max' in this.props)) return;
                var theValue = value !== undefined ? value : prevState.value;
                var nextValue = this.trimAlignValue(theValue, this.props);
                if (nextValue === prevState.value) return;
                 // eslint-disable-next-line
                this.setState({
                    value: nextValue
                });
                if (!(min === prevProps.min && max === prevProps.max) && $7245e2184e59d4f1$export$f4657b4dc4cc2ea4(theValue, this.props)) onChange(nextValue);
            }
        },
        {
            key: "onChange",
            value: function onChange(state) {
                var props = this.props;
                var isNotControlled = !('value' in props);
                var nextState = state.value > this.props.max ? (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, state), {}, {
                    value: this.props.max
                }) : state;
                if (isNotControlled) this.setState(nextState);
                var changedValue = nextState.value;
                props.onChange(changedValue);
            }
        },
        {
            key: "onStart",
            value: function onStart(position) {
                this.setState({
                    dragging: true
                });
                var props = this.props;
                var prevValue = this.getValue();
                props.onBeforeChange(prevValue);
                var value = this.calcValueByPos(position);
                this.startValue = value;
                this.startPosition = position;
                if (value === prevValue) return;
                this.prevMovedHandleIndex = 0;
                this.onChange({
                    value: value
                });
            }
        },
        {
            key: "onMove",
            value: function onMove(e, position) {
                $7245e2184e59d4f1$export$3f9ffdaf2961f43f(e);
                var oldValue = this.state.value;
                var value = this.calcValueByPos(position);
                if (value === oldValue) return;
                this.onChange({
                    value: value
                });
            }
        },
        {
            key: "onKeyboard",
            value: function onKeyboard(e) {
                var _this$props2 = this.props, reverse = _this$props2.reverse, vertical = _this$props2.vertical;
                var valueMutator = $7245e2184e59d4f1$export$3bef836a1fb84ee6(e, vertical, reverse);
                if (valueMutator) {
                    $7245e2184e59d4f1$export$3f9ffdaf2961f43f(e);
                    var state = this.state;
                    var oldValue = state.value;
                    var mutatedValue = valueMutator(oldValue, this.props);
                    var value = this.trimAlignValue(mutatedValue);
                    if (value === oldValue) return;
                    this.onChange({
                        value: value
                    });
                    this.props.onAfterChange(value);
                    this.onEnd();
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.state.value;
            }
        },
        {
            key: "getLowerBound",
            value: function getLowerBound() {
                var minPoint = this.props.startPoint || this.props.min;
                return this.state.value > minPoint ? minPoint : this.state.value;
            }
        },
        {
            key: "getUpperBound",
            value: function getUpperBound() {
                if (this.state.value < this.props.startPoint) return this.props.startPoint;
                return this.state.value;
            }
        },
        {
            key: "trimAlignValue",
            value: function trimAlignValue(v) {
                var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (v === null) return null;
                var mergedProps = (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, this.props), nextProps);
                var val = $7245e2184e59d4f1$export$65e4339c6f9d8d24(v, mergedProps);
                return $7245e2184e59d4f1$export$5bea24a9dfe5ab1a(val, mergedProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, prefixCls = _this$props3.prefixCls, vertical = _this$props3.vertical, included = _this$props3.included, disabled = _this$props3.disabled, minimumTrackStyle = _this$props3.minimumTrackStyle, trackStyle = _this$props3.trackStyle, handleStyle = _this$props3.handleStyle, tabIndex = _this$props3.tabIndex, ariaLabelForHandle = _this$props3.ariaLabelForHandle, ariaLabelledByForHandle = _this$props3.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = _this$props3.ariaValueTextFormatterForHandle, min = _this$props3.min, max = _this$props3.max, startPoint = _this$props3.startPoint, reverse = _this$props3.reverse, handleGenerator = _this$props3.handle;
                var _this$state = this.state, value = _this$state.value, dragging = _this$state.dragging;
                var offset = this.calcOffset(value);
                var handle = handleGenerator({
                    className: "".concat(prefixCls, "-handle"),
                    prefixCls: prefixCls,
                    vertical: vertical,
                    offset: offset,
                    value: value,
                    dragging: dragging,
                    disabled: disabled,
                    min: min,
                    max: max,
                    reverse: reverse,
                    index: 0,
                    tabIndex: tabIndex,
                    ariaLabel: ariaLabelForHandle,
                    ariaLabelledBy: ariaLabelledByForHandle,
                    ariaValueTextFormatter: ariaValueTextFormatterForHandle,
                    style: handleStyle[0] || handleStyle,
                    ref: function ref(h) {
                        return _this2.saveHandle(0, h);
                    }
                });
                var trackOffset = startPoint !== undefined ? this.calcOffset(startPoint) : 0;
                var mergedTrackStyle = trackStyle[0] || trackStyle;
                var track = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $6153d32a04184434$export$2e2bcd8739ae039), {
                    className: "".concat(prefixCls, "-track"),
                    vertical: vertical,
                    included: included,
                    offset: trackOffset,
                    reverse: reverse,
                    length: offset - trackOffset,
                    style: (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, minimumTrackStyle), mergedTrackStyle)
                });
                return {
                    tracks: track,
                    handles: handle
                };
            }
        }
    ]);
    return Slider;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component);
var $0e654d3c2532379a$export$2e2bcd8739ae039 = (0, $2a78e0de08f64294$export$2e2bcd8739ae039)($0e654d3c2532379a$var$Slider);










var $8NFma = parcelRequire("8NFma");




var $73820928faa25922$var$_trimAlignValue = function trimAlignValue(_ref) {
    var value = _ref.value, handle = _ref.handle, bounds = _ref.bounds, props = _ref.props;
    var allowCross = props.allowCross, pushable = props.pushable;
    var thershold = Number(pushable);
    var valInRange = $7245e2184e59d4f1$export$65e4339c6f9d8d24(value, props);
    var valNotConflict = valInRange;
    if (!allowCross && handle != null && bounds !== undefined) {
        if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) valNotConflict = bounds[handle - 1] + thershold;
        if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) valNotConflict = bounds[handle + 1] - thershold;
    }
    return $7245e2184e59d4f1$export$5bea24a9dfe5ab1a(valNotConflict, props);
};
var $73820928faa25922$var$Range = /*#__PURE__*/ function(_React$Component) {
    (0, $165305ab584beb18$export$2e2bcd8739ae039)(Range, _React$Component);
    var _super = (0, $5d0d7e04eb688530$export$2e2bcd8739ae039)(Range);
    function Range(props) {
        var _this;
        (0, $a0703d0085fc4fb2$export$2e2bcd8739ae039)(this, Range);
        _this = _super.call(this, props);
        _this.positionGetValue = function(position) {
            var bounds = _this.getValue();
            var value = _this.calcValueByPos(position);
            var closestBound = _this.getClosestBound(value);
            var index = _this.getBoundNeedMoving(value, closestBound);
            var prevValue = bounds[index];
            if (value === prevValue) return null;
            var nextBounds = (0, $4ac5e71af87e3f54$export$2e2bcd8739ae039)(bounds);
            nextBounds[index] = value;
            return nextBounds;
        };
        _this.onEnd = function(force) {
            var handle = _this.state.handle;
            _this.removeDocumentEvents();
            if (!handle) _this.dragTrack = false;
            if (handle !== null || force) _this.props.onAfterChange(_this.getValue());
            _this.setState({
                handle: null
            });
        };
        var count = props.count, min = props.min, max = props.max;
        var initialValue = Array.apply(void 0, (0, $4ac5e71af87e3f54$export$2e2bcd8739ae039)(Array(count + 1))).map(function() {
            return min;
        });
        var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
        var value = props.value !== undefined ? props.value : defaultValue;
        var bounds = value.map(function(v, i) {
            return $73820928faa25922$var$_trimAlignValue({
                value: v,
                handle: i,
                props: props
            });
        });
        var recent = bounds[0] === max ? 0 : bounds.length - 1;
        _this.state = {
            handle: null,
            recent: recent,
            bounds: bounds
        };
        return _this;
    }
    /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */ /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */ (0, $fe9a5bf59b39de5a$export$2e2bcd8739ae039)(Range, [
        {
            key: "calcValueByPos",
            value: function calcValueByPos(value) {
                return 0;
            }
        },
        {
            key: "getSliderLength",
            value: function getSliderLength() {
                return 0;
            }
        },
        {
            key: "calcOffset",
            value: function calcOffset(value) {
                return 0;
            }
        },
        {
            key: "saveHandle",
            value: function saveHandle(index, h) {}
        },
        {
            key: "removeDocumentEvents",
            value: function removeDocumentEvents() {}
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _this$props = this.props, onChange = _this$props.onChange, value = _this$props.value, min = _this$props.min, max = _this$props.max;
                if (!('min' in this.props || 'max' in this.props)) return;
                if (min === prevProps.min && max === prevProps.max) return;
                var currentValue = value || prevState.bounds;
                if (currentValue.some(function(v) {
                    return $7245e2184e59d4f1$export$f4657b4dc4cc2ea4(v, _this2.props);
                })) {
                    var newValues = currentValue.map(function(v) {
                        return $7245e2184e59d4f1$export$65e4339c6f9d8d24(v, _this2.props);
                    });
                    onChange(newValues);
                }
            }
        },
        {
            key: "onChange",
            value: function onChange(state) {
                var props = this.props;
                var isNotControlled = !('value' in props);
                if (isNotControlled) this.setState(state);
                else {
                    var controlledState = {};
                    [
                        'handle',
                        'recent'
                    ].forEach(function(item) {
                        if (state[item] !== undefined) controlledState[item] = state[item];
                    });
                    if (Object.keys(controlledState).length) this.setState(controlledState);
                }
                var data = (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, this.state), state);
                var changedValue = data.bounds;
                props.onChange(changedValue);
            }
        },
        {
            key: "onStart",
            value: function onStart(position) {
                var props = this.props, state = this.state;
                var bounds = this.getValue();
                props.onBeforeChange(bounds);
                var value = this.calcValueByPos(position);
                this.startValue = value;
                this.startPosition = position;
                var closestBound = this.getClosestBound(value);
                this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
                this.setState({
                    handle: this.prevMovedHandleIndex,
                    recent: this.prevMovedHandleIndex
                });
                var prevValue = bounds[this.prevMovedHandleIndex];
                if (value === prevValue) return;
                var nextBounds = (0, $4ac5e71af87e3f54$export$2e2bcd8739ae039)(state.bounds);
                nextBounds[this.prevMovedHandleIndex] = value;
                this.onChange({
                    bounds: nextBounds
                });
            }
        },
        {
            key: "onMove",
            value: function onMove(e, position, dragTrack, startBounds) {
                $7245e2184e59d4f1$export$3f9ffdaf2961f43f(e);
                var state = this.state, props = this.props;
                var maxValue = props.max || 100;
                var minValue = props.min || 0;
                if (dragTrack) {
                    var pos = props.vertical ? -position : position;
                    pos = props.reverse ? -pos : pos;
                    var max = maxValue - Math.max.apply(Math, (0, $4ac5e71af87e3f54$export$2e2bcd8739ae039)(startBounds));
                    var min = minValue - Math.min.apply(Math, (0, $4ac5e71af87e3f54$export$2e2bcd8739ae039)(startBounds));
                    var ratio = Math.min(Math.max(pos / (this.getSliderLength() / (maxValue - minValue)), min), max);
                    var nextBounds = startBounds.map(function(v) {
                        return Math.floor(Math.max(Math.min(v + ratio, maxValue), minValue));
                    });
                    if (state.bounds.map(function(c, i) {
                        return c === nextBounds[i];
                    }).some(function(c) {
                        return !c;
                    })) this.onChange({
                        bounds: nextBounds
                    });
                    return;
                }
                var value = this.calcValueByPos(position);
                var oldValue = state.bounds[state.handle];
                if (value === oldValue) return;
                this.moveTo(value);
            }
        },
        {
            key: "onKeyboard",
            value: function onKeyboard(e) {
                var _this$props2 = this.props, reverse = _this$props2.reverse, vertical = _this$props2.vertical;
                var valueMutator = $7245e2184e59d4f1$export$3bef836a1fb84ee6(e, vertical, reverse);
                if (valueMutator) {
                    $7245e2184e59d4f1$export$3f9ffdaf2961f43f(e);
                    var state = this.state, props = this.props;
                    var bounds = state.bounds, handle = state.handle;
                    var oldValue = bounds[handle === null ? state.recent : handle];
                    var mutatedValue = valueMutator(oldValue, props);
                    var value = $73820928faa25922$var$_trimAlignValue({
                        value: mutatedValue,
                        handle: handle,
                        bounds: state.bounds,
                        props: props
                    });
                    if (value === oldValue) return;
                    var isFromKeyboardEvent = true;
                    this.moveTo(value, isFromKeyboardEvent);
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.state.bounds;
            }
        },
        {
            key: "getClosestBound",
            value: function getClosestBound(value) {
                var bounds = this.state.bounds;
                var closestBound = 0;
                for(var i = 1; i < bounds.length - 1; i += 1)if (value >= bounds[i]) closestBound = i;
                if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) closestBound += 1;
                return closestBound;
            }
        },
        {
            key: "getBoundNeedMoving",
            value: function getBoundNeedMoving(value, closestBound) {
                var _this$state = this.state, bounds = _this$state.bounds, recent = _this$state.recent;
                var boundNeedMoving = closestBound;
                var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
                if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) boundNeedMoving = recent;
                if (isAtTheSamePoint && value !== bounds[closestBound + 1]) boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
                return boundNeedMoving;
            }
        },
        {
            key: "getLowerBound",
            value: function getLowerBound() {
                return this.state.bounds[0];
            }
        },
        {
            key: "getUpperBound",
            value: function getUpperBound() {
                var bounds = this.state.bounds;
                return bounds[bounds.length - 1];
            }
        },
        {
            key: "getPoints",
            value: function getPoints() {
                var _this$props3 = this.props, marks = _this$props3.marks, step = _this$props3.step, min = _this$props3.min, max = _this$props3.max;
                var cache = this.internalPointsCache;
                if (!cache || cache.marks !== marks || cache.step !== step) {
                    var pointsObject = (0, $41de237383779de8$export$2e2bcd8739ae039)({}, marks);
                    if (step !== null) for(var point = min; point <= max; point += step)pointsObject[point] = point;
                    var points = Object.keys(pointsObject).map(parseFloat);
                    points.sort(function(a, b) {
                        return a - b;
                    });
                    this.internalPointsCache = {
                        marks: marks,
                        step: step,
                        points: points
                    };
                }
                return this.internalPointsCache.points;
            }
        },
        {
            key: "moveTo",
            value: function moveTo(value, isFromKeyboardEvent) {
                var _this3 = this;
                var state = this.state, props = this.props;
                var nextBounds = (0, $4ac5e71af87e3f54$export$2e2bcd8739ae039)(state.bounds);
                var handle = state.handle === null ? state.recent : state.handle;
                nextBounds[handle] = value;
                var nextHandle = handle;
                if (props.pushable !== false) this.pushSurroundingHandles(nextBounds, nextHandle);
                else if (props.allowCross) {
                    nextBounds.sort(function(a, b) {
                        return a - b;
                    });
                    nextHandle = nextBounds.indexOf(value);
                }
                this.onChange({
                    recent: nextHandle,
                    handle: nextHandle,
                    bounds: nextBounds
                });
                if (isFromKeyboardEvent) {
                    // known problem: because setState is async,
                    // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
                    // cause onBeforeChange and onAfterChange receive wrong value.
                    // here use setState callback to hack，but not elegant
                    this.props.onAfterChange(nextBounds);
                    this.setState({}, function() {
                        _this3.handlesRefs[nextHandle].focus();
                    });
                    this.onEnd();
                }
            }
        },
        {
            key: "pushSurroundingHandles",
            value: function pushSurroundingHandles(bounds, handle) {
                var value = bounds[handle];
                var pushable = this.props.pushable;
                var threshold = Number(pushable);
                var direction = 0;
                if (bounds[handle + 1] - value < threshold) direction = 1; // push to right
                if (value - bounds[handle - 1] < threshold) direction = -1; // push to left
                if (direction === 0) return;
                var nextHandle = handle + direction;
                var diffToNext = direction * (bounds[nextHandle] - value);
                if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) // revert to original value if pushing is impossible
                // eslint-disable-next-line no-param-reassign
                bounds[handle] = bounds[nextHandle] - direction * threshold;
            }
        },
        {
            key: "pushHandle",
            value: function pushHandle(bounds, handle, direction, amount) {
                var originalValue = bounds[handle];
                var currentValue = bounds[handle];
                while(direction * (currentValue - originalValue) < amount){
                    if (!this.pushHandleOnePoint(bounds, handle, direction)) {
                        // can't push handle enough to create the needed `amount` gap, so we
                        // revert its position to the original value
                        // eslint-disable-next-line no-param-reassign
                        bounds[handle] = originalValue;
                        return false;
                    }
                    currentValue = bounds[handle];
                } // the handle was pushed enough to create the needed `amount` gap
                return true;
            }
        },
        {
            key: "pushHandleOnePoint",
            value: function pushHandleOnePoint(bounds, handle, direction) {
                var points = this.getPoints();
                var pointIndex = points.indexOf(bounds[handle]);
                var nextPointIndex = pointIndex + direction;
                if (nextPointIndex >= points.length || nextPointIndex < 0) // reached the minimum or maximum available point, can't push anymore
                return false;
                var nextHandle = handle + direction;
                var nextValue = points[nextPointIndex];
                var pushable = this.props.pushable;
                var threshold = Number(pushable);
                var diffToNext = direction * (bounds[nextHandle] - nextValue);
                if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) // couldn't push next handle, so we won't push this one either
                return false;
                 // push the handle
                // eslint-disable-next-line no-param-reassign
                bounds[handle] = nextValue;
                return true;
            }
        },
        {
            key: "trimAlignValue",
            value: function trimAlignValue(value) {
                var _this$state2 = this.state, handle = _this$state2.handle, bounds = _this$state2.bounds;
                return $73820928faa25922$var$_trimAlignValue({
                    value: value,
                    handle: handle,
                    bounds: bounds,
                    props: this.props
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var _this$state3 = this.state, handle = _this$state3.handle, bounds = _this$state3.bounds;
                var _this$props4 = this.props, prefixCls = _this$props4.prefixCls, vertical = _this$props4.vertical, included = _this$props4.included, disabled = _this$props4.disabled, min = _this$props4.min, max = _this$props4.max, reverse = _this$props4.reverse, handleGenerator = _this$props4.handle, trackStyle = _this$props4.trackStyle, handleStyle = _this$props4.handleStyle, tabIndex = _this$props4.tabIndex, ariaLabelGroupForHandles = _this$props4.ariaLabelGroupForHandles, ariaLabelledByGroupForHandles = _this$props4.ariaLabelledByGroupForHandles, ariaValueTextFormatterGroupForHandles = _this$props4.ariaValueTextFormatterGroupForHandles;
                var offsets = bounds.map(function(v) {
                    return _this4.calcOffset(v);
                });
                var handleClassName = "".concat(prefixCls, "-handle");
                var handles = bounds.map(function(v, i) {
                    var _classNames;
                    var mergedTabIndex = tabIndex[i] || 0;
                    if (disabled || tabIndex[i] === null) mergedTabIndex = null;
                    var dragging = handle === i;
                    return handleGenerator({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))((_classNames = {}, (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_classNames, handleClassName, true), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_classNames, "".concat(handleClassName, "-").concat(i + 1), true), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_classNames, "".concat(handleClassName, "-dragging"), dragging), _classNames)),
                        prefixCls: prefixCls,
                        vertical: vertical,
                        dragging: dragging,
                        offset: offsets[i],
                        value: v,
                        index: i,
                        tabIndex: mergedTabIndex,
                        min: min,
                        max: max,
                        reverse: reverse,
                        disabled: disabled,
                        style: handleStyle[i],
                        ref: function ref(h) {
                            return _this4.saveHandle(i, h);
                        },
                        ariaLabel: ariaLabelGroupForHandles[i],
                        ariaLabelledBy: ariaLabelledByGroupForHandles[i],
                        ariaValueTextFormatter: ariaValueTextFormatterGroupForHandles[i]
                    });
                });
                var tracks = bounds.slice(0, -1).map(function(_, index) {
                    var _classNames2;
                    var i = index + 1;
                    var trackClassName = (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))((_classNames2 = {}, (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-track"), true), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-track-").concat(i), true), _classNames2));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $6153d32a04184434$export$2e2bcd8739ae039), {
                        className: trackClassName,
                        vertical: vertical,
                        reverse: reverse,
                        included: included,
                        offset: offsets[i - 1],
                        length: offsets[i] - offsets[i - 1],
                        style: trackStyle[index],
                        key: i
                    });
                });
                return {
                    tracks: tracks,
                    handles: handles
                };
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (!('value' in props || 'min' in props || 'max' in props)) return null;
                var value = props.value || state.bounds;
                var nextBounds = value.map(function(v, i) {
                    return $73820928faa25922$var$_trimAlignValue({
                        value: v,
                        handle: i,
                        bounds: state.bounds,
                        props: props
                    });
                });
                if (state.bounds.length === nextBounds.length) {
                    if (nextBounds.every(function(v, i) {
                        return v === state.bounds[i];
                    })) return null;
                } else nextBounds = value.map(function(v, i) {
                    return $73820928faa25922$var$_trimAlignValue({
                        value: v,
                        handle: i,
                        props: props
                    });
                });
                return (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, state), {}, {
                    bounds: nextBounds
                });
            }
        }
    ]);
    return Range;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component);
/* eslint-enable */ $73820928faa25922$var$Range.displayName = 'Range';
$73820928faa25922$var$Range.defaultProps = {
    count: 1,
    allowCross: true,
    pushable: false,
    draggableTrack: false,
    tabIndex: [],
    ariaLabelGroupForHandles: [],
    ariaLabelledByGroupForHandles: [],
    ariaValueTextFormatterGroupForHandles: []
};
var $73820928faa25922$export$2e2bcd8739ae039 = (0, $2a78e0de08f64294$export$2e2bcd8739ae039)($73820928faa25922$var$Range);




var $jz4iA = parcelRequire("jz4iA");








var $8NFma = parcelRequire("8NFma");

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");

var $jz4iA = parcelRequire("jz4iA");




var $8NFma = parcelRequire("8NFma");


var $jz4iA = parcelRequire("jz4iA");



var $1oVxX = parcelRequire("1oVxX");




var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");
var $f5523740186e2cf7$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $f5523740186e2cf7$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $f5523740186e2cf7$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $f5523740186e2cf7$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $f5523740186e2cf7$var$rafUUID = 0;
var $f5523740186e2cf7$var$rafIds = new Map();
function $f5523740186e2cf7$var$cleanup(id) {
    $f5523740186e2cf7$var$rafIds.delete(id);
}
var $f5523740186e2cf7$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $f5523740186e2cf7$var$rafUUID += 1;
    var id = $f5523740186e2cf7$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $f5523740186e2cf7$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $f5523740186e2cf7$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $f5523740186e2cf7$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$f5523740186e2cf7$var$wrapperRaf.cancel = function(id) {
    var realId = $f5523740186e2cf7$var$rafIds.get(id);
    $f5523740186e2cf7$var$cleanup(id);
    return $f5523740186e2cf7$var$caf(realId);
};
var $f5523740186e2cf7$export$2e2bcd8739ae039 = $f5523740186e2cf7$var$wrapperRaf;


function $9102837f0ed2a1da$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}




var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");
function $d3ab5e8f9b81c2d1$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $d3ab5e8f9b81c2d1$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(node) === 'object' && $d3ab5e8f9b81c2d1$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($d3ab5e8f9b81c2d1$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $d3ab5e8f9b81c2d1$export$2e2bcd8739ae039(node) {
    var domNode = $d3ab5e8f9b81c2d1$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))), node);
    }
    return null;
}




var $8NFma = parcelRequire("8NFma");
var $6d433702dbe58a39$exports = {};
'use strict';

$6d433702dbe58a39$exports = (parcelRequire("j1hfP"));



var $8NFma = parcelRequire("8NFma");
function $a1bc47844c0b9f81$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $8NFma.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}



var $9b87b0b2780bd611$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var $9b87b0b2780bd611$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var $9b87b0b2780bd611$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $9b87b0b2780bd611$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(object) === 'object' && // React Element type
    (object.$$typeof === $9b87b0b2780bd611$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $9b87b0b2780bd611$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $9b87b0b2780bd611$var$REACT_FRAGMENT_TYPE);
}


var $b585f86dd8ac61f9$var$ReactMajorVersion = Number((0, $8NFma.version).split('.')[0]);
var $b585f86dd8ac61f9$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $b585f86dd8ac61f9$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $b585f86dd8ac61f9$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $b585f86dd8ac61f9$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $a1bc47844c0b9f81$export$2e2bcd8739ae039)(function() {
        return $b585f86dd8ac61f9$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $b585f86dd8ac61f9$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($b585f86dd8ac61f9$var$isReactElement(nodeOrComponent) && $b585f86dd8ac61f9$var$ReactMajorVersion >= 19) return true;
    var type = (0, $6d433702dbe58a39$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $6d433702dbe58a39$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $6d433702dbe58a39$exports.ForwardRef)) return false;
    return true;
};
function $b585f86dd8ac61f9$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $8NFma.isValidElement)(node) && !(0, $9b87b0b2780bd611$export$2e2bcd8739ae039)(node);
}
var $b585f86dd8ac61f9$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $b585f86dd8ac61f9$var$isReactElement(node) && $b585f86dd8ac61f9$export$c1cec34af06bcf7(node);
};
var $b585f86dd8ac61f9$export$7465e5c0bf44f19a = function getNodeRef(node) {
    if (node && $b585f86dd8ac61f9$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};




var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");
function $fa5bdd70e835077c$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


var $249a58021379aa7c$var$Portal = /*#__PURE__*/ (0, $8NFma.forwardRef)(function(props, ref) {
    var didUpdate = props.didUpdate, getContainer = props.getContainer, children = props.children;
    var parentRef = (0, $8NFma.useRef)();
    var containerRef = (0, $8NFma.useRef)();
    // Ref return nothing, only for wrapper check exist
    (0, $8NFma.useImperativeHandle)(ref, function() {
        return {};
    });
    // Create container in client side with sync to avoid useEffect not get ref
    var initRef = (0, $8NFma.useRef)(false);
    if (!initRef.current && (0, $fa5bdd70e835077c$export$2e2bcd8739ae039)()) {
        containerRef.current = getContainer();
        parentRef.current = containerRef.current.parentNode;
        initRef.current = true;
    }
    // [Legacy] Used by `rc-trigger`
    (0, $8NFma.useEffect)(function() {
        didUpdate === null || didUpdate === void 0 || didUpdate(props);
    });
    (0, $8NFma.useEffect)(function() {
        // Restore container to original place
        // React 18 StrictMode will unmount first and mount back for effect test:
        // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
        if (containerRef.current.parentNode === null && parentRef.current !== null) parentRef.current.appendChild(containerRef.current);
        return function() {
            var _containerRef$current;
            // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
            // Since some component use `Portal` directly, we have to keep the logic here.
            (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current = _containerRef$current.parentNode) === null || _containerRef$current === void 0 || _containerRef$current.removeChild(containerRef.current);
        };
    }, []);
    return containerRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).createPortal(children, containerRef.current) : null;
});
var $249a58021379aa7c$export$2e2bcd8739ae039 = $249a58021379aa7c$var$Portal;




function $4ef46dc7008e6493$var$isPointsEq(a1, a2, isAlignPoint) {
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $4ef46dc7008e6493$export$44605b74f7c5d944(builtinPlacements, placementStr, align) {
    var baseAlign = builtinPlacements[placementStr] || {};
    return (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, baseAlign), align);
}
function $4ef46dc7008e6493$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var placement = placements[i];
        if ($4ef46dc7008e6493$var$isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return '';
}



var $jz4iA = parcelRequire("jz4iA");

function $3b86bbcb24b44a1d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $22edb70d56193891$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $02550737ba08c18f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $3bbae3add6a4bdae$export$2e2bcd8739ae039(r, e) {
    return (0, $3b86bbcb24b44a1d$export$2e2bcd8739ae039)(r) || (0, $22edb70d56193891$export$2e2bcd8739ae039)(r, e) || (0, $ae4970148ece50ad$export$2e2bcd8739ae039)(r, e) || (0, $02550737ba08c18f$export$2e2bcd8739ae039)();
}




var $8NFma = parcelRequire("8NFma");
var $ad2f0028db36cb3f$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};



var $jz4iA = parcelRequire("jz4iA");


var $8NFma = parcelRequire("8NFma");









var $8NFma = parcelRequire("8NFma");


var $8NFma = parcelRequire("8NFma");
var $e770b0013b21b955$var$_excluded = [
    "children"
];
var $e770b0013b21b955$export$841858b892ce1f4c = /*#__PURE__*/ $8NFma.createContext({});
function $e770b0013b21b955$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $cfae3d675552f8ab$export$2e2bcd8739ae039)(_ref, $e770b0013b21b955$var$_excluded);
    return /*#__PURE__*/ $8NFma.createElement($e770b0013b21b955$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}







var $8NFma = parcelRequire("8NFma");
var $85139a4dbf3a86d2$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $165305ab584beb18$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $5d0d7e04eb688530$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $a0703d0085fc4fb2$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $fe9a5bf59b39de5a$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($8NFma.Component);
var $85139a4dbf3a86d2$export$2e2bcd8739ae039 = $85139a4dbf3a86d2$var$DomWrapper;






var $8NFma = parcelRequire("8NFma");
function $af8cd0e17efce15c$export$2e2bcd8739ae039(callback) {
    var fnRef = $8NFma.useRef();
    fnRef.current = callback;
    var memoFn = $8NFma.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}





var $8NFma = parcelRequire("8NFma");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $0e99bcc1fc96d845$var$useInternalLayoutEffect = (0, $fa5bdd70e835077c$export$2e2bcd8739ae039)() ? $8NFma.useLayoutEffect : $8NFma.useEffect;
var $0e99bcc1fc96d845$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $8NFma.useRef(true);
    $0e99bcc1fc96d845$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $0e99bcc1fc96d845$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $0e99bcc1fc96d845$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $0e99bcc1fc96d845$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $0e99bcc1fc96d845$export$2e2bcd8739ae039 = $0e99bcc1fc96d845$var$useLayoutEffect;




var $8NFma = parcelRequire("8NFma");
function $a0da78b8501d131f$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $8NFma.useRef(false);
    var _React$useState = $8NFma.useState(defaultValue), _React$useState2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $8NFma.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $32279f3f9592ddd4$var$hasValue(value) {
    return value !== undefined;
}
function $32279f3f9592ddd4$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $a0da78b8501d131f$export$2e2bcd8739ae039)(function() {
        if ($32279f3f9592ddd4$var$hasValue(value)) return value;
        else if ($32279f3f9592ddd4$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $af8cd0e17efce15c$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $a0da78b8501d131f$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $0e99bcc1fc96d845$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $0e99bcc1fc96d845$export$9283e56bae2f7b0f)(function() {
        if (!$32279f3f9592ddd4$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $af8cd0e17efce15c$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}



function $aa93e39125f40e37$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}









function $06e7f5ebe1552031$export$2e2bcd8739ae039(r) {
    return (0, $3b86bbcb24b44a1d$export$2e2bcd8739ae039)(r) || (0, $975c10fa3ca03dc7$export$2e2bcd8739ae039)(r) || (0, $ae4970148ece50ad$export$2e2bcd8739ae039)(r) || (0, $02550737ba08c18f$export$2e2bcd8739ae039)();
}



function $e77e423e91143a48$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $06e7f5ebe1552031$export$2e2bcd8739ae039)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $4ac5e71af87e3f54$export$2e2bcd8739ae039)(entity);
    else clone = (0, $41de237383779de8$export$2e2bcd8739ae039)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $e77e423e91143a48$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $e77e423e91143a48$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $aa93e39125f40e37$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $e77e423e91143a48$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $e77e423e91143a48$var$isObject(obj) {
    return (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $e77e423e91143a48$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $e77e423e91143a48$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $e77e423e91143a48$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $e77e423e91143a48$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $aa93e39125f40e37$export$2e2bcd8739ae039)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $e77e423e91143a48$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $aa93e39125f40e37$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $e77e423e91143a48$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(originValue) !== 'object') // Init container if not exist
                    clone = $e77e423e91143a48$export$2e2bcd8739ae039(clone, path, $e77e423e91143a48$var$createEmpty(value));
                    $e77e423e91143a48$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $4ac5e71af87e3f54$export$2e2bcd8739ae039)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $e77e423e91143a48$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}








var $8NFma = parcelRequire("8NFma");

function $7659387b50532545$export$2e2bcd8739ae039(defaultValue) {
    var _React$useReducer = $8NFma.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    var currentValueRef = $8NFma.useRef(defaultValue);
    var getValue = (0, $af8cd0e17efce15c$export$2e2bcd8739ae039)(function() {
        return currentValueRef.current;
    });
    var setValue = (0, $af8cd0e17efce15c$export$2e2bcd8739ae039)(function(updater) {
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}



var $8NFma = parcelRequire("8NFma");
var $56b6ea5284fb22c9$export$de71442bbf2143da = 'none';
var $56b6ea5284fb22c9$export$4fc3521687bcacd2 = 'appear';
var $56b6ea5284fb22c9$export$5d6af549241fe2e8 = 'enter';
var $56b6ea5284fb22c9$export$59b1c493d29f68e4 = 'leave';
var $56b6ea5284fb22c9$export$40b34dd77d5522bf = 'none';
var $56b6ea5284fb22c9$export$1b792916a5fac4fc = 'prepare';
var $56b6ea5284fb22c9$export$9563153dd25a3ce8 = 'start';
var $56b6ea5284fb22c9$export$e205886172277ec6 = 'active';
var $56b6ea5284fb22c9$export$3a846c3d2fac10b8 = 'end';
var $56b6ea5284fb22c9$export$98351fa4e6b4f204 = 'prepared';



var $8NFma = parcelRequire("8NFma");


// ================= Transition =================
// Event wrapper. Copy from react source code
function $097f1c4d44348920$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $097f1c4d44348920$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $097f1c4d44348920$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $097f1c4d44348920$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $097f1c4d44348920$var$vendorPrefixes = $097f1c4d44348920$export$6e8b350b1a8958a0((0, $fa5bdd70e835077c$export$2e2bcd8739ae039)(), typeof window !== 'undefined' ? window : {});
var $097f1c4d44348920$var$style = {};
if ((0, $fa5bdd70e835077c$export$2e2bcd8739ae039)()) {
    var $097f1c4d44348920$var$_document$createEleme = document.createElement('div');
    $097f1c4d44348920$var$style = $097f1c4d44348920$var$_document$createEleme.style;
}
var $097f1c4d44348920$var$prefixedEventNames = {};
function $097f1c4d44348920$export$a032e4f39350c1d8(eventName) {
    if ($097f1c4d44348920$var$prefixedEventNames[eventName]) return $097f1c4d44348920$var$prefixedEventNames[eventName];
    var prefixMap = $097f1c4d44348920$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $097f1c4d44348920$var$style) {
                $097f1c4d44348920$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $097f1c4d44348920$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
var $097f1c4d44348920$var$internalAnimationEndName = $097f1c4d44348920$export$a032e4f39350c1d8('animationend');
var $097f1c4d44348920$var$internalTransitionEndName = $097f1c4d44348920$export$a032e4f39350c1d8('transitionend');
var $097f1c4d44348920$export$d28133ed3ad06c8b = !!($097f1c4d44348920$var$internalAnimationEndName && $097f1c4d44348920$var$internalTransitionEndName);
var $097f1c4d44348920$export$760cc9769c51b738 = $097f1c4d44348920$var$internalAnimationEndName || 'animationend';
var $097f1c4d44348920$export$44baea64b8602e3c = $097f1c4d44348920$var$internalTransitionEndName || 'transitionend';
function $097f1c4d44348920$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(transitionName) === 'object') {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}


var $802ff500d4f30974$export$2e2bcd8739ae039 = function(onInternalMotionEnd) {
    var cacheElementRef = (0, $8NFma.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $097f1c4d44348920$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $097f1c4d44348920$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $097f1c4d44348920$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $097f1c4d44348920$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $8NFma.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $8NFma = parcelRequire("8NFma");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $822257b94f6caced$var$useIsomorphicLayoutEffect = (0, $fa5bdd70e835077c$export$2e2bcd8739ae039)() ? (0, $8NFma.useLayoutEffect) : (0, $8NFma.useEffect);
var $822257b94f6caced$export$2e2bcd8739ae039 = $822257b94f6caced$var$useIsomorphicLayoutEffect;





var $8NFma = parcelRequire("8NFma");




var $8NFma = parcelRequire("8NFma");
var $2677df4d8d3c7de7$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $8NFma.useRef(null);
    function cancelNextFrame() {
        (0, $f5523740186e2cf7$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $f5523740186e2cf7$export$2e2bcd8739ae039)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $8NFma.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


var $3dbcb03cf6fd5c96$var$FULL_STEP_QUEUE = [
    (0, $56b6ea5284fb22c9$export$1b792916a5fac4fc),
    (0, $56b6ea5284fb22c9$export$9563153dd25a3ce8),
    (0, $56b6ea5284fb22c9$export$e205886172277ec6),
    (0, $56b6ea5284fb22c9$export$3a846c3d2fac10b8)
];
var $3dbcb03cf6fd5c96$var$SIMPLE_STEP_QUEUE = [
    (0, $56b6ea5284fb22c9$export$1b792916a5fac4fc),
    (0, $56b6ea5284fb22c9$export$98351fa4e6b4f204)
];
var $3dbcb03cf6fd5c96$export$c2029bf6cfdbc28a = false;
var $3dbcb03cf6fd5c96$export$dbee1e282e8c4830 = true;
function $3dbcb03cf6fd5c96$export$39e04e72f972b885(step) {
    return step === (0, $56b6ea5284fb22c9$export$e205886172277ec6) || step === (0, $56b6ea5284fb22c9$export$3a846c3d2fac10b8);
}
var $3dbcb03cf6fd5c96$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $a0da78b8501d131f$export$2e2bcd8739ae039)((0, $56b6ea5284fb22c9$export$40b34dd77d5522bf)), _useState2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $2677df4d8d3c7de7$export$2e2bcd8739ae039)(), _useNextFrame2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $56b6ea5284fb22c9$export$1b792916a5fac4fc), true);
    }
    var STEP_QUEUE = prepareOnly ? $3dbcb03cf6fd5c96$var$SIMPLE_STEP_QUEUE : $3dbcb03cf6fd5c96$var$FULL_STEP_QUEUE;
    (0, $822257b94f6caced$export$2e2bcd8739ae039)(function() {
        if (step !== (0, $56b6ea5284fb22c9$export$40b34dd77d5522bf) && step !== (0, $56b6ea5284fb22c9$export$3a846c3d2fac10b8)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $3dbcb03cf6fd5c96$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $8NFma.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};


function $1a0eac86731cd356$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $a0da78b8501d131f$export$2e2bcd8739ae039)(), _useState2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useSyncState = (0, $7659387b50532545$export$2e2bcd8739ae039)((0, $56b6ea5284fb22c9$export$de71442bbf2143da)), _useSyncState2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
    var _useState3 = (0, $a0da78b8501d131f$export$2e2bcd8739ae039)(null), _useState4 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useState3, 2), style = _useState4[0], setStyle = _useState4[1];
    var currentStatus = getStatus();
    var mountedRef = (0, $8NFma.useRef)(false);
    var deadlineRef = (0, $8NFma.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $8NFma.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $56b6ea5284fb22c9$export$de71442bbf2143da));
        setStyle(null, true);
    }
    var onInternalMotionEnd = (0, $af8cd0e17efce15c$export$2e2bcd8739ae039)(function(event) {
        var status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $56b6ea5284fb22c9$export$de71442bbf2143da)) return;
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $56b6ea5284fb22c9$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $56b6ea5284fb22c9$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $56b6ea5284fb22c9$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    var _useDomMotionEvents = (0, $802ff500d4f30974$export$2e2bcd8739ae039)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        switch(targetStatus){
            case 0, $56b6ea5284fb22c9$export$4fc3521687bcacd2:
                return (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)({}, (0, $56b6ea5284fb22c9$export$1b792916a5fac4fc), onAppearPrepare), (0, $56b6ea5284fb22c9$export$9563153dd25a3ce8), onAppearStart), (0, $56b6ea5284fb22c9$export$e205886172277ec6), onAppearActive);
            case 0, $56b6ea5284fb22c9$export$5d6af549241fe2e8:
                return (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)({}, (0, $56b6ea5284fb22c9$export$1b792916a5fac4fc), onEnterPrepare), (0, $56b6ea5284fb22c9$export$9563153dd25a3ce8), onEnterStart), (0, $56b6ea5284fb22c9$export$e205886172277ec6), onEnterActive);
            case 0, $56b6ea5284fb22c9$export$59b1c493d29f68e4:
                return (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)({}, (0, $56b6ea5284fb22c9$export$1b792916a5fac4fc), onLeavePrepare), (0, $56b6ea5284fb22c9$export$9563153dd25a3ce8), onLeaveStart), (0, $56b6ea5284fb22c9$export$e205886172277ec6), onLeaveActive);
            default:
                return {};
        }
    };
    var eventHandlers = $8NFma.useMemo(function() {
        return getEventHandlers(currentStatus);
    }, [
        currentStatus
    ]);
    var _useStepQueue = (0, $3dbcb03cf6fd5c96$export$2e2bcd8739ae039)(currentStatus, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $56b6ea5284fb22c9$export$1b792916a5fac4fc)) {
            var onPrepare = eventHandlers[0, $56b6ea5284fb22c9$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $3dbcb03cf6fd5c96$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $56b6ea5284fb22c9$export$e205886172277ec6) && currentStatus !== (0, $56b6ea5284fb22c9$export$de71442bbf2143da)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $56b6ea5284fb22c9$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $3dbcb03cf6fd5c96$export$dbee1e282e8c4830;
    }), _useStepQueue2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $3dbcb03cf6fd5c96$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    var visibleRef = (0, $8NFma.useRef)(null);
    // Update with new status
    (0, $822257b94f6caced$export$2e2bcd8739ae039)(function() {
        // When use Suspense, the `visible` will repeat trigger,
        // But not real change of the `visible`, we need to skip it.
        // https://github.com/ant-design/ant-design/issues/44379
        if (mountedRef.current && visibleRef.current === visible) return;
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $56b6ea5284fb22c9$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $56b6ea5284fb22c9$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $56b6ea5284fb22c9$export$59b1c493d29f68e4);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $56b6ea5284fb22c9$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $56b6ea5284fb22c9$export$de71442bbf2143da));
        visibleRef.current = visible;
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $8NFma.useEffect)(function() {
        if (// Cancel appear
        currentStatus === (0, $56b6ea5284fb22c9$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        currentStatus === (0, $56b6ea5284fb22c9$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        currentStatus === (0, $56b6ea5284fb22c9$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $56b6ea5284fb22c9$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $8NFma.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $8NFma.useRef(false);
    (0, $8NFma.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $56b6ea5284fb22c9$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $56b6ea5284fb22c9$export$1b792916a5fac4fc] && step === (0, $56b6ea5284fb22c9$export$9563153dd25a3ce8)) mergedStyle = (0, $41de237383779de8$export$2e2bcd8739ae039)({
        transition: 'none'
    }, mergedStyle);
    return [
        currentStatus,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}





function $af5e6f2eff03af29$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(config) === 'object') transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $8NFma.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $8NFma.useContext((0, $e770b0013b21b955$export$841858b892ce1f4c)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $8NFma.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $8NFma.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $d3ab5e8f9b81c2d1$export$2e2bcd8739ae039)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $1a0eac86731cd356$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $8NFma.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $8NFma.useCallback(function(node) {
            nodeRef.current = node;
            (0, $b585f86dd8ac61f9$export$f17fd18fa51dcb5b)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $56b6ea5284fb22c9$export$de71442bbf2143da)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $41de237383779de8$export$2e2bcd8739ae039)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                style: {
                    display: 'none'
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            // In motion
            var statusSuffix;
            if (statusStep === (0, $56b6ea5284fb22c9$export$1b792916a5fac4fc)) statusSuffix = 'prepare';
            else if ((0, $3dbcb03cf6fd5c96$export$39e04e72f972b885)(statusStep)) statusSuffix = 'active';
            else if (statusStep === (0, $56b6ea5284fb22c9$export$9563153dd25a3ce8)) statusSuffix = 'start';
            var motionCls = (0, $097f1c4d44348920$export$27c72201b1d09951)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))((0, $097f1c4d44348920$export$27c72201b1d09951)(motionName, status), (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $8NFma.isValidElement(motionChildren) && (0, $b585f86dd8ac61f9$export$c1cec34af06bcf7)(motionChildren)) {
            var originNodeRef = (0, $b585f86dd8ac61f9$export$7465e5c0bf44f19a)(motionChildren);
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $8NFma.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $8NFma.createElement((0, $85139a4dbf3a86d2$export$2e2bcd8739ae039), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $af5e6f2eff03af29$export$2e2bcd8739ae039 = $af5e6f2eff03af29$export$e265d52a86a9f199((0, $097f1c4d44348920$export$d28133ed3ad06c8b));



var $jz4iA = parcelRequire("jz4iA");





var $1oVxX = parcelRequire("1oVxX");




var $8NFma = parcelRequire("8NFma");



var $3cf2454505af5acf$export$3904baa009bc026e = 'add';
var $3cf2454505af5acf$export$851162f0adad2cbc = 'keep';
var $3cf2454505af5acf$export$c8b3fb08b68cfc85 = 'remove';
var $3cf2454505af5acf$export$2ac1bd1808d2e43a = 'removed';
function $3cf2454505af5acf$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(key) === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $3cf2454505af5acf$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($3cf2454505af5acf$export$c47fd798e598c85c);
}
function $3cf2454505af5acf$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $3cf2454505af5acf$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $3cf2454505af5acf$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, obj), {}, {
                            status: $3cf2454505af5acf$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, currentKeyObj), {}, {
                    status: $3cf2454505af5acf$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, keyObj), {}, {
            status: $3cf2454505af5acf$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, obj), {}, {
            status: $3cf2454505af5acf$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $3cf2454505af5acf$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $3cf2454505af5acf$export$851162f0adad2cbc;
        });
    });
    return list;
}



var $f2ae4ff8848aedd4$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $f2ae4ff8848aedd4$var$_excluded2 = [
    "status"
];
var $f2ae4ff8848aedd4$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $f2ae4ff8848aedd4$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $af5e6f2eff03af29$export$2e2bcd8739ae039);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $165305ab584beb18$export$2e2bcd8739ae039)(CSSMotionList, _React$Component);
        var _super = (0, $5d0d7e04eb688530$export$2e2bcd8739ae039)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $a0703d0085fc4fb2$export$2e2bcd8739ae039)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "removeKey", function(removeKey) {
                _this.setState(function(prevState) {
                    var nextKeyEntities = prevState.keyEntities.map(function(entity) {
                        if (entity.key !== removeKey) return entity;
                        return (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, entity), {}, {
                            status: (0, $3cf2454505af5acf$export$2ac1bd1808d2e43a)
                        });
                    });
                    return {
                        keyEntities: nextKeyEntities
                    };
                }, function() {
                    var keyEntities = _this.state.keyEntities;
                    var restKeysCount = keyEntities.filter(function(_ref) {
                        var status = _ref.status;
                        return status !== (0, $3cf2454505af5acf$export$2ac1bd1808d2e43a);
                    }).length;
                    if (restKeysCount === 0 && _this.props.onAllRemoved) _this.props.onAllRemoved();
                });
            });
            return _this;
        }
        (0, $fe9a5bf59b39de5a$export$2e2bcd8739ae039)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $cfae3d675552f8ab$export$2e2bcd8739ae039)(_this$props, $f2ae4ff8848aedd4$var$_excluded);
                    var Component = component || $8NFma.Fragment;
                    var motionProps = {};
                    $f2ae4ff8848aedd4$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $8NFma.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $cfae3d675552f8ab$export$2e2bcd8739ae039)(_ref2, $f2ae4ff8848aedd4$var$_excluded2);
                        var visible = status === (0, $3cf2454505af5acf$export$3904baa009bc026e) || status === (0, $3cf2454505af5acf$export$851162f0adad2cbc);
                        return /*#__PURE__*/ $8NFma.createElement(CSSMotion, (0, $jz4iA.default)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) _this2.removeKey(eventProps.key);
                            }
                        }), function(props, ref) {
                            return children((0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $3cf2454505af5acf$export$84bd7bd42ccc0f72)(keys);
                    var mixedKeyEntities = (0, $3cf2454505af5acf$export$14527669107aa301)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $3cf2454505af5acf$export$2ac1bd1808d2e43a) && entity.status === (0, $3cf2454505af5acf$export$c8b3fb08b68cfc85)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($8NFma.Component);
    (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(CSSMotionList, "defaultProps", {
        component: 'div'
    });
    return CSSMotionList;
}
var $f2ae4ff8848aedd4$export$2e2bcd8739ae039 = $f2ae4ff8848aedd4$export$fcfc62c1d33d5e2e((0, $097f1c4d44348920$export$d28133ed3ad06c8b));



var $420974de752ed086$export$2e2bcd8739ae039 = (0, $af5e6f2eff03af29$export$2e2bcd8739ae039);


function $d090e14a8d7b7b4d$export$7b8936ddc277a29a(_ref) {
    var prefixCls = _ref.prefixCls, motion = _ref.motion, animation = _ref.animation, transitionName = _ref.transitionName;
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}


function $a2d3b44c5566710b$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, mask = props.mask, maskMotion = props.maskMotion, maskAnimation = props.maskAnimation, maskTransitionName = props.maskTransitionName;
    if (!mask) return null;
    var motion = {};
    if (maskMotion || maskTransitionName || maskAnimation) motion = (0, $41de237383779de8$export$2e2bcd8739ae039)({
        motionAppear: true
    }, (0, $d090e14a8d7b7b4d$export$7b8936ddc277a29a)({
        motion: maskMotion,
        prefixCls: prefixCls,
        transitionName: maskTransitionName,
        animation: maskAnimation
    }));
    return /*#__PURE__*/ $8NFma.createElement((0, $420974de752ed086$export$2e2bcd8739ae039), (0, $jz4iA.default)({}, motion, {
        visible: visible,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $8NFma.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))("".concat(prefixCls, "-mask"), className)
        });
    });
}



var $jz4iA = parcelRequire("jz4iA");



var $8NFma = parcelRequire("8NFma");
// export this package's api


function $62489153aa47ee3b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $62489153aa47ee3b$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $62489153aa47ee3b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $62489153aa47ee3b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $62489153aa47ee3b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $62489153aa47ee3b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $62489153aa47ee3b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $62489153aa47ee3b$var$_typeof(obj);
}
function $62489153aa47ee3b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $62489153aa47ee3b$var$vendorPrefix;
var $62489153aa47ee3b$var$jsCssMap = {
    Webkit: '-webkit-',
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-'
};
function $62489153aa47ee3b$var$getVendorPrefix() {
    if ($62489153aa47ee3b$var$vendorPrefix !== undefined) return $62489153aa47ee3b$var$vendorPrefix;
    $62489153aa47ee3b$var$vendorPrefix = '';
    var style = document.createElement('p').style;
    var testProp = 'Transform';
    for(var key in $62489153aa47ee3b$var$jsCssMap)if (key + testProp in style) $62489153aa47ee3b$var$vendorPrefix = key;
    return $62489153aa47ee3b$var$vendorPrefix;
}
function $62489153aa47ee3b$var$getTransitionName() {
    return $62489153aa47ee3b$var$getVendorPrefix() ? "".concat($62489153aa47ee3b$var$getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}
function $62489153aa47ee3b$var$getTransformName() {
    return $62489153aa47ee3b$var$getVendorPrefix() ? "".concat($62489153aa47ee3b$var$getVendorPrefix(), "Transform") : 'transform';
}
function $62489153aa47ee3b$var$setTransitionProperty(node, value) {
    var name = $62489153aa47ee3b$var$getTransitionName();
    if (name) {
        node.style[name] = value;
        if (name !== 'transitionProperty') node.style.transitionProperty = value;
    }
}
function $62489153aa47ee3b$var$setTransform(node, value) {
    var name = $62489153aa47ee3b$var$getTransformName();
    if (name) {
        node.style[name] = value;
        if (name !== 'transform') node.style.transform = value;
    }
}
function $62489153aa47ee3b$var$getTransitionProperty(node) {
    return node.style.transitionProperty || node.style[$62489153aa47ee3b$var$getTransitionName()];
}
function $62489153aa47ee3b$var$getTransformXY(node) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue($62489153aa47ee3b$var$getTransformName());
    if (transform && transform !== 'none') {
        var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
        return {
            x: parseFloat(matrix[12] || matrix[4], 0),
            y: parseFloat(matrix[13] || matrix[5], 0)
        };
    }
    return {
        x: 0,
        y: 0
    };
}
var $62489153aa47ee3b$var$matrix2d = /matrix\((.*)\)/;
var $62489153aa47ee3b$var$matrix3d = /matrix3d\((.*)\)/;
function $62489153aa47ee3b$var$setTransformXY(node, xy) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue($62489153aa47ee3b$var$getTransformName());
    if (transform && transform !== 'none') {
        var arr;
        var match2d = transform.match($62489153aa47ee3b$var$matrix2d);
        if (match2d) {
            match2d = match2d[1];
            arr = match2d.split(',').map(function(item) {
                return parseFloat(item, 10);
            });
            arr[4] = xy.x;
            arr[5] = xy.y;
            $62489153aa47ee3b$var$setTransform(node, "matrix(".concat(arr.join(','), ")"));
        } else {
            var match3d = transform.match($62489153aa47ee3b$var$matrix3d)[1];
            arr = match3d.split(',').map(function(item) {
                return parseFloat(item, 10);
            });
            arr[12] = xy.x;
            arr[13] = xy.y;
            $62489153aa47ee3b$var$setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
        }
    } else $62489153aa47ee3b$var$setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
}
var $62489153aa47ee3b$var$RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var $62489153aa47ee3b$var$getComputedStyleX;
// https://stackoverflow.com/a/3485654/3040605
function $62489153aa47ee3b$var$forceRelayout(elem) {
    var originalStyle = elem.style.display;
    elem.style.display = 'none';
    elem.offsetHeight; // eslint-disable-line
    elem.style.display = originalStyle;
}
function $62489153aa47ee3b$var$css(el, name, v) {
    var value = v;
    if ($62489153aa47ee3b$var$_typeof(name) === 'object') {
        for(var i in name)if (name.hasOwnProperty(i)) $62489153aa47ee3b$var$css(el, i, name[i]);
        return undefined;
    }
    if (typeof value !== 'undefined') {
        if (typeof value === 'number') value = "".concat(value, "px");
        el.style[name] = value;
        return undefined;
    }
    return $62489153aa47ee3b$var$getComputedStyleX(el, name);
}
function $62489153aa47ee3b$var$getClientPosition(elem) {
    var box;
    var x;
    var y;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement;
    // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
    box = elem.getBoundingClientRect();
    // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
    // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
    // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
    x = Math.floor(box.left);
    y = Math.floor(box.top);
    // In IE, most of the time, 2 extra pixels are added to the top and left
    // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
    // IE6 standards mode, this border can be overridden by setting the
    // document element's border to zero -- thus, we cannot rely on the
    // offset always being 2 pixels.
    // In quirks mode, the offset can be determined by querying the body's
    // clientLeft/clientTop, but in standards mode, it is found by querying
    // the document element's clientLeft/clientTop.  Since we already called
    // getClientBoundingRect we have already forced a reflow, so it is not
    // too expensive just to query them all.
    // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
    // 窗口边框标准是设 documentElement ,quirks 时设置 body
    // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
    // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
    // 标准 ie 下 docElem.clientTop 就是 border-top
    // ie7 html 即窗口边框改变不了。永远为 2
    // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
        left: x,
        top: y
    };
}
function $62489153aa47ee3b$var$getScroll(w, top) {
    var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
    var method = "scroll".concat(top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        // ie6,7,8 standard mode
        ret = d.documentElement[method];
        if (typeof ret !== 'number') // quirks mode
        ret = d.body[method];
    }
    return ret;
}
function $62489153aa47ee3b$var$getScrollLeft(w) {
    return $62489153aa47ee3b$var$getScroll(w);
}
function $62489153aa47ee3b$var$getScrollTop(w) {
    return $62489153aa47ee3b$var$getScroll(w, true);
}
function $62489153aa47ee3b$var$getOffset(el) {
    var pos = $62489153aa47ee3b$var$getClientPosition(el);
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $62489153aa47ee3b$var$getScrollLeft(w);
    pos.top += $62489153aa47ee3b$var$getScrollTop(w);
    return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */ function $62489153aa47ee3b$var$isWindow(obj) {
    // must use == for ie8
    /* eslint eqeqeq:0 */ return obj !== null && obj !== undefined && obj == obj.window;
}
function $62489153aa47ee3b$var$getDocument(node) {
    if ($62489153aa47ee3b$var$isWindow(node)) return node.document;
    if (node.nodeType === 9) return node;
    return node.ownerDocument;
}
function $62489153aa47ee3b$var$_getComputedStyle(elem, name, cs) {
    var computedStyle = cs;
    var val = '';
    var d = $62489153aa47ee3b$var$getDocument(elem);
    computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
    // https://github.com/kissyteam/kissy/issues/61
    if (computedStyle) val = computedStyle.getPropertyValue(name) || computedStyle[name];
    return val;
}
var $62489153aa47ee3b$var$_RE_NUM_NO_PX = new RegExp("^(".concat($62489153aa47ee3b$var$RE_NUM, ")(?!px)[a-z%]+$"), 'i');
var $62489153aa47ee3b$var$RE_POS = /^(top|right|bottom|left)$/;
var $62489153aa47ee3b$var$CURRENT_STYLE = 'currentStyle';
var $62489153aa47ee3b$var$RUNTIME_STYLE = 'runtimeStyle';
var $62489153aa47ee3b$var$LEFT = 'left';
var $62489153aa47ee3b$var$PX = 'px';
function $62489153aa47ee3b$var$_getComputedStyleIE(elem, name) {
    // currentStyle maybe null
    // http://msdn.microsoft.com/en-us/library/ms535231.aspx
    var ret = elem[$62489153aa47ee3b$var$CURRENT_STYLE] && elem[$62489153aa47ee3b$var$CURRENT_STYLE][name];
    // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
    // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
    // 在 ie 下不对，需要直接用 offset 方式
    // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels
    // exclude left right for relativity
    if ($62489153aa47ee3b$var$_RE_NUM_NO_PX.test(ret) && !$62489153aa47ee3b$var$RE_POS.test(name)) {
        // Remember the original values
        var style = elem.style;
        var left = style[$62489153aa47ee3b$var$LEFT];
        var rsLeft = elem[$62489153aa47ee3b$var$RUNTIME_STYLE][$62489153aa47ee3b$var$LEFT];
        // prevent flashing of content
        elem[$62489153aa47ee3b$var$RUNTIME_STYLE][$62489153aa47ee3b$var$LEFT] = elem[$62489153aa47ee3b$var$CURRENT_STYLE][$62489153aa47ee3b$var$LEFT];
        // Put in the new values to get a computed value out
        style[$62489153aa47ee3b$var$LEFT] = name === 'fontSize' ? '1em' : ret || 0;
        ret = style.pixelLeft + $62489153aa47ee3b$var$PX;
        // Revert the changed values
        style[$62489153aa47ee3b$var$LEFT] = left;
        elem[$62489153aa47ee3b$var$RUNTIME_STYLE][$62489153aa47ee3b$var$LEFT] = rsLeft;
    }
    return ret === '' ? 'auto' : ret;
}
if (typeof window !== 'undefined') $62489153aa47ee3b$var$getComputedStyleX = window.getComputedStyle ? $62489153aa47ee3b$var$_getComputedStyle : $62489153aa47ee3b$var$_getComputedStyleIE;
function $62489153aa47ee3b$var$getOffsetDirection(dir, option) {
    if (dir === 'left') return option.useCssRight ? 'right' : dir;
    return option.useCssBottom ? 'bottom' : dir;
}
function $62489153aa47ee3b$var$oppositeOffsetDirection(dir) {
    if (dir === 'left') return 'right';
    else if (dir === 'right') return 'left';
    else if (dir === 'top') return 'bottom';
    else if (dir === 'bottom') return 'top';
}
// 设置 elem 相对 elem.ownerDocument 的坐标
function $62489153aa47ee3b$var$setLeftTop(elem, offset, option) {
    // set position first, in-case top/left are set even on static elem
    if ($62489153aa47ee3b$var$css(elem, 'position') === 'static') elem.style.position = 'relative';
    var presetH = -999;
    var presetV = -999;
    var horizontalProperty = $62489153aa47ee3b$var$getOffsetDirection('left', option);
    var verticalProperty = $62489153aa47ee3b$var$getOffsetDirection('top', option);
    var oppositeHorizontalProperty = $62489153aa47ee3b$var$oppositeOffsetDirection(horizontalProperty);
    var oppositeVerticalProperty = $62489153aa47ee3b$var$oppositeOffsetDirection(verticalProperty);
    if (horizontalProperty !== 'left') presetH = 999;
    if (verticalProperty !== 'top') presetV = 999;
    var originalTransition = '';
    var originalOffset = $62489153aa47ee3b$var$getOffset(elem);
    if ('left' in offset || 'top' in offset) {
        originalTransition = $62489153aa47ee3b$var$getTransitionProperty(elem) || '';
        $62489153aa47ee3b$var$setTransitionProperty(elem, 'none');
    }
    if ('left' in offset) {
        elem.style[oppositeHorizontalProperty] = '';
        elem.style[horizontalProperty] = "".concat(presetH, "px");
    }
    if ('top' in offset) {
        elem.style[oppositeVerticalProperty] = '';
        elem.style[verticalProperty] = "".concat(presetV, "px");
    }
    // force relayout
    $62489153aa47ee3b$var$forceRelayout(elem);
    var old = $62489153aa47ee3b$var$getOffset(elem);
    var originalStyle = {};
    for(var key in offset)if (offset.hasOwnProperty(key)) {
        var dir = $62489153aa47ee3b$var$getOffsetDirection(key, option);
        var preset = key === 'left' ? presetH : presetV;
        var off = originalOffset[key] - old[key];
        if (dir === key) originalStyle[dir] = preset + off;
        else originalStyle[dir] = preset - off;
    }
    $62489153aa47ee3b$var$css(elem, originalStyle);
    // force relayout
    $62489153aa47ee3b$var$forceRelayout(elem);
    if ('left' in offset || 'top' in offset) $62489153aa47ee3b$var$setTransitionProperty(elem, originalTransition);
    var ret = {};
    for(var _key in offset)if (offset.hasOwnProperty(_key)) {
        var _dir = $62489153aa47ee3b$var$getOffsetDirection(_key, option);
        var _off = offset[_key] - originalOffset[_key];
        if (_key === _dir) ret[_dir] = originalStyle[_dir] + _off;
        else ret[_dir] = originalStyle[_dir] - _off;
    }
    $62489153aa47ee3b$var$css(elem, ret);
}
function $62489153aa47ee3b$var$setTransform$1(elem, offset) {
    var originalOffset = $62489153aa47ee3b$var$getOffset(elem);
    var originalXY = $62489153aa47ee3b$var$getTransformXY(elem);
    var resultXY = {
        x: originalXY.x,
        y: originalXY.y
    };
    if ('left' in offset) resultXY.x = originalXY.x + offset.left - originalOffset.left;
    if ('top' in offset) resultXY.y = originalXY.y + offset.top - originalOffset.top;
    $62489153aa47ee3b$var$setTransformXY(elem, resultXY);
}
function $62489153aa47ee3b$var$setOffset(elem, offset, option) {
    if (option.ignoreShake) {
        var oriOffset = $62489153aa47ee3b$var$getOffset(elem);
        var oLeft = oriOffset.left.toFixed(0);
        var oTop = oriOffset.top.toFixed(0);
        var tLeft = offset.left.toFixed(0);
        var tTop = offset.top.toFixed(0);
        if (oLeft === tLeft && oTop === tTop) return;
    }
    if (option.useCssRight || option.useCssBottom) $62489153aa47ee3b$var$setLeftTop(elem, offset, option);
    else if (option.useCssTransform && $62489153aa47ee3b$var$getTransformName() in document.body.style) $62489153aa47ee3b$var$setTransform$1(elem, offset);
    else $62489153aa47ee3b$var$setLeftTop(elem, offset, option);
}
function $62489153aa47ee3b$var$each(arr, fn) {
    for(var i = 0; i < arr.length; i++)fn(arr[i]);
}
function $62489153aa47ee3b$var$isBorderBoxFn(elem) {
    return $62489153aa47ee3b$var$getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var $62489153aa47ee3b$var$BOX_MODELS = [
    'margin',
    'border',
    'padding'
];
var $62489153aa47ee3b$var$CONTENT_INDEX = -1;
var $62489153aa47ee3b$var$PADDING_INDEX = 2;
var $62489153aa47ee3b$var$BORDER_INDEX = 1;
var $62489153aa47ee3b$var$MARGIN_INDEX = 0;
function $62489153aa47ee3b$var$swap(elem, options, callback) {
    var old = {};
    var style = elem.style;
    var name;
    // Remember the old values, and insert the new ones
    for(name in options)if (options.hasOwnProperty(name)) {
        old[name] = style[name];
        style[name] = options[name];
    }
    callback.call(elem);
    // Revert the old values
    for(name in options)if (options.hasOwnProperty(name)) style[name] = old[name];
}
function $62489153aa47ee3b$var$getPBMWidth(elem, props, which) {
    var value = 0;
    var prop;
    var j;
    var i;
    for(j = 0; j < props.length; j++){
        prop = props[j];
        if (prop) for(i = 0; i < which.length; i++){
            var cssProp = void 0;
            if (prop === 'border') cssProp = "".concat(prop).concat(which[i], "Width");
            else cssProp = prop + which[i];
            value += parseFloat($62489153aa47ee3b$var$getComputedStyleX(elem, cssProp)) || 0;
        }
    }
    return value;
}
var $62489153aa47ee3b$var$domUtils = {
    getParent: function getParent(element) {
        var parent = element;
        do if (parent.nodeType === 11 && parent.host) parent = parent.host;
        else parent = parent.parentNode;
        while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
        return parent;
    }
};
$62489153aa47ee3b$var$each([
    'Width',
    'Height'
], function(name) {
    $62489153aa47ee3b$var$domUtils["doc".concat(name)] = function(refWin) {
        var d = refWin.document;
        return Math.max(// firefox chrome documentElement.scrollHeight< body.scrollHeight
        // ie standard mode : documentElement.scrollHeight> body.scrollHeight
        d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
        d.body["scroll".concat(name)], $62489153aa47ee3b$var$domUtils["viewport".concat(name)](d));
    };
    $62489153aa47ee3b$var$domUtils["viewport".concat(name)] = function(win) {
        // pc browser includes scrollbar in window.innerWidth
        var prop = "client".concat(name);
        var doc = win.document;
        var body = doc.body;
        var documentElement = doc.documentElement;
        var documentElementProp = documentElement[prop];
        // 标准模式取 documentElement
        // backcompat 取 body
        return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
    };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */ function $62489153aa47ee3b$var$getWH(elem, name, ex) {
    var extra = ex;
    if ($62489153aa47ee3b$var$isWindow(elem)) return name === 'width' ? $62489153aa47ee3b$var$domUtils.viewportWidth(elem) : $62489153aa47ee3b$var$domUtils.viewportHeight(elem);
    else if (elem.nodeType === 9) return name === 'width' ? $62489153aa47ee3b$var$domUtils.docWidth(elem) : $62489153aa47ee3b$var$domUtils.docHeight(elem);
    var which = name === 'width' ? [
        'Left',
        'Right'
    ] : [
        'Top',
        'Bottom'
    ];
    var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
    var isBorderBox = $62489153aa47ee3b$var$isBorderBoxFn(elem);
    var cssBoxValue = 0;
    if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
        borderBoxValue = undefined;
        // Fall back to computed then un computed css if necessary
        cssBoxValue = $62489153aa47ee3b$var$getComputedStyleX(elem, name);
        if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) cssBoxValue = elem.style[name] || 0;
        // Normalize '', auto, and prepare for extra
        cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
    }
    if (extra === undefined) extra = isBorderBox ? $62489153aa47ee3b$var$BORDER_INDEX : $62489153aa47ee3b$var$CONTENT_INDEX;
    var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
    var val = borderBoxValue || cssBoxValue;
    if (extra === $62489153aa47ee3b$var$CONTENT_INDEX) {
        if (borderBoxValueOrIsBorderBox) return val - $62489153aa47ee3b$var$getPBMWidth(elem, [
            'border',
            'padding'
        ], which);
        return cssBoxValue;
    } else if (borderBoxValueOrIsBorderBox) {
        if (extra === $62489153aa47ee3b$var$BORDER_INDEX) return val;
        return val + (extra === $62489153aa47ee3b$var$PADDING_INDEX ? -$62489153aa47ee3b$var$getPBMWidth(elem, [
            'border'
        ], which) : $62489153aa47ee3b$var$getPBMWidth(elem, [
            'margin'
        ], which));
    }
    return cssBoxValue + $62489153aa47ee3b$var$getPBMWidth(elem, $62489153aa47ee3b$var$BOX_MODELS.slice(extra), which);
}
var $62489153aa47ee3b$var$cssShow = {
    position: 'absolute',
    visibility: 'hidden',
    display: 'block'
};
// fix #119 : https://github.com/kissyteam/kissy/issues/119
function $62489153aa47ee3b$var$getWHIgnoreDisplay() {
    for(var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++)args[_key2] = arguments[_key2];
    var val;
    var elem = args[0];
    // in case elem is window
    // elem.offsetWidth === undefined
    if (elem.offsetWidth !== 0) val = $62489153aa47ee3b$var$getWH.apply(undefined, args);
    else $62489153aa47ee3b$var$swap(elem, $62489153aa47ee3b$var$cssShow, function() {
        val = $62489153aa47ee3b$var$getWH.apply(undefined, args);
    });
    return val;
}
$62489153aa47ee3b$var$each([
    'width',
    'height'
], function(name) {
    var first = name.charAt(0).toUpperCase() + name.slice(1);
    $62489153aa47ee3b$var$domUtils["outer".concat(first)] = function(el, includeMargin) {
        return el && $62489153aa47ee3b$var$getWHIgnoreDisplay(el, name, includeMargin ? $62489153aa47ee3b$var$MARGIN_INDEX : $62489153aa47ee3b$var$BORDER_INDEX);
    };
    var which = name === 'width' ? [
        'Left',
        'Right'
    ] : [
        'Top',
        'Bottom'
    ];
    $62489153aa47ee3b$var$domUtils[name] = function(elem, v) {
        var val = v;
        if (val !== undefined) {
            if (elem) {
                var isBorderBox = $62489153aa47ee3b$var$isBorderBoxFn(elem);
                if (isBorderBox) val += $62489153aa47ee3b$var$getPBMWidth(elem, [
                    'padding',
                    'border'
                ], which);
                return $62489153aa47ee3b$var$css(elem, name, val);
            }
            return undefined;
        }
        return elem && $62489153aa47ee3b$var$getWHIgnoreDisplay(elem, name, $62489153aa47ee3b$var$CONTENT_INDEX);
    };
});
function $62489153aa47ee3b$var$mix(to, from) {
    for(var i in from)if (from.hasOwnProperty(i)) to[i] = from[i];
    return to;
}
var $62489153aa47ee3b$var$utils = {
    getWindow: function getWindow(node) {
        if (node && node.document && node.setTimeout) return node;
        var doc = node.ownerDocument || node;
        return doc.defaultView || doc.parentWindow;
    },
    getDocument: $62489153aa47ee3b$var$getDocument,
    offset: function offset(el, value, option) {
        if (typeof value !== 'undefined') $62489153aa47ee3b$var$setOffset(el, value, option || {});
        else return $62489153aa47ee3b$var$getOffset(el);
    },
    isWindow: $62489153aa47ee3b$var$isWindow,
    each: $62489153aa47ee3b$var$each,
    css: $62489153aa47ee3b$var$css,
    clone: function clone(obj) {
        var i;
        var ret = {};
        for(i in obj)if (obj.hasOwnProperty(i)) ret[i] = obj[i];
        var overflow = obj.overflow;
        if (overflow) {
            for(i in obj)if (obj.hasOwnProperty(i)) ret.overflow[i] = obj.overflow[i];
        }
        return ret;
    },
    mix: $62489153aa47ee3b$var$mix,
    getWindowScrollLeft: function getWindowScrollLeft(w) {
        return $62489153aa47ee3b$var$getScrollLeft(w);
    },
    getWindowScrollTop: function getWindowScrollTop(w) {
        return $62489153aa47ee3b$var$getScrollTop(w);
    },
    merge: function merge() {
        var ret = {};
        for(var i = 0; i < arguments.length; i++)$62489153aa47ee3b$var$utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
        return ret;
    },
    viewportWidth: 0,
    viewportHeight: 0
};
$62489153aa47ee3b$var$mix($62489153aa47ee3b$var$utils, $62489153aa47ee3b$var$domUtils);
/**
 * 得到会导致元素显示不全的祖先元素
 */ var $62489153aa47ee3b$var$getParent = $62489153aa47ee3b$var$utils.getParent;
function $62489153aa47ee3b$var$getOffsetParent(element) {
    if ($62489153aa47ee3b$var$utils.isWindow(element) || element.nodeType === 9) return null;
    // ie 这个也不是完全可行
    /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */ // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
    //  In other browsers it only includes elements with position absolute, relative or
    // fixed, not elements with overflow set to auto or scroll.
    //        if (UA.ie && ieMode < 8) {
    //            return element.offsetParent;
    //        }
    // 统一的 offsetParent 方法
    var doc = $62489153aa47ee3b$var$utils.getDocument(element);
    var body = doc.body;
    var parent;
    var positionStyle = $62489153aa47ee3b$var$utils.css(element, 'position');
    var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
    if (!skipStatic) return element.nodeName.toLowerCase() === 'html' ? null : $62489153aa47ee3b$var$getParent(element);
    for(parent = $62489153aa47ee3b$var$getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = $62489153aa47ee3b$var$getParent(parent)){
        positionStyle = $62489153aa47ee3b$var$utils.css(parent, 'position');
        if (positionStyle !== 'static') return parent;
    }
    return null;
}
var $62489153aa47ee3b$var$getParent$1 = $62489153aa47ee3b$var$utils.getParent;
function $62489153aa47ee3b$var$isAncestorFixed(element) {
    if ($62489153aa47ee3b$var$utils.isWindow(element) || element.nodeType === 9) return false;
    var doc = $62489153aa47ee3b$var$utils.getDocument(element);
    var body = doc.body;
    var parent = null;
    for(parent = $62489153aa47ee3b$var$getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
    parent && parent !== body && parent !== doc; parent = $62489153aa47ee3b$var$getParent$1(parent)){
        var positionStyle = $62489153aa47ee3b$var$utils.css(parent, 'position');
        if (positionStyle === 'fixed') return true;
    }
    return false;
}
/**
 * 获得元素的显示部分的区域
 */ function $62489153aa47ee3b$var$getVisibleRectForElement(element, alwaysByViewport) {
    var visibleRect = {
        left: 0,
        right: Infinity,
        top: 0,
        bottom: Infinity
    };
    var el = $62489153aa47ee3b$var$getOffsetParent(element);
    var doc = $62489153aa47ee3b$var$utils.getDocument(element);
    var win = doc.defaultView || doc.parentWindow;
    var body = doc.body;
    var documentElement = doc.documentElement;
    // Determine the size of the visible rect by climbing the dom accounting for
    // all scrollable containers.
    while(el){
        // clientWidth is zero for inline block elements in ie.
        if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
        // viewport. In some browsers, el.offsetParent may be
        // document.documentElement, so check for that too.
        el !== body && el !== documentElement && $62489153aa47ee3b$var$utils.css(el, 'overflow') !== 'visible') {
            var pos = $62489153aa47ee3b$var$utils.offset(el);
            // add border
            pos.left += el.clientLeft;
            pos.top += el.clientTop;
            visibleRect.top = Math.max(visibleRect.top, pos.top);
            visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
            pos.left + el.clientWidth);
            visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
            visibleRect.left = Math.max(visibleRect.left, pos.left);
        } else if (el === body || el === documentElement) break;
        el = $62489153aa47ee3b$var$getOffsetParent(el);
    }
    // Set element position to fixed
    // make sure absolute element itself don't affect it's visible area
    // https://github.com/ant-design/ant-design/issues/7601
    var originalPosition = null;
    if (!$62489153aa47ee3b$var$utils.isWindow(element) && element.nodeType !== 9) {
        originalPosition = element.style.position;
        var position = $62489153aa47ee3b$var$utils.css(element, 'position');
        if (position === 'absolute') element.style.position = 'fixed';
    }
    var scrollX = $62489153aa47ee3b$var$utils.getWindowScrollLeft(win);
    var scrollY = $62489153aa47ee3b$var$utils.getWindowScrollTop(win);
    var viewportWidth = $62489153aa47ee3b$var$utils.viewportWidth(win);
    var viewportHeight = $62489153aa47ee3b$var$utils.viewportHeight(win);
    var documentWidth = documentElement.scrollWidth;
    var documentHeight = documentElement.scrollHeight;
    // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
    // We should cut this ourself.
    var bodyStyle = window.getComputedStyle(body);
    if (bodyStyle.overflowX === 'hidden') documentWidth = win.innerWidth;
    if (bodyStyle.overflowY === 'hidden') documentHeight = win.innerHeight;
    // Reset element position after calculate the visible area
    if (element.style) element.style.position = originalPosition;
    if (alwaysByViewport || $62489153aa47ee3b$var$isAncestorFixed(element)) {
        // Clip by viewport's size.
        visibleRect.left = Math.max(visibleRect.left, scrollX);
        visibleRect.top = Math.max(visibleRect.top, scrollY);
        visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
        visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
    } else {
        // Clip by document's size.
        var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
        visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
        var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
        visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
    }
    return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function $62489153aa47ee3b$var$adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
    var pos = $62489153aa47ee3b$var$utils.clone(elFuturePos);
    var size = {
        width: elRegion.width,
        height: elRegion.height
    };
    if (overflow.adjustX && pos.left < visibleRect.left) pos.left = visibleRect.left;
    // Left edge inside and right edge outside viewport, try to resize it.
    if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) size.width -= pos.left + size.width - visibleRect.right;
    // Right edge outside viewport, try to move it.
    if (overflow.adjustX && pos.left + size.width > visibleRect.right) // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
    // Top edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top < visibleRect.top) pos.top = visibleRect.top;
    // Top edge inside and bottom edge outside viewport, try to resize it.
    if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) size.height -= pos.top + size.height - visibleRect.bottom;
    // Bottom edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
    return $62489153aa47ee3b$var$utils.mix(pos, size);
}
function $62489153aa47ee3b$var$getRegion(node) {
    var offset;
    var w;
    var h;
    if (!$62489153aa47ee3b$var$utils.isWindow(node) && node.nodeType !== 9) {
        offset = $62489153aa47ee3b$var$utils.offset(node);
        w = $62489153aa47ee3b$var$utils.outerWidth(node);
        h = $62489153aa47ee3b$var$utils.outerHeight(node);
    } else {
        var win = $62489153aa47ee3b$var$utils.getWindow(node);
        offset = {
            left: $62489153aa47ee3b$var$utils.getWindowScrollLeft(win),
            top: $62489153aa47ee3b$var$utils.getWindowScrollTop(win)
        };
        w = $62489153aa47ee3b$var$utils.viewportWidth(win);
        h = $62489153aa47ee3b$var$utils.viewportHeight(win);
    }
    offset.width = w;
    offset.height = h;
    return offset;
}
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */ function $62489153aa47ee3b$var$getAlignOffset(region, align) {
    var V = align.charAt(0);
    var H = align.charAt(1);
    var w = region.width;
    var h = region.height;
    var x = region.left;
    var y = region.top;
    if (V === 'c') y += h / 2;
    else if (V === 'b') y += h;
    if (H === 'c') x += w / 2;
    else if (H === 'r') x += w;
    return {
        left: x,
        top: y
    };
}
function $62489153aa47ee3b$var$getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
    var p1 = $62489153aa47ee3b$var$getAlignOffset(refNodeRegion, points[1]);
    var p2 = $62489153aa47ee3b$var$getAlignOffset(elRegion, points[0]);
    var diff = [
        p2.left - p1.left,
        p2.top - p1.top
    ];
    return {
        left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
        top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
    };
}
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */ // http://yiminghe.iteye.com/blog/1124720
function $62489153aa47ee3b$var$isFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function $62489153aa47ee3b$var$isFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function $62489153aa47ee3b$var$isCompleteFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function $62489153aa47ee3b$var$isCompleteFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function $62489153aa47ee3b$var$flip(points, reg, map) {
    var ret = [];
    $62489153aa47ee3b$var$utils.each(points, function(p) {
        ret.push(p.replace(reg, function(m) {
            return map[m];
        }));
    });
    return ret;
}
function $62489153aa47ee3b$var$flipOffset(offset, index) {
    offset[index] = -offset[index];
    return offset;
}
function $62489153aa47ee3b$var$convertOffset(str, offsetLen) {
    var n;
    if (/%$/.test(str)) n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
    else n = parseInt(str, 10);
    return n || 0;
}
function $62489153aa47ee3b$var$normalizeOffset(offset, el) {
    offset[0] = $62489153aa47ee3b$var$convertOffset(offset[0], el.width);
    offset[1] = $62489153aa47ee3b$var$convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */ function $62489153aa47ee3b$var$doAlign(el, tgtRegion, align, isTgtRegionVisible) {
    var points = align.points;
    var offset = align.offset || [
        0,
        0
    ];
    var targetOffset = align.targetOffset || [
        0,
        0
    ];
    var overflow = align.overflow;
    var source = align.source || el;
    offset = [].concat(offset);
    targetOffset = [].concat(targetOffset);
    overflow = overflow || {};
    var newOverflowCfg = {};
    var fail = 0;
    var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
    // 当前节点可以被放置的显示区域
    var visibleRect = $62489153aa47ee3b$var$getVisibleRectForElement(source, alwaysByViewport);
    // 当前节点所占的区域, left/top/width/height
    var elRegion = $62489153aa47ee3b$var$getRegion(source);
    // 将 offset 转换成数值，支持百分比
    $62489153aa47ee3b$var$normalizeOffset(offset, elRegion);
    $62489153aa47ee3b$var$normalizeOffset(targetOffset, tgtRegion);
    // 当前节点将要被放置的位置
    var elFuturePos = $62489153aa47ee3b$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
    // 当前节点将要所处的区域
    var newElRegion = $62489153aa47ee3b$var$utils.merge(elRegion, elFuturePos);
    // 如果可视区域不能完全放置当前节点时允许调整
    if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
        if (overflow.adjustX) // 如果横向不能放下
        {
            if ($62489153aa47ee3b$var$isFailX(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var newPoints = $62489153aa47ee3b$var$flip(points, /[lr]/gi, {
                    l: 'r',
                    r: 'l'
                });
                // 偏移量也反下
                var newOffset = $62489153aa47ee3b$var$flipOffset(offset, 0);
                var newTargetOffset = $62489153aa47ee3b$var$flipOffset(targetOffset, 0);
                var newElFuturePos = $62489153aa47ee3b$var$getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
                if (!$62489153aa47ee3b$var$isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = newPoints;
                    offset = newOffset;
                    targetOffset = newTargetOffset;
                }
            }
        }
        if (overflow.adjustY) // 如果纵向不能放下
        {
            if ($62489153aa47ee3b$var$isFailY(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var _newPoints = $62489153aa47ee3b$var$flip(points, /[tb]/gi, {
                    t: 'b',
                    b: 't'
                });
                // 偏移量也反下
                var _newOffset = $62489153aa47ee3b$var$flipOffset(offset, 1);
                var _newTargetOffset = $62489153aa47ee3b$var$flipOffset(targetOffset, 1);
                var _newElFuturePos = $62489153aa47ee3b$var$getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
                if (!$62489153aa47ee3b$var$isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = _newPoints;
                    offset = _newOffset;
                    targetOffset = _newTargetOffset;
                }
            }
        }
        // 如果失败，重新计算当前节点将要被放置的位置
        if (fail) {
            elFuturePos = $62489153aa47ee3b$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
            $62489153aa47ee3b$var$utils.mix(newElRegion, elFuturePos);
        }
        var isStillFailX = $62489153aa47ee3b$var$isFailX(elFuturePos, elRegion, visibleRect);
        var isStillFailY = $62489153aa47ee3b$var$isFailY(elFuturePos, elRegion, visibleRect);
        // 检查反下后的位置是否可以放下了，如果仍然放不下：
        // 1. 复原修改过的定位参数
        if (isStillFailX || isStillFailY) {
            var _newPoints2 = points;
            // 重置对应部分的翻转逻辑
            if (isStillFailX) _newPoints2 = $62489153aa47ee3b$var$flip(points, /[lr]/gi, {
                l: 'r',
                r: 'l'
            });
            if (isStillFailY) _newPoints2 = $62489153aa47ee3b$var$flip(points, /[tb]/gi, {
                t: 'b',
                b: 't'
            });
            points = _newPoints2;
            offset = align.offset || [
                0,
                0
            ];
            targetOffset = align.targetOffset || [
                0,
                0
            ];
        }
        // 2. 只有指定了可以调整当前方向才调整
        newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
        newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
        // 确实要调整，甚至可能会调整高度宽度
        if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) newElRegion = $62489153aa47ee3b$var$adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
    // need judge to in case set fixed with in css on height auto element
    if (newElRegion.width !== elRegion.width) $62489153aa47ee3b$var$utils.css(source, 'width', $62489153aa47ee3b$var$utils.width(source) + newElRegion.width - elRegion.width);
    if (newElRegion.height !== elRegion.height) $62489153aa47ee3b$var$utils.css(source, 'height', $62489153aa47ee3b$var$utils.height(source) + newElRegion.height - elRegion.height);
    // https://github.com/kissyteam/kissy/issues/190
    // 相对于屏幕位置没变，而 left/top 变了
    // 例如 <div 'relative'><el absolute></div>
    $62489153aa47ee3b$var$utils.offset(source, {
        left: newElRegion.left,
        top: newElRegion.top
    }, {
        useCssRight: align.useCssRight,
        useCssBottom: align.useCssBottom,
        useCssTransform: align.useCssTransform,
        ignoreShake: align.ignoreShake
    });
    return {
        points: points,
        offset: offset,
        targetOffset: targetOffset,
        overflow: newOverflowCfg
    };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/ function $62489153aa47ee3b$var$isOutOfVisibleRect(target, alwaysByViewport) {
    var visibleRect = $62489153aa47ee3b$var$getVisibleRectForElement(target, alwaysByViewport);
    var targetRegion = $62489153aa47ee3b$var$getRegion(target);
    return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function $62489153aa47ee3b$export$ec21431d5ee6c534(el, refNode, align) {
    var target = align.target || refNode;
    var refNodeRegion = $62489153aa47ee3b$var$getRegion(target);
    var isTargetNotOutOfVisible = !$62489153aa47ee3b$var$isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
    return $62489153aa47ee3b$var$doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
$62489153aa47ee3b$export$ec21431d5ee6c534.__getOffsetParent = $62489153aa47ee3b$var$getOffsetParent;
$62489153aa47ee3b$export$ec21431d5ee6c534.__getVisibleRectForElement = $62489153aa47ee3b$var$getVisibleRectForElement;
/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */ function $62489153aa47ee3b$export$38f0e12f0aa28098(el, tgtPoint, align) {
    var pageX;
    var pageY;
    var doc = $62489153aa47ee3b$var$utils.getDocument(el);
    var win = doc.defaultView || doc.parentWindow;
    var scrollX = $62489153aa47ee3b$var$utils.getWindowScrollLeft(win);
    var scrollY = $62489153aa47ee3b$var$utils.getWindowScrollTop(win);
    var viewportWidth = $62489153aa47ee3b$var$utils.viewportWidth(win);
    var viewportHeight = $62489153aa47ee3b$var$utils.viewportHeight(win);
    if ('pageX' in tgtPoint) pageX = tgtPoint.pageX;
    else pageX = scrollX + tgtPoint.clientX;
    if ('pageY' in tgtPoint) pageY = tgtPoint.pageY;
    else pageY = scrollY + tgtPoint.clientY;
    var tgtRegion = {
        left: pageX,
        top: pageY,
        width: 0,
        height: 0
    };
    var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
    // Provide default target point
    var points = [
        align.points[0],
        'cc'
    ];
    return $62489153aa47ee3b$var$doAlign(el, tgtRegion, $62489153aa47ee3b$var$_objectSpread2($62489153aa47ee3b$var$_objectSpread2({}, align), {}, {
        points: points
    }), pointInView);
}
var $62489153aa47ee3b$export$2e2bcd8739ae039 = $62489153aa47ee3b$export$ec21431d5ee6c534;




/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $6bd75fa00eae78ea$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $64ecca1b33f9f5ed$export$2e2bcd8739ae039)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(a) === 'object' && (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(b) === 'object') {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $6bd75fa00eae78ea$export$2e2bcd8739ae039 = $6bd75fa00eae78ea$var$isEqual;



var $f77508a4d0920b35$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};





var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");
var $c375eb3ad80875c0$export$2e2bcd8739ae039 = function(callback, buffer) {
    var calledRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(false);
    var timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(null);
    function cancelTrigger() {
        window.clearTimeout(timeoutRef.current);
    }
    function trigger(force) {
        cancelTrigger();
        if (!calledRef.current || force === true) {
            if (callback(force) === false) // Not delay since callback cancelled self
            return;
            calledRef.current = true;
            timeoutRef.current = window.setTimeout(function() {
                calledRef.current = false;
            }, buffer);
        } else timeoutRef.current = window.setTimeout(function() {
            calledRef.current = false;
            trigger();
        }, buffer);
    }
    return [
        trigger,
        function() {
            calledRef.current = false;
            cancelTrigger();
        }
    ];
};



/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $6873d325be803505$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $6873d325be803505$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $6873d325be803505$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $6873d325be803505$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($6873d325be803505$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $6873d325be803505$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $6873d325be803505$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $6873d325be803505$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $6873d325be803505$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $6873d325be803505$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $6873d325be803505$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $6873d325be803505$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $6873d325be803505$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $6873d325be803505$var$throttle(this.refresh.bind(this), $6873d325be803505$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$6873d325be803505$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($6873d325be803505$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$6873d325be803505$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $6873d325be803505$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $6873d325be803505$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $6873d325be803505$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $6873d325be803505$var$global$1;
};
// Placeholder of an empty content rectangle.
var $6873d325be803505$var$emptyRect = $6873d325be803505$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $6873d325be803505$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $6873d325be803505$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $6873d325be803505$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $6873d325be803505$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $6873d325be803505$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $6873d325be803505$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $6873d325be803505$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $6873d325be803505$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $6873d325be803505$var$emptyRect;
    var styles = $6873d325be803505$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $6873d325be803505$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $6873d325be803505$var$toFloat(styles.width), height = $6873d325be803505$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $6873d325be803505$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $6873d325be803505$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$6873d325be803505$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $6873d325be803505$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $6873d325be803505$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $6873d325be803505$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $6873d325be803505$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $6873d325be803505$var$isDocumentElement(target) {
    return target === $6873d325be803505$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $6873d325be803505$var$getContentRect(target) {
    if (!$6873d325be803505$var$isBrowser) return $6873d325be803505$var$emptyRect;
    if ($6873d325be803505$var$isSVGGraphicsElement(target)) return $6873d325be803505$var$getSVGContentRect(target);
    return $6873d325be803505$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $6873d325be803505$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $6873d325be803505$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $6873d325be803505$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $6873d325be803505$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $6873d325be803505$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $6873d325be803505$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $6873d325be803505$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $6873d325be803505$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $6873d325be803505$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $6873d325be803505$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $6873d325be803505$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $6873d325be803505$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $6873d325be803505$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $6873d325be803505$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $6873d325be803505$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $6873d325be803505$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $6873d325be803505$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $6873d325be803505$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $6873d325be803505$var$ResizeObserverController.getInstance();
        var observer = new $6873d325be803505$var$ResizeObserverSPI(callback, controller, this);
        $6873d325be803505$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $6873d325be803505$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $6873d325be803505$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $6873d325be803505$var$index = function() {
    // Export existing implementation if available.
    if (typeof $6873d325be803505$var$global$1.ResizeObserver !== 'undefined') return $6873d325be803505$var$global$1.ResizeObserver;
    return $6873d325be803505$var$ResizeObserver;
}();
var $6873d325be803505$export$2e2bcd8739ae039 = $6873d325be803505$var$index;



function $6d0d038d3f95f599$export$792a4d7b8e9efb33(prev, next) {
    if (prev === next) return true;
    if (!prev || !next) return false;
    if ('pageX' in next && 'pageY' in next) return prev.pageX === next.pageX && prev.pageY === next.pageY;
    if ('clientX' in next && 'clientY' in next) return prev.clientX === next.clientX && prev.clientY === next.clientY;
    return false;
}
function $6d0d038d3f95f599$export$2284e449d64b22d5(activeElement, container) {
    // Focus back if is in the container
    if (activeElement !== document.activeElement && (0, $9102837f0ed2a1da$export$2e2bcd8739ae039)(container, activeElement) && typeof activeElement.focus === 'function') activeElement.focus();
}
function $6d0d038d3f95f599$export$f56787db9e74dfe(element, callback) {
    var prevWidth = null;
    var prevHeight = null;
    function onResize(_ref) {
        var _ref2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_ref, 1), target = _ref2[0].target;
        if (!document.documentElement.contains(target)) return;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) // https://webkit.org/blog/9997/resizeobserver-in-webkit/
        Promise.resolve().then(function() {
            callback({
                width: fixedWidth,
                height: fixedHeight
            });
        });
        prevWidth = fixedWidth;
        prevHeight = fixedHeight;
    }
    var resizeObserver = new (0, $6873d325be803505$export$2e2bcd8739ae039)(onResize);
    if (element) resizeObserver.observe(element);
    return function() {
        resizeObserver.disconnect();
    };
}


function $f363ffd589035457$var$getElement(func) {
    if (typeof func !== 'function') return null;
    return func();
}
function $f363ffd589035457$var$getPoint(point) {
    if ((0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(point) !== 'object' || !point) return null;
    return point;
}
var $f363ffd589035457$var$Align = function Align(_ref, ref) {
    var children = _ref.children, disabled = _ref.disabled, target = _ref.target, align = _ref.align, onAlign = _ref.onAlign, monitorWindowResize = _ref.monitorWindowResize, _ref$monitorBufferTim = _ref.monitorBufferTime, monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
    var cacheRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef({});
    /** Popup node ref */ var nodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef();
    var childNode = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Children.only(children); // ===================== Align ======================
    // We save the props here to avoid closure makes props ood
    var forceAlignPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef({});
    forceAlignPropsRef.current.disabled = disabled;
    forceAlignPropsRef.current.target = target;
    forceAlignPropsRef.current.align = align;
    forceAlignPropsRef.current.onAlign = onAlign;
    var _useBuffer = (0, $c375eb3ad80875c0$export$2e2bcd8739ae039)(function() {
        var _forceAlignPropsRef$c = forceAlignPropsRef.current, latestDisabled = _forceAlignPropsRef$c.disabled, latestTarget = _forceAlignPropsRef$c.target, latestAlign = _forceAlignPropsRef$c.align, latestOnAlign = _forceAlignPropsRef$c.onAlign;
        var source = nodeRef.current;
        if (!latestDisabled && latestTarget && source) {
            var _result;
            var _element = $f363ffd589035457$var$getElement(latestTarget);
            var _point = $f363ffd589035457$var$getPoint(latestTarget);
            cacheRef.current.element = _element;
            cacheRef.current.point = _point;
            cacheRef.current.align = latestAlign; // IE lose focus after element realign
            // We should record activeElement and restore later
            var _document = document, activeElement = _document.activeElement; // We only align when element is visible
            if (_element && (0, $f77508a4d0920b35$export$2e2bcd8739ae039)(_element)) _result = (0, $62489153aa47ee3b$export$ec21431d5ee6c534)(source, _element, latestAlign);
            else if (_point) _result = (0, $62489153aa47ee3b$export$38f0e12f0aa28098)(source, _point, latestAlign);
            (0, $6d0d038d3f95f599$export$2284e449d64b22d5)(activeElement, source);
            if (latestOnAlign && _result) latestOnAlign(source, _result);
            return true;
        }
        return false;
    }, monitorBufferTime), _useBuffer2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useBuffer, 2), _forceAlign = _useBuffer2[0], cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
    // Handle props change
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(), _React$useState2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(), _React$useState4 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_React$useState3, 2), point = _React$useState4[0], setPoint = _React$useState4[1];
    (0, $0e99bcc1fc96d845$export$2e2bcd8739ae039)(function() {
        setElement($f363ffd589035457$var$getElement(target));
        setPoint($f363ffd589035457$var$getPoint(target));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(function() {
        if (cacheRef.current.element !== element || !(0, $6d0d038d3f95f599$export$792a4d7b8e9efb33)(cacheRef.current.point, point) || !(0, $6bd75fa00eae78ea$export$2e2bcd8739ae039)(cacheRef.current.align, align)) _forceAlign();
    }); // Watch popup element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(function() {
        var cancelFn = (0, $6d0d038d3f95f599$export$f56787db9e74dfe)(nodeRef.current, _forceAlign);
        return cancelFn;
    }, [
        nodeRef.current
    ]); // Watch target element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(function() {
        var cancelFn = (0, $6d0d038d3f95f599$export$f56787db9e74dfe)(element, _forceAlign);
        return cancelFn;
    }, [
        element
    ]); // Listen for disabled change
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(function() {
        if (!disabled) _forceAlign();
        else cancelForceAlign();
    }, [
        disabled
    ]); // Listen for window resize
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(function() {
        if (monitorWindowResize) {
            var cancelFn = (0, $22181e543287e129$export$2e2bcd8739ae039)(window, 'resize', _forceAlign);
            return cancelFn.remove;
        }
    }, [
        monitorWindowResize
    ]); // Clear all if unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(function() {
        return function() {
            cancelForceAlign();
        };
    }, []); // ====================== Ref =======================
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {
                return _forceAlign(true);
            }
        };
    }); // ===================== Render =====================
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).isValidElement(childNode)) childNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).cloneElement(childNode, {
        ref: (0, $b585f86dd8ac61f9$export$ab452c34e8e05029)(childNode.ref, nodeRef)
    });
    return childNode;
};
var $f363ffd589035457$var$RcAlign = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).forwardRef($f363ffd589035457$var$Align);
$f363ffd589035457$var$RcAlign.displayName = 'Align';
var $f363ffd589035457$export$2e2bcd8739ae039 = $f363ffd589035457$var$RcAlign;


var $9e1decf5b15d2aee$export$2e2bcd8739ae039 = (0, $f363ffd589035457$export$2e2bcd8739ae039);






function $782a5c805335f468$export$2e2bcd8739ae039() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ 
    $782a5c805335f468$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return r;
    };
    var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag";
    function c(t, r, e, n) {
        return Object.defineProperty(t, r, {
            value: e,
            enumerable: !n,
            configurable: !n,
            writable: !n
        });
    }
    try {
        c({}, "");
    } catch (t) {
        c = function c(t, r, e) {
            return t[r] = e;
        };
    }
    function h(r, e, n, o) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype);
        return c(a, "_invoke", function(r, e, n) {
            var o = 1;
            return function(i, a) {
                if (3 === o) throw Error("Generator is already running");
                if (4 === o) {
                    if ("throw" === i) throw a;
                    return {
                        value: t,
                        done: !0
                    };
                }
                for(n.method = i, n.arg = a;;){
                    var u = n.delegate;
                    if (u) {
                        var c = d(u, n);
                        if (c) {
                            if (c === f) continue;
                            return c;
                        }
                    }
                    if ("next" === n.method) n.sent = n._sent = n.arg;
                    else if ("throw" === n.method) {
                        if (1 === o) throw o = 4, n.arg;
                        n.dispatchException(n.arg);
                    } else "return" === n.method && n.abrupt("return", n.arg);
                    o = 3;
                    var h = s(r, e, n);
                    if ("normal" === h.type) {
                        if (o = n.done ? 4 : 2, h.arg === f) continue;
                        return {
                            value: h.arg,
                            done: n.done
                        };
                    }
                    "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg);
                }
            };
        }(r, n, new Context(o || [])), !0), a;
    }
    function s(t, r, e) {
        try {
            return {
                type: "normal",
                arg: t.call(r, e)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    r.wrap = h;
    var f = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var l = {};
    c(l, i, function() {
        return this;
    });
    var p = Object.getPrototypeOf, y = p && p(p(x([])));
    y && y !== e && n.call(y, i) && (l = y);
    var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l);
    function g(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(r) {
            c(t, r, function(t) {
                return this._invoke(r, t);
            });
        });
    }
    function AsyncIterator(t, r) {
        function e(o, i, a, u) {
            var c = s(t[o], t, i);
            if ("throw" !== c.type) {
                var h = c.arg, f = h.value;
                return f && "object" == (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function(t) {
                    e("next", t, a, u);
                }, function(t) {
                    e("throw", t, a, u);
                }) : r.resolve(f).then(function(t) {
                    h.value = t, a(h);
                }, function(t) {
                    return e("throw", t, a, u);
                });
            }
            u(c.arg);
        }
        var o;
        c(this, "_invoke", function(t, n) {
            function i() {
                return new r(function(r, o) {
                    e(t, n, r, o);
                });
            }
            return o = o ? o.then(i, i) : i();
        }, !0);
    }
    function d(r, e) {
        var n = e.method, o = r.i[n];
        if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f;
        var i = s(o, r.i, e.arg);
        if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f;
        var a = i.arg;
        return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
    }
    function w(t) {
        this.tryEntries.push(t);
    }
    function m(r) {
        var e = r[4] || {};
        e.type = "normal", e.arg = t, r[4] = e;
    }
    function Context(t) {
        this.tryEntries = [
            [
                -1
            ]
        ], t.forEach(w, this), this.reset(!0);
    }
    function x(r) {
        if (null != r) {
            var e = r[i];
            if (e) return e.call(r);
            if ("function" == typeof r.next) return r;
            if (!isNaN(r.length)) {
                var o = -1, a = function e() {
                    for(; ++o < r.length;)if (n.call(r, o)) return e.value = r[o], e.done = !1, e;
                    return e.value = t, e.done = !0, e;
                };
                return a.next = a;
            }
        }
        throw new TypeError((0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(r) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function(t) {
        var r = "function" == typeof t && t.constructor;
        return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name));
    }, r.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t;
    }, r.awrap = function(t) {
        return {
            __await: t
        };
    }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function() {
        return this;
    }), r.AsyncIterator = AsyncIterator, r.async = function(t, e, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(h(t, e, n, o), i);
        return r.isGeneratorFunction(e) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, g(v), c(v, u, "Generator"), c(v, i, function() {
        return this;
    }), c(v, "toString", function() {
        return "[object Generator]";
    }), r.keys = function(t) {
        var r = Object(t), e = [];
        for(var n in r)e.unshift(n);
        return function t() {
            for(; e.length;)if ((n = e.pop()) in r) return t.value = n, t.done = !1, t;
            return t.done = !0, t;
        };
    }, r.values = x, Context.prototype = {
        constructor: Context,
        reset: function reset(r) {
            if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for(var e in this)"t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0][4];
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(r) {
            if (this.done) throw r;
            var e = this;
            function n(t) {
                a.type = "throw", a.arg = r, e.next = t;
            }
            for(var o = e.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2];
                if (-1 === i[0]) return n("end"), !1;
                if (!c && !h) throw Error("try statement without catch or finally");
                if (null != i[0] && i[0] <= u) {
                    if (u < c) return this.method = "next", this.arg = t, n(c), !0;
                    if (u < h) return n(h), !1;
                }
            }
        },
        abrupt: function abrupt(t, r) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var n = this.tryEntries[e];
                if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) {
                    var o = n;
                    break;
                }
            }
            o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null);
            var i = o ? o[4] : {};
            return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i);
        },
        complete: function complete(t, r) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f;
        },
        finish: function finish(t) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var e = this.tryEntries[r];
                if (e[2] === t) return this.complete(e[4], e[3]), m(e), f;
            }
        },
        "catch": function _catch(t) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var e = this.tryEntries[r];
                if (e[0] === t) {
                    var n = e[4];
                    if ("throw" === n.type) {
                        var o = n.arg;
                        m(e);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(r, e, n) {
            return this.delegate = {
                i: x(r),
                r: e,
                n: n
            }, "next" === this.method && (this.arg = t), f;
        }
    }, r;
}


function $6719bd827e69c482$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $6719bd827e69c482$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $6719bd827e69c482$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $6719bd827e69c482$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}




var $8NFma = parcelRequire("8NFma");


/**
 * Popup should follow the steps for each component work correctly:
 * measure - check for the current stretch size
 * align - let component align the position
 * aligned - re-align again in case additional className changed the size
 * afterAlign - choice next step is trigger motion or finished
 * beforeMotion - should reset motion to invisible so that CSSMotion can do normal motion
 * motion - play the motion
 * stable - everything is done
 */ var $d5ea2e689d853ac0$var$StatusQueue = [
    'measure',
    'alignPre',
    'align',
    null,
    'motion'
];
var $d5ea2e689d853ac0$export$2e2bcd8739ae039 = function(visible, doMeasure) {
    var _useState = (0, $a0da78b8501d131f$export$2e2bcd8739ae039)(null), _useState2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useState, 2), status = _useState2[0], setInternalStatus = _useState2[1];
    var rafRef = (0, $8NFma.useRef)();
    function setStatus(nextStatus) {
        setInternalStatus(nextStatus, true);
    }
    function cancelRaf() {
        (0, $f5523740186e2cf7$export$2e2bcd8739ae039).cancel(rafRef.current);
    }
    function goNextStatus(callback) {
        cancelRaf();
        rafRef.current = (0, $f5523740186e2cf7$export$2e2bcd8739ae039)(function() {
            // Only align should be manually trigger
            setStatus(function(prev) {
                switch(status){
                    case 'align':
                        return 'motion';
                    case 'motion':
                        return 'stable';
                    default:
                }
                return prev;
            });
            callback === null || callback === void 0 || callback();
        });
    } // Init status
    (0, $8NFma.useEffect)(function() {
        setStatus('measure');
    }, [
        visible
    ]); // Go next status
    (0, $8NFma.useEffect)(function() {
        switch(status){
            case 'measure':
                doMeasure();
                break;
            default:
        }
        if (status) rafRef.current = (0, $f5523740186e2cf7$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $6719bd827e69c482$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $782a5c805335f468$export$2e2bcd8739ae039)().mark(function _callee() {
            var index, nextStatus;
            return (0, $782a5c805335f468$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        index = $d5ea2e689d853ac0$var$StatusQueue.indexOf(status);
                        nextStatus = $d5ea2e689d853ac0$var$StatusQueue[index + 1];
                        if (nextStatus && index !== -1) setStatus(nextStatus);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
    }, [
        status
    ]);
    (0, $8NFma.useEffect)(function() {
        return function() {
            cancelRaf();
        };
    }, []);
    return [
        status,
        goNextStatus
    ];
};





var $8NFma = parcelRequire("8NFma");
var $0b88e15d35a7c969$export$2e2bcd8739ae039 = function(stretch) {
    var _React$useState = $8NFma.useState({
        width: 0,
        height: 0
    }), _React$useState2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_React$useState, 2), targetSize = _React$useState2[0], setTargetSize = _React$useState2[1];
    function measureStretch(element) {
        var tgtWidth = element.offsetWidth, tgtHeight = element.offsetHeight;
        var _element$getBoundingC = element.getBoundingClientRect(), width = _element$getBoundingC.width, height = _element$getBoundingC.height; // Rect is more accurate than offset, use if near
        if (Math.abs(tgtWidth - width) < 1 && Math.abs(tgtHeight - height) < 1) {
            tgtWidth = width;
            tgtHeight = height;
        }
        setTargetSize({
            width: tgtWidth,
            height: tgtHeight
        });
    } // Merge stretch style
    var style = $8NFma.useMemo(function() {
        var sizeStyle = {};
        if (stretch) {
            var width = targetSize.width, height = targetSize.height; // Stretch with target
            if (stretch.indexOf('height') !== -1 && height) sizeStyle.height = height;
            else if (stretch.indexOf('minHeight') !== -1 && height) sizeStyle.minHeight = height;
            if (stretch.indexOf('width') !== -1 && width) sizeStyle.width = width;
            else if (stretch.indexOf('minWidth') !== -1 && width) sizeStyle.minWidth = width;
        }
        return sizeStyle;
    }, [
        stretch,
        targetSize
    ]);
    return [
        style,
        measureStretch
    ];
};


var $23b7e75a034b2283$var$PopupInner = /*#__PURE__*/ $8NFma.forwardRef(function(props, ref) {
    var visible = props.visible, prefixCls = props.prefixCls, className = props.className, style = props.style, children = props.children, zIndex = props.zIndex, stretch = props.stretch, destroyPopupOnHide = props.destroyPopupOnHide, forceRender = props.forceRender, align = props.align, point = props.point, getRootDomNode = props.getRootDomNode, getClassNameFromAlign = props.getClassNameFromAlign, onAlign = props.onAlign, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onMouseDown = props.onMouseDown, onTouchStart = props.onTouchStart, onClick = props.onClick;
    var alignRef = (0, $8NFma.useRef)();
    var elementRef = (0, $8NFma.useRef)();
    var _useState = (0, $8NFma.useState)(), _useState2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useState, 2), alignedClassName = _useState2[0], setAlignedClassName = _useState2[1]; // ======================= Measure ========================
    var _useStretchStyle = (0, $0b88e15d35a7c969$export$2e2bcd8739ae039)(stretch), _useStretchStyle2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useStretchStyle, 2), stretchStyle = _useStretchStyle2[0], measureStretchStyle = _useStretchStyle2[1];
    function doMeasure() {
        if (stretch) measureStretchStyle(getRootDomNode());
    } // ======================== Status ========================
    var _useVisibleStatus = (0, $d5ea2e689d853ac0$export$2e2bcd8739ae039)(visible, doMeasure), _useVisibleStatus2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useVisibleStatus, 2), status = _useVisibleStatus2[0], goNextStatus = _useVisibleStatus2[1]; // ======================== Aligns ========================
    /**
   * `alignedClassName` may modify `source` size,
   * which means one time align may not move to the correct position at once.
   *
   * We will reset `alignTimes` for each status switch to `alignPre`
   * and let `rc-align` to align for multiple times to ensure get final stable place.
   * Currently we mark `alignTimes < 2` repeat align, it will increase if user report for align issue.
   * 
   * Update:
   * In React 18. `rc-align` effect of align may faster than ref called trigger `forceAlign`.
   * We adjust this to `alignTimes < 2`.
   * We need refactor `rc-align` to support mark of `forceAlign` call if this still happen.
   */ var _useState3 = (0, $8NFma.useState)(0), _useState4 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useState3, 2), alignTimes = _useState4[0], setAlignTimes = _useState4[1];
    var prepareResolveRef = (0, $8NFma.useRef)();
    (0, $0e99bcc1fc96d845$export$2e2bcd8739ae039)(function() {
        if (status === 'alignPre') setAlignTimes(0);
    }, [
        status
    ]); // `target` on `rc-align` can accept as a function to get the bind element or a point.
    // ref: https://www.npmjs.com/package/rc-align
    function getAlignTarget() {
        if (point) return point;
        return getRootDomNode;
    }
    function forceAlign() {
        var _alignRef$current;
        (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 || _alignRef$current.forceAlign();
    }
    function onInternalAlign(popupDomNode, matchAlign) {
        var nextAlignedClassName = getClassNameFromAlign(matchAlign);
        if (alignedClassName !== nextAlignedClassName) setAlignedClassName(nextAlignedClassName);
         // We will retry multi times to make sure that the element has been align in the right position.
        setAlignTimes(function(val) {
            return val + 1;
        });
        if (status === 'align') onAlign === null || onAlign === void 0 || onAlign(popupDomNode, matchAlign);
    } // Delay to go to next status
    (0, $0e99bcc1fc96d845$export$2e2bcd8739ae039)(function() {
        if (status === 'align') {
            // Repeat until not more align needed
            if (alignTimes < 3) forceAlign();
            else goNextStatus(function() {
                var _prepareResolveRef$cu;
                (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 || _prepareResolveRef$cu.call(prepareResolveRef);
            });
        }
    }, [
        alignTimes
    ]); // ======================== Motion ========================
    var motion = (0, $41de237383779de8$export$2e2bcd8739ae039)({}, (0, $d090e14a8d7b7b4d$export$7b8936ddc277a29a)(props));
    [
        'onAppearEnd',
        'onEnterEnd',
        'onLeaveEnd'
    ].forEach(function(eventName) {
        var originHandler = motion[eventName];
        motion[eventName] = function(element, event) {
            goNextStatus();
            return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
        };
    });
    function onShowPrepare() {
        return new Promise(function(resolve) {
            prepareResolveRef.current = resolve;
        });
    } // Go to stable directly when motion not provided
    $8NFma.useEffect(function() {
        if (!motion.motionName && status === 'motion') goNextStatus();
    }, [
        motion.motionName,
        status
    ]); // ========================= Refs =========================
    $8NFma.useImperativeHandle(ref, function() {
        return {
            forceAlign: forceAlign,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, stretchStyle), {}, {
        zIndex: zIndex,
        opacity: status === 'motion' || status === 'stable' || !visible ? undefined : 0,
        // Cannot interact with disappearing elements
        // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
        pointerEvents: !visible && status !== 'stable' ? 'none' : undefined
    }, style); // Align status
    var alignDisabled = true;
    if (align !== null && align !== void 0 && align.points && (status === 'align' || status === 'stable')) alignDisabled = false;
    var childNode = children; // Wrapper when multiple children
    if ($8NFma.Children.count(children) > 1) childNode = /*#__PURE__*/ $8NFma.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
    return /*#__PURE__*/ $8NFma.createElement((0, $420974de752ed086$export$2e2bcd8739ae039), (0, $jz4iA.default)({
        visible: visible,
        ref: elementRef,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }, motion, {
        onAppearPrepare: onShowPrepare,
        onEnterPrepare: onShowPrepare,
        removeOnLeave: destroyPopupOnHide,
        forceRender: forceRender
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))(prefixCls, className, alignedClassName, motionClassName);
        return /*#__PURE__*/ $8NFma.createElement((0, $9e1decf5b15d2aee$export$2e2bcd8739ae039), {
            target: getAlignTarget(),
            key: "popup",
            ref: alignRef,
            monitorWindowResize: true,
            disabled: alignDisabled,
            align: align,
            onAlign: onInternalAlign
        }, /*#__PURE__*/ $8NFma.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseDownCapture: onMouseDown,
            onTouchStartCapture: onTouchStart,
            onClick: onClick,
            style: (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, motionStyle), mergedStyle)
        }, childNode));
    });
});
$23b7e75a034b2283$var$PopupInner.displayName = 'PopupInner';
var $23b7e75a034b2283$export$2e2bcd8739ae039 = $23b7e75a034b2283$var$PopupInner;



var $jz4iA = parcelRequire("jz4iA");


var $8NFma = parcelRequire("8NFma");


var $72d94763de743a5d$var$MobilePopupInner = /*#__PURE__*/ $8NFma.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, children = props.children, _props$mobile = props.mobile;
    _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
    var popupClassName = _props$mobile.popupClassName, popupStyle = _props$mobile.popupStyle, _props$mobile$popupMo = _props$mobile.popupMotion, popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo, popupRender = _props$mobile.popupRender, onClick = props.onClick;
    var elementRef = $8NFma.useRef(); // ========================= Refs =========================
    $8NFma.useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {},
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $41de237383779de8$export$2e2bcd8739ae039)({
        zIndex: zIndex
    }, popupStyle);
    var childNode = children; // Wrapper when multiple children
    if ($8NFma.Children.count(children) > 1) childNode = /*#__PURE__*/ $8NFma.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
     // Mobile support additional render
    if (popupRender) childNode = popupRender(childNode);
    return /*#__PURE__*/ $8NFma.createElement((0, $420974de752ed086$export$2e2bcd8739ae039), (0, $jz4iA.default)({
        visible: visible,
        ref: elementRef,
        removeOnLeave: true
    }, popupMotion), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))(prefixCls, popupClassName, motionClassName);
        return /*#__PURE__*/ $8NFma.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onClick: onClick,
            style: (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, motionStyle), mergedStyle)
        }, childNode);
    });
});
$72d94763de743a5d$var$MobilePopupInner.displayName = 'MobilePopupInner';
var $72d94763de743a5d$export$2e2bcd8739ae039 = $72d94763de743a5d$var$MobilePopupInner;


var $e60735d87b813ad2$var$_excluded = [
    "visible",
    "mobile"
];
var $e60735d87b813ad2$var$Popup = /*#__PURE__*/ $8NFma.forwardRef(function(_ref, ref) {
    var visible = _ref.visible, mobile = _ref.mobile, props = (0, $cfae3d675552f8ab$export$2e2bcd8739ae039)(_ref, $e60735d87b813ad2$var$_excluded);
    var _useState = (0, $8NFma.useState)(visible), _useState2 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useState, 2), innerVisible = _useState2[0], serInnerVisible = _useState2[1];
    var _useState3 = (0, $8NFma.useState)(false), _useState4 = (0, $3bbae3add6a4bdae$export$2e2bcd8739ae039)(_useState3, 2), inMobile = _useState4[0], setInMobile = _useState4[1];
    var cloneProps = (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, props), {}, {
        visible: innerVisible
    }); // We check mobile in visible changed here.
    // And this also delay set `innerVisible` to avoid popup component render flash
    (0, $8NFma.useEffect)(function() {
        serInnerVisible(visible);
        if (visible && mobile) setInMobile((0, $ad2f0028db36cb3f$export$2e2bcd8739ae039)());
    }, [
        visible,
        mobile
    ]);
    var popupNode = inMobile ? /*#__PURE__*/ $8NFma.createElement((0, $72d94763de743a5d$export$2e2bcd8739ae039), (0, $jz4iA.default)({}, cloneProps, {
        mobile: mobile,
        ref: ref
    })) : /*#__PURE__*/ $8NFma.createElement((0, $23b7e75a034b2283$export$2e2bcd8739ae039), (0, $jz4iA.default)({}, cloneProps, {
        ref: ref
    })); // We can use fragment directly but this may failed some selector usage. Keep as origin logic
    return /*#__PURE__*/ $8NFma.createElement("div", null, /*#__PURE__*/ $8NFma.createElement((0, $a2d3b44c5566710b$export$2e2bcd8739ae039), cloneProps), popupNode);
});
$e60735d87b813ad2$var$Popup.displayName = 'Popup';
var $e60735d87b813ad2$export$2e2bcd8739ae039 = $e60735d87b813ad2$var$Popup;



var $8NFma = parcelRequire("8NFma");
var $e90c08fa9bd2745e$var$TriggerContext = /*#__PURE__*/ $8NFma.createContext(null);
var $e90c08fa9bd2745e$export$2e2bcd8739ae039 = $e90c08fa9bd2745e$var$TriggerContext;


function $02f89f0811118fef$var$noop() {}
function $02f89f0811118fef$var$returnEmptyString() {
    return '';
}
function $02f89f0811118fef$var$returnDocument(element) {
    if (element) return element.ownerDocument;
    return window.document;
}
var $02f89f0811118fef$var$ALL_HANDLERS = [
    'onClick',
    'onMouseDown',
    'onTouchStart',
    'onMouseEnter',
    'onMouseLeave',
    'onFocus',
    'onBlur',
    'onContextMenu'
];
function $02f89f0811118fef$export$55e99723d7f71b47(PortalComponent) {
    var Trigger = /*#__PURE__*/ function(_React$Component) {
        (0, $165305ab584beb18$export$2e2bcd8739ae039)(Trigger, _React$Component);
        var _super = (0, $5d0d7e04eb688530$export$2e2bcd8739ae039)(Trigger);
        // ensure `getContainer` will be called only once
        function Trigger(props) {
            var _this;
            (0, $a0703d0085fc4fb2$export$2e2bcd8739ae039)(this, Trigger);
            _this = _super.call(this, props);
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "popupRef", /*#__PURE__*/ $8NFma.createRef());
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "triggerRef", /*#__PURE__*/ $8NFma.createRef());
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "portalContainer", void 0);
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "attachId", void 0);
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "clickOutsideHandler", void 0);
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "touchOutsideHandler", void 0);
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "contextMenuOutsideHandler1", void 0);
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "contextMenuOutsideHandler2", void 0);
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "mouseDownTimeout", void 0);
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "focusTime", void 0);
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "preClickTime", void 0);
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "preTouchTime", void 0);
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "delayTimer", void 0);
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "hasPopupMouseDown", void 0);
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "onMouseEnter", function(e) {
                var mouseEnterDelay = _this.props.mouseEnterDelay;
                _this.fireEvents('onMouseEnter', e);
                _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "onMouseMove", function(e) {
                _this.fireEvents('onMouseMove', e);
                _this.setPoint(e);
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "onMouseLeave", function(e) {
                _this.fireEvents('onMouseLeave', e);
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "onPopupMouseEnter", function() {
                _this.clearDelayTimer();
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "onPopupMouseLeave", function(e) {
                var _this$popupRef$curren;
                // https://github.com/react-component/trigger/pull/13
                // react bug?
                if (e.relatedTarget && !e.relatedTarget.setTimeout && (0, $9102837f0ed2a1da$export$2e2bcd8739ae039)((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e.relatedTarget)) return;
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "onFocus", function(e) {
                _this.fireEvents('onFocus', e); // incase focusin and focusout
                _this.clearDelayTimer();
                if (_this.isFocusToShow()) {
                    _this.focusTime = Date.now();
                    _this.delaySetPopupVisible(true, _this.props.focusDelay);
                }
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "onMouseDown", function(e) {
                _this.fireEvents('onMouseDown', e);
                _this.preClickTime = Date.now();
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "onTouchStart", function(e) {
                _this.fireEvents('onTouchStart', e);
                _this.preTouchTime = Date.now();
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "onBlur", function(e) {
                _this.fireEvents('onBlur', e);
                _this.clearDelayTimer();
                if (_this.isBlurToHide()) _this.delaySetPopupVisible(false, _this.props.blurDelay);
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "onContextMenu", function(e) {
                e.preventDefault();
                _this.fireEvents('onContextMenu', e);
                _this.setPopupVisible(true, e);
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "onContextMenuClose", function() {
                if (_this.isContextMenuToShow()) _this.close();
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "onClick", function(event) {
                _this.fireEvents('onClick', event); // focus will trigger click
                if (_this.focusTime) {
                    var preTime;
                    if (_this.preClickTime && _this.preTouchTime) preTime = Math.min(_this.preClickTime, _this.preTouchTime);
                    else if (_this.preClickTime) preTime = _this.preClickTime;
                    else if (_this.preTouchTime) preTime = _this.preTouchTime;
                    if (Math.abs(preTime - _this.focusTime) < 20) return;
                    _this.focusTime = 0;
                }
                _this.preClickTime = 0;
                _this.preTouchTime = 0; // Only prevent default when all the action is click.
                // https://github.com/ant-design/ant-design/issues/17043
                // https://github.com/ant-design/ant-design/issues/17291
                if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) event.preventDefault();
                var nextVisible = !_this.state.popupVisible;
                if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) _this.setPopupVisible(!_this.state.popupVisible, event);
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "onPopupMouseDown", function() {
                _this.hasPopupMouseDown = true;
                clearTimeout(_this.mouseDownTimeout);
                _this.mouseDownTimeout = window.setTimeout(function() {
                    _this.hasPopupMouseDown = false;
                }, 0);
                if (_this.context) {
                    var _this$context;
                    (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
                }
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "onDocumentClick", function(event) {
                if (_this.props.mask && !_this.props.maskClosable) return;
                var target = event.target;
                var root = _this.getRootDomNode();
                var popupNode = _this.getPopupDomNode();
                if (// https://github.com/ant-design/ant-design/issues/29853
                (!(0, $9102837f0ed2a1da$export$2e2bcd8739ae039)(root, target) || _this.isContextMenuOnly()) && !(0, $9102837f0ed2a1da$export$2e2bcd8739ae039)(popupNode, target) && !_this.hasPopupMouseDown) _this.close();
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "getRootDomNode", function() {
                var getTriggerDOMNode = _this.props.getTriggerDOMNode;
                if (getTriggerDOMNode) return getTriggerDOMNode(_this.triggerRef.current);
                try {
                    var domNode = (0, $d3ab5e8f9b81c2d1$export$2e2bcd8739ae039)(_this.triggerRef.current);
                    if (domNode) return domNode;
                } catch (err) {}
                return (0, (/*@__PURE__*/$parcel$interopDefault($2pmb0))).findDOMNode((0, $1oVxX.default)(_this));
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "getPopupClassNameFromAlign", function(align) {
                var className = [];
                var _this$props = _this.props, popupPlacement = _this$props.popupPlacement, builtinPlacements = _this$props.builtinPlacements, prefixCls = _this$props.prefixCls, alignPoint = _this$props.alignPoint, getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;
                if (popupPlacement && builtinPlacements) className.push((0, $4ef46dc7008e6493$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, align, alignPoint));
                if (getPopupClassNameFromAlign) className.push(getPopupClassNameFromAlign(align));
                return className.join(' ');
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "getComponent", function() {
                var _this$props2 = _this.props, prefixCls = _this$props2.prefixCls, destroyPopupOnHide = _this$props2.destroyPopupOnHide, popupClassName = _this$props2.popupClassName, onPopupAlign = _this$props2.onPopupAlign, popupMotion = _this$props2.popupMotion, popupAnimation = _this$props2.popupAnimation, popupTransitionName = _this$props2.popupTransitionName, popupStyle = _this$props2.popupStyle, mask = _this$props2.mask, maskAnimation = _this$props2.maskAnimation, maskTransitionName = _this$props2.maskTransitionName, maskMotion = _this$props2.maskMotion, zIndex = _this$props2.zIndex, popup = _this$props2.popup, stretch = _this$props2.stretch, alignPoint = _this$props2.alignPoint, mobile = _this$props2.mobile, forceRender = _this$props2.forceRender, onPopupClick = _this$props2.onPopupClick;
                var _this$state = _this.state, popupVisible = _this$state.popupVisible, point = _this$state.point;
                var align = _this.getPopupAlign();
                var mouseProps = {};
                if (_this.isMouseEnterToShow()) mouseProps.onMouseEnter = _this.onPopupMouseEnter;
                if (_this.isMouseLeaveToHide()) mouseProps.onMouseLeave = _this.onPopupMouseLeave;
                mouseProps.onMouseDown = _this.onPopupMouseDown;
                mouseProps.onTouchStart = _this.onPopupMouseDown;
                return /*#__PURE__*/ $8NFma.createElement((0, $e60735d87b813ad2$export$2e2bcd8739ae039), (0, $jz4iA.default)({
                    prefixCls: prefixCls,
                    destroyPopupOnHide: destroyPopupOnHide,
                    visible: popupVisible,
                    point: alignPoint && point,
                    className: popupClassName,
                    align: align,
                    onAlign: onPopupAlign,
                    animation: popupAnimation,
                    getClassNameFromAlign: _this.getPopupClassNameFromAlign
                }, mouseProps, {
                    stretch: stretch,
                    getRootDomNode: _this.getRootDomNode,
                    style: popupStyle,
                    mask: mask,
                    zIndex: zIndex,
                    transitionName: popupTransitionName,
                    maskAnimation: maskAnimation,
                    maskTransitionName: maskTransitionName,
                    maskMotion: maskMotion,
                    ref: _this.popupRef,
                    motion: popupMotion,
                    mobile: mobile,
                    forceRender: forceRender,
                    onClick: onPopupClick
                }), typeof popup === 'function' ? popup() : popup);
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "attachParent", function(popupContainer) {
                (0, $f5523740186e2cf7$export$2e2bcd8739ae039).cancel(_this.attachId);
                var _this$props3 = _this.props, getPopupContainer = _this$props3.getPopupContainer, getDocument = _this$props3.getDocument;
                var domNode = _this.getRootDomNode();
                var mountNode;
                if (!getPopupContainer) mountNode = getDocument(_this.getRootDomNode()).body;
                else if (domNode || getPopupContainer.length === 0) // Compatible for legacy getPopupContainer with domNode argument.
                // If no need `domNode` argument, will call directly.
                // https://codesandbox.io/s/eloquent-mclean-ss93m?file=/src/App.js
                mountNode = getPopupContainer(domNode);
                if (mountNode) mountNode.appendChild(popupContainer);
                else // Retry after frame render in case parent not ready
                _this.attachId = (0, $f5523740186e2cf7$export$2e2bcd8739ae039)(function() {
                    _this.attachParent(popupContainer);
                });
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "getContainer", function() {
                if (!_this.portalContainer) {
                    // In React.StrictMode component will call render multiple time in first mount.
                    // When you want to refactor with FC, useRef will also init multiple time and
                    // point to different useRef instance which will create multiple element
                    // (This multiple render will not trigger effect so you can not clean up this
                    // in effect). But this is safe with class component since it always point to same class instance.
                    var getDocument = _this.props.getDocument;
                    var popupContainer = getDocument(_this.getRootDomNode()).createElement('div'); // Make sure default popup container will never cause scrollbar appearing
                    // https://github.com/react-component/trigger/issues/41
                    popupContainer.style.position = 'absolute';
                    popupContainer.style.top = '0';
                    popupContainer.style.left = '0';
                    popupContainer.style.width = '100%';
                    _this.portalContainer = popupContainer;
                }
                _this.attachParent(_this.portalContainer);
                return _this.portalContainer;
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "setPoint", function(point) {
                var alignPoint = _this.props.alignPoint;
                if (!alignPoint || !point) return;
                _this.setState({
                    point: {
                        pageX: point.pageX,
                        pageY: point.pageY
                    }
                });
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "handlePortalUpdate", function() {
                if (_this.state.prevPopupVisible !== _this.state.popupVisible) _this.props.afterPopupVisibleChange(_this.state.popupVisible);
            });
            (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)((0, $1oVxX.default)(_this), "triggerContextValue", {
                onPopupMouseDown: _this.onPopupMouseDown
            });
            var _popupVisible;
            if ('popupVisible' in props) _popupVisible = !!props.popupVisible;
            else _popupVisible = !!props.defaultPopupVisible;
            _this.state = {
                prevPopupVisible: _popupVisible,
                popupVisible: _popupVisible
            };
            $02f89f0811118fef$var$ALL_HANDLERS.forEach(function(h) {
                _this["fire".concat(h)] = function(e) {
                    _this.fireEvents(h, e);
                };
            });
            return _this;
        }
        (0, $fe9a5bf59b39de5a$export$2e2bcd8739ae039)(Trigger, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.componentDidUpdate();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    var props = this.props;
                    var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
                    // https://github.com/ant-design/ant-design/issues/5804
                    // https://github.com/react-component/calendar/issues/250
                    // https://github.com/react-component/trigger/issues/50
                    if (state.popupVisible) {
                        var currentDocument;
                        if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
                            currentDocument = props.getDocument(this.getRootDomNode());
                            this.clickOutsideHandler = (0, $22181e543287e129$export$2e2bcd8739ae039)(currentDocument, 'mousedown', this.onDocumentClick);
                        } // always hide on mobile
                        if (!this.touchOutsideHandler) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.touchOutsideHandler = (0, $22181e543287e129$export$2e2bcd8739ae039)(currentDocument, 'touchstart', this.onDocumentClick);
                        } // close popup when trigger type contains 'onContextMenu' and document is scrolling.
                        if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.contextMenuOutsideHandler1 = (0, $22181e543287e129$export$2e2bcd8739ae039)(currentDocument, 'scroll', this.onContextMenuClose);
                        } // close popup when trigger type contains 'onContextMenu' and window is blur.
                        if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) this.contextMenuOutsideHandler2 = (0, $22181e543287e129$export$2e2bcd8739ae039)(window, 'blur', this.onContextMenuClose);
                        return;
                    }
                    this.clearOutsideHandler();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDelayTimer();
                    this.clearOutsideHandler();
                    clearTimeout(this.mouseDownTimeout);
                    (0, $f5523740186e2cf7$export$2e2bcd8739ae039).cancel(this.attachId);
                }
            },
            {
                key: "getPopupDomNode",
                value: function getPopupDomNode() {
                    var _this$popupRef$curren2;
                    // for test
                    return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
                }
            },
            {
                key: "getPopupAlign",
                value: function getPopupAlign() {
                    var props = this.props;
                    var popupPlacement = props.popupPlacement, popupAlign = props.popupAlign, builtinPlacements = props.builtinPlacements;
                    if (popupPlacement && builtinPlacements) return (0, $4ef46dc7008e6493$export$44605b74f7c5d944)(builtinPlacements, popupPlacement, popupAlign);
                    return popupAlign;
                }
            },
            {
                key: "setPopupVisible",
                value: /**
       * @param popupVisible    Show or not the popup element
       * @param event           SyntheticEvent, used for `pointAlign`
       */ function setPopupVisible(popupVisible, event) {
                    var alignPoint = this.props.alignPoint;
                    var prevPopupVisible = this.state.popupVisible;
                    this.clearDelayTimer();
                    if (prevPopupVisible !== popupVisible) {
                        if (!('popupVisible' in this.props)) this.setState({
                            popupVisible: popupVisible,
                            prevPopupVisible: prevPopupVisible
                        });
                        this.props.onPopupVisibleChange(popupVisible);
                    } // Always record the point position since mouseEnterDelay will delay the show
                    if (alignPoint && event && popupVisible) this.setPoint(event);
                }
            },
            {
                key: "delaySetPopupVisible",
                value: function delaySetPopupVisible(visible, delayS, event) {
                    var _this2 = this;
                    var delay = delayS * 1000;
                    this.clearDelayTimer();
                    if (delay) {
                        var point = event ? {
                            pageX: event.pageX,
                            pageY: event.pageY
                        } : null;
                        this.delayTimer = window.setTimeout(function() {
                            _this2.setPopupVisible(visible, point);
                            _this2.clearDelayTimer();
                        }, delay);
                    } else this.setPopupVisible(visible, event);
                }
            },
            {
                key: "clearDelayTimer",
                value: function clearDelayTimer() {
                    if (this.delayTimer) {
                        clearTimeout(this.delayTimer);
                        this.delayTimer = null;
                    }
                }
            },
            {
                key: "clearOutsideHandler",
                value: function clearOutsideHandler() {
                    if (this.clickOutsideHandler) {
                        this.clickOutsideHandler.remove();
                        this.clickOutsideHandler = null;
                    }
                    if (this.contextMenuOutsideHandler1) {
                        this.contextMenuOutsideHandler1.remove();
                        this.contextMenuOutsideHandler1 = null;
                    }
                    if (this.contextMenuOutsideHandler2) {
                        this.contextMenuOutsideHandler2.remove();
                        this.contextMenuOutsideHandler2 = null;
                    }
                    if (this.touchOutsideHandler) {
                        this.touchOutsideHandler.remove();
                        this.touchOutsideHandler = null;
                    }
                }
            },
            {
                key: "createTwoChains",
                value: function createTwoChains(event) {
                    var childPros = this.props.children.props;
                    var props = this.props;
                    if (childPros[event] && props[event]) return this["fire".concat(event)];
                    return childPros[event] || props[event];
                }
            },
            {
                key: "isClickToShow",
                value: function isClickToShow() {
                    var _this$props4 = this.props, action = _this$props4.action, showAction = _this$props4.showAction;
                    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
                }
            },
            {
                key: "isContextMenuOnly",
                value: function isContextMenuOnly() {
                    var action = this.props.action;
                    return action === 'contextMenu' || action.length === 1 && action[0] === 'contextMenu';
                }
            },
            {
                key: "isContextMenuToShow",
                value: function isContextMenuToShow() {
                    var _this$props5 = this.props, action = _this$props5.action, showAction = _this$props5.showAction;
                    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
                }
            },
            {
                key: "isClickToHide",
                value: function isClickToHide() {
                    var _this$props6 = this.props, action = _this$props6.action, hideAction = _this$props6.hideAction;
                    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
                }
            },
            {
                key: "isMouseEnterToShow",
                value: function isMouseEnterToShow() {
                    var _this$props7 = this.props, action = _this$props7.action, showAction = _this$props7.showAction;
                    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
                }
            },
            {
                key: "isMouseLeaveToHide",
                value: function isMouseLeaveToHide() {
                    var _this$props8 = this.props, action = _this$props8.action, hideAction = _this$props8.hideAction;
                    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
                }
            },
            {
                key: "isFocusToShow",
                value: function isFocusToShow() {
                    var _this$props9 = this.props, action = _this$props9.action, showAction = _this$props9.showAction;
                    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
                }
            },
            {
                key: "isBlurToHide",
                value: function isBlurToHide() {
                    var _this$props10 = this.props, action = _this$props10.action, hideAction = _this$props10.hideAction;
                    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
                }
            },
            {
                key: "forcePopupAlign",
                value: function forcePopupAlign() {
                    if (this.state.popupVisible) {
                        var _this$popupRef$curren3;
                        (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 || _this$popupRef$curren3.forceAlign();
                    }
                }
            },
            {
                key: "fireEvents",
                value: function fireEvents(type, e) {
                    var childCallback = this.props.children.props[type];
                    if (childCallback) childCallback(e);
                    var callback = this.props[type];
                    if (callback) callback(e);
                }
            },
            {
                key: "close",
                value: function close() {
                    this.setPopupVisible(false);
                }
            },
            {
                key: "render",
                value: function render() {
                    var popupVisible = this.state.popupVisible;
                    var _this$props11 = this.props, children = _this$props11.children, forceRender = _this$props11.forceRender, alignPoint = _this$props11.alignPoint, className = _this$props11.className, autoDestroy = _this$props11.autoDestroy;
                    var child = $8NFma.Children.only(children);
                    var newChildProps = {
                        key: 'trigger'
                    }; // ============================== Visible Handlers ==============================
                    // >>> ContextMenu
                    if (this.isContextMenuToShow()) newChildProps.onContextMenu = this.onContextMenu;
                    else newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
                     // >>> Click
                    if (this.isClickToHide() || this.isClickToShow()) {
                        newChildProps.onClick = this.onClick;
                        newChildProps.onMouseDown = this.onMouseDown;
                        newChildProps.onTouchStart = this.onTouchStart;
                    } else {
                        newChildProps.onClick = this.createTwoChains('onClick');
                        newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
                        newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
                    } // >>> Hover(enter)
                    if (this.isMouseEnterToShow()) {
                        newChildProps.onMouseEnter = this.onMouseEnter; // Point align
                        if (alignPoint) newChildProps.onMouseMove = this.onMouseMove;
                    } else newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
                     // >>> Hover(leave)
                    if (this.isMouseLeaveToHide()) newChildProps.onMouseLeave = this.onMouseLeave;
                    else newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
                     // >>> Focus
                    if (this.isFocusToShow() || this.isBlurToHide()) {
                        newChildProps.onFocus = this.onFocus;
                        newChildProps.onBlur = this.onBlur;
                    } else {
                        newChildProps.onFocus = this.createTwoChains('onFocus');
                        newChildProps.onBlur = this.createTwoChains('onBlur');
                    } // =================================== Render ===================================
                    var childrenClassName = (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))(child && child.props && child.props.className, className);
                    if (childrenClassName) newChildProps.className = childrenClassName;
                    var cloneProps = (0, $41de237383779de8$export$2e2bcd8739ae039)({}, newChildProps);
                    if ((0, $b585f86dd8ac61f9$export$c1cec34af06bcf7)(child)) cloneProps.ref = (0, $b585f86dd8ac61f9$export$ab452c34e8e05029)(this.triggerRef, child.ref);
                    var trigger = /*#__PURE__*/ $8NFma.cloneElement(child, cloneProps);
                    var portal; // prevent unmounting after it's rendered
                    if (popupVisible || this.popupRef.current || forceRender) portal = /*#__PURE__*/ $8NFma.createElement(PortalComponent, {
                        key: "portal",
                        getContainer: this.getContainer,
                        didUpdate: this.handlePortalUpdate
                    }, this.getComponent());
                    if (!popupVisible && autoDestroy) portal = null;
                    return /*#__PURE__*/ $8NFma.createElement((0, $e90c08fa9bd2745e$export$2e2bcd8739ae039).Provider, {
                        value: this.triggerContextValue
                    }, trigger, portal);
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref, prevState) {
                    var popupVisible = _ref.popupVisible;
                    var newState = {};
                    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
                        newState.popupVisible = popupVisible;
                        newState.prevPopupVisible = prevState.popupVisible;
                    }
                    return newState;
                }
            }
        ]);
        return Trigger;
    }($8NFma.Component);
    (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(Trigger, "contextType", (0, $e90c08fa9bd2745e$export$2e2bcd8739ae039));
    (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)(Trigger, "defaultProps", {
        prefixCls: 'rc-trigger-popup',
        getPopupClassNameFromAlign: $02f89f0811118fef$var$returnEmptyString,
        getDocument: $02f89f0811118fef$var$returnDocument,
        onPopupVisibleChange: $02f89f0811118fef$var$noop,
        afterPopupVisibleChange: $02f89f0811118fef$var$noop,
        onPopupAlign: $02f89f0811118fef$var$noop,
        popupClassName: '',
        mouseEnterDelay: 0,
        mouseLeaveDelay: 0.1,
        focusDelay: 0,
        blurDelay: 0.15,
        popupStyle: {},
        destroyPopupOnHide: false,
        popupAlign: {},
        defaultPopupVisible: false,
        mask: false,
        maskClosable: true,
        action: [],
        showAction: [],
        hideAction: [],
        autoDestroy: false
    });
    return Trigger;
}
var $02f89f0811118fef$export$2e2bcd8739ae039 = $02f89f0811118fef$export$55e99723d7f71b47((0, $249a58021379aa7c$export$2e2bcd8739ae039));


var $9db286effa3443d6$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $9db286effa3443d6$var$targetOffset = [
    0,
    0
];
var $9db286effa3443d6$export$803cd8101b6c182b = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        overflow: $9db286effa3443d6$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $9db286effa3443d6$var$targetOffset
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        overflow: $9db286effa3443d6$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $9db286effa3443d6$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $9db286effa3443d6$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $9db286effa3443d6$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $9db286effa3443d6$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $9db286effa3443d6$var$targetOffset
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $9db286effa3443d6$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $9db286effa3443d6$var$targetOffset
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $9db286effa3443d6$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $9db286effa3443d6$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $9db286effa3443d6$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $9db286effa3443d6$var$targetOffset
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $9db286effa3443d6$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $9db286effa3443d6$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $9db286effa3443d6$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $9db286effa3443d6$var$targetOffset
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $9db286effa3443d6$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $9db286effa3443d6$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $9db286effa3443d6$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $9db286effa3443d6$var$targetOffset
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $9db286effa3443d6$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $9db286effa3443d6$var$targetOffset
    }
};
var $9db286effa3443d6$export$2e2bcd8739ae039 = $9db286effa3443d6$export$803cd8101b6c182b;



var $8NFma = parcelRequire("8NFma");

function $451b661fd3f6837f$export$2e2bcd8739ae039(props) {
    var showArrow = props.showArrow, arrowContent = props.arrowContent, children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style = props.style;
    return /*#__PURE__*/ $8NFma.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))("".concat(prefixCls, "-content"), className),
        style: style
    }, showArrow !== false && /*#__PURE__*/ $8NFma.createElement("div", {
        className: "".concat(prefixCls, "-arrow"),
        key: "arrow"
    }, arrowContent), /*#__PURE__*/ $8NFma.createElement("div", {
        className: "".concat(prefixCls, "-inner"),
        id: id,
        role: "tooltip",
        style: overlayInnerStyle
    }, typeof children === 'function' ? children() : children));
}


var $7f8e5f42f50a13c6$var$_excluded = [
    "overlayClassName",
    "trigger",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "overlayStyle",
    "prefixCls",
    "children",
    "onVisibleChange",
    "afterVisibleChange",
    "transitionName",
    "animation",
    "motion",
    "placement",
    "align",
    "destroyTooltipOnHide",
    "defaultVisible",
    "getTooltipContainer",
    "overlayInnerStyle",
    "arrowContent",
    "overlay",
    "id",
    "showArrow"
];
var $7f8e5f42f50a13c6$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        'hover'
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? 'right' : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, restProps = (0, $cfae3d675552f8ab$export$2e2bcd8739ae039)(props, $7f8e5f42f50a13c6$var$_excluded);
    var domRef = (0, $8NFma.useRef)(null);
    (0, $8NFma.useImperativeHandle)(ref, function() {
        return domRef.current;
    });
    var extraProps = (0, $41de237383779de8$export$2e2bcd8739ae039)({}, restProps);
    if ('visible' in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $8NFma.createElement((0, $451b661fd3f6837f$export$2e2bcd8739ae039), {
            showArrow: showArrow,
            arrowContent: arrowContent,
            key: "content",
            prefixCls: prefixCls,
            id: id,
            overlayInnerStyle: overlayInnerStyle
        }, overlay);
    };
    var destroyTooltip = false;
    var autoDestroy = false;
    if (typeof destroyTooltipOnHide === 'boolean') destroyTooltip = destroyTooltipOnHide;
    else if (destroyTooltipOnHide && (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(destroyTooltipOnHide) === 'object') {
        var keepParent = destroyTooltipOnHide.keepParent;
        destroyTooltip = keepParent === true;
        autoDestroy = keepParent === false;
    }
    return /*#__PURE__*/ $8NFma.createElement((0, $02f89f0811118fef$export$2e2bcd8739ae039), (0, $jz4iA.default)({
        popupClassName: overlayClassName,
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $9db286effa3443d6$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: domRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltip,
        autoDestroy: autoDestroy,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
    }, extraProps), children);
};
var $7f8e5f42f50a13c6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $8NFma.forwardRef)($7f8e5f42f50a13c6$var$Tooltip);



var $9c43fb30dc49e5c6$export$2e2bcd8739ae039 = (0, $7f8e5f42f50a13c6$export$2e2bcd8739ae039);




var $a1be002fd90a0ac9$var$SliderTooltip = /*#__PURE__*/ $8NFma.forwardRef(function(props, ref) {
    var visible = props.visible, overlay = props.overlay;
    var innerRef = $8NFma.useRef(null);
    var tooltipRef = (0, $b585f86dd8ac61f9$export$ab452c34e8e05029)(ref, innerRef);
    var rafRef = $8NFma.useRef(null);
    function cancelKeepAlign() {
        (0, $f5523740186e2cf7$export$2e2bcd8739ae039).cancel(rafRef.current);
    }
    function keepAlign() {
        rafRef.current = (0, $f5523740186e2cf7$export$2e2bcd8739ae039)(function() {
            var _innerRef$current;
            (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 || _innerRef$current.forcePopupAlign();
        });
    }
    $8NFma.useEffect(function() {
        if (visible) keepAlign();
        else cancelKeepAlign();
        return cancelKeepAlign;
    }, [
        visible,
        overlay
    ]);
    return /*#__PURE__*/ $8NFma.createElement((0, $9c43fb30dc49e5c6$export$2e2bcd8739ae039), (0, $jz4iA.default)({
        ref: tooltipRef
    }, props));
});
var $a1be002fd90a0ac9$export$2e2bcd8739ae039 = $a1be002fd90a0ac9$var$SliderTooltip;



function $b7a3ef8bae925e7f$export$2e2bcd8739ae039(Component) {
    var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return _a = /*#__PURE__*/ function(_React$Component) {
        (0, $165305ab584beb18$export$2e2bcd8739ae039)(ComponentWrapper, _React$Component);
        var _super = (0, $5d0d7e04eb688530$export$2e2bcd8739ae039)(ComponentWrapper);
        function ComponentWrapper() {
            var _this;
            (0, $a0703d0085fc4fb2$export$2e2bcd8739ae039)(this, ComponentWrapper);
            _this = _super.apply(this, arguments);
            _this.state = {
                visibles: {}
            };
            _this.handleTooltipVisibleChange = function(index, visible) {
                _this.setState(function(prevState) {
                    return {
                        visibles: (0, $41de237383779de8$export$2e2bcd8739ae039)((0, $41de237383779de8$export$2e2bcd8739ae039)({}, prevState.visibles), {}, (0, $1c3963e2ec4676f7$export$2e2bcd8739ae039)({}, index, visible))
                    };
                });
            };
            _this.handleWithTooltip = function(_ref) {
                var value = _ref.value, dragging = _ref.dragging, index = _ref.index, disabled = _ref.disabled, restProps = (0, $cfae3d675552f8ab$export$2e2bcd8739ae039)(_ref, [
                    "value",
                    "dragging",
                    "index",
                    "disabled"
                ]);
                var _this$props = _this.props, tipFormatter = _this$props.tipFormatter, tipProps = _this$props.tipProps, handleStyle = _this$props.handleStyle, getTooltipContainer = _this$props.getTooltipContainer;
                var _tipProps$prefixCls = tipProps.prefixCls, prefixCls = _tipProps$prefixCls === void 0 ? 'rc-slider-tooltip' : _tipProps$prefixCls, _tipProps$overlay = tipProps.overlay, overlay = _tipProps$overlay === void 0 ? tipFormatter(value) : _tipProps$overlay, _tipProps$placement = tipProps.placement, placement = _tipProps$placement === void 0 ? 'top' : _tipProps$placement, _tipProps$visible = tipProps.visible, visible = _tipProps$visible === void 0 ? false : _tipProps$visible, restTooltipProps = (0, $cfae3d675552f8ab$export$2e2bcd8739ae039)(tipProps, [
                    "prefixCls",
                    "overlay",
                    "placement",
                    "visible"
                ]);
                var handleStyleWithIndex;
                if (Array.isArray(handleStyle)) handleStyleWithIndex = handleStyle[index] || handleStyle[0];
                else handleStyleWithIndex = handleStyle;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $a1be002fd90a0ac9$export$2e2bcd8739ae039), (0, $jz4iA.default)({}, restTooltipProps, {
                    getTooltipContainer: getTooltipContainer,
                    prefixCls: prefixCls,
                    overlay: overlay,
                    placement: placement,
                    visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
                    key: index
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $35ceda88dbcc177c$export$2e2bcd8739ae039), (0, $jz4iA.default)({}, restProps, {
                    style: (0, $41de237383779de8$export$2e2bcd8739ae039)({}, handleStyleWithIndex),
                    value: value,
                    onMouseEnter: function onMouseEnter() {
                        return _this.handleTooltipVisibleChange(index, true);
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this.handleTooltipVisibleChange(index, false);
                    }
                })));
            };
            return _this;
        }
        (0, $fe9a5bf59b39de5a$export$2e2bcd8739ae039)(ComponentWrapper, [
            {
                key: "render",
                value: function render() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(Component, (0, $jz4iA.default)({}, this.props, {
                        handle: this.handleWithTooltip
                    }));
                }
            }
        ]);
        return ComponentWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component), _a.defaultProps = {
        tipFormatter: function tipFormatter(value) {
            return value;
        },
        handleStyle: [
            {}
        ],
        tipProps: {},
        getTooltipContainer: function getTooltipContainer(node) {
            return node.parentNode;
        }
    }, _a;
}



var $a80d4978515c9d1e$var$InternalSlider = (0, $0e654d3c2532379a$export$2e2bcd8739ae039);
$a80d4978515c9d1e$var$InternalSlider.Range = (0, $73820928faa25922$export$2e2bcd8739ae039);
$a80d4978515c9d1e$var$InternalSlider.Handle = (0, $35ceda88dbcc177c$export$2e2bcd8739ae039);
$a80d4978515c9d1e$var$InternalSlider.createSliderWithTooltip = (0, $b7a3ef8bae925e7f$export$2e2bcd8739ae039);
var $a80d4978515c9d1e$export$2e2bcd8739ae039 = $a80d4978515c9d1e$var$InternalSlider;



var $8NFma = parcelRequire("8NFma");
class $fb636af17aa59593$var$Range extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).PureComponent {
    constructor(props){
        super(props);
        /**
		 * Use the constructor to push marks and startValue into state
		 * so it can be used in componentDidMount to trigger the onChange method
		 * (range input always has a kind of 'active' state so the user could
		 * just accept the current value and continue in the form)
		 */ const { options: options, scaleOptions: { type: type }, defaultValue: defaultValue } = this.props;
        // Set marks
        let marks = {};
        if (type === 'fixed') {
            const steps = 100 / (options.length - 1);
            for(let i = 0, value = 0; i < options.length; i++, value += steps)marks[value] = options[i].label;
        } else // type: percentage
        marks = {
            0: '0 %',
            100: '100 %'
        };
        // Set start value
        let startValue;
        if (type === 'fixed') {
            const steps = 100 / (options.length - 1);
            if (defaultValue) startValue = steps * defaultValue;
            else // Check if the number of options is even
            startValue = options.length % 2 === 0 ? steps * Math.ceil(options.length / 2) : 50;
        } else // type: percentage
        startValue = defaultValue ? defaultValue : 50;
        this.state = {
            marks: marks,
            startValue: startValue
        };
    }
    componentDidMount = ()=>{
        this.props.handleChange(this.state.startValue);
    };
    render() {
        const { scaleOptions: { type: type, knob_type: knob_type, tooltip: tooltip, background: background, reverse: reverse }, handleChange: handleChange } = this.props;
        const { Handle: Handle } = (0, $a80d4978515c9d1e$export$2e2bcd8739ae039);
        const handle = (props)=>{
            const { value: value, dragging: dragging, index: index, ...restProps } = props;
            const tooltipText = tooltip.replace('[value]', type === 'percentage' ? value : this.state.marks[value]);
            return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a1be002fd90a0ac9$export$2e2bcd8739ae039), {
                prefixCls: "rc-slider-tooltip",
                overlay: tooltipText,
                visible: dragging,
                placement: "top",
                children: /*#__PURE__*/ (0, $1IdZj.jsx)(Handle, {
                    value: value,
                    ...restProps
                })
            }, index);
        };
        const attributes = {
            className: `knob-type--${knob_type}`,
            included: background,
            reverse: reverse,
            marks: this.state.marks,
            step: type === 'fixed' ? null : 1,
            onChange: handleChange,
            defaultValue: this.state.startValue
        };
        return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a80d4978515c9d1e$export$2e2bcd8739ae039), {
            ...attributes,
            ...tooltip && {
                handle: handle
            }
        });
    }
}
var $fb636af17aa59593$export$2e2bcd8739ae039 = $fb636af17aa59593$var$Range;
$fb636af17aa59593$var$Range.propTypes = {
    defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).any,
    handleChange: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).any,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).any,
    scaleOptions: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).any
};



var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");
class $e6b76af36175be3c$var$Toggle extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    render() {
        const { id: id, name: name, title: title, checked: checked, handleChange: handleChange } = this.props;
        return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: "input",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("label", {
                    htmlFor: id,
                    children: title
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                    type: "checkbox",
                    name: name,
                    id: id,
                    onChange: handleChange,
                    checked: checked
                })
            ]
        });
    }
}
var $e6b76af36175be3c$export$2e2bcd8739ae039 = $e6b76af36175be3c$var$Toggle;
$e6b76af36175be3c$var$Toggle.propTypes = {
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
    handleChange: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string
};


class $fb707fd6331be674$var$Question extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    getAnswer = (question, type)=>{
        const answers = question.answers;
        const userInput = this.props.userInput;
        let answer = '';
        switch(type){
            case 'scale':
                answer = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $fb636af17aa59593$export$2e2bcd8739ae039), {
                    options: answers,
                    scaleOptions: question.scale_options,
                    defaultValue: userInput,
                    handleChange: this.props.handleSliderChange
                }, question.ID);
                break;
            case 'dropdown':
                answer = /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ce4a206fc6628ca0$export$2e2bcd8739ae039), {
                    name: question.ID,
                    options: answers,
                    defaultValue: userInput,
                    placeholder: question.dropdown_options.placeholder,
                    handleChange: this.props.handleChange
                }, question.ID);
                break;
            default:
                answer = Object.keys(answers).map((key)=>{
                    const uniqueKey = question.ID + '_' + key;
                    const props = {
                        id: key,
                        name: question.ID,
                        title: answers[key].label,
                        checked: type === 'single' ? userInput === parseInt(key) : userInput && userInput.length ? userInput.includes(parseInt(key)) : false,
                        handleChange: this.props.handleChange
                    };
                    return type === 'single' ? /*#__PURE__*/ (0, $1IdZj.jsx)((0, $d5af52267f39a723$export$2e2bcd8739ae039), {
                        ...props
                    }, uniqueKey) : /*#__PURE__*/ (0, $1IdZj.jsx)((0, $e6b76af36175be3c$export$2e2bcd8739ae039), {
                        ...props
                    }, uniqueKey);
                });
        }
        return answer;
    };
    render() {
        const { question: question, labels: labels } = this.props;
        const type = question.input_type;
        const answer_count = question.answers.length > 1 ? question.answers.length : 0;
        let hint = '';
        switch(type){
            case 'multiple':
                hint = labels.multiple_hint;
                break;
            case 'single':
                hint = labels.appropriate_answer;
                break;
            case 'scale':
                hint = question.scale_options.type === 'fixed' ? labels.appropriate_answer : labels.estimate_in_percent;
                break;
        }
        return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: "ms-form__question",
            "data-type": type,
            "data-count": answer_count,
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                    className: "ms-form__headlines",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("h4", {
                            children: question.title
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("h5", {
                            children: hint !== '' && `(${hint})`
                        })
                    ]
                }),
                question.image && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    className: "ms-form__header-image",
                    children: question.image && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9edc08ff19eb0b97$export$2e2bcd8739ae039), {
                        image: question.image
                    })
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    className: "ms-form__answers",
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: `ms-form__answers__${type}`,
                        children: this.getAnswer(question, type)
                    })
                })
            ]
        });
    }
}
var $fb707fd6331be674$export$2e2bcd8739ae039 = $fb707fd6331be674$var$Question;
$fb707fd6331be674$var$Question.propTypes = {
    handleChange: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    handleSliderChange: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    labels: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    question: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    userInput: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).array
    ])
};



var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");


class $160f28d3c9c01ca8$var$Result extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.getStageRecommendations = $df23d4326b8d2ae1$export$a0e4cd1069957a24.bind(this);
        this.getContact = $df23d4326b8d2ae1$export$52411745da118fc8.bind(this);
    }
    getCircle = (viewBoxSize, className, size = '31.831')=>{
        const spacer = (viewBoxSize - size) / 2;
        const half_the_size = size / 2;
        return /*#__PURE__*/ (0, $1IdZj.jsx)("path", {
            className: className,
            d: `M${half_the_size + spacer} ${spacer}a ${half_the_size} ${half_the_size} 0 0 1 0 ${size}a ${half_the_size} ${half_the_size} 0 0 1 0 -${size}`
        });
    };
    getBulletPoints = (bullets)=>{
        return Object.keys(bullets).map((key, index)=>/*#__PURE__*/ (0, $1IdZj.jsx)("li", {
                children: bullets[index].bullet
            }, index));
    };
    render() {
        const viewBoxSize = 40;
        const { userData: userData, image: image, labels: labels } = this.props;
        const style = {
            '--percentage': `${userData.score}, 100`
        };
        const recommendations = this.getStageRecommendations();
        const contact = this.getContact();
        const expert_headline = labels[`expert_headline_${contact.gender}`];
        return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: "ms-form__result",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                    className: "ms-form__score",
                    "data-color-scheme": "highlight",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                            className: "ms-form__percentage",
                            style: style,
                            children: [
                                image && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9edc08ff19eb0b97$export$2e2bcd8739ae039), {
                                    image: image
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsxs)("svg", {
                                    className: "value",
                                    viewBox: `0 0 ${viewBoxSize} ${viewBoxSize}`,
                                    children: [
                                        this.getCircle(viewBoxSize, 'circle-bg', 40),
                                        this.getCircle(viewBoxSize, 'circle-line'),
                                        this.getCircle(viewBoxSize, 'circle'),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)("text", {
                                            className: "text",
                                            x: "50%",
                                            y: "55%",
                                            dominantBaseline: "middle",
                                            textAnchor: "middle",
                                            children: userData.score
                                        })
                                    ]
                                })
                            ]
                        }),
                        recommendations.intro && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            className: "ms-form__statment",
                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("h4", {
                                className: "text-subline",
                                children: recommendations.intro
                            })
                        })
                    ]
                }),
                recommendations.text && /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                    className: "ms-form__recommendation",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("h4", {
                            className: "ms-form__expert-headline",
                            children: expert_headline
                        }),
                        contact.image && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            className: "ms-form__expert-image",
                            children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9edc08ff19eb0b97$export$2e2bcd8739ae039), {
                                image: contact.image
                            })
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                            className: "ms-form__expert-text",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: recommendations.text
                                    }
                                }),
                                recommendations.bullet_points && /*#__PURE__*/ (0, $1IdZj.jsx)("ul", {
                                    children: this.getBulletPoints(recommendations.bullet_points)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            className: "ms-form__expert-ending",
                            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("p", {
                                children: [
                                    labels.contact_greeting,
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $1IdZj.jsxs)("strong", {
                                        children: [
                                            contact.first_name,
                                            " ",
                                            contact.last_name
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
}
var $160f28d3c9c01ca8$export$2e2bcd8739ae039 = $160f28d3c9c01ca8$var$Result;
$160f28d3c9c01ca8$var$Result.propTypes = {
    labels: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    image: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).any,
    highscoreContent: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    dimensions: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    userData: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    contacts: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    updateUserContact: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func
};



var $1IdZj = parcelRequire("1IdZj");

var $fb0st = parcelRequire("fb0st");

var $8NFma = parcelRequire("8NFma");

class $9a2f499cce978be4$var$Section extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    render() {
        const { image: image, title: title, text: text } = this.props;
        return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: "ms-form__intro",
            children: [
                image && /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9edc08ff19eb0b97$export$2e2bcd8739ae039), {
                    image: image
                }),
                title && /*#__PURE__*/ (0, $1IdZj.jsx)("h3", {
                    children: title
                }),
                text && /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
                    className: "text-subline-sm",
                    dangerouslySetInnerHTML: {
                        __html: text
                    }
                })
            ]
        });
    }
}
var $9a2f499cce978be4$export$2e2bcd8739ae039 = $9a2f499cce978be4$var$Section;
$9a2f499cce978be4$var$Section.propTypes = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string
};


class $4e9e075709843f3e$var$Slide extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
    }
    getSlideContent = (type)=>{
        const { contacts: contacts, slide: slide, slides: slides, labels: labels, handleChange: handleChange, handleSliderChange: handleSliderChange, dimensions: dimensions, userInput: userInput, userData: userData } = this.props;
        switch(type){
            case 'content':
                return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9a2f499cce978be4$export$2e2bcd8739ae039), {
                    image: slide.image,
                    title: slide.title,
                    text: slide.text
                });
            case 'question':
                return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $fb707fd6331be674$export$2e2bcd8739ae039), {
                    userInput: userInput,
                    question: slide,
                    labels: labels,
                    handleChange: handleChange,
                    handleSliderChange: handleSliderChange
                });
            case 'results':
                return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $160f28d3c9c01ca8$export$2e2bcd8739ae039), {
                    labels: labels,
                    image: slide.image,
                    highscoreContent: slide.highscore,
                    dimensions: dimensions,
                    userData: userData,
                    contacts: contacts,
                    updateUserContact: this.props.updateUserContact
                });
            case 'next_steps':
                return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $01328e895cd0998c$export$2e2bcd8739ae039), {
                    ...slide,
                    userData: userData,
                    slides: slides,
                    dimensions: dimensions
                });
        }
    };
    render() {
        return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            id: "slide",
            className: "ms-form__slide",
            children: this.getSlideContent(this.props.slide.type)
        });
    }
}
var $4e9e075709843f3e$export$2e2bcd8739ae039 = $4e9e075709843f3e$var$Slide;
$4e9e075709843f3e$var$Slide.propTypes = {
    contacts: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    dimensions: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    handleChange: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    handleSliderChange: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    labels: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    slide: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    slides: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).array,
    updateUserContact: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).func,
    userData: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).object,
    userInput: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).array
    ])
};



var $bvxsi = parcelRequire("bvxsi");
const $6aef330f22debfde$export$b3b42fd4816dc25f = function(nextSlide = false) {
    if ((0, $bvxsi.getUID)()) {
        const state = this.state;
        const uID = (0, $bvxsi.getUID)();
        const formData = {
            forms: {
                form_id: state.id,
                form_name: state.title,
                location: window.location.hostname + window.location.pathname,
                user_id: uID,
                completed: +(state.userData.progress >= state.slides.indexOf(state.slides.filter((slide)=>slide.type === 'results')[0])),
                progress: state.userData.progress,
                last_slide: state.position
            }
        };
        // If user switched to next slide
        if (nextSlide) {
            /**
			 * Check if scores can be sent to the database
			 */ // Loop dimensions in userData and check which of those have a valid score
            const dimensionScore = [];
            Object.keys(state.userData.dimensions).map((d)=>{
                if ('score' in state.userData.dimensions[d] && state.userData.dimensions[d].score !== false) // Build string, for example: "Collect: 34"
                dimensionScore.push(state.dimensions[d].name + ': ' + state.userData.dimensions[d].score);
            });
            formData.forms.dimension_score = dimensionScore.join('|');
            // Check if a total score exists
            if ('score' in state.userData && state.userData.score !== false) formData.forms.total_score = state.userData.score;
            /**
			 * Questions
			 */ const questions = [];
            /**
			 * Questions: Check previous slide
			 */ if (state.position > 0) {
                const prevSlide = state.slides[state.position - 1];
                if (prevSlide.type === 'question') {
                    const prevQuestion = {
                        form_id: state.id,
                        user_id: uID,
                        // end_timestamp
                        question_id: prevSlide.ID,
                        question_type: prevSlide.input_type,
                        dimension: prevSlide.dimension,
                        question_text: prevSlide.title
                    };
                    let results = state.userData.dimensions[prevSlide.dimension].results[prevSlide.ID];
                    let answerText;
                    if (prevSlide.input_type === 'scale' && prevSlide.scale_options.type === 'percentage') answerText = results.answers;
                    else if (Array.isArray(results.answers)) {
                        const answers = [];
                        results.answers.forEach((val)=>{
                            answers.push(prevSlide.answers[val].label);
                        });
                        answerText = answers.join('|');
                    } else answerText = prevSlide.answers[results.answers].label;
                    prevQuestion.answer = answerText;
                    if ('score' in results) prevQuestion.answer_score = results.score;
                    questions.push(prevQuestion);
                }
            }
            /**
			 * Questions: Check current slide
			 */ const currentSlide = state.slides[state.position];
            if (currentSlide.type === 'question') questions.push({
                form_id: state.id,
                user_id: uID,
                question_id: currentSlide.ID,
                question_type: currentSlide.input_type,
                dimension: currentSlide.dimension,
                question_text: currentSlide.title
            });
            if (questions.length) formData.questions = questions;
        }
        /**
		 * Send data
		 */ $6aef330f22debfde$export$4cf66ea383b0b3ac(formData, state);
    }
};
const $6aef330f22debfde$export$4cf66ea383b0b3ac = function(data, state) {
    fetch(state.apiRout.itdms_ajax + '?action=' + window.itdms_ajax.db_action, {
        method: 'POST',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
};



var $NnYqF = parcelRequire("NnYqF");

var $WkwyL = parcelRequire("WkwyL");


var $aoYbE = parcelRequire("aoYbE");

var $bvxsi = parcelRequire("bvxsi");
class $5d2713b3bd206196$var$App extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.state = {
            loaded: false,
            // Could be overwritten by data from session storage
            ...this.getInitialState()
        };
        // Bind imported functions
        this.handleChange = $NnYqF.handleChange.bind(this);
        this.handleSliderChange = $NnYqF.handleSliderChange.bind(this);
        this.afterChangeHandled = $NnYqF.afterChangeHandled.bind(this);
        this.goToExactSlide = $WkwyL.goToExactSlide.bind(this);
        this.goToPrevSlide = $WkwyL.goToPrevSlide.bind(this);
        this.goToNextSlide = $WkwyL.goToNextSlide.bind(this);
        this.onSlideChange = $WkwyL.onSlideChange.bind(this);
        this.restartSurvey = $WkwyL.restartSurvey.bind(this);
        this.getQuestionScore = $aoYbE.getQuestionScore.bind(this);
        this.calcUserScore = $aoYbE.calcUserScore.bind(this);
        this.calcDimensionScore = $aoYbE.calcDimensionScore.bind(this);
        this.calcTotalScore = $aoYbE.calcTotalScore.bind(this);
        this.generateUID = $bvxsi.generateUID.bind(this);
        this.trackUser = $bvxsi.trackUser.bind(this);
        this.getSessionData = $bvxsi.getSessionData.bind(this);
        this.getStorageFormKey = $bvxsi.getStorageFormKey.bind(this);
        this.updateSessionData = $bvxsi.updateSessionData.bind(this);
        this.updateUserContact = (0, $df23d4326b8d2ae1$export$56eb8157210847c9).bind(this);
        this.dbPushData = $6aef330f22debfde$export$b3b42fd4816dc25f.bind(this);
    }
    getInitialState = ()=>{
        return {
            position: 0,
            userData: {
                dimensions: {},
                score: false,
                progress: 0
            }
        };
    };
    componentDidMount() {
        // Fetch form data from REST API
        this.fetchPostData();
        // Generate user ID
        this.generateUID();
    }
    componentDidUpdate() {
        if (this.state.loaded) // Update session storage to possibly restore the current state
        this.updateSessionData();
    }
    fetchPostData = ()=>{
        fetch(this.props.api).then((response)=>response.json()).then((json)=>{
            if (json) // Update state in two steps
            // 1. Push form data
            this.setState(json, ()=>{
                // 2. Fetch user data from session storage
                this.setState({
                    ...this.getSessionData(),
                    loaded: true
                });
            });
            else console.error(json);
        });
    };
    render() {
        const state = this.state;
        if (state.loaded) {
            const slide = state.slides[state.position];
            const progress = 'progress' in slide ? slide.progress : false;
            let userInput = false;
            if (slide.type === 'question') {
                const d = slide.dimension;
                userInput = state.userData.dimensions[d]?.results?.[slide.ID] ? state.userData.dimensions[d].results[slide.ID].answers : false;
            }
            return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "ms-form",
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4e9e075709843f3e$export$2e2bcd8739ae039), {
                        updateUserContact: this.updateUserContact,
                        contacts: state.contacts,
                        dimensions: state.dimensions,
                        userData: state.userData,
                        userInput: userInput,
                        slide: slide,
                        labels: this.state.labels,
                        handleChange: this.handleChange,
                        handleSliderChange: this.handleSliderChange,
                        slides: state.slides
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a3d3ed27e1a6538a$export$2e2bcd8739ae039), {
                        resultsSlide: state.slides.indexOf(state.slides.filter((slide)=>slide.type === 'results')[0]),
                        slide: slide,
                        position: state.position,
                        slideCount: Object.keys(state.slides).length,
                        dimensions: state.dimensions,
                        progress: progress,
                        labels: this.state.labels,
                        restartBtnCallback: this.restartSurvey,
                        prevBtnCallback: this.goToPrevSlide,
                        nextBtnCallback: this.goToNextSlide,
                        goToSlideCallback: this.goToExactSlide,
                        userData: state.userData
                    })
                ]
            });
        } else return null;
    }
}
var $5d2713b3bd206196$export$2e2bcd8739ae039 = $5d2713b3bd206196$var$App;
$5d2713b3bd206196$var$App.propTypes = {
    api: (0, (/*@__PURE__*/$parcel$interopDefault($fb0st))).string
};


const $232dcd0ca98b18f2$var$el = document.querySelector('.maturity-score');
if ($232dcd0ca98b18f2$var$el) {
    const root = (0, (/*@__PURE__*/$parcel$interopDefault($6T1J1))).createRoot($232dcd0ca98b18f2$var$el);
    root.render(/*#__PURE__*/ (0, $1IdZj.jsx)((0, $5d2713b3bd206196$export$2e2bcd8739ae039), {
        api: $232dcd0ca98b18f2$var$el.getAttribute('data-rest-endpoint'),
        track: $232dcd0ca98b18f2$var$el.getAttribute('data-track'),
        version: $232dcd0ca98b18f2$var$el.getAttribute('data-version')
    }));
}

})();
//# sourceMappingURL=maturity_score.min.js.map
